(function () {
  var CURRENT_ASSET_VERSION="20260731-contextual-upsell-price-v3";
  (function () {
    if (window.__tk9SlideCartRenderWatchdog) return;
    window.__tk9SlideCartRenderWatchdog = true;
    var rescues = 0;
    window.setInterval(function () {
      try {
        if (rescues >= 2) return;
        if (window.__tk9SlideCartAssetVersion === CURRENT_ASSET_VERSION) return;
        var drawer = document.querySelector("[data-tk9-slide-cart]");
        var body = drawer && drawer.querySelector("[data-tk9-body]");
        if (!drawer || !body) return;
        if (body.childElementCount > 0 || body.textContent.trim()) return;
        var tags = Array.prototype.slice.call(document.querySelectorAll("script[src*='tk9-slide-cart-v2.js']"));
        var source = "";
        for (var index = 0; index < tags.length; index += 1) {
          if (tags[index].src.indexOf(CURRENT_ASSET_VERSION) !== -1) { source = tags[index].src; break; }
        }
        if (!source && tags.length) source = tags[tags.length - 1].src;
        if (!source) return;
        rescues += 1;
        var script = document.createElement("script");
        script.src = source.split("&rescue=")[0] + "&rescue=" + rescues + "-" + Date.now();
        script.async = false;
        (document.head || document.documentElement).appendChild(script);
      } catch (error) {}
    }, 4000);
  })();
  (function () {
    if (window.__tk9CartAddDedupe) return;
    window.__tk9CartAddDedupe = true;
    var pending = { body: "", at: 0, ready: null, copy: null };
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = "";
      try {
        url = typeof input === "string" ? input : (input && input.url) || "";
      } catch (error) {}
      if (!/\/cart\/add(\.js)?(\?|$)/.test(url)) return nativeFetch.apply(this, arguments);
      var body = init && typeof init.body === "string" ? init.body : "";
      var key = body;
      try {
        var parsed = JSON.parse(body);
        var items = parsed && parsed.items ? parsed.items : [parsed];
        key = items.map(function (item) {
          return String((item && (item.id || item.variant_id)) || "") + "x" + String((item && item.quantity) || 1);
        }).sort().join("|");
      } catch (error) {}
      var now = Date.now();
      if (key && key === pending.body && now - pending.at < 1500 && pending.ready) {
        return pending.ready.then(function () { return pending.copy.clone(); });
      }
      pending.body = key;
      pending.at = now;
      pending.copy = null;
      pending.ready = nativeFetch.apply(this, arguments).then(function (response) {
        pending.copy = response.clone();
        return response;
      });
      return pending.ready;
    };
  })();
  if (
    window.__tk9SlideCartLoaded &&
    window.__tk9SlideCartAssetVersion === CURRENT_ASSET_VERSION
  ) {
    return;
  }
  window.__tk9SlideCartLoaded = true;
  window.__tk9SlideCartAssetVersion = CURRENT_ASSET_VERSION;

  function blockLegacyRuntimeFallback() {
    if (typeof document === "undefined") return;
    [
      CURRENT_ASSET_VERSION,
      "20260625-patch-cart-preview-v34",
      "20260625-harness-kit-pdp-v33",
      "20260625-harness-kit-grid-v35",
      "20260625-cart-saved-badge-v27",
      "20260625-cart-positive-v20"
    ].forEach(function (version) {
      if (document.querySelector('script[data-tk9-slide-cart-processing-cutoff-fallback="' + version + '"]')) return;
      var sentinel = document.createElement("script");
      sentinel.type = "application/json";
      sentinel.setAttribute("data-tk9-slide-cart-processing-cutoff-fallback", version);
      sentinel.textContent = "{}";
      (document.head || document.documentElement).appendChild(sentinel);
    });
  }

  blockLegacyRuntimeFallback();

  var DEFAULT_CONFIG = {
    enabled: false,
    forceDisabled: false,
    enableParam: "tk9_slide_cart",
    disableParam: "tk9_slide_cart_off",
    rulesUrl: "",
    offerEngineUrl: "",
    availabilityUrl: "",
    inventoryPromiseEnabled: false,
    pdpInventoryPromisePresentationEnabled: true,
    inventoryPromiseEnableParam: "tk9_inventory_promise_on",
    inventoryPromiseDisableParam: "tk9_inventory_promise_off",
    inventoryPromiseUrl: "",
    inventoryPromisePilotUrl: "",
    liveActivityEndpoint: "",
    cartUrl: "/cart.js",
    addUrl: "/cart/add.js",
    changeUrl: "/cart/change.js",
    updateUrl: "/cart/update.js",
    cartPageUrl: "/cart",
    checkoutUrl: "/checkout",
    additionalCheckoutButtonsEnabled: true,
    assetBaseUrl: "",
    dogdadSaleEnabled: false,
    dogdadSaleCode: "",
    dogdadSaleLabel: "",
    dogdadSaleEndsAt: "",
    experimentId: "native_slide_cart_launch",
    variationId: "variation_1",
    layoutVariant: "upsell_first",
    layoutExperimentEnabled: false,
    layoutExperimentRate: 0.5,
    layoutParam: "tk9_slide_cart_layout",
    cartValueAddExperimentEnabled: true,
    cartValueAddExperimentId: "tk9_cart_value_add_slots_20260623",
    cartValueAddExperimentRate: 0.5,
    cartValueAddParam: "tk9_cart_value_add_arm",
    presentationVariant: "premium",
    presentationExperimentEnabled: false,
    presentationExperimentRate: 0.5,
    presentationParam: "tk9_slide_cart_presentation",
    setupProgressEnabled: false,
    setupProgressParam: "tk9_slide_cart_setup",
    premiumMaxOffers: 12,
    cartMoneyPromiseContainment: true,
    checkoutVerifiedHarnessFallbackEnabled: false,
    debug: false,
    shadowOnly: false
  };

  var config = Object.assign({}, DEFAULT_CONFIG, window.TeamK9SlideCartConfig || {});
  var RULES_URL_VERSION = "20260630-pool-cover-compare-v1";

  function refreshRulesUrl(url) {
    if (!url) return url;
    return String(url).replace(
      /(tk9-slide-cart-offers\.json)(?:\?v=[^"'&\s]+)?/,
      "$1?v=" + RULES_URL_VERSION
    );
  }

  function previewThemeParamPresent() {
    try {
      var params = new URLSearchParams(window.location.search);
      return Boolean(params.get("preview_theme_id") || params.get("_ab"));
    } catch (error) {
      return false;
    }
  }

  function inventoryPromiseRuntimeEnabled() {
    try {
      var params = new URLSearchParams(window.location.search);
      var mode = String(params.get("tk9_inventory_promise") || "").toLowerCase();
      if (mode === "off" || mode === "0" || mode === "false") return false;
      if (params.get(config.inventoryPromiseDisableParam || "tk9_inventory_promise_off") === "1") return false;
      if (mode === "on" || mode === "1" || mode === "true" || mode === "pilot") return true;
      if (params.get(config.inventoryPromiseEnableParam || "tk9_inventory_promise_on") === "1") return true;
    } catch (error) {}
    return config.inventoryPromiseEnabled === true;
  }

  function inventoryPromiseCacheBucket() {
    var now = new Date();
    var minuteBucket = Math.floor(now.getUTCMinutes() / 30) * 30;
    return [
      now.getUTCFullYear(),
      String(now.getUTCMonth() + 1).padStart(2, "0"),
      String(now.getUTCDate()).padStart(2, "0"),
      String(now.getUTCHours()).padStart(2, "0"),
      String(minuteBucket).padStart(2, "0")
    ].join("");
  }

  function withInventoryPromiseCacheBucket(url) {
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set("tk9_proof_v", inventoryPromiseCacheBucket());
      if (/^\//.test(String(url || ""))) return parsed.pathname + parsed.search + parsed.hash;
      return parsed.toString();
    } catch (error) {
      return url;
    }
  }

  function refreshInventoryPromiseUrl(url) {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("tk9_inventory_promise") === "pilot" && config.inventoryPromisePilotUrl) {
        return withInventoryPromiseCacheBucket(config.inventoryPromisePilotUrl);
      }
      var overrideUrl = params.get("tk9_inventory_promise_url");
      if (previewThemeParamPresent() && overrideUrl && /^\/|^https?:\/\//i.test(overrideUrl)) {
        return withInventoryPromiseCacheBucket(overrideUrl);
      }
    } catch (error) {}
    return withInventoryPromiseCacheBucket(url);
  }

  config.rulesUrl = refreshRulesUrl(config.rulesUrl);
  config.inventoryPromiseEnabled = inventoryPromiseRuntimeEnabled();
  config.inventoryPromiseUrl = config.inventoryPromiseEnabled ? refreshInventoryPromiseUrl(config.inventoryPromiseUrl) : "";
  var state = {
    rules: null,
    offerEngine: null,
    offerEngineLoaded: false,
    availability: null,
    availabilityLoaded: false,
    inventoryPromise: null,
    inventoryPromiseLoaded: false,
    inventoryPromiseRequest: null,
    cart: null,
    suppressed: [],
    open: false,
    busy: false,
    attributionBusy: false,
    attributionMarked: false,
    discountBusy: false,
    discountEditing: false,
    discountMessage: "",
    discountOpen: false,
    expressCheckoutOpen: false,
    impressionKeys: {},
    variantCompareAtCents: {},
    compareAtHandlesLoaded: {},
    compareAtHandleRequests: {},
    liveAvailabilityHandlesLoaded: {},
    liveAvailabilityHandleRequests: {},
    inventoryLiveActivity: {
      sessionId: "",
      counts: {},
      lastChecked: {},
      requests: {},
      intervals: {}
    },
    layoutVariant: "",
    presentationVariant: "",
    cartValueAddArm: ""
  };

  function injectCriticalLayoutCss() {
    if (document.getElementById("tk9-slide-cart-critical-css")) return;
    var style = document.createElement("style");
    style.id = "tk9-slide-cart-critical-css";
    style.textContent = [
      ".tk9-slide-cart{height:100vh;height:100dvh;overflow:hidden;}",
      ".tk9-slide-cart__body{min-height:0;overflow-y:auto;overflow-x:hidden;overscroll-behavior:contain;-webkit-overflow-scrolling:touch;}",
      ".tk9-slide-cart__footer{position:relative;z-index:2;flex:0 0 auto;overflow:hidden;overscroll-behavior:none;overscroll-behavior-y:none;touch-action:manipulation;-webkit-overflow-scrolling:auto;}",
      ".tk9-discount-form{min-width:0;max-width:100%;overflow:hidden;}",
      ".tk9-discount-form input{min-width:0;}",
      ".tk9-pay-row,.tk9-trust-row{min-width:0;max-width:100%;}",
      ".tk9-pay-row span,.tk9-pay-row button,.tk9-pay-row a{min-width:0;max-width:100%;overflow:hidden;white-space:nowrap;}",
      ".tk9-pay-logo b,.tk9-pay-logo em{display:inline-block;max-width:100%;overflow:hidden;text-overflow:clip;white-space:nowrap;}",
      ".tk9-pay-row--count-5 .tk9-pay-logo--amazon{gap:0;font-size:10.5px;}",
      ".tk9-cart-line__selected{display:flex;flex-wrap:wrap;gap:6px;align-items:center;min-width:0;margin-top:4px;color:#667085;font-size:13px;font-weight:800;line-height:1.25;}",
      ".tk9-cart-line__selected-label{color:#59667a;font-weight:900;}",
      ".tk9-cart-line__size-pill{display:inline-flex;align-items:center;gap:4px;flex-wrap:nowrap;max-width:100%;padding:3px 8px;border:1px solid #173b68;border-radius:999px;background:#eef5ff;color:#173b68;font-weight:950;line-height:1.1;white-space:nowrap;}",
      ".tk9-cart-line__size-pill span{font-size:12px;}.tk9-cart-line__size-pill em{color:#102a4c;font-size:14px;font-style:normal;font-weight:950;}.tk9-cart-line__size-pill small{color:#173b68;font-size:12px;font-weight:950;white-space:nowrap;}",
      ".tk9-cart-line__size-note{max-width:360px;margin-top:3px;color:#667085;font-size:12px;font-weight:800;line-height:1.18;}.tk9-cart-line__size-note-compact{display:none;}",
      ".tk9-cart-line__promise{max-width:360px;margin-top:3px;color:#173b68;font-size:12px;font-weight:900;line-height:1.18;}.tk9-cart-line__promise-detail{max-width:360px;margin-top:2px;color:#475569;font-size:11.5px;font-weight:850;line-height:1.16;}.tk9-cart-delivery-group{border-top:1px solid #e4ebf4;}.tk9-cart-delivery-group:first-child{border-top:0;}.tk9-cart-delivery-group__header{padding:10px 18px 5px 18px;color:#172033;font-size:13px;font-weight:950;line-height:1.12;}.tk9-cart-delivery-group__title{display:block;}.tk9-cart-delivery-group__sub{display:block;margin-top:2px;color:#64748b;font-size:11.5px;font-weight:850;line-height:1.12;}.tk9-inventory-promise-part--positive{color:#0f766e}.tk9-inventory-promise-part--caution{color:#9a5b00}.tk9-inventory-promise-part--danger{color:#d71920}.tk9-cart-line__promise--direct_ship,.tk9-cart-line__promise--delayed_delivery,.tk9-cart-line__promise--split_ship,.tk9-cart-line__promise--split_bundle,.tk9-cart-line__promise--ships_in_parts{color:#9a5b00}.tk9-cart-line__promise--backorder_sellable,.tk9-cart-line__promise--production_backorder,.tk9-cart-line__promise--reserve{color:#9f1239}.tk9-cart-line__promise--out_of_stock,.tk9-cart-line__promise--alert_only,.tk9-cart-line__promise--alert_me{color:#9f1239}.tk9-cart-line__promise--ready_to_ship,.tk9-cart-line__promise--ships_now,.tk9-cart-line__promise--available_now{color:#0f766e}.tk9-cart-line__promise--low_stock{color:#d71920}.tk9-cart-line--custom-patch .tk9-cart-line__promise{white-space:nowrap}.tk9-processing-cutoff{margin:5px 0 8px;color:#172033;text-align:center;font-size:13px;font-weight:950;line-height:1.15}.tk9-processing-cutoff[hidden]{display:none!important}",
      "@media(max-width:640px){.tk9-pdp-patch~.buy-buttons-block{margin-block-start:-16px!important;margin-top:-16px!important}}",
      "@media(max-width:520px){.tk9-cart-delivery-group__header{padding:8px 16px 4px 16px;font-size:11.5px}.tk9-cart-delivery-group__sub{font-size:10.5px}.tk9-cart-line__selected{gap:4px;font-size:13px;line-height:1.14}.tk9-cart-line__selected-label{display:none}.tk9-cart-line__size-pill{gap:3px;padding:3px 7px}.tk9-cart-line__size-pill span{display:none}.tk9-cart-line__size-pill em{font-size:13px}.tk9-cart-line__size-pill small{font-size:11px}.tk9-cart-line__size-note,.tk9-cart-line__promise{max-width:100%;margin-top:3px;font-size:12px;line-height:1.08;white-space:normal}.tk9-cart-line--custom-patch{grid-template-columns:92px minmax(0,1fr) auto}.tk9-cart-line--custom-patch .tk9-cart-line__image,.tk9-cart-line--custom-patch .tk9-cart-line__image-link{width:80px;height:58px;border-radius:10px}.tk9-cart-line--custom-patch .tk9-cart-line__promise{font-size:9px;line-height:1;white-space:nowrap;text-overflow:ellipsis}.tk9-cart-line--custom-patch .tk9-cart-line__properties{display:grid;-webkit-line-clamp:initial;font-size:10.5px;line-height:1.08}.tk9-cart-line--custom-patch .tk9-cart-line__mockup-note{display:none}.tk9-cart-line__promise-detail{display:none!important}.tk9-processing-cutoff{margin:4px 0 7px;font-size:11.5px}.tk9-cart-line__size-note-full{display:none}.tk9-cart-line__size-note-compact{display:inline}}",
      "@media(max-width:520px){.tk9-pay-row{gap:5px}.tk9-pay-row span,.tk9-pay-row button,.tk9-pay-row a{padding-left:4px;padding-right:4px;font-size:10.5px}.tk9-pay-row--count-5 .tk9-pay-logo--amazon b,.tk9-pay-row--count-5 .tk9-pay-logo--amazon em{font-size:10px}}"
    ].join("");
    (document.head || document.documentElement).appendChild(style);
  }

  function preventFooterScroll(event) {
    if (!state.open) return;
    var target = event.target;
    if (target && target.closest && target.closest("input, textarea, select")) return;
    event.preventDefault();
  }

  var cartSaleTimerId = null;
  var cartProcessingTimerId = null;

  function cartSaleEndMs() {
    if (!config.dogdadSaleEnabled || !config.dogdadSaleEndsAt) return 0;
    var end = Date.parse(config.dogdadSaleEndsAt);
    return Number.isFinite(end) ? end : 0;
  }

  function formatCartSaleTime(ms) {
    var totalMinutes = Math.max(0, Math.floor(ms / 60000));
    var days = Math.floor(totalMinutes / 1440);
    var hours = Math.floor((totalMinutes % 1440) / 60);
    var minutes = totalMinutes % 60;
    var parts = [];
    if (days > 0) parts.push(days + "D");
    parts.push(String(hours).padStart(2, "0") + "H");
    parts.push(String(minutes).padStart(2, "0") + "M");
    return parts.join(" ");
  }

  function updateCartSaleTimer() {
    var shell = document.querySelector("[data-tk9-cart-sale-timer]");
    if (!shell) return;
    var end = cartSaleEndMs();
    var remaining = end - Date.now();
    if (!end || remaining <= 0) {
      shell.setAttribute("hidden", "");
      shell.classList.remove("is-visible");
      return;
    }
    var label = shell.querySelector("[data-tk9-cart-sale-label]");
    var timer = shell.querySelector("[data-tk9-cart-sale-countdown]");
    if (label) label.textContent = config.dogdadSaleLabel ? String(config.dogdadSaleLabel).toUpperCase() : "SALE SAVINGS";
    if (timer) timer.textContent = "Ends in " + formatCartSaleTime(remaining);
    shell.removeAttribute("hidden");
    shell.classList.add("is-visible");
  }

  function startCartSaleTimer() {
    updateCartSaleTimer();
    if (cartSaleTimerId) return;
    cartSaleTimerId = window.setInterval(updateCartSaleTimer, 60000);
  }

  function formatCutoffDuration(minutes) {
    var safeMinutes = Math.max(1, Math.round(Number(minutes) || 1));
    var hours = Math.floor(safeMinutes / 60);
    var remainder = safeMinutes % 60;
    if (hours <= 0) return remainder + "m";
    return hours + "h " + remainder + "m";
  }

  function processingCountdownWindowMinutes() {
    return 120;
  }

  function cartProcessingCutoffText() {
    var minutes = minutesUntilSameDayOrderCutoff();
    if (minutes <= 0 || minutes > processingCountdownWindowMinutes()) return "";
    return "Order in " + formatCutoffDuration(minutes) + " for today's processing";
  }

  function updateCartProcessingCutoff() {
    var node = document.querySelector("[data-tk9-cart-processing-cutoff]");
    if (!node) return;
    var text = cartProcessingCutoffText();
    if (!text) {
      node.setAttribute("hidden", "");
      node.textContent = "";
      return;
    }
    node.textContent = text;
    node.removeAttribute("hidden");
  }

  function startCartProcessingTimer() {
    updateCartProcessingCutoff();
    if (cartProcessingTimerId) return;
    cartProcessingTimerId = window.setInterval(updateCartProcessingCutoff, 60000);
  }

  function shouldAutoFocusDrawerInput() {
    try {
      return window.innerWidth >= 750 && window.matchMedia && window.matchMedia("(pointer: fine)").matches;
    } catch (error) {
      return false;
    }
  }

  function enabledByParam() {
    try {
      return new URLSearchParams(window.location.search).get(config.enableParam) === "1";
    } catch (error) {
      return false;
    }
  }

  function disabledByParam() {
    try {
      return new URLSearchParams(window.location.search).get(config.disableParam) === "1";
    } catch (error) {
      return false;
    }
  }

  function layoutParam() {
    try {
      var value = new URLSearchParams(window.location.search).get(config.layoutParam || "tk9_slide_cart_layout");
      return value === "upsell_first" || value === "bonus_first" ? value : "";
    } catch (error) {
      return "";
    }
  }

  function presentationParam() {
    try {
      var value = new URLSearchParams(window.location.search).get(config.presentationParam || "tk9_slide_cart_presentation");
      return normalizePresentationVariant(value);
    } catch (error) {
      return "";
    }
  }

  function normalizePresentationVariant(value) {
    var normalized = String(value || "").trim().toLowerCase();
    if (normalized === "premium" || normalized === "tk9_premium" || normalized === "owned_premium") return "premium";
    if (normalized === "standard") return "standard";
    return "";
  }

  function activeSetupProgressEnabled() {
    return false;
  }

  function activeLayoutVariant() {
    if (state.layoutVariant) return state.layoutVariant;
    var forced = layoutParam();
    if (forced) {
      state.layoutVariant = forced;
      return state.layoutVariant;
    }
    try {
      if (config.layoutExperimentEnabled) {
        var stored = window.localStorage.getItem("tk9_slide_cart_layout_variant");
        if (stored === "upsell_first" || stored === "bonus_first") {
          state.layoutVariant = stored;
          return state.layoutVariant;
        }
        state.layoutVariant = Math.random() < Number(config.layoutExperimentRate || 0.5) ? "upsell_first" : "bonus_first";
        window.localStorage.setItem("tk9_slide_cart_layout_variant", state.layoutVariant);
        return state.layoutVariant;
      }
    } catch (error) {}
    state.layoutVariant = config.layoutVariant === "upsell_first" ? "upsell_first" : "bonus_first";
    return state.layoutVariant;
  }

  function activePresentationVariant() {
    if (state.presentationVariant) return state.presentationVariant;
    var forced = presentationParam();
    if (forced) {
      state.presentationVariant = forced;
      return state.presentationVariant;
    }
    try {
      if (config.presentationExperimentEnabled) {
        var stored = window.localStorage.getItem("tk9_slide_cart_presentation_variant");
        var storedPresentation = normalizePresentationVariant(stored);
        if (storedPresentation) {
          state.presentationVariant = storedPresentation;
          if (stored !== storedPresentation) window.localStorage.setItem("tk9_slide_cart_presentation_variant", state.presentationVariant);
          return state.presentationVariant;
        }
        state.presentationVariant = Math.random() < Number(config.presentationExperimentRate || 0.5) ? "premium" : "standard";
        window.localStorage.setItem("tk9_slide_cart_presentation_variant", state.presentationVariant);
        return state.presentationVariant;
      }
    } catch (error) {}
    state.presentationVariant = normalizePresentationVariant(config.presentationVariant) || "standard";
    return state.presentationVariant;
  }

  function cartValueAddParam() {
    try {
      var value = new URLSearchParams(window.location.search).get(config.cartValueAddParam || "tk9_cart_value_add_arm");
      return value === "one_featured" || value === "two_picks" ? value : "";
    } catch (error) {
      return "";
    }
  }

  function activeCartValueAddArm() {
    if (state.cartValueAddArm) return state.cartValueAddArm;
    var forced = cartValueAddParam();
    if (forced) {
      state.cartValueAddArm = forced;
      return state.cartValueAddArm;
    }
    try {
      if (config.cartValueAddExperimentEnabled) {
        var stored = window.localStorage.getItem("tk9_cart_value_add_arm");
        if (stored === "one_featured" || stored === "two_picks") {
          state.cartValueAddArm = stored;
          return state.cartValueAddArm;
        }
        state.cartValueAddArm = Math.random() < Number(config.cartValueAddExperimentRate || 0.5) ? "one_featured" : "two_picks";
        window.localStorage.setItem("tk9_cart_value_add_arm", state.cartValueAddArm);
        return state.cartValueAddArm;
      }
    } catch (error) {}
    state.cartValueAddArm = "two_picks";
    return state.cartValueAddArm;
  }

  function cartValueAddSlotCount() {
    return activeCartValueAddArm() === "one_featured" ? 1 : 2;
  }

  function activeVariationId() {
    var layoutVariation = activeLayoutVariant() === "upsell_first" ? "variation_2_upsell_first" : (config.variationId || "variation_1");
    var presentationVariation = activePresentationVariant() === "premium" ? layoutVariation + "_premium" : layoutVariation;
    return presentationVariation + "_" + activeCartValueAddArm();
  }

  function forceDisabled() {
    // Zombie poison pill (2026-07-02): config.forceDisabled=true silences
    // every OLDER cached v2 generation (stale-guard injections, cached-page
    // copies — they all honor this flag from the shared global config).
    // THIS build ignores that one flag when primarySurface is "page", so it
    // alone runs the add-intercept and routes to the cart page. The URL and
    // localStorage kill switches still disable everything, including us.
    var configPill = Boolean(config.forceDisabled) && String(config.primarySurface || "") !== "page";
    try {
      return Boolean(
        configPill ||
          disabledByParam() ||
          window.localStorage.getItem("tk9_slide_cart_disabled") === "1"
      );
    } catch (error) {
      return Boolean(configPill || disabledByParam());
    }
  }

  function isEnabled() {
    if (forceDisabled()) return false;
    try {
      return Boolean(
        config.enabled ||
          enabledByParam() ||
          window.localStorage.getItem("tk9_slide_cart_enabled") === "1"
      );
    } catch (error) {
      return Boolean(config.enabled || enabledByParam());
    }
  }

  function debugLog() {
    if (!config.debug) return;
    try {
      var args = Array.prototype.slice.call(arguments);
      args.unshift("[Team K9 slide cart]");
      console.info.apply(console, args);
    } catch (error) {}
  }

  function money(cents) {
    return "$" + (Number(cents || 0) / 100).toFixed(2);
  }

  function roundedDollarAmount(cents) {
    var amount = Number(cents || 0);
    if (!isFinite(amount) || amount <= 0) return "";
    return "$" + Math.max(1, Math.round(amount / 100));
  }

  function roundedSavingsText(compareAtCents, priceCents) {
    var savings = Number(compareAtCents || 0) - Number(priceCents || 0);
    var rounded = roundedDollarAmount(savings);
    return rounded ? rounded + " OFF" : "";
  }

  function subtotalSavingsMoneyText(compareAtCents, priceCents) {
    var savings = Number(compareAtCents || 0) - Number(priceCents || 0);
    var rounded = roundedDollarAmount(savings);
    return rounded ? rounded + " SAVED" : "";
  }

  function subtotalSavingsPercentText(compareAtCents, priceCents) {
    var compareAt = Number(compareAtCents || 0);
    var price = Number(priceCents || 0);
    var savings = Math.max(compareAt - price, 0);
    if (!compareAt || !savings) return "";
    var rate = savings / compareAt;
    return rate >= 0.245 ? Math.max(1, Math.round(rate * 100)) + "% OFF" : "";
  }

  function savingsPillHtml(compareAtCents, priceCents, className) {
    var text = roundedSavingsText(compareAtCents, priceCents);
    if (!text) return "";
    return '<span class="' + (className || "tk9-save-pill") + '">' + escapeHtml(text) + '</span>';
  }

  function savingsBadgeSummary(compareAtCents, priceCents, options) {
    options = options || {};
    var compareAt = Number(compareAtCents || 0);
    var price = Number(priceCents || 0);
    var savings = Math.max(compareAt - price, 0);
    if (!compareAt || !savings) return null;
    var rate = savings / compareAt;
    if (rate >= 0.245 || (options.preferPercent && rate >= 0.095)) {
      return {
        text: Math.max(1, Math.round(rate * 100)) + "% OFF",
        kind: "percent"
      };
    }
    return {
      text: roundedSavingsText(compareAt, price),
      kind: "money"
    };
  }

  function subtotalSavingsPillHtml(compareAtCents, priceCents, options) {
    options = options || {};
    var compareAt = Number(compareAtCents || 0);
    var price = Number(priceCents || 0);
    var savings = Math.max(compareAt - price, 0);
    if (!compareAt || !savings) return "";
    var moneyText = subtotalSavingsMoneyText(compareAt, price);
    var percentText = subtotalSavingsPercentText(compareAt, price);
    var pills = [];
    if (moneyText) {
      pills.push('<span class="tk9-subtotal-save-pill tk9-subtotal-save-pill--money">' + escapeHtml(moneyText) + '</span>');
    }
    if (percentText) {
      pills.push('<span class="tk9-subtotal-save-pill tk9-subtotal-save-pill--percent">' + escapeHtml(percentText) + '</span>');
    }
    if (!pills.length) return "";
    return '<span class="tk9-subtotal-save-pills" aria-label="Cart savings">' + pills.join("") + '</span>';
  }

  function configuredDiscountPercent(code) {
    var rate = configuredDiscountRate(code);
    return rate > 0 && rate < 1 ? Math.round(rate * 100) : 0;
  }

  function selectedPdpVariantId() {
    try {
      var id = new URLSearchParams(window.location.search).get("variant");
      if (id) return String(id);
    } catch (error) {}
    var input = document.querySelector('form[action*="/cart/add"] [name="id"], product-form-component [name="id"], input[name="id"], select[name="id"]');
    return input && input.value ? String(input.value) : "";
  }

  function embeddedPdpVariant(id) {
    if (!id) return null;
    var product = window.bcpo_product || window.product || null;
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    for (var index = 0; index < variants.length; index += 1) {
      if (String(variants[index].id) === String(id)) return variants[index];
    }
    return null;
  }

  function cleanKitSelectionText(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .replace(/\s+\|\s+/g, " / ")
      .trim();
  }

  function isBundleKitSelectionText(value) {
    var text = cleanKitSelectionText(value).toLowerCase();
    if (!text || /default title/.test(text)) return false;
    if (/\b(car\s*seat\s*cover|seat\s*cover|hard\s*bottom|hammock)\b/.test(text) && /\bfree\b/.test(text)) {
      return false;
    }
    return Boolean(
      /\b\d+\s*[- ]?\s*pack\b/.test(text) ||
      /\b(two|three|four|five|six|twelve)\s*[- ]?\s*pack\b/.test(text) ||
      /\b\d+\s*[- ]?\s*in\s*[- ]?\s*1\b/.test(text) ||
      /\b(2|4|two|four)\s+dual[- ]?fan\s+kit(?:s)?\b/.test(text) ||
      /\b(12|twelve)\s*[- ]?\s*patch(?:es)?\b/.test(text) ||
      /\b(bundle|bundled|bundle sku|system)\b/.test(text) ||
      (/\bharness\b/.test(text) && /\s\+\s/.test(text) && !/\bfree\b/.test(text))
    );
  }

  function kitSelectionFromVariant(variant, fallbackTitle) {
    var title = cleanKitSelectionText(
      (variant && (variant.public_title || variant.title)) ||
      fallbackTitle ||
      ""
    );
    var options = [variant && variant.option1, variant && variant.option2, variant && variant.option3]
      .filter(function (value) { return cleanKitSelectionText(value); })
      .map(cleanKitSelectionText);
    var kitOption = cleanKitSelectionText(variant && variant.option3);
    var kitSelection = "";
    if (isBundleKitSelectionText(kitOption)) kitSelection = kitOption;
    else if (isBundleKitSelectionText(title)) kitSelection = title;
    return {
      tk9_kit_selection: kitSelection,
      tk9_variant_selection: title,
      tk9_variant_option_1: options[0] || "",
      tk9_variant_option_2: options[1] || "",
      tk9_variant_option_3: options[2] || ""
    };
  }

  function selectedPdpKitSelection(formData) {
    var variantId = formData && formData.get ? formData.get("id") : selectedPdpVariantId();
    variantId = variantId || selectedPdpVariantId();
    var variant = embeddedPdpVariant(variantId) || {};
    var fallbackTitle = "";
    try {
      fallbackTitle = Array.prototype.slice.call(document.querySelectorAll(
        'variant-picker input:checked, variant-picker option:checked, variant-swatch-king input:checked, variant-swatch-king option:checked, form[action*="/cart/add"] input:checked, form[action*="/cart/add"] option:checked'
      )).map(function (node) {
        var value = cleanKitSelectionText(node.getAttribute("data-option-value") || node.value || node.textContent);
        if (/^(true|false|on|off|0|1)$/i.test(value)) return "";
        return value;
      }).filter(Boolean).join(" / ");
    } catch (error) {}
    return Object.assign({ tk9_variant_id: variantId ? String(variantId) : "" }, kitSelectionFromVariant(variant, fallbackTitle));
  }

  function addKitSelectionProperties(properties, selection) {
    var merged = Object.assign({}, properties || {});
    if (selection && selection.tk9_kit_selection) merged._tk9_kit_selection = selection.tk9_kit_selection;
    if (selection && selection.tk9_variant_selection) merged._tk9_variant_selection = selection.tk9_variant_selection;
    if (selection && selection.tk9_variant_option_1) merged._tk9_variant_option_1 = selection.tk9_variant_option_1;
    if (selection && selection.tk9_variant_option_2) merged._tk9_variant_option_2 = selection.tk9_variant_option_2;
    if (selection && selection.tk9_variant_option_3) merged._tk9_variant_option_3 = selection.tk9_variant_option_3;
    return merged;
  }

  function loadInventoryPromise() {
    if (!config.inventoryPromiseEnabled || !config.inventoryPromiseUrl) {
      state.inventoryPromise = null;
      state.inventoryPromiseLoaded = true;
      return Promise.resolve(null);
    }
    if (state.inventoryPromiseLoaded) return Promise.resolve(state.inventoryPromise);
    if (state.inventoryPromiseRequest) return state.inventoryPromiseRequest;
    state.inventoryPromiseRequest = fetchJson(config.inventoryPromiseUrl, { cache: "no-store" })
      .then(function (manifest) {
        state.inventoryPromise = manifest && (manifest.variants || manifest.bundles) ? manifest : null;
        state.inventoryPromiseLoaded = true;
        return state.inventoryPromise;
      })
      .catch(function (error) {
        state.inventoryPromise = null;
        state.inventoryPromiseLoaded = true;
        debugLog("inventory promise manifest unavailable", error);
        return null;
      })
      .finally(function () {
        state.inventoryPromiseRequest = null;
      });
    return state.inventoryPromiseRequest;
  }

  function inventoryPromiseEntry(variantId) {
    if (!config.inventoryPromiseEnabled) return null;
    var id = String(variantId || "").trim();
    var manifest = state.inventoryPromise || {};
    if (!id) return null;
    return manifest.bundles && manifest.bundles[id] || manifest.variants && manifest.variants[id] || null;
  }

  function manualDirectShipPromiseEntry(variantId) {
    if (!config.inventoryPromiseEnabled) return null;
    var id = String(variantId || "").trim();
    var fanVariants = {
      "44107734155363": "1 Dual-Fan Kit",
      "44107734188131": "2 Dual-Fan Kits",
      "44198189924451": "4-pack"
    };
    if (!Object.prototype.hasOwnProperty.call(fanVariants, id)) return null;
    return {
      id: id,
      source: "manual_fan_direct_ship_20260621",
      productHandle: "dual-headrest-cooling-fans-usb-a",
      productTitle: "Team K9 Backseat Dog Cooling Fans (USB-A)",
      variantTitle: fanVariants[id],
      state: "direct_ship",
      facts: {},
      routePromise: {
        routeProfile: "direct_tracked",
        dominantCarrier: "yunexpress",
        confidence: "medium",
        showPdpGetItBy: false,
        getItByBusinessDays: null,
        pdpDeliveryText: "Ships direct with tracking",
        cartLine: "AVAILABLE NOW · Ships direct with tracking",
        customerDeliveryWindow: "direct tracked delivery"
      },
      surfaceCopy: {
        promiseState: "direct_ship",
        cartLine: "AVAILABLE NOW · Ships direct with tracking",
        emailFlowKey: "direct_ship",
        supportContext: "direct_ship_expected",
        lineItemProperties: {
          _promise_state: "direct_ship",
          _promise_line: "AVAILABLE NOW · Ships direct with tracking",
          _email_flow_key: "direct_ship",
          _support_context: "direct_ship_expected"
        }
      }
    };
  }

  function inventoryPromiseSurface(entry) {
    return entry && entry.surfaceCopy && typeof entry.surfaceCopy === "object" ? entry.surfaceCopy : {};
  }

  function inventoryPromiseState(entry) {
    var surface = inventoryPromiseSurface(entry);
    return String(surface.promiseState || entry && entry.state || "").trim();
  }

  function inventoryPromiseClass(entry) {
    var stateName = inventoryPromiseState(entry);
    if ((stateName === "ships_now" || stateName === "ready_to_ship") && inventoryHasLowStockSignal(entry)) return "low_stock";
    if (stateName === "direct_ship" || stateName === "delayed_delivery" || stateName === "available_now") return "direct_ship";
    return stateName.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "") || "standard";
  }

  function inventoryPdpStatusClass(entry) {
    var stateName = inventoryPromiseState(entry);
    if (inventoryIsLowStockPresentation(entry)) return "low_stock";
    if ((stateName === "ships_now" || stateName === "ready_to_ship") && !inventoryHasLowStockSignal(entry)) return "ships_now";
    if (stateName === "direct_ship" || stateName === "delayed_delivery" || stateName === "available_now") return "direct_ship";
    if (stateName === "ships_in_parts" || stateName === "split_ship" || stateName === "split_bundle") return "ships_now";
    return "direct_ship";
  }

  function isStandardInventoryState(text, stateName) {
    var normalized = normalizeText(text);
    return normalized === "in stock" ||
      normalized === "ready to ship" ||
      normalized === normalizeText("IN STOCK · Ready to ship") ||
      normalized === normalizeText("IN STOCK · Claim yours while supplies last") ||
      normalized === normalizeText("IN STOCK · While supplies last") ||
      stateName === "standard";
  }

  function isStandardInventoryPromise(text, entry) {
    return isStandardInventoryState(text, inventoryPromiseState(entry));
  }

  function inventoryPromiseText(entry, surfaceName) {
    if (!entry) return "";
    var surface = inventoryPromiseSurface(entry);
    var customer = entry.customer || {};
    if (surfaceName === "variant") return inventoryNormalizeSurfacePromiseText(surface.variantSupport || customer.badge || customer.pdpNote || "");
    if (surfaceName === "cta") return inventoryNormalizeSurfacePromiseText(surface.ctaSupport || (!isStandardInventoryPromise(surface.variantSupport, entry) ? customer.pdpNote : "") || "");
    if (surfaceName === "cart") return inventoryNormalizeStoredPromiseLine(surface.cartLine || customer.cartNote || "");
    return "";
  }

  function inventoryNumber(value) {
    var number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function inventoryEntryHasOwnLowStockSignal(entry) {
    var facts = entry && entry.facts || {};
    var usAvailable = inventoryNumber(facts.usAvailable);
    var projectedOosDays = inventoryNumber(facts.projectedOosDays);
    return Boolean(
      usAvailable !== null && usAvailable > 0 && usAvailable <= 25 ||
      projectedOosDays !== null && projectedOosDays > 0 && projectedOosDays <= 10
    );
  }

  function inventoryComponentEntries(entry) {
    var required = entry && entry.components && Array.isArray(entry.components.required) ? entry.components.required : [];
    return required.map(function (component) {
      return inventoryPromiseEntry(component.componentVariantId || component.componentKey);
    }).filter(Boolean);
  }

  function inventoryHasLowStockSignal(entry) {
    if (inventoryEntryHasOwnLowStockSignal(entry)) return true;
    return inventoryComponentEntries(entry).some(inventoryEntryHasOwnLowStockSignal);
  }

  function promiseLinePropertiesForVariant(variantId) {
    if (!config.inventoryPromiseEnabled) return {};
    var entry = inventoryFallbackPromiseEntry(variantId, inventoryPromiseEntry(variantId));
    var surface = inventoryPromiseSurface(entry);
    var source = surface.lineItemProperties && typeof surface.lineItemProperties === "object" ? surface.lineItemProperties : {};
    var properties = {};
    ["_promise_state", "_promise_line", "_email_flow_key", "_support_context"].forEach(function (name) {
      var value = source[name];
      if (name === "_promise_line") value = inventoryNormalizeStoredPromiseLine(value);
      if (value !== null && value !== undefined && String(value).trim() !== "") properties[name] = String(value).trim();
    });
    return properties;
  }

  function mergeInventoryPromiseProperties(properties, variantId) {
    var merged = Object.assign({}, properties || {});
    var promiseProperties = promiseLinePropertiesForVariant(variantId);
    Object.keys(promiseProperties).forEach(function (name) {
      if (!merged[name]) merged[name] = promiseProperties[name];
    });
    return merged;
  }

  function appendInventoryPromiseProperties(formData, variantId) {
    if (!config.inventoryPromiseEnabled) return formData;
    if (!formData) return formData;
    var id = variantId || formData.get("id") || selectedPdpVariantId();
    var promiseProperties = promiseLinePropertiesForVariant(id);
    Object.keys(promiseProperties).forEach(function (name) {
      var key = "properties[" + name + "]";
      if (typeof formData.set === "function") formData.set(key, promiseProperties[name]);
      else formData.append(key, promiseProperties[name]);
    });
    return formData;
  }

  function primaryPdpForm() {
    return document.querySelector('form.shopify-product-form[action*="/cart/add"], form[action*="/cart/add"]');
  }

  function pdpAddButton(form) {
    if (!form || !form.querySelector) return null;
    return form.querySelector('button[name="add"], button[type="submit"], input[type="submit"], [data-add-to-cart], .add-to-cart-button');
  }

  function clearPdpPromiseClasses(node) {
    if (!node || !node.classList) return;
    Array.prototype.slice.call(node.classList).forEach(function (className) {
      if (/^tk9-promise-buy-block/.test(className)) node.classList.remove(className);
    });
  }

  function markPdpPromiseLayout(form, entry) {
    var stateClass = inventoryPromiseClass(entry);
    var nodes = [
      form,
      form && form.querySelector && form.querySelector(".product-form-buttons"),
      form && form.closest && form.closest(".buy-buttons-block")
    ].filter(Boolean);
    nodes.forEach(function (node) {
      clearPdpPromiseClasses(node);
      if (!entry) return;
      node.classList.add("tk9-promise-buy-block");
      node.classList.add("tk9-promise-buy-block--" + stateClass);
    });
  }

  function pdpAddButtonLabel(entry) {
    var surface = inventoryPromiseSurface(entry);
    var label = String(surface.ctaLabel || "").trim();
    if (/ships?\s*separately|split\s*ship/i.test(label)) return "";
    return "";
  }

  function setPdpAddButtonLabel(form, entry) {
    var button = pdpAddButton(form);
    if (!button) return;
    var label = pdpAddButtonLabel(entry);
    if (button.tagName === "INPUT") {
      if (!button.hasAttribute("data-tk9-original-atc-label")) button.setAttribute("data-tk9-original-atc-label", String(button.value || "").trim());
      button.value = label || button.getAttribute("data-tk9-original-atc-label") || "Add to Cart";
      return;
    }
    var textNode = button.querySelector(".add-to-cart-text__content");
    if (!textNode) return;
    if (!textNode.hasAttribute("data-tk9-original-atc-label")) textNode.setAttribute("data-tk9-original-atc-label", String(textNode.textContent || "").trim());
    textNode.textContent = label || textNode.getAttribute("data-tk9-original-atc-label") || "Add to Cart";
    if (label) button.setAttribute("aria-label", label);
    else button.removeAttribute("aria-label");
  }

  function insertAfter(reference, node) {
    if (!reference || !reference.parentNode || !node) return false;
    reference.parentNode.insertBefore(node, reference.nextSibling);
    return true;
  }

  function ensurePdpPromiseStack(form) {
    if (!form) return null;
    var stack = form.querySelector("[data-tk9-pdp-promise-stack]");
    if (!stack) {
      stack = document.createElement("div");
      stack.setAttribute("data-tk9-pdp-promise-stack", "1");
      stack.className = "tk9-pdp-promise-stack";
    }
    var button = pdpAddButton(form);
    var buttonRow = button && button.closest && button.closest(".product-form-buttons");
    var buttonWrap = button && button.closest && button.closest(".add-to-cart-wrapper") || button;
    var reference = buttonRow || buttonWrap || null;
    if (reference && reference.parentNode) {
      if (stack.parentNode !== reference.parentNode || stack.previousSibling !== reference) {
        reference.parentNode.insertBefore(stack, reference.nextSibling);
      }
      return stack;
    }
    if (!stack.parentNode) form.appendChild(stack);
    return stack;
  }

  function ensurePdpPromiseNode(form, slot) {
    if (!form) return null;
    var selector = '[data-tk9-pdp-promise="' + slot + '"]';
    var node = form.querySelector(selector);
    if (!node) {
      node = document.createElement("div");
      node.setAttribute("data-tk9-pdp-promise", slot);
      node.setAttribute("aria-live", "polite");
    }
    if (slot === "status" || slot === "delivery" || slot === "proof") {
      var stack = ensurePdpPromiseStack(form);
      if (!stack) return node;
      var reference = null;
      if (slot === "delivery") {
        reference = stack.querySelector('[data-tk9-pdp-promise="status"]');
      }
      if (slot === "proof") {
        reference = stack.querySelector('[data-tk9-pdp-promise="delivery"]') || stack.querySelector('[data-tk9-pdp-promise="status"]');
      }
      if (reference && reference.parentNode === stack) {
        if (node.parentNode !== stack || node.previousSibling !== reference) {
          stack.insertBefore(node, reference.nextSibling);
        }
      } else if (node.parentNode !== stack) {
        stack.insertBefore(node, stack.firstChild);
      }
      return node;
    }
    if (node.parentNode) return node;
    form.appendChild(node);
    return node;
  }

  function setPdpPromiseNode(node, text, entry, slot) {
    if (!node) return;
    var stateClass = slot === "status" ? inventoryPdpStatusClass(entry) : inventoryPromiseClass(entry);
    node.className = "tk9-pdp-promise tk9-pdp-promise--" + slot + " tk9-pdp-promise--" + stateClass;
    node.setAttribute("data-tk9-promise-state", inventoryPromiseState(entry));
    if (!text) {
      node.hidden = true;
      node.textContent = "";
      return;
    }
    node.hidden = false;
    node.innerHTML = slot === "proof"
      ? inventoryProofDisplayHtml(entry, text)
      : slot === "delivery"
        ? inventoryDeliveryDisplayHtml(entry, text)
        : inventoryPromiseDisplayHtml(text);
  }

  function inventoryDeliveryIcon(entry, text) {
    var value = normalizeText(text || "");
    if (/ship separately|arrive separately|separate packages/.test(value)) return "⚡";
    if (/order in|order now|order today|get it|processing/.test(value)) return "⌛";
    return "";
  }

  function inventoryDeliveryDisplayHtml(entry, text) {
    var icon = inventoryDeliveryIcon(entry, text);
    var bodyText = String(text || "").replace(/^[\s⌛⚡]+/, "").trim();
    var body = escapeHtml(bodyText);
    if (!body) return "";
    return (icon ? '<span class="tk9-pdp-delivery-icon" aria-hidden="true">' + icon + '</span>' : "") +
      '<span class="tk9-pdp-delivery-text">' + body + '</span>';
  }

  function inventoryPromiseDisplayHtml(text) {
    var value = String(text || "").trim();
    var normalizedValue = normalizeText(value);
    if (normalizeText(value) === normalizeText("IN STOCK · SHIPS SEPARATELY")) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">IN STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Bundle items may ship separately</span>';
    }
    if (normalizeText(value) === normalizeText("IN STOCK · Claim yours while available")) {
      return "IN STOCK";
    }
    if (normalizeText(value) === normalizeText("IN STOCK · Claim yours while supplies last")) {
      return "IN STOCK";
    }
    if (normalizedValue === normalizeText("IN STOCK · Ready to ship")) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">IN STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive"> · Ready to ship</span>';
    }
    if (normalizeText(value) === normalizeText("IN STOCK · Bundle ships separately")) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">IN STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Bundle items may ship separately</span>';
    }
    if (normalizedValue === normalizeText("IN STOCK · Cover ships first, bed follows")) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">IN STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Bundle items may ship separately</span>';
    }
    if (normalizedValue === normalizeText("IN STOCK · Bundle items ship separately")) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">IN STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Bundle items may ship separately</span>';
    }
    if (normalizedValue === normalizeText("IN STOCK · Bundle items may ship separately")) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">IN STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Bundle items may ship separately</span>';
    }
    if (
      normalizedValue === normalizeText("IN STOCK · Bundle items may ship separately") ||
      normalizedValue === normalizeText("LOW STOCK · Bundle items may ship separately")
    ) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">IN STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Bundle items may ship separately</span>';
    }
    if (normalizedValue === normalizeText("IN STOCK · Bundle items may arrive separately")) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">IN STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Bundle items may ship separately</span>';
    }
    if (
      normalizedValue === normalizeText("Bundle items may ship separately") ||
      normalizedValue === normalizeText("Bundle items may arrive separately") ||
      normalizedValue === normalizeText("May ship separately") ||
      normalizedValue === normalizeText("May arrive separately")
    ) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution">Bundle items may ship separately</span>';
    }
    if (
      normalizedValue === normalizeText("LOW STOCK ALERT · Ready to ship") ||
      normalizedValue === normalizeText("LOW STOCK · Ready to ship")
    ) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--danger">LOW STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive"> · Ready to ship</span>';
    }
    if (
      normalizedValue === normalizeText("LOW STOCK ALERT") ||
      normalizedValue === normalizeText("LOW STOCK")
    ) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--danger">LOW STOCK</span>';
    }
    var lowSplitMatch = value.match(/^LOW STOCK(?:\s+ALERT)?\s*[·-]\s*(Bundle items|Items|May) may (?:arrive|ship) separately(?:\s*(?:for faster delivery))?(?:\s*[·-]\s*(Only\s+\d+\s+left|Limited stock available))?$/i);
    if (lowSplitMatch) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--danger">LOW STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Bundle items may ship separately</span>' +
        (lowSplitMatch[2] ? '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--danger"> · ' + escapeHtml(lowSplitMatch[2]) + '</span>' : "");
    }
    if (normalizeText(value) === normalizeText("IN STOCK · BUNDLE ITEMS SHIP SEPARATELY")) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">IN STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Bundle items may ship separately</span>';
    }
    if (normalizeText(value) === normalizeText("IN STOCK · ships separately for faster delivery")) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">IN STOCK</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Bundle items may ship separately</span>';
    }
    if (
      normalizedValue === normalizeText("CUSTOM PATCH · Ships separately") ||
      normalizedValue === normalizeText("MADE TO ORDER · Ships separately") ||
      normalizedValue === normalizeText("MADE TO ORDER · Ships separately after printing") ||
      normalizedValue === normalizeText("MADE TO ORDER · Ships after printing")
    ) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">MADE TO ORDER</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Ships after printing</span>';
    }
    if (
      normalizedValue === normalizeText("AVAILABLE NOW · Ships direct") ||
      normalizedValue === normalizeText("AVAILABLE NOW · Ships direct with tracking") ||
      normalizedValue === normalizeText("AVAILABLE NOW · Ships direct in 5-11 business days") ||
      normalizedValue === normalizeText("AVAILABLE NOW · Arrives in 5-11 business days") ||
      normalizedValue === normalizeText("AVAILABLE NOW · Ships direct with tracking") ||
      normalizedValue === normalizeText("AVAILABLE · Ships direct with tracking") ||
      normalizedValue === normalizeText("AVAILABLE · Ships direct with tracking") ||
      normalizedValue === normalizeText("Ships direct with tracking")
    ) {
      return '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--positive">AVAILABLE NOW</span>' +
        '<span class="tk9-inventory-promise-part tk9-inventory-promise-part--caution"> · Ships direct with tracking</span>';
    }
    return escapeHtml(value);
  }

  function selectedVariantPromiseEntry() {
    var variantId = selectedPdpVariantId();
    var entry = inventoryPromiseEntry(variantId);
    return inventoryFallbackPromiseEntry(variantId, entry);
  }

  function inventoryAvailabilityFallbackState(variantId, entry) {
    if (entry) return "";
    var availability = variantAvailabilityEntry(variantId);
    if (!availability) return "";
    var stateName = String(availability.availabilityState || "").trim();
    if (availability.available === false || stateName === "out_of_stock" || stateName === "unavailable") return "";
    if (availability.inStock === true || stateName === "in_stock" || availability.available === true) return "direct_ship";
    return "";
  }

  function inventoryAvailabilityFallbackPromiseEntry(variantId) {
    var id = String(variantId || "").trim();
    var fallbackState = inventoryAvailabilityFallbackState(id, null);
    if (!fallbackState) return null;
    var availability = variantAvailabilityEntry(id) || {};
    var promiseLine = "AVAILABLE NOW · Ships direct with tracking";
    return {
      id: id,
      key: id,
      source: "shopify_availability_fallback",
      productHandle: String(availability.productHandle || ""),
      productTitle: String(availability.productTitle || ""),
      variantTitle: String(availability.variantTitle || ""),
      shopifyVariantId: id,
      sku: String(availability.sku || ""),
      state: fallbackState,
      facts: {},
      routePromise: {
        routeProfile: "direct_tracked",
        dominantCarrier: "yunexpress",
        showPdpGetItBy: false,
        pdpDeliveryText: "Ships direct with tracking",
        cartLine: "AVAILABLE NOW · Ships direct with tracking"
      },
      surfaceCopy: {
        promiseState: fallbackState,
        variantSupport: "AVAILABLE NOW",
        ctaLabel: "Add to Cart",
        ctaSupport: "",
        cartLine: promiseLine,
        checkoutLine: "",
        emailFlowKey: "direct_tracked",
        supportContext: "direct_tracked_fallback",
        lineItemProperties: {
          _promise_state: fallbackState,
          _promise_line: promiseLine,
          _email_flow_key: "direct_tracked",
          _support_context: "direct_tracked_fallback",
          _promise_route: "direct_tracked",
          _promise_delivery_window: "direct tracked delivery"
        }
      },
      customer: {
        badge: "AVAILABLE NOW",
        buttonLabel: "Add to Cart",
        pdpNote: "Ships direct with tracking",
        cartNote: "AVAILABLE NOW · Ships direct with tracking"
      }
    };
  }

  function inventoryFallbackPromiseEntry(variantId, entry) {
    if (!config.inventoryPromiseEnabled) return null;
    return entry || manualDirectShipPromiseEntry(variantId) || inventoryAvailabilityFallbackPromiseEntry(variantId) || null;
  }

  function removePdpPromiseSlot(slot) {
    Array.prototype.slice.call(document.querySelectorAll('[data-tk9-pdp-promise="' + slot + '"]')).forEach(function (node) {
      node.remove();
    });
  }

  function isVisibleElement(node) {
    return Boolean(node && (node.offsetWidth || node.offsetHeight || node.getClientRects().length));
  }

  function selectedInventoryStatusTarget() {
    var swatchOptions = Array.prototype.slice.call(document.querySelectorAll("[option-name]"));
    for (var swatchIndex = 0; swatchIndex < swatchOptions.length; swatchIndex += 1) {
      var swatchOption = swatchOptions[swatchIndex];
      var swatchName = (swatchOption.getAttribute("option-name") || "") + " " + (swatchOption.textContent || "");
      if (!/bundle|kit|setup/i.test(swatchName)) continue;
      var swatchLabel = swatchOption.querySelector(".swatch-label:not(.visually-hidden-label)") || swatchOption.querySelector(".swatch-option-name");
      if (isVisibleElement(swatchLabel)) return swatchLabel;
    }

    var selectedId = selectedPdpVariantId();
    var fieldsets = Array.prototype.slice.call(document.querySelectorAll("variant-picker fieldset.variant-option, fieldset.variant-option"));
    for (var index = 0; index < fieldsets.length; index += 1) {
      var fieldset = fieldsets[index];
      var checked = fieldset.querySelector("input:checked[data-variant-id], input:checked");
      var labelText = ((fieldset.querySelector("legend") || {}).textContent || "") + " " + ((checked && checked.name) || "");
      if (!/bundle|kit|setup/i.test(labelText)) continue;
      if (checked && checked.getAttribute("data-variant-id") && String(checked.getAttribute("data-variant-id")) !== String(selectedId)) continue;
      return fieldset.querySelector("legend");
    }
    return null;
  }

  function inventoryInlinePromiseText(entry) {
    return "";
  }

  function inventoryIsLowStockPresentation(entry) {
    if (!entry) return false;
    var stateName = inventoryPromiseState(entry);
    var route = inventoryRoutePromise(entry);
    var routeProfile = String(route.routeProfile || "").trim();
    if (routeProfile === "direct_tracked" || routeProfile === "yunexpress") return false;
    if (stateName === "alert_me" || stateName === "alert_only" || stateName === "hold_or_notify" || stateName === "out_of_stock" || stateName === "do_not_sell") return false;
    if (stateName === "reserve" || stateName === "backorder_sellable" || stateName === "production_backorder") return false;
    return stateName === "low_stock" || inventoryHasLowStockSignal(entry) || inventoryLowStockAvailable(entry) !== null;
  }

  function inventoryPdpPromiseText(entry) {
    if (!entry) return "";
    var promiseState = inventoryPromiseState(entry);
    if (inventoryIsLowStockPresentation(entry)) {
      return "LOW STOCK ALERT";
    }
    if (promiseState === "ships_now" || promiseState === "ready_to_ship") return "IN STOCK";
    if (promiseState === "available_now") return "AVAILABLE NOW";
    if (promiseState === "low_stock" && String(inventoryRoutePromise(entry).routeProfile || "").trim() === "direct_tracked") return "AVAILABLE NOW";
    if (promiseState === "ships_in_parts" || promiseState === "split_ship" || promiseState === "split_bundle") return "IN STOCK";
    if (promiseState === "direct_ship" || promiseState === "delayed_delivery") return "AVAILABLE NOW";
    if (promiseState === "reserve" || promiseState === "backorder_sellable" || promiseState === "production_backorder") return "RESERVE YOURS";
    if (promiseState === "alert_me" || promiseState === "alert_only" || promiseState === "hold_or_notify") return "SOLD OUT";
    if (promiseState === "out_of_stock" || promiseState === "do_not_sell") return "SOLD OUT";
    return "";
  }

  function deliveryDaysForPromiseState(stateName) {
    if (stateName === "ships_now" || stateName === "ready_to_ship" || stateName === "low_stock") return 5;
    if (stateName === "direct_ship" || stateName === "delayed_delivery" || stateName === "ships_in_parts" || stateName === "split_ship" || stateName === "split_bundle") return 11;
    if (stateName === "reserve" || stateName === "backorder_sellable" || stateName === "production_backorder") return 11;
    return 0;
  }

  function addBusinessDays(date, days) {
    var result = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 0, 0);
    var remaining = Math.max(0, Number(days) || 0);
    while (remaining > 0) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) remaining -= 1;
    }
    return result;
  }

  function isBusinessDay(date) {
    var day = (date || new Date()).getDay();
    return day !== 0 && day !== 6;
  }

  function centralTimeParts(date) {
    try {
      var parts = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Chicago",
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      }).formatToParts(date || new Date()).reduce(function (acc, part) {
        acc[part.type] = part.value;
        return acc;
      }, {});
      return {
        hour: Number(parts.hour || 0),
        minute: Number(parts.minute || 0),
        second: Number(parts.second || 0),
      };
    } catch (error) {
      var fallback = date || new Date();
      return {
        hour: fallback.getHours(),
        minute: fallback.getMinutes(),
        second: fallback.getSeconds(),
      };
    }
  }

  function minutesUntilSameDayOrderCutoff() {
    var parts = centralTimeParts(new Date());
    var nowMinutes = (parts.hour * 60) + parts.minute + (parts.second / 60);
    var cutoffMinutes = (18 * 60) + 15;
    return Math.round(cutoffMinutes - nowMinutes);
  }

  function minutesUntilOrderCutoff() {
    var minutes = minutesUntilSameDayOrderCutoff();
    if (minutes <= 0) minutes += 24 * 60;
    return Math.max(1, Math.round(minutes));
  }

  function cutoffCountdownText() {
    var minutes = minutesUntilSameDayOrderCutoff();
    if (minutes <= 0 || minutes > processingCountdownWindowMinutes()) return "";
    var hours = Math.floor(minutes / 60);
    var remainder = minutes % 60;
    var prefix = "Order in ";
    if (hours <= 0) return prefix + remainder + "m";
    return prefix + hours + "h " + remainder + "m";
  }

  function shouldShowProcessingCountdown() {
    var sameDayCutoffMinutes = minutesUntilSameDayOrderCutoff();
    return sameDayCutoffMinutes > 0 && sameDayCutoffMinutes <= processingCountdownWindowMinutes();
  }

  function orderPromiseLeadText() {
    return shouldShowProcessingCountdown() ? cutoffCountdownText() : "Order now";
  }

  function processingCutoffPromiseText() {
    if (!shouldShowProcessingCountdown()) return "";
    return cutoffCountdownText() + " for today's processing";
  }

  function domesticDeliveryPromiseText() {
    return orderPromiseLeadText() + " for delivery in 1 week or less";
  }

  function formatGetItBy(days) {
    if (!days) return "";
    return orderPromiseLeadText() + " for delivery in 1 week or less";
  }

  function inventoryIsKnownCoverBedSplit(entry) {
    if (!entry) return false;
    if (String(entry.productHandle || "") !== "hard-bottom-csce") return false;
    var haystack = [
      entry.sku,
      entry.variantTitle,
      entry.surfaceCopy && entry.surfaceCopy.variantLabel,
      entry.customer && entry.customer.badge
    ].join(" ");
    return /cover[_\s-]*bed|plush\s+bed|backseat\s+dog\s+bed/i.test(haystack);
  }

  function inventoryHasSeparateBundleSignal(entry) {
    if (!entry) return false;
    var stateName = inventoryPromiseState(entry);
    var shipmentStructure = String(entry.shipmentStructure || "").toLowerCase();
    if (
      shipmentStructure !== "split" &&
      stateName !== "ships_in_parts" &&
      stateName !== "split_ship" &&
      stateName !== "split_bundle"
    ) {
      return false;
    }
    var surface = inventoryPromiseSurface(entry);
    var customer = entry.customer || {};
    var route = inventoryRoutePromise(entry);
    var haystack = [
      entry.state,
      entry.variantTitle,
      surface.cartLine,
      surface.checkoutLine,
      surface.emailSubject,
      surface.emailPreview,
      surface.emailBody,
      customer.pdpNote,
      customer.cartNote,
      customer.checkoutNote,
      route.pdpDeliveryText,
      route.cartLine
    ].join(" ");
    return inventoryIsKnownCoverBedSplit(entry) || /may\s+(?:ship|arrive)\s+separately|separate\s+packages|bundle\s+items/i.test(haystack);
  }

  function inventorySplitShipText(entry) {
    return "Bundle items may ship separately";
  }

  function inventoryRoutePromise(entry) {
    return entry && entry.routePromise && typeof entry.routePromise === "object" ? entry.routePromise : {};
  }

  function inventoryNormalizeRouteDeliveryText(text) {
    var value = String(text || "").trim();
    var normalized = normalizeText(value);
    if (
      normalized === normalizeText("Bundle items may arrive separately") ||
      normalized === normalizeText("Bundle items may ship separately") ||
      normalized === normalizeText("May arrive in separate packages") ||
      normalized === normalizeText("May arrive separately") ||
      normalized === normalizeText("May ship separately") ||
      normalized === normalizeText("May ship separately for faster delivery") ||
      normalized === normalizeText("Bundle items may ship separately for faster delivery") ||
      normalized === normalizeText("Bundle items may ship separately")
    ) {
      return "IN STOCK · " + inventorySplitShipText();
    }
    if (
      normalized === normalizeText("Ships direct with tracking")
    ) {
      return "Ships direct with tracking";
    }
    return value;
  }

  function inventoryNormalizeRouteCartLine(text) {
    var value = String(text || "").trim();
    var normalized = normalizeText(value);
    if (
      normalized === normalizeText("IN STOCK · Bundle items may arrive separately") ||
      normalized === normalizeText("IN STOCK · Bundle items may ship separately") ||
      normalized === normalizeText("BUNDLE AVAILABLE · May arrive separately") ||
      normalized === normalizeText("BUNDLE AVAILABLE · May ship separately") ||
      normalized === normalizeText("BUNDLE AVAILABLE · May ship separately for faster delivery")
    ) {
      return "IN STOCK · " + inventorySplitShipText();
    }
    if (
      normalized === normalizeText("AVAILABLE NOW · Ships direct with tracking") ||
      normalized === normalizeText("AVAILABLE · Ships direct with tracking") ||
      normalized === normalizeText("AVAILABLE · Ships direct with tracking") ||
      normalized === normalizeText("AVAILABLE NOW · Ships direct with tracking") ||
      normalized === normalizeText("Ships direct with tracking")
    ) {
      return "AVAILABLE NOW · Ships direct with tracking";
    }
    return value;
  }

  function inventoryNormalizeStoredPromiseLine(text) {
    var value = inventoryNormalizeRouteCartLine(text);
    if (!value) return "";
    var normalized = normalizeText(value);
    if (normalized.indexOf(normalizeText("LOW STOCK ALERT")) === 0) {
      return value.replace(/^LOW STOCK ALERT\b/i, "LOW STOCK");
    }
    if (
      normalized === normalizeText("LOW STOCK · Bundle items may arrive separately") ||
      normalized === normalizeText("LOW STOCK · Bundle items may ship separately") ||
      normalized === normalizeText("LOW STOCK · May ship separately") ||
      normalized === normalizeText("LOW STOCK · May arrive separately")
    ) {
      return "IN STOCK · " + inventorySplitShipText();
    }
    return value;
  }

  function inventoryNormalizeSurfacePromiseText(text) {
    var value = inventoryNormalizeStoredPromiseLine(text);
    if (!value) return "";
    var normalized = normalizeText(value);
    if (/^low stock alert\b/i.test(value)) return value.replace(/^LOW STOCK ALERT\b/i, "LOW STOCK");
    if (
      normalized === normalizeText("IN STOCK · Bundle items may arrive separately") ||
      normalized === normalizeText("IN STOCK · Bundle items may ship separately")
    ) {
      return inventorySplitShipText();
    }
    if (
      normalized === normalizeText("AVAILABLE NOW · Ships direct with tracking") ||
      normalized === normalizeText("AVAILABLE NOW · Ships direct with tracking") ||
      normalized === normalizeText("Ships direct with tracking")
    ) {
      return "Ships direct with tracking";
    }
    return value;
  }

  function inventoryRouteDeliveryText(entry, fallbackText) {
    var route = inventoryRoutePromise(entry);
    return inventoryNormalizeRouteDeliveryText(route.pdpDeliveryText || fallbackText || "");
  }

  function inventoryRouteCartLine(entry, fallbackText) {
    var route = inventoryRoutePromise(entry);
    return inventoryNormalizeRouteCartLine(route.cartLine || fallbackText || "");
  }

  function inventoryGetItByBusinessDays(entry, stateName) {
    var route = inventoryRoutePromise(entry);
    if (route && route.showPdpGetItBy === false) return 0;
    var routeDays = Number(route && route.getItByBusinessDays);
    if (Number.isFinite(routeDays) && routeDays > 0) return routeDays;
    return deliveryDaysForPromiseState(stateName);
  }

  function inventoryDomesticDeliveryText(entry, stateName) {
    var route = inventoryRoutePromise(entry);
    var routeProfile = String(route.routeProfile || "").trim();
    if (routeProfile === "fedex_cover" || routeProfile === "fedex_bed") {
      return domesticDeliveryPromiseText();
    }
    if (routeProfile === "usps_harness" || routeProfile === "usps_accessory") {
      return domesticDeliveryPromiseText();
    }

    var days = inventoryGetItByBusinessDays(entry, stateName);
    if (days > 0 && days <= 7) return domesticDeliveryPromiseText();
    return formatGetItBy(days);
  }

  function inventoryDeliveryText(entry) {
    if (!entry) return "";
    var stateName = inventoryPromiseState(entry);
    if (inventoryHasSeparateBundleSignal(entry)) return inventorySplitShipText(entry);
    if (stateName === "ships_in_parts" || stateName === "split_ship" || stateName === "split_bundle") {
      return inventoryRouteDeliveryText(entry, inventorySplitShipText(entry));
    }
    if (stateName === "direct_ship" || stateName === "delayed_delivery") return inventoryRouteDeliveryText(entry, "Ships direct with tracking");
    if (stateName === "low_stock" && String(inventoryRoutePromise(entry).routeProfile || "").trim() === "direct_tracked") return inventoryRouteDeliveryText(entry, "Ships direct with tracking");
    if (stateName === "available_now") return "";
    if (stateName === "reserve" || stateName === "backorder_sellable" || stateName === "production_backorder") return inventoryRouteDeliveryText(entry, "Next batch on the way");
    if (stateName === "alert_me" || stateName === "alert_only" || stateName === "hold_or_notify" || stateName === "out_of_stock" || stateName === "do_not_sell") return "Get alerted when it's back";
    if (stateName !== "ships_now" && stateName !== "ready_to_ship" && stateName !== "low_stock") return "";
    return inventoryDomesticDeliveryText(entry, stateName);
  }

  function roundedInventoryVelocity(value) {
    var number = inventoryNumber(value);
    if (number === null || number <= 0) return 0;
    return Math.max(1, Math.round(number));
  }

  function inventoryAllEntries() {
    var manifest = state.inventoryPromise || {};
    return Object.values(manifest.variants || {}).concat(Object.values(manifest.bundles || {}));
  }

  function inventoryProofMetrics() {
    var manifest = state.inventoryPromise || {};
    return manifest.proofMetrics && typeof manifest.proofMetrics === "object" ? manifest.proofMetrics : {};
  }

  function inventoryProofVerifiedAt(fieldName, metricRecord) {
    var proof = inventoryProofMetrics();
    var field = String(fieldName || "");
    var isViewMetric = /view/i.test(field);
    return (
      metricRecord && (metricRecord.proofVerifiedAt || metricRecord.verifiedAt) ||
      (isViewMetric ? proof.viewVerifiedAt : proof.verifiedAt) ||
      ""
    );
  }

  function inventoryProofFreshnessWindowMs(fieldName) {
    var field = String(fieldName || "");
    if (/view/i.test(field)) return 30 * 60 * 1000;
    if (/week/i.test(field)) return 36 * 60 * 60 * 1000;
    if (/sold|today|24|4/i.test(field)) return 90 * 60 * 1000;
    return 90 * 60 * 1000;
  }

  function inventoryProofMetricIsFresh(fieldName, metricRecord) {
    var verifiedAt = inventoryProofVerifiedAt(fieldName, metricRecord);
    var verifiedMs = Date.parse(verifiedAt || "");
    if (!Number.isFinite(verifiedMs)) return false;
    var ageMs = Date.now() - verifiedMs;
    if (ageMs < -5 * 60 * 1000) return false;
    if (ageMs < 0) ageMs = 0;
    return ageMs <= inventoryProofFreshnessWindowMs(fieldName);
  }

  function inventoryProofMetricIsVerified(fieldName, metricRecord) {
    var proof = inventoryProofMetrics();
    var field = String(fieldName || "");
    var isViewMetric = /view/i.test(field);
    var source = String(
      metricRecord && metricRecord.proofSource ||
      metricRecord && metricRecord.source ||
      (isViewMetric ? proof.viewSource : proof.source) ||
      ""
    ).trim();

    if (!inventoryProofMetricIsFresh(fieldName, metricRecord)) return false;
    if (isViewMetric) return Boolean(source && source !== "shopify_orders");
    return source === "shopify_orders";
  }

  function inventoryProductProofMetric(entry, fieldName) {
    if (!entry || !entry.productHandle) return 0;
    var proof = inventoryProofMetrics();
    if (!inventoryProofMetricIsVerified(fieldName, proof)) return 0;
    var products = proof.products && typeof proof.products === "object" ? proof.products : {};
    var product = products[entry.productHandle] || {};
    return inventoryNumber(product[fieldName]) || 0;
  }

  function inventoryEntryProofMetric(entry, fieldName) {
    var facts = entry && entry.facts || {};
    if (!inventoryProofMetricIsVerified(fieldName, facts)) return 0;
    return inventoryNumber(facts[fieldName]) || 0;
  }

  function inventoryLiveActivitySessionId() {
    if (state.inventoryLiveActivity.sessionId) return state.inventoryLiveActivity.sessionId;
    var key = "tk9_inventory_live_activity_session_id";
    try {
      var stored = window.sessionStorage.getItem(key);
      if (stored) {
        state.inventoryLiveActivity.sessionId = stored;
        return stored;
      }
      var next = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + "-" + Math.random().toString(16).slice(2);
      window.sessionStorage.setItem(key, next);
      state.inventoryLiveActivity.sessionId = next;
      return next;
    } catch (error) {
      state.inventoryLiveActivity.sessionId = String(Date.now()) + "-" + Math.random().toString(16).slice(2);
      return state.inventoryLiveActivity.sessionId;
    }
  }

  function inventoryLiveActivityEndpoint() {
    return String(config.liveActivityEndpoint || "").trim();
  }

  function inventoryLiveActivityCount(entry) {
    var handle = String(entry && entry.productHandle || "").trim();
    if (!handle) return 0;
    var checkedAt = Number(state.inventoryLiveActivity.lastChecked[handle] || 0);
    if (!checkedAt || Date.now() - checkedAt > 45000) return 0;
    return inventoryNumber(state.inventoryLiveActivity.counts[handle]) || 0;
  }

  function inventoryLiveActivityBadge(entry) {
    var count = inventoryLiveActivityCount(entry);
    if (count >= 3) return inventoryProofBadge("attention", count + " viewing now");
    return null;
  }

  function requestInventoryLiveActivity(entry, options) {
    if (!entry || !entry.productHandle || !/^\/products\//.test(window.location.pathname || "")) return;
    var endpoint = inventoryLiveActivityEndpoint();
    if (!endpoint) return;
    var handle = String(entry.productHandle || "").trim();
    if (!handle) return;
    var now = Date.now();
    var force = options && options.force;
    if (!force && now - Number(state.inventoryLiveActivity.lastChecked[handle] || 0) < 12000) return;
    if (state.inventoryLiveActivity.requests[handle]) return;

    var payload = {
      sessionId: inventoryLiveActivitySessionId(),
      scope: "product:" + handle,
      pageType: "product",
      productHandle: handle,
      productId: String(entry.shopifyProductId || ""),
      path: window.location.pathname,
      activeWindowSeconds: 90
    };

    state.inventoryLiveActivity.requests[handle] = fetch(endpoint, {
      method: "POST",
      cache: "no-store",
      credentials: "omit",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (!response.ok) throw new Error("live activity unavailable");
        return response.json();
      })
      .then(function (data) {
        var count = inventoryNumber(data && (data.activeViewers || data.count || data.viewers)) || 0;
        state.inventoryLiveActivity.counts[handle] = count;
        state.inventoryLiveActivity.lastChecked[handle] = Date.now();
        enhanceInventoryPromiseSurfaces();
      })
      .catch(function (error) {
        debugLog("inventory live activity unavailable", error);
      })
      .finally(function () {
        state.inventoryLiveActivity.requests[handle] = null;
      });
  }

  function startInventoryLiveActivity(entry) {
    if (!entry || !entry.productHandle) return;
    var handle = String(entry.productHandle || "").trim();
    if (!handle) return;
    requestInventoryLiveActivity(entry);
    if (state.inventoryLiveActivity.intervals[handle]) return;
    state.inventoryLiveActivity.intervals[handle] = window.setInterval(function () {
      var current = selectedVariantPromiseEntry();
      if (!current || String(current.productHandle || "") !== handle) return;
      requestInventoryLiveActivity(current, { force: true });
    }, 25000);
  }

  function inventoryProductMetric(entry, fieldName) {
    if (!entry || !entry.productHandle) return inventoryNumber(entry && entry.facts && entry.facts[fieldName]) || 0;
    return inventoryAllEntries().reduce(function (total, otherEntry) {
      if (!otherEntry || otherEntry.productHandle !== entry.productHandle) return total;
      if (otherEntry.components) return total;
      return total + (inventoryNumber(otherEntry && otherEntry.facts && otherEntry.facts[fieldName]) || 0);
    }, 0);
  }

  function inventoryProductVelocity(entry) {
    if (!entry || !entry.productHandle) return inventoryNumber(entry && entry.facts && entry.facts.dailyVelocity) || 0;
    return inventoryProductMetric(entry, "dailyVelocity");
  }

  function inventoryProductCurrentWeekSales(entry) {
    if (!entry || !entry.productHandle) return inventoryNumber(entry && entry.facts && entry.facts.currentWeekSales) || 0;
    var proofWeek = inventoryProductProofMetric(entry, "soldThisWeek");
    if (proofWeek) return proofWeek;
    return inventoryProductMetric(entry, "currentWeekSales");
  }

  function demandSalesText(count, options) {
    var weekly = Math.max(0, Math.round(Number(count) || 0));
    var suffix = options && options.setup ? " across this setup" : "";
    if (weekly >= 10) return weekly + " sold this week" + suffix;
    if (weekly >= 5) return weekly + " sold this week" + suffix;
    return "";
  }

  function inventoryProofBadge(type, text) {
    var value = String(text || "").trim();
    return value ? { type: type || "standard", text: value } : null;
  }

  function inventoryProofUnitLabel(entry) {
    return "";
  }

  function inventoryProofFamilyKey(entry) {
    var text = normalizeText([
      entry && entry.productHandle,
      entry && entry.productTitle,
      entry && entry.variantTitle,
      entry && entry.sku
    ].filter(Boolean).join(" "));
    if (/leash/.test(text)) return "leash";
    if (/collar/.test(text)) return "collar";
    if (/patch/.test(text)) return "patch";
    if (/bed/.test(text)) return "bed";
    if (/csce|seat cover|car seat cover|backseat cover/.test(text)) return "cover";
    if (/harness/.test(text)) return "harness";
    if (/fan/.test(text)) return "fan";
    return "";
  }

  function inventoryComponentFamilySkus(entry) {
    var facts = entry && entry.facts || {};
    if (Array.isArray(facts.componentSkus)) return facts.componentSkus.map(String);
    return [];
  }

  function inventoryComponentSkuMatchesFamily(sku, familyKey) {
    var value = String(sku || "").toUpperCase();
    if (!value || !familyKey) return false;
    if (familyKey === "leash") return /LEASH/.test(value);
    if (familyKey === "collar") return /COLLAR/.test(value);
    if (familyKey === "patch") return /PATCH/.test(value);
    if (familyKey === "bed") return /BED/.test(value);
    if (familyKey === "cover") return /CSCE|COVER/.test(value);
    if (familyKey === "harness") return /HARNESS|MBH/.test(value);
    if (familyKey === "fan") return /FAN/.test(value);
    return false;
  }

  function inventoryComponentFamilyProofMetric(entry, fieldName) {
    var familyKey = inventoryProofFamilyKey(entry);
    if (!familyKey) return 0;
    return inventoryAllEntries().reduce(function (total, otherEntry) {
      if (!otherEntry || otherEntry === entry) return total;
      var componentSkus = inventoryComponentFamilySkus(otherEntry);
      if (!componentSkus.length) return total;
      if (!componentSkus.some(function (sku) { return inventoryComponentSkuMatchesFamily(sku, familyKey); })) return total;
      return total + (inventoryEntryProofMetric(otherEntry, fieldName) || 0);
    }, 0);
  }

  function inventoryDemandBadgeFromCounts(entry, recentCount, todayCount, last24Count, weekCount) {
    var recent = Math.max(0, Math.round(Number(recentCount) || 0));
    var daily = Math.max(0, Math.round(Number(todayCount) || 0));
    var last24 = Math.max(0, Math.round(Number(last24Count) || 0));
    var weekly = Math.max(0, Math.round(Number(weekCount) || 0));
    if (recent >= 12) return inventoryProofBadge("velocity", "Hot right now · " + recent + " sold in 4h");
    if (recent >= 6) return inventoryProofBadge("velocity", "High demand · " + recent + " sold in 4h");
    if (last24 >= 50) return inventoryProofBadge("velocity", "Best seller · " + last24 + " sold in 24h");
    if (last24 >= 25) return inventoryProofBadge("velocity", "High demand · " + last24 + " sold in 24h");
    if (daily >= 15) return inventoryProofBadge("velocity", daily + " sold today");
    if (daily >= 8) return inventoryProofBadge("velocity", "Popular today");
    if (weekly >= 100) return inventoryProofBadge("velocity", "Best seller this week");
    if (weekly >= 50 && inventoryProofFamilyKey(entry) === "leash") return inventoryProofBadge("velocity", "Popular add-on this week");
    if (weekly >= 50) return inventoryProofBadge("velocity", "High demand this week");
    if (weekly >= 25) return inventoryProofBadge("velocity", "Popular this week");
    return null;
  }

  function inventoryAttentionBadgeFromCounts(entry, recentCount, todayCount, last24Count) {
    var recent = Math.max(0, Math.round(Number(recentCount) || 0));
    var daily = Math.max(0, Math.round(Number(todayCount) || 0));
    var last24 = Math.max(0, Math.round(Number(last24Count) || 0));
    if (recent >= 75) return inventoryProofBadge("attention", recent + " viewed last 4h");
    if (daily >= 120) return inventoryProofBadge("attention", daily + " viewed today");
    if (last24 >= 180) return inventoryProofBadge("attention", last24 + " viewed in 24h");
    return null;
  }

  function inventoryLowStockAvailable(entry) {
    var candidates = [];
    function addCandidate(candidateEntry) {
      if (!inventoryEntryHasOwnLowStockSignal(candidateEntry)) return;
      var candidateAvailable = inventoryNumber(candidateEntry && candidateEntry.facts && candidateEntry.facts.usAvailable);
      if (candidateAvailable !== null && candidateAvailable > 0 && candidateAvailable <= 30) candidates.push(candidateAvailable);
    }
    addCandidate(entry);
    inventoryComponentEntries(entry).forEach(addCandidate);
    if (!candidates.length) return null;
    return Math.min.apply(Math, candidates);
  }

  function inventorySurfaceProofBadges(surface) {
    if (!surface || !surface.proofLine) return [];
    if (!inventoryProofMetricIsVerified("sold", surface)) return [];
    return String(surface.proofLine || "")
      .split(/\s+·\s+/)
      .map(function (part) {
        var normalized = normalizeText(part);
        var type = /only|left|low stock|act fast/.test(normalized) ? "scarcity" : /sold|bought|viewed|popular|trending/.test(normalized) ? "velocity" : "standard";
        return inventoryProofBadge(type, part);
      })
      .filter(Boolean)
      .slice(0, 2);
  }

  function inventoryProofBadges(entry) {
    if (!entry) return [];
    var surface = inventoryPromiseSurface(entry);
    var surfaceBadges = inventorySurfaceProofBadges(surface);
    if (surfaceBadges.length) return surfaceBadges;
    var promiseState = inventoryPromiseState(entry);
    var soldToday = inventoryEntryProofMetric(entry, "soldToday") || inventoryEntryProofMetric(entry, "todaySales");
    var soldLast4Hours = inventoryEntryProofMetric(entry, "soldLast4Hours");
    var soldLast24Hours = inventoryEntryProofMetric(entry, "soldLast24Hours");
    var soldThisWeek = inventoryEntryProofMetric(entry, "soldThisWeek");
    var viewedToday = inventoryEntryProofMetric(entry, "viewedToday") || inventoryEntryProofMetric(entry, "todayViews");
    var viewedLast4Hours = inventoryEntryProofMetric(entry, "viewedLast4Hours") || inventoryEntryProofMetric(entry, "last4HourViews");
    var viewedLast24Hours = inventoryEntryProofMetric(entry, "viewedLast24Hours") || inventoryEntryProofMetric(entry, "last24HourViews");
    var productWeekSales = inventoryProductProofMetric(entry, "soldThisWeek") || soldThisWeek;
    var productTodaySales = inventoryProductProofMetric(entry, "soldToday") || inventoryProductProofMetric(entry, "todaySales") || soldToday;
    var productRecentSales = inventoryProductProofMetric(entry, "soldLast4Hours") || soldLast4Hours;
    var productLast24Sales = inventoryProductProofMetric(entry, "soldLast24Hours") || soldLast24Hours;
    var componentWeekSales = inventoryComponentFamilyProofMetric(entry, "soldThisWeek");
    var componentTodaySales = inventoryComponentFamilyProofMetric(entry, "soldToday");
    var componentRecentSales = inventoryComponentFamilyProofMetric(entry, "soldLast4Hours");
    var componentLast24Sales = inventoryComponentFamilyProofMetric(entry, "soldLast24Hours");
    var productViewedToday = inventoryProductProofMetric(entry, "viewedToday") || inventoryProductProofMetric(entry, "todayViews") || viewedToday;
    var productViewedRecent = inventoryProductProofMetric(entry, "viewedLast4Hours") || inventoryProductProofMetric(entry, "last4HourViews") || viewedLast4Hours;
    var productViewedLast24 = inventoryProductProofMetric(entry, "viewedLast24Hours") || inventoryProductProofMetric(entry, "last24HourViews") || viewedLast24Hours;
    var proofRecentSales = Math.max(productRecentSales, componentRecentSales, soldLast4Hours);
    var proofTodaySales = Math.max(productTodaySales, componentTodaySales, soldToday);
    var proofLast24Sales = Math.max(productLast24Sales, componentLast24Sales, soldLast24Hours);
    var proofWeekSales = Math.max(productWeekSales, componentWeekSales, soldThisWeek);
    var demandBadge = inventoryDemandBadgeFromCounts(
      entry,
      proofRecentSales,
      proofTodaySales,
      proofLast24Sales,
      proofWeekSales
    );
    var attentionBadge = inventoryAttentionBadgeFromCounts(
      entry,
      Math.max(productViewedRecent, viewedLast4Hours),
      Math.max(productViewedToday, viewedToday),
      Math.max(productViewedLast24, viewedLast24Hours)
    ) || inventoryLiveActivityBadge(entry);
    var scarcityAvailable = inventoryLowStockAvailable(entry);
    var lowStockHasMomentum = proofRecentSales >= 3 || proofTodaySales >= 5 || proofLast24Sales >= 12 || proofWeekSales >= 25;
    var badges = [];

    if (scarcityAvailable !== null) {
      if (scarcityAvailable <= 25) badges.push(inventoryProofBadge("scarcity", "Only " + scarcityAvailable + " left"));
      else badges.push(inventoryProofBadge("scarcity", "Limited stock available"));
      if (demandBadge && lowStockHasMomentum && badges.length < 2) badges.push(demandBadge);
    } else if (demandBadge) {
      badges.push(demandBadge);
    }
    if (attentionBadge && badges.length < 2) badges.push(attentionBadge);

    if (badges.length) return badges.filter(Boolean).slice(0, 2);

    return [];
  }

  function inventoryProofText(entry) {
    return inventoryProofBadges(entry).map(function (badge) { return badge.text; }).join(" · ");
  }

  function inventoryProofDisplayHtml(entry, text) {
    var badges = inventoryProofBadges(entry);
    if (!badges.length && text) {
      badges = String(text || "")
        .split(/\s+·\s+/)
        .map(function (part) { return inventoryProofBadge("standard", part); })
        .filter(Boolean)
        .slice(0, 2);
    }
    return badges.map(function (badge) {
      var icon = "";
      if (badge.type === "scarcity") icon = "🚨";
      else if (badge.type === "velocity") icon = "🔥";
      else if (badge.type === "attention") icon = "👀";
      return '<span class="tk9-pdp-proof-badge tk9-pdp-proof-badge--' + escapeHtml(badge.type || "standard") + '">' +
        (icon ? '<span class="tk9-pdp-proof-icon" aria-hidden="true">' + icon + '</span>' : "") +
        '<span>' + escapeHtml(badge.text) + '</span></span>';
    }).join("");
  }

  function setPdpInlinePromise(text, entry) {
    var target = selectedInventoryStatusTarget();
    if (!text || !target) {
      removePdpPromiseSlot("variant");
      return;
    }
    var node = target.querySelector('[data-tk9-pdp-promise="variant"]');
    Array.prototype.slice.call(document.querySelectorAll('[data-tk9-pdp-promise="variant"]')).forEach(function (existing) {
      if (existing !== node) existing.remove();
    });
    if (!node || node.tagName !== "SPAN") {
      if (node) node.remove();
      node = document.createElement("span");
      node.setAttribute("data-tk9-pdp-promise", "variant");
      node.setAttribute("aria-live", "polite");
      target.appendChild(node);
    }
    setPdpPromiseNode(node, text, entry, "variant-inline");
  }

  function enhanceInventoryPromiseTiles() {
    var inputs = Array.prototype.slice.call(document.querySelectorAll("fieldset.variant-option input[data-variant-id], input[name^='Choose a Kit'][data-variant-id], input[name^='Choose a Bundle'][data-variant-id]"));
    inputs.forEach(function (input) {
      var entry = inventoryPromiseEntry(input.getAttribute("data-variant-id"));
      var label = input.closest && input.closest("label");
      if (!label) return;
      var text = inventoryPromiseText(entry, "variant");
      var existing = label.querySelector("[data-tk9-kit-tile-promise]");
      if (!entry || !text || isStandardInventoryPromise(text, entry)) {
        if (existing) existing.remove();
        label.classList.remove("tk9-kit-tile-has-promise");
        return;
      }
      label.classList.add("tk9-kit-tile-has-promise");
      if (!existing) {
        existing = document.createElement("span");
        existing.className = "tk9-kit-tile-promise";
        existing.setAttribute("data-tk9-kit-tile-promise", "1");
        label.appendChild(existing);
      }
      existing.textContent = text;
    });
  }

  function clearInventoryPromiseSurfaces() {
    ["variant", "cta", "status", "delivery", "proof"].forEach(removePdpPromiseSlot);
    Array.prototype.slice.call(document.querySelectorAll("[data-tk9-kit-tile-promise]")).forEach(function (node) {
      node.remove();
    });
    Array.prototype.slice.call(document.querySelectorAll(".tk9-kit-tile-has-promise")).forEach(function (node) {
      node.classList.remove("tk9-kit-tile-has-promise");
    });
    Array.prototype.slice.call(document.querySelectorAll(".tk9-promise-buy-block")).forEach(clearPdpPromiseClasses);
    Array.prototype.slice.call(document.querySelectorAll("[data-tk9-pdp-promise-stack]")).forEach(function (stack) {
      if (!String(stack.textContent || "").trim()) stack.remove();
    });
  }

  function enhanceInventoryPromiseSurfaces() {
    if (!/^\/products\//.test(window.location.pathname || "")) return;
    if (!config.inventoryPromiseEnabled) {
      clearInventoryPromiseSurfaces();
      return;
    }
    if (!state.inventoryPromiseLoaded) {
      loadInventoryPromise().then(enhanceInventoryPromiseSurfaces);
      return;
    }
    var form = primaryPdpForm();
    if (!form) return;
    var entry = selectedVariantPromiseEntry();
    if (config.pdpInventoryPromisePresentationEnabled === false) {
      clearInventoryPromiseSurfaces();
      setPdpAddButtonLabel(form, entry);
      return;
    }
    var statusText = inventoryPdpPromiseText(entry);
    var deliveryText = inventoryDeliveryText(entry);
    var proofText = inventoryProofText(entry);
    setPdpInlinePromise("", entry);
    markPdpPromiseLayout(form, entry);
    setPdpAddButtonLabel(form, entry);
    removePdpPromiseSlot("cta");
    setPdpPromiseNode(ensurePdpPromiseNode(form, "status"), statusText, entry, "status");
    setPdpPromiseNode(ensurePdpPromiseNode(form, "delivery"), deliveryText, entry, "delivery");
    setPdpPromiseNode(ensurePdpPromiseNode(form, "proof"), proofText, entry, "proof");
    enhanceInventoryPromiseTiles();
  }

  var pdpFreshProductCache = {};
  var pdpFreshProductPromises = {};
  var pdpFreshVariantFallbacks = {
    "hard-bottom-csce": {
      "42156188500067": { id: 42156188500067, title: "Black / Large (Fits Most Vehicles) / Seat Cover + Free Safety Belt", option3: "Seat Cover + Free Safety Belt", price: 16999, compare_at_price: 19998 },
      "42818876637283": { id: 42818876637283, title: "Black / Large (Fits Most Vehicles) / Seat Cover + Plush Bed + Free Safety Belt", option3: "Seat Cover + Plush Bed + Free Safety Belt", price: 23998, compare_at_price: 28997 },
      "42156188532835": { id: 42156188532835, title: "Black / Extra-Large (Fits Bigger Trucks) / Seat Cover + Free Safety Belt", option3: "Seat Cover + Free Safety Belt", price: 19999, compare_at_price: 22998 },
      "42818876670051": { id: 42818876670051, title: "Black / Extra-Large (Fits Bigger Trucks) / Seat Cover + Plush Bed + Free Safety Belt", option3: "Seat Cover + Plush Bed + Free Safety Belt", price: 26999, compare_at_price: 32997 },
      "42553130123363": { id: 42553130123363, title: "Gray / Large (Fits Most Vehicles) / Seat Cover + Free Safety Belt", option3: "Seat Cover + Free Safety Belt", price: 16999, compare_at_price: 19998 },
      "42818876702819": { id: 42818876702819, title: "Gray / Large (Fits Most Vehicles) / Seat Cover + Plush Bed + Free Safety Belt", option3: "Seat Cover + Plush Bed + Free Safety Belt", price: 23998, compare_at_price: 28997 },
      "42553130156131": { id: 42553130156131, title: "Gray / Extra-Large (Fits Bigger Trucks) / Seat Cover + Free Safety Belt", option3: "Seat Cover + Free Safety Belt", price: 19999, compare_at_price: 22998 },
      "42818876735587": { id: 42818876735587, title: "Gray / Extra-Large (Fits Bigger Trucks) / Seat Cover + Plush Bed + Free Safety Belt", option3: "Seat Cover + Plush Bed + Free Safety Belt", price: 26999, compare_at_price: 32997 },
      "42897163550819": { id: 42897163550819, title: "Beige / Large (Fits Most Vehicles) / Seat Cover + Free Safety Belt", option3: "Seat Cover + Free Safety Belt", price: 16999, compare_at_price: 19998 },
      "42897163583587": { id: 42897163583587, title: "Beige / Large (Fits Most Vehicles) / Seat Cover + Plush Bed + Free Safety Belt", option3: "Seat Cover + Plush Bed + Free Safety Belt", price: 23998, compare_at_price: 28997 },
      "42897163616355": { id: 42897163616355, title: "Beige / Extra-Large (Fits Bigger Trucks) / Seat Cover + Free Safety Belt", option3: "Seat Cover + Free Safety Belt", price: 19999, compare_at_price: 22998 },
      "42897163649123": { id: 42897163649123, title: "Beige / Extra-Large (Fits Bigger Trucks) / Seat Cover + Plush Bed + Free Safety Belt", option3: "Seat Cover + Plush Bed + Free Safety Belt", price: 26999, compare_at_price: 32997 }
    }
  };

  function freshPdpHandle(handle) {
    handle = String(handle || "");
    return Object.prototype.hasOwnProperty.call(pdpFreshVariantFallbacks, handle) ? handle : "";
  }

  function pdpVariantFromProduct(product, id) {
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    for (var index = 0; index < variants.length; index += 1) {
      if (String(variants[index].id) === String(id)) return variants[index];
    }
    return null;
  }

  function resolvePdpVariant(id, handle) {
    handle = freshPdpHandle(handle);
    if (handle) {
      var fresh = pdpVariantFromProduct(pdpFreshProductCache[handle], id);
      if (fresh) return fresh;
      var fallback = pdpFreshVariantFallbacks[handle] && pdpFreshVariantFallbacks[handle][String(id)];
      if (fallback) return fallback;
    }
    return embeddedPdpVariant(id);
  }

  function ensureFreshPdpProduct(handle, callback) {
    handle = freshPdpHandle(handle);
    if (!handle || pdpFreshProductCache[handle]) return;
    if (!pdpFreshProductPromises[handle]) {
      pdpFreshProductPromises[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js?tk9_pdp_price=" + Date.now(), {
        credentials: "same-origin",
        cache: "no-store"
      })
        .then(function (response) {
          if (!response.ok) throw new Error("HTTP " + response.status);
          return response.json();
        })
        .then(function (product) {
          if (product && Array.isArray(product.variants)) pdpFreshProductCache[handle] = product;
          return product;
        })
        .catch(function (error) {
          debugLog("fresh PDP product lookup failed", handle, error);
          return null;
        });
    }
    if (typeof callback === "function") {
      pdpFreshProductPromises[handle].then(function () {
        callback();
      });
    }
  }

  function kitTileBadgeText(title, compareAtCents, priceCents) {
    var save = roundedSavingsText(compareAtCents, priceCents);
    if (!save) return "";
    title = String(title || "");
    if (/4-pack/i.test(title)) return save + " · MAX AIRFLOW";
    if (/2 Dual-Fan|2-pack/i.test(title)) return save + " · BEST VALUE";
    if (/Plush Backseat Dog Bed|Backseat Dog Bed/i.test(title)) return save + " · BEST MATCH";
    if (/Waterproof Cover|Pool Cover/i.test(title)) return save + " · KEEPS IT CLEAN";
    if (/MOLLE|10-In-1|System/i.test(title)) return save + " · MAX KIT";
    if (/Bungee Leash.*Tactical Collar.*12 Patch|Tactical Collar.*12 Patch.*Bungee Leash/i.test(title)) return save + " · BEST VALUE";
    return save;
  }

  function harnessKitCopy(title) {
    title = String(title || "").replace(/\s+/g, " ").trim();
    var hasLeash = /Bungee Leash/i.test(title);
    var hasCollar = /Tactical Collar/i.test(title);
    var hasPatches = /12 Patch/i.test(title);
    var hasMolle = /MOLLE/i.test(title);

    if (/10-In-1/i.test(title)) {
      return { title: "All-in system", meta: "Nothing left to buy", key: "system" };
    }
    if (hasLeash && hasCollar && hasPatches && hasMolle) {
      return { title: "Trail setup", meta: "Dog carries the gear", key: "trail" };
    }
    if (hasLeash && hasCollar && hasPatches) {
      return { title: "Complete setup", meta: "The full walk system", key: "best" };
    }
    if (hasLeash && hasPatches) {
      return { title: "Leash + patches", meta: "Pull control + ID", key: "leash-patches" };
    }
    if (hasCollar && hasPatches) {
      return { title: "Collar + patches", meta: "Backup control + ID", key: "collar-patches" };
    }
    if (hasLeash && hasCollar) {
      return { title: "Leash + collar", meta: "Full walk control", key: "leash-collar" };
    }
    if (hasPatches) {
      return { title: "12-patch kit", meta: "ID that earns space", key: "patches" };
    }
    if (hasCollar) {
      return { title: "Collar kit", meta: "Backup control point", key: "collar" };
    }
    if (hasLeash) {
      return { title: "Leash kit", meta: "Absorbs hard pulls", key: "leash" };
    }
    return { title: "Harness", meta: "Just the harness", key: "harness" };
  }

  function harnessKitChoiceRank(key) {
    var order = {
      harness: 10,
      leash: 20,
      collar: 30,
      patches: 40,
      "leash-collar": 50,
      "leash-patches": 60,
      "collar-patches": 70,
      best: 80,
      trail: 90,
      system: 100
    };
    return Object.prototype.hasOwnProperty.call(order, key) ? order[key] : 999;
  }

  function compactSavingsText(compareAtCents, priceCents) {
    var savings = Number(compareAtCents || 0) - Number(priceCents || 0);
    var rounded = roundedDollarAmount(savings);
    return rounded ? rounded + " OFF" : "";
  }

  function normalizedOptionText(value) {
    return String(value || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function selectedSwatchKingValue(optionName) {
    var list = swatchList(optionName);
    if (!list) return "";
    var selected = list.querySelector(".swatch-view-item[aria-checked='true'], .swatch-view-item .swatch-selected, .swatch-view-item.swatch-selected");
    var item = selected && selected.closest ? selected.closest(".swatch-view-item") : selected;
    if (!item) item = list.querySelector(".swatch-view-item");
    if (!item) return "";
    var input = item.querySelector("input");
    return item.getAttribute("orig-value") || item.getAttribute("aria-label") || input && input.value || item.textContent || "";
  }

  function selectedHarnessKitOptions(variants) {
    variants = Array.isArray(variants) ? variants : [];
    var selectedId = selectedPdpVariantId();
    var current = null;
    for (var index = 0; index < variants.length; index += 1) {
      if (String(variants[index].id) === String(selectedId)) {
        current = variants[index];
        break;
      }
    }
    return {
      color: current && current.option1 || selectedSwatchKingValue("Choose a Color"),
      size: current && current.option2 || selectedSwatchKingValue("Choose a Size")
    };
  }

  function harnessKitVariantForTitle(variants, selectedOptions, kitTitle) {
    variants = Array.isArray(variants) ? variants : [];
    selectedOptions = selectedOptions || {};
    var normalizedTitle = normalizedOptionText(kitTitle);
    var selectedColor = normalizedOptionText(selectedOptions.color);
    var selectedSize = normalizedOptionText(selectedOptions.size);
    var colorFallback = null;
    var titleFallback = null;
    for (var index = 0; index < variants.length; index += 1) {
      var variant = variants[index] || {};
      if (normalizedOptionText(variant.option3 || (variant.options && variant.options[2])) !== normalizedTitle) continue;
      if (!titleFallback) titleFallback = variant;
      if (selectedColor && normalizedOptionText(variant.option1 || (variant.options && variant.options[0])) === selectedColor) {
        if (!colorFallback) colorFallback = variant;
        if (!selectedSize || normalizedOptionText(variant.option2 || (variant.options && variant.options[1])) === selectedSize) return variant;
      }
    }
    return colorFallback || titleFallback;
  }

  function seatCoverBundleCopy(title) {
    title = String(title || "").replace(/\s+/g, " ").trim();
    if (/Plush Backseat Dog Bed|Dog Bed/i.test(title)) {
      return { title: "Add The Plush Bed", meta: "Cleaner ride + comfier spot", key: "comfort" };
    }
    return { title: "Protect My Seats", meta: "Cover + FREE safety belt", key: "cover" };
  }

  function seatCoverBundleChoiceRank(key) {
    return key === "comfort" ? 20 : 10;
  }

  function selectedSeatCoverBundleOptions(variants) {
    variants = Array.isArray(variants) ? variants : [];
    var selectedId = selectedPdpVariantId();
    var current = null;
    for (var index = 0; index < variants.length; index += 1) {
      if (String(variants[index].id) === String(selectedId)) {
        current = variants[index];
        break;
      }
    }
    return {
      color: current && current.option1 || selectedSwatchKingValue("Choose a Color"),
      size: current && current.option2 || selectedSwatchKingValue("Choose a Size")
    };
  }

  function seatCoverBundleVariantForTitle(variants, selectedOptions, bundleTitle) {
    variants = Array.isArray(variants) ? variants : [];
    selectedOptions = selectedOptions || {};
    var normalizedTitle = normalizedOptionText(bundleTitle);
    var selectedColor = normalizedOptionText(selectedOptions.color);
    var selectedSize = normalizedOptionText(selectedOptions.size);
    var colorFallback = null;
    var titleFallback = null;
    for (var index = 0; index < variants.length; index += 1) {
      var variant = variants[index] || {};
      if (normalizedOptionText(variant.option3 || (variant.options && variant.options[2])) !== normalizedTitle) continue;
      if (!titleFallback) titleFallback = variant;
      if (selectedColor && normalizedOptionText(variant.option1 || (variant.options && variant.options[0])) === selectedColor) {
        if (!colorFallback) colorFallback = variant;
        if (!selectedSize || normalizedOptionText(variant.option2 || (variant.options && variant.options[1])) === selectedSize) return variant;
      }
    }
    return colorFallback || titleFallback;
  }

  function pdpVariantImageUrl(variant) {
    var src = variant && variant.featured_image && (variant.featured_image.src || variant.featured_image) || "";
    src = String(src || "");
    if (!src) return "";
    var separator = src.indexOf("?") === -1 ? "?" : "&";
    return src + separator + "width=320&height=320&crop=top";
  }

  function setSwatchKingTileImage(item, variant) {
    if (!item) return;
    var url = pdpVariantImageUrl(variant);
    if (!url) return;
    var image = item.querySelector(".star-set-image");
    if (!image) return;
    image.style.backgroundImage = 'url("' + url.replace(/"/g, "%22") + '")';
    image.style.backgroundPosition = "center";
    image.style.backgroundRepeat = "no-repeat";
    image.style.backgroundSize = "contain";
  }

  function nativePickerOptionGroup(optionName) {
    var normalizedName = normalizedOptionText(optionName);
    return Array.prototype.slice.call(document.querySelectorAll("[data-tk9-np-option]")).find(function (group) {
      return normalizedOptionText(group.getAttribute("option-name")) === normalizedName;
    }) || null;
  }

  function selectedNativePickerValue(optionName) {
    var group = nativePickerOptionGroup(optionName);
    if (!group) return "";
    var selected = group.querySelector("[data-tk9-np-value-btn].is-selected, [data-tk9-np-value-btn][aria-pressed='true']");
    return selected && (selected.getAttribute("data-tk9-np-value") || selected.getAttribute("data-tk9-np-display") || selected.textContent) || "";
  }

  function pdpVariantRawImageUrl(variant) {
    var src = variant && variant.featured_image && (variant.featured_image.src || variant.featured_image) || "";
    return String(src || "");
  }

  function shopifySizedImageUrl(src, width) {
    src = String(src || "").replace(/^\/\//, "https://");
    if (!src) return "";
    try {
      var parsed = new URL(src, window.location.origin);
      if (/cdn\.shopify\.com|teamk9\.com/i.test(parsed.hostname)) {
        parsed.searchParams.set("width", String(width));
        return parsed.toString();
      }
    } catch (error) {}
    return src;
  }

  function seatCoverNativeVariantForOptions(variants, options) {
    variants = Array.isArray(variants) ? variants : [];
    options = options || {};
    var selectedColor = normalizedOptionText(options.color);
    var selectedSize = normalizedOptionText(options.size);
    var selectedBundle = normalizedOptionText(options.bundle);
    var bundleFallback = null;
    var colorFallback = null;
    for (var index = 0; index < variants.length; index += 1) {
      var variant = variants[index] || {};
      if (selectedColor && normalizedOptionText(variant.option1 || (variant.options && variant.options[0])) !== selectedColor) continue;
      if (selectedBundle && normalizedOptionText(variant.option3 || (variant.options && variant.options[2])) !== selectedBundle) continue;
      if (!bundleFallback) bundleFallback = variant;
      if (selectedSize && normalizedOptionText(variant.option2 || (variant.options && variant.options[1])) === selectedSize) return variant;
    }
    if (bundleFallback) return bundleFallback;
    for (var fallbackIndex = 0; fallbackIndex < variants.length; fallbackIndex += 1) {
      var fallback = variants[fallbackIndex] || {};
      if (selectedColor && normalizedOptionText(fallback.option1 || (fallback.options && fallback.options[0])) !== selectedColor) continue;
      if (!colorFallback) colorFallback = fallback;
      if (selectedSize && normalizedOptionText(fallback.option2 || (fallback.options && fallback.options[1])) === selectedSize) return fallback;
    }
    return colorFallback;
  }

  function setNativePickerChipImage(button, variant) {
    var img = button && button.querySelector && button.querySelector(".tk9-np__chip-img");
    var raw = pdpVariantRawImageUrl(variant);
    if (!img || !raw) return;
    var next = shopifySizedImageUrl(raw, 320);
    if (img.getAttribute("data-tk9-dynamic-variant-src") === next) return;
    img.setAttribute("data-tk9-dynamic-variant-src", next);
    img.src = next;
    img.srcset = [
      shopifySizedImageUrl(raw, 96) + " 96w",
      shopifySizedImageUrl(raw, 240) + " 240w",
      next + " 320w",
      shopifySizedImageUrl(raw, 480) + " 480w"
    ].join(", ");
  }

  function enhanceSeatCoverNativePickerColorImages() {
    var picker = document.querySelector('[data-tk9-np][data-handle="hard-bottom-csce"]') || document.querySelector("[data-tk9-np]");
    var productHandle = String(picker && picker.getAttribute("data-handle") || (window.bcpo_product && window.bcpo_product.handle) || (window.product && window.product.handle) || window.location.pathname || "");
    if (!/hard-bottom-csce/i.test(productHandle)) return;
    var colorGroup = nativePickerOptionGroup("Choose a Color");
    if (!colorGroup) return;
    var freshProduct = pdpFreshProductCache["hard-bottom-csce"];
    if (!freshProduct || !Array.isArray(freshProduct.variants) || !freshProduct.variants.length) {
      ensureFreshPdpProduct("hard-bottom-csce", enhanceSeatCoverNativePickerColorImages);
      return;
    }
    var selectedId = selectedPdpVariantId();
    var current = pdpVariantFromProduct(freshProduct, selectedId) || resolvePdpVariant(selectedId, "hard-bottom-csce");
    var size = selectedNativePickerValue("Choose a Size") || current && (current.option2 || (current.options && current.options[1])) || "";
    var bundle = selectedNativePickerValue("Choose a Bundle") || current && (current.option3 || (current.options && current.options[2])) || "";
    Array.prototype.slice.call(colorGroup.querySelectorAll("[data-tk9-np-value-btn]")).forEach(function (button) {
      var color = button.getAttribute("data-tk9-np-value") || button.getAttribute("data-tk9-np-display") || "";
      var variant = seatCoverNativeVariantForOptions(freshProduct.variants, { color: color, size: size, bundle: bundle });
      setNativePickerChipImage(button, variant);
    });
  }

  function setSeatCoverBundleChoiceCopy(container, rawTitle) {
    if (!container) return;
    var copy = seatCoverBundleCopy(rawTitle);
    container.setAttribute("data-tk9-seat-cover-choice", copy.key);
    var node = container.querySelector("[data-tk9-kit-choice-copy]");
    if (!node) {
      node = document.createElement("span");
      node.className = "tk9-kit-choice-copy";
      node.setAttribute("data-tk9-kit-choice-copy", "1");
      container.appendChild(node);
    }
    node.innerHTML = '<span>' + escapeHtml(copy.title) + '</span><small>' + escapeHtml(copy.meta) + '</small>';
  }

  function setSeatCoverBundleSavingsBadge(item, rawTitle, variant) {
    if (!item) return;
    var copy = seatCoverBundleCopy(rawTitle);
    var host = item.querySelector(".swatch-image") || item;
    var existing = host.querySelector("[data-tk9-kit-tile-badge]");
    var price = Number(variant && variant.price || 0);
    var compareAt = Number(variant && (variant.compare_at_price || variant.compareAtPrice) || 0);
    var text = compactSavingsText(compareAt, price);
    item.classList.toggle("tk9-kit-tile-has-savings", Boolean(text));
    item.classList.toggle("tk9-kit-tile-best", copy.key === "comfort");
    if (!text) {
      if (existing) existing.remove();
      return;
    }
    if (!existing) {
      existing = document.createElement("span");
      existing.setAttribute("data-tk9-kit-tile-badge", "1");
      existing.className = "tk9-kit-tile-badge tk9-kit-tile-badge--swatch";
      host.appendChild(existing);
    }
    existing.textContent = text;
  }

  function setHarnessKitSavingsBadge(item, rawTitle, variant) {
    if (!item) return;
    var copy = harnessKitCopy(rawTitle);
    var host = item.querySelector(".swatch-image") || item;
    var existing = host.querySelector("[data-tk9-kit-tile-badge]");
    var price = Number(variant && variant.price || 0);
    var compareAt = Number(variant && (variant.compare_at_price || variant.compareAtPrice) || 0);
    var text = copy.key === "harness" ? "" : compactSavingsText(compareAt, price);
    item.classList.toggle("tk9-kit-tile-has-savings", Boolean(text));
    item.classList.toggle("tk9-kit-tile-best", copy.key === "best");
    item.classList.toggle("tk9-kit-tile-max", copy.key === "system" || copy.key === "trail");
    if (!text) {
      if (existing) existing.remove();
      return;
    }
    if (!existing) {
      existing = document.createElement("span");
      existing.setAttribute("data-tk9-kit-tile-badge", "1");
      existing.className = "tk9-kit-tile-badge tk9-kit-tile-badge--swatch";
      host.appendChild(existing);
    }
    existing.textContent = text;
  }

  function setHarnessKitChoiceCopy(container, rawTitle) {
    if (!container) return;
    var copy = harnessKitCopy(rawTitle);
    container.setAttribute("data-tk9-kit-choice", copy.key);
    var node = container.querySelector("[data-tk9-kit-choice-copy]");
    if (!node) {
      node = document.createElement("span");
      node.className = "tk9-kit-choice-copy";
      node.setAttribute("data-tk9-kit-choice-copy", "1");
      container.appendChild(node);
    }
    node.innerHTML = '<span>' + escapeHtml(copy.title) + '</span><small>' + escapeHtml(copy.meta) + '</small>';
  }

  function enhanceHarnessKitSwatchKingTiles() {
    var product = window.bcpo_product || window.product || {};
    var handle = String(product.handle || window.location.pathname || "");
    if (!/harness/i.test(handle)) return false;

    var list = swatchList("Choose a Kit");
    if (!list) return false;
    document.documentElement.setAttribute("data-tk9-harness-pdp", "1");
    list.setAttribute("data-tk9-harness-kit-row", "1");
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var selectedOptions = selectedHarnessKitOptions(variants);

    var kitItems = Array.prototype.slice.call(list.querySelectorAll(".swatch-view-item")).map(function (item, index) {
      var rawTitle = item.getAttribute("orig-value") || item.getAttribute("aria-label") || item.textContent || "";
      var copy = harnessKitCopy(rawTitle);
      return { item: item, rawTitle: rawTitle, copy: copy, index: index, rank: harnessKitChoiceRank(copy.key) };
    }).sort(function (left, right) {
      return left.rank - right.rank || left.index - right.index;
    });

    kitItems.forEach(function (entry) {
      var item = entry.item;
      var rawTitle = entry.rawTitle;
      var copy = entry.copy;
      var variant = harnessKitVariantForTitle(variants, selectedOptions, rawTitle);
      if (item.parentNode === list) list.appendChild(item);
      item.style.order = String(entry.rank);
      item.classList.add("tk9-harness-kit-choice");
      item.setAttribute("data-tk9-kit-choice", copy.key);
      setHarnessKitChoiceCopy(item.querySelector(".swatch-image") || item, rawTitle);
      setHarnessKitSavingsBadge(item, rawTitle, variant);
      var hiddenText = item.querySelector(".swatch-img-text");
      if (hiddenText) hiddenText.setAttribute("aria-hidden", "true");
    });

    return true;
  }

  function enhanceSeatCoverBundleSwatchKingTiles() {
    var product = window.bcpo_product || window.product || {};
    var handle = String(product.handle || window.location.pathname || "");
    if (!/hard-bottom-csce/i.test(handle)) return false;

    var list = swatchList("Choose a Bundle");
    if (!list) return false;
    document.documentElement.setAttribute("data-tk9-seat-cover-pdp", "1");
    list.setAttribute("data-tk9-seat-cover-bundle-row", "1");
    normalizeSeatCoverBundleLabel();
    ensureFreshPdpProduct("hard-bottom-csce", enhancePdpKitTiles);

    var freshProduct = pdpFreshProductCache["hard-bottom-csce"];
    var variants = freshProduct && Array.isArray(freshProduct.variants) ? freshProduct.variants : product && Array.isArray(product.variants) ? product.variants : [];
    if (!variants.length && pdpFreshVariantFallbacks["hard-bottom-csce"]) {
      variants = Object.keys(pdpFreshVariantFallbacks["hard-bottom-csce"]).map(function (id) {
        return pdpFreshVariantFallbacks["hard-bottom-csce"][id];
      });
    }
    var selectedOptions = selectedSeatCoverBundleOptions(variants);

    var bundleItems = Array.prototype.slice.call(list.querySelectorAll(".swatch-view-item")).map(function (item, index) {
      var rawTitle = item.getAttribute("orig-value") || item.getAttribute("aria-label") || item.textContent || "";
      var copy = seatCoverBundleCopy(rawTitle);
      return { item: item, rawTitle: rawTitle, copy: copy, index: index, rank: seatCoverBundleChoiceRank(copy.key) };
    }).sort(function (left, right) {
      return left.rank - right.rank || left.index - right.index;
    });

    bundleItems.forEach(function (entry) {
      var item = entry.item;
      var rawTitle = entry.rawTitle;
      var copy = entry.copy;
      var variant = seatCoverBundleVariantForTitle(variants, selectedOptions, rawTitle);
      if (item.parentNode === list) list.appendChild(item);
      item.style.order = String(entry.rank);
      item.classList.add("tk9-seat-cover-bundle-choice");
      item.setAttribute("data-tk9-seat-cover-choice", copy.key);
      setSeatCoverBundleChoiceCopy(item.querySelector(".swatch-image") || item, rawTitle);
      setSeatCoverBundleSavingsBadge(item, rawTitle, variant);
      setSwatchKingTileImage(item, variant);
      var hiddenText = item.querySelector(".swatch-img-text");
      if (hiddenText) hiddenText.setAttribute("aria-hidden", "true");
    });
    window.setTimeout(normalizeSeatCoverBundleLabel, 80);

    return true;
  }

  function normalizeSeatCoverBundleLabel() {
    Array.prototype.slice.call(document.querySelectorAll('variant-swatch-king [option-name="Choose a Bundle"] .swatch-label, .swatches [option-name="Choose a Bundle"] .swatch-label, [option-name="Choose a Bundle"] .swatch-label, .swatch-label')).forEach(function (label) {
      var text = (label.textContent || "").replace(/\s+/g, " ").trim();
      var bundleInput = label.querySelector('input[name="Choose a Bundle"]');
      if (!bundleInput && !/^Choose a Bundle\s*:/i.test(text)) return;
      var optionName = label.querySelector(".swatch-option-name");
      if (!optionName) {
        label.textContent = "Choose a Bundle";
        return;
      }
      optionName.textContent = "Choose a Bundle";
      Array.prototype.slice.call(label.querySelectorAll(".swatch-variant-name")).forEach(function (node) {
        node.remove();
      });
      Array.prototype.slice.call(label.childNodes).forEach(function (node) {
        if (node.nodeType === 3) node.textContent = "";
      });
    });
  }

  function enhancePdpKitTiles() {
    if (!/^\/products\//.test(window.location.pathname || "")) return;
    var product = window.bcpo_product || window.product || null;
    var productHandle = String((product && product.handle) || window.location.pathname || "");
    if (/harness/i.test(productHandle)) {
      document.documentElement.setAttribute("data-tk9-harness-pdp", "1");
    }
    if (/hard-bottom-csce/i.test(productHandle)) {
      document.documentElement.setAttribute("data-tk9-seat-cover-pdp", "1");
      enhanceSeatCoverNativePickerColorImages();
    }
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var variantById = {};
    for (var index = 0; index < variants.length; index += 1) {
      variantById[String(variants[index].id)] = variants[index];
    }
    var displayMap = cartDisplayRules().bundleCompareAtVariantMap || {};
    var inputs = [];
    document.querySelectorAll("fieldset.variant-option").forEach(function (fieldset) {
      var legend = fieldset.querySelector("legend");
      if (!/Choose a Kit|Choose a Bundle/i.test(legend && legend.textContent ? legend.textContent : "")) return;
      fieldset.querySelectorAll("input[data-variant-id]").forEach(function (input) {
        inputs.push(input);
      });
    });
    document.querySelectorAll('input[name^="Choose a Kit"][data-variant-id], input[name^="Choose a Bundle"][data-variant-id]').forEach(function (input) {
      if (inputs.indexOf(input) === -1) inputs.push(input);
    });
    var swatchKingKitEnhanced = enhanceHarnessKitSwatchKingTiles();
    var seatCoverBundleEnhanced = enhanceSeatCoverBundleSwatchKingTiles();
    if (inputs.length || swatchKingKitEnhanced || seatCoverBundleEnhanced) document.documentElement.setAttribute("data-tk9-pdp-kit-tiles", "1");
    inputs.forEach(function (input) {
      var label = input.closest("label");
      if (!label) return;
      var variantId = String(input.getAttribute("data-variant-id") || "");
      var handle = freshPdpHandle((window.bcpo_product && window.bcpo_product.handle) || (window.product && window.product.handle) || "");
      var variant = (handle && resolvePdpVariant(variantId, handle)) || variantById[variantId] || embeddedPdpVariant(variantId);
      var price = Number((variant && variant.price) || 0);
      var compareAt = Number((variant && (variant.compare_at_price || variant.compareAtPrice)) || displayMap[variantId] || 0);
      var title = input.getAttribute("aria-label") || input.value || (variant && (variant.option3 || variant.title)) || "";
      var isHarnessKit = /harness/i.test(productHandle);
      var copy = isHarnessKit ? harnessKitCopy(title) : null;
      var text = isHarnessKit ? (copy.key === "harness" ? "" : compactSavingsText(compareAt, price)) : kitTileBadgeText(title, compareAt, price);
      var existing = label.querySelector("[data-tk9-kit-tile-badge]");
      label.classList.add("tk9-kit-tile-enhanced");
      if (isHarnessKit) {
        label.setAttribute("data-tk9-kit-choice", copy.key);
        label.style.order = String(harnessKitChoiceRank(copy.key));
        setHarnessKitChoiceCopy(label, title);
      }
      if (!text || compareAt <= price) {
        if (existing) existing.remove();
        label.classList.remove("tk9-kit-tile-has-savings", "tk9-kit-tile-best", "tk9-kit-tile-max");
        return;
      }
      label.classList.add("tk9-kit-tile-has-savings");
      label.classList.toggle("tk9-kit-tile-best", isHarnessKit ? copy.key === "best" : /BEST VALUE/i.test(text));
      label.classList.toggle("tk9-kit-tile-max", isHarnessKit ? copy.key === "system" || copy.key === "trail" : /MAX KIT/i.test(text));
      if (!existing) {
        existing = document.createElement("span");
        existing.setAttribute("data-tk9-kit-tile-badge", "1");
        existing.className = "tk9-kit-tile-badge";
        label.appendChild(existing);
      }
      existing.textContent = text;
    });
  }

  function swatchList(optionName) {
    return document.querySelector('variant-swatch-king [option-name="' + optionName + '"] ul.swatch-view, .swatches [option-name="' + optionName + '"] ul.swatch-view');
  }

  function swatchItemByOrigValue(list, value) {
    return Array.prototype.slice.call(list ? list.children : []).find(function (item) {
      return String(item.getAttribute("orig-value") || "") === value;
    }) || null;
  }

  function enhanceHarnessSwatchKingRows() {
    var product = window.bcpo_product || window.product || {};
    var handle = String(product.handle || window.location.pathname || "");
    if (!/harness/i.test(handle)) return;
    document.documentElement.setAttribute("data-tk9-harness-pdp", "1");

    var isFullDesktop = !window.matchMedia || window.matchMedia("(min-width: 1200px)").matches;
    var isMobile = window.matchMedia && window.matchMedia("(max-width: 749px)").matches;

    var colorList = swatchList("Choose a Color");
    if (colorList && isFullDesktop) {
      colorList.setAttribute("data-tk9-harness-color-row", "1");
      colorList.removeAttribute("data-tk9-harness-color-row-mobile");
      if (colorList.getAttribute("data-tk9-harness-color-order") !== "desktop") {
        [
          "Blaze Orange",
          "Desert Brown",
          "Olive Drab Green",
          "K9 Black",
          "Pink Camo",
          "MultiCam",
          "Lavender"
        ].forEach(function (value) {
          var item = swatchItemByOrigValue(colorList, value);
          if (item) colorList.appendChild(item);
        });
        colorList.setAttribute("data-tk9-harness-color-order", "desktop");
      }
    } else if (colorList && isMobile) {
      colorList.setAttribute("data-tk9-harness-color-row-mobile", "1");
      colorList.removeAttribute("data-tk9-harness-color-row");
      if (colorList.getAttribute("data-tk9-harness-color-order") !== "mobile") {
        [
          "Blaze Orange",
          "K9 Black",
          "Desert Brown",
          "Olive Drab Green",
          "Pink Camo",
          "MultiCam",
          "Lavender"
        ].forEach(function (value) {
          var item = swatchItemByOrigValue(colorList, value);
          if (item) colorList.appendChild(item);
        });
        colorList.setAttribute("data-tk9-harness-color-order", "mobile");
      }
    }

    var sizeList = swatchList("Choose a Size");
    if (sizeList && isFullDesktop) sizeList.setAttribute("data-tk9-harness-size-row", "1");
  }

  function sizeChoiceFromText(text) {
    var value = String(text || "").replace(/\s+/g, " ").trim();
    var match = value.match(/\b(Extra-Small|Extra Small|XS|Small|Medium|Large|Extra-Large|Extra Large|XL)\b(?:\s*\(([^)]+)\))?/i);
    if (!match) return null;
    var raw = match[1].toLowerCase().replace(/\s+/g, "-");
    var code = raw === "extra-small" || raw === "xs" ? "XS"
      : raw === "small" ? "S"
      : raw === "medium" ? "M"
      : raw === "large" ? "L"
      : raw === "extra-large" || raw === "xl" ? "XL"
      : "";
    if (!code) return null;
    return {
      code: code,
      label: code === "XS" ? "Extra-Small"
        : code === "S" ? "Small"
        : code === "M" ? "Medium"
        : code === "L" ? "Large"
        : "Extra-Large",
      band: match[2] || "",
      text: value
    };
  }

  function injectHarnessSizeCss() {
    if (document.getElementById("tk9-harness-size-clarity-css")) return;
    var style = document.createElement("style");
    style.id = "tk9-harness-size-clarity-css";
    style.textContent = [
      ".tk9-size-clarity{margin:8px 0 10px;padding:10px 12px;border:1px solid #0f766e;border-radius:8px;background:#edfdfa;color:#11231f;font-size:14px;line-height:1.3;}",
      ".tk9-size-clarity strong{display:block;margin-bottom:3px;font-size:15px;line-height:1.2;}",
      ".tk9-size-clarity em{font-style:normal;font-weight:800;color:#0f766e;}",
      ".tk9-size-tile{position:relative;display:flex!important;flex-direction:column;align-items:flex-start!important;justify-content:center;gap:2px;min-height:58px;padding-top:8px!important;padding-bottom:8px!important;}",
      ".tk9-size-tile__code{font-size:18px;font-weight:900;line-height:1;color:#111827;}",
      ".tk9-size-tile__band{font-size:12px;font-weight:800;line-height:1.2;color:#4b5563;}",
      ".tk9-size-tile--xs{border-color:#d97706!important;background:#fff8eb!important;}",
      ".tk9-size-tile--medium{border-color:#0f766e!important;background:#f0fdfa!important;}",
      ".tk9-size-tile input:checked~.tk9-size-tile__code,.tk9-size-tile:has(input:checked) .tk9-size-tile__code{color:#0f766e;}",
      "@media(max-width:640px){.tk9-size-clarity{font-size:13px}.tk9-size-tile{min-height:54px}.tk9-size-tile__code{font-size:17px}}"
    ].join("");
    (document.head || document.documentElement).appendChild(style);
  }

  function inputLabel(input) {
    if (!input) return null;
    var escapedId = "";
    try {
      escapedId = input.id && window.CSS && CSS.escape ? CSS.escape(input.id) : String(input.id || "").replace(/"/g, '\\"');
    } catch (error) {
      escapedId = String(input.id || "").replace(/"/g, '\\"');
    }
    return input.closest("label") || (escapedId ? document.querySelector('label[for="' + escapedId + '"]') : null);
  }

  function enhanceHarnessSizeSelection() {
    var product = window.bcpo_product || window.product || {};
    var handle = String(product.handle || window.location.pathname || "");
    if (!/harness/i.test(handle)) return;
    document.documentElement.setAttribute("data-tk9-harness-pdp", "1");

    var fieldsets = Array.prototype.slice.call(document.querySelectorAll("fieldset.variant-option, variant-picker fieldset, form[action*='/cart/add'] fieldset"));
    fieldsets.forEach(function (fieldset) {
      var inputs = Array.prototype.slice.call(fieldset.querySelectorAll("input[type='radio'], input[data-variant-id]"));
      var choices = inputs.map(function (input) {
        var label = inputLabel(input);
        var text = input.getAttribute("aria-label") || input.value || (label && label.textContent) || "";
        return { input: input, label: label, size: sizeChoiceFromText(text) };
      }).filter(function (choice) {
        return choice.size;
      });
      var codes = choices.map(function (choice) { return choice.size.code; });
      if (codes.indexOf("XS") === -1 || codes.indexOf("M") === -1) return;

      injectHarnessSizeCss();
      fieldset.classList.add("tk9-size-fieldset");

      choices.forEach(function (choice) {
        if (!choice.label || choice.label.getAttribute("data-tk9-size-clarified") === "1") return;
        choice.label.setAttribute("data-tk9-size-clarified", "1");
        choice.label.classList.add("tk9-size-tile");
        if (choice.size.code === "XS") choice.label.classList.add("tk9-size-tile--xs");
        if (choice.size.code === "M") choice.label.classList.add("tk9-size-tile--medium");
        var code = document.createElement("span");
        code.className = "tk9-size-tile__code";
        code.textContent = choice.size.code + " - " + choice.size.label;
        var band = document.createElement("span");
        band.className = "tk9-size-tile__band";
        band.textContent = choice.size.band ? choice.size.band.replace(/\bLB\b/i, "lb") : "Confirm with the size chart";
        choice.label.appendChild(code);
        choice.label.appendChild(band);
      });

      var selected = choices.find(function (choice) { return choice.input.checked; }) || choices[0];
      var callout = fieldset.querySelector("[data-tk9-size-clarity]");
      if (!callout) {
        var legend = fieldset.querySelector("legend");
        callout = document.createElement("div");
        callout.className = "tk9-size-clarity";
        callout.setAttribute("data-tk9-size-clarity", "1");
        if (legend && legend.parentNode) legend.parentNode.insertBefore(callout, legend.nextSibling);
        else fieldset.insertBefore(callout, fieldset.firstChild);
      }
      callout.innerHTML = '<strong>Confirm harness size before checkout</strong><span>Selected: <em>' + escapeHtml(selected.size.label + " (" + selected.size.code + ")") + '</em>' + (selected.size.band ? ' - ' + escapeHtml(selected.size.band.replace(/\bLB\b/i, "lb")) : "") + '</span>';
    });
  }

  function enhanceFanPdpDefaultTwoPack() {
    if (window.location.pathname.replace(/\/$/, "") !== "/products/dual-headrest-cooling-fans-usb-a") return;
    document.documentElement.setAttribute("data-tk9-fan-pdp-two-pack-nudge", "1");

    var twoPackId = "44107734188131";
    var onePackId = "44107734155363";
    var fourPackId = "44198189924451";
    var fanChoices = [
      { id: onePackId, label: "1 Dual-Fan Kit" },
      { id: twoPackId, label: "2 Dual-Fan Kits", badge: "SAVE $20 · BEST VALUE", best: true },
      { id: fourPackId, label: "4-pack", badge: "SAVE $60 · MAX AIRFLOW", max: true }
    ];

    function normalizeFanLabel(value) {
      return String(value || "").replace(/\s+/g, " ").trim();
    }

    function fanChoiceByLabel(labelText) {
      var label = normalizeFanLabel(labelText);
      return fanChoices.find(function (choice) {
        return label === choice.label || label.indexOf(choice.label) !== -1;
      }) || null;
    }

    function fanChoiceById(variantId) {
      return fanChoices.find(function (choice) {
        return String(choice.id) === String(variantId);
      }) || null;
    }

    function findInput(variantId, labelText) {
      var direct = document.querySelector('input[data-variant-id="' + variantId + '"]');
      if (direct) return direct;
      var holder = document.querySelector('[data-variant-id="' + variantId + '"]');
      if (holder && holder.matches && holder.matches("input")) return holder;
      var nested = holder && holder.querySelector && holder.querySelector("input");
      if (nested) return nested;
      return Array.prototype.slice.call(document.querySelectorAll("input")).find(function (input) {
          return String(input.value || "").trim() === labelText;
        }) || null;
    }

    function fanInputs() {
      return fanChoices.map(function (choice) {
        return Object.assign({}, choice, { input: findInput(choice.id, choice.label) });
      });
    }

    function fanInputById(variantId) {
      var match = fanInputs().find(function (choice) {
        return String(choice.id) === String(variantId);
      });
      return match && match.input;
    }

    function fanVisibleChoice() {
      var selectedText = "";
      var swatchLabel = document.querySelector('variant-swatch-king [option-name="Choose a Bundle"] .swatch-label, .swatches [option-name="Choose a Bundle"] .swatch-label');
      if (swatchLabel) selectedText = swatchLabel.textContent || "";
      var selectedSwatch = document.querySelector('variant-swatch-king [option-name="Choose a Bundle"] .swatch-selected, .swatches [option-name="Choose a Bundle"] .swatch-selected, .swatch-view-item[aria-checked="true"]');
      if (!selectedText && selectedSwatch) selectedText = selectedSwatch.textContent || selectedSwatch.getAttribute("aria-label") || "";
      return fanChoiceByLabel(selectedText);
    }

    var fanVariantSyncActive = false;

    function dispatchNativeEvents(node) {
      if (!node) return;
      ["input", "change"].forEach(function (eventName) {
        try {
          node.dispatchEvent(new Event(eventName, { bubbles: true }));
        } catch (error) {}
      });
    }

    function setFanFormVariant(choice) {
      if (!choice) return;
      Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"] [name="id"], product-form-component [name="id"], input[name="id"], select[name="id"]')).forEach(function (node) {
        if (!node || node.disabled) return;
        var changed = String(node.value || "") !== String(choice.id);
        if (node.tagName === "SELECT") {
          var option = Array.prototype.slice.call(node.options || []).find(function (item) {
            return String(item.value) === String(choice.id);
          });
          if (!option) return;
          node.value = String(choice.id);
        } else {
          node.value = String(choice.id);
          node.setAttribute("value", String(choice.id));
        }
        if (changed) dispatchNativeEvents(node);
      });
    }

    function setFanNativeChoice(choice) {
      fanInputs().forEach(function (item) {
        var input = item.input;
        if (!input) return;
        var selected = String(item.id) === String(choice.id);
        var changed = Boolean(input.checked) !== selected || String(input.getAttribute("aria-checked") || "") !== (selected ? "true" : "false");
        try {
          input.checked = selected;
          input.setAttribute("aria-checked", selected ? "true" : "false");
        } catch (error) {}
        var label = input.closest("label");
        if (label) {
          label.classList.toggle("tk9-fan-pdp-visible-selected", selected);
          label.setAttribute("aria-pressed", selected ? "true" : "false");
        }
        if (selected && changed) dispatchNativeEvents(input);
      });
    }

    function setFanSwatchChoice(choice) {
      Array.prototype.slice.call(document.querySelectorAll('variant-swatch-king [option-name="Choose a Bundle"] .swatch-view-item, .swatches [option-name="Choose a Bundle"] .swatch-view-item')).forEach(function (item) {
        var itemChoice = fanChoiceByLabel(item.getAttribute("aria-label") || item.textContent || "");
        if (!itemChoice) return;
        var selected = String(itemChoice.id) === String(choice.id);
        item.setAttribute("aria-checked", selected ? "true" : "false");
        item.classList.toggle("swatch-selected", selected);
        var selector = item.querySelector(".swatch-selector");
        if (selector) selector.classList.toggle("swatch-selected", selected);
      });
    }

    function setFanLegend(choice) {
      var swatchLabel = document.querySelector('variant-swatch-king [option-name="Choose a Bundle"] .swatch-label, .swatches [option-name="Choose a Bundle"] .swatch-label');
      if (swatchLabel) swatchLabel.textContent = "Choose a Bundle : " + choice.label;
      var nativeInput = fanInputById(choice.id);
      updateBundleLegend(nativeInput || { closest: function () { return null; }, value: choice.label });
    }

    function setFanUrl(choice) {
      try {
        var url = new URL(window.location.href);
        if (url.searchParams.get("variant") === String(choice.id)) return;
        url.searchParams.set("variant", String(choice.id));
        window.history.replaceState(window.history.state, "", url.toString());
      } catch (error) {}
    }

    function syncFanVariant(choice, updateUrl) {
      if (!choice) return;
      if (fanVariantSyncActive) return;
      fanVariantSyncActive = true;
      try {
        setFanNativeChoice(choice);
        setFanFormVariant(choice);
        setFanSwatchChoice(choice);
        setFanLegend(choice);
        if (updateUrl) setFanUrl(choice);
        window.setTimeout(enhancePdpBundlePricing, 20);
        window.setTimeout(enhanceInventoryPromiseSurfaces, 35);
        try {
          document.dispatchEvent(new CustomEvent("tk9:fan-variant-sync", { detail: { variantId: choice.id, label: choice.label } }));
        } catch (error) {}
      } finally {
        fanVariantSyncActive = false;
      }
    }

    function bindFanVariantSync() {
      if (window.__tk9FanVariantSyncBound) return;
      window.__tk9FanVariantSyncBound = true;
      document.addEventListener("click", function (event) {
        var target = event.target && event.target.closest && event.target.closest('variant-swatch-king [option-name="Choose a Bundle"] .swatch-view-item, variant-swatch-king [option-name="Choose a Bundle"] .swatch-selector, .swatches [option-name="Choose a Bundle"] .swatch-view-item, .swatches [option-name="Choose a Bundle"] .swatch-selector, input[value="1 Dual-Fan Kit"], input[value="2 Dual-Fan Kits"], input[value="4-pack"], select.sticky-variant-selector');
        if (!target) return;
        var choice = fanChoiceByLabel(target.getAttribute("aria-label") || target.value || target.textContent || "");
        if (!choice) return;
        window.setTimeout(function () { syncFanVariant(choice, true); }, 0);
        window.setTimeout(function () { syncFanVariant(choice, true); }, 140);
        window.setTimeout(function () { syncFanVariant(choice, true); }, 420);
      }, true);
      document.addEventListener("change", function (event) {
        if (fanVariantSyncActive) return;
        var target = event.target;
        if (!target || !target.matches || !target.matches('input[value="1 Dual-Fan Kit"], input[value="2 Dual-Fan Kits"], input[value="4-pack"], select.sticky-variant-selector')) return;
        var choice = fanChoiceByLabel(target.value || target.getAttribute("aria-label") || "");
        if (choice) syncFanVariant(choice, true);
      }, true);
    }

    bindFanVariantSync();

    var twoPackInput = findInput(twoPackId, "2 Dual-Fan Kits");
    var onePackInput = findInput(onePackId, "1 Dual-Fan Kit");
    var fourPackInput = findInput(fourPackId, "4-pack");
    [twoPackInput, onePackInput, fourPackInput].forEach(function (input) {
      if (!input) return;
      var label = input.closest("label");
      if (label) label.classList.add("tk9-kit-tile-enhanced");
    });

    fanInputs().forEach(function (choice) {
      if (!choice.input || !choice.badge) return;
      var label = choice.input.closest("label");
      if (label) {
        label.classList.toggle("tk9-fan-pdp-best-value", Boolean(choice.best));
        label.classList.toggle("tk9-kit-tile-max", Boolean(choice.max));
        var badge = label.querySelector("[data-tk9-fan-pdp-badge]");
        if (!badge) {
          badge = document.createElement("span");
          badge.className = "tk9-kit-tile-badge tk9-fan-pdp-badge";
          badge.setAttribute("data-tk9-fan-pdp-badge", "1");
          label.appendChild(badge);
        }
        badge.textContent = choice.badge;
      }
    });

    if (onePackInput) {
      var onePackLabel = onePackInput.closest("label");
      if (onePackLabel) onePackLabel.classList.add("tk9-fan-pdp-one-pack");
    }

    function priceText() {
      var priceNode = document.querySelector(".july4th-price-block, [data-current-price], .price, .product__price");
      return priceNode && priceNode.textContent ? priceNode.textContent : "";
    }

    function inputLabel(input) {
      if (!input) return "";
      return input.getAttribute("aria-label") || input.value || input.getAttribute("value") || "";
    }

    function setVisibleChoice(input, selected) {
      if (!input) return;
      try {
        input.checked = Boolean(selected);
        input.setAttribute("aria-checked", selected ? "true" : "false");
      } catch (error) {}
      var label = input.closest("label");
      if (label) {
        label.classList.toggle("tk9-fan-pdp-visible-selected", Boolean(selected));
        label.setAttribute("aria-pressed", selected ? "true" : "false");
      }
    }

    function updateBundleLegend(selectedInput) {
      var fieldset = selectedInput && selectedInput.closest("fieldset");
      var legend = fieldset && fieldset.querySelector("legend");
      var label = inputLabel(selectedInput);
      if (!legend || !label || !/Choose a Bundle/i.test(legend.textContent || "")) return;
      legend.textContent = "Choose a Bundle : " + label;
    }

    var selectedId = selectedPdpVariantId();
    var selectedInput = String(selectedId) === twoPackId ? twoPackInput : String(selectedId) === onePackId ? onePackInput : String(selectedId) === fourPackId ? fourPackInput : null;
    var shownPrice = priceText();
    if (!selectedInput && /\$99\.99/.test(shownPrice)) selectedInput = twoPackInput;
    if (!selectedInput && /\$59\.99/.test(shownPrice)) selectedInput = onePackInput;
    if (!selectedInput && /\$179\.99/.test(shownPrice)) selectedInput = fourPackInput;
    var visibleChoice = fanVisibleChoice();
    var selectedChoice = fanChoiceById(selectedId) || (selectedInput && fanChoiceByLabel(inputLabel(selectedInput))) || visibleChoice;
    if (visibleChoice && (!selectedChoice || String(selectedChoice.id) !== String(visibleChoice.id))) selectedChoice = visibleChoice;
    if (selectedChoice && String(selectedPdpVariantId()) !== String(selectedChoice.id)) {
      syncFanVariant(selectedChoice, true);
      selectedInput = fanInputById(selectedChoice.id);
    }
    if (selectedInput) {
      setVisibleChoice(twoPackInput, selectedInput === twoPackInput);
      setVisibleChoice(onePackInput, selectedInput === onePackInput);
      setVisibleChoice(fourPackInput, selectedInput === fourPackInput);
      updateBundleLegend(selectedInput);
    }
  }

  function enhancePdpBundlePricing() {
    var priceBlock = document.querySelector(".july4th-price-block");
    if (!priceBlock) return;
    var productHandle = priceBlock.getAttribute("data-product-handle") || (window.bcpo_product && window.bcpo_product.handle) || (window.product && window.product.handle) || "";
    var freshHandle = freshPdpHandle(productHandle);
    var variantId = selectedPdpVariantId();
    if (freshHandle) {
      ensureFreshPdpProduct(freshHandle, function () {
        enhancePdpBundlePricing();
        enhancePdpKitTiles();
      });
    }
    var variant = resolvePdpVariant(variantId, freshHandle || productHandle);
    if (!variant) return;
    var price = Number(variant.price || 0);
    var compareAt = Number(variant.compare_at_price || variant.compareAtPrice || 0);
    var kitTitle = String(variant.option3 || variant.public_title || variant.title || "");
    var isSale = compareAt > price;
    var isBundleDeal = isSale && kitTitle.indexOf("+") !== -1;
    var current = priceBlock.querySelector("[data-current-price]");
    var compare = priceBlock.querySelector("[data-compare-price]");
    var compareWrapper = priceBlock.querySelector(".july4th-compare-price");
    var priceRow = priceBlock.querySelector(".price-row");
    var wrapper = priceBlock.querySelector(".july4th-price-wrapper");
    var savings = priceBlock.querySelector(".july4th-savings-badge");
    var savingsHost = priceRow || wrapper;
    if (!savings && savingsHost) {
      savings = document.createElement("span");
      savings.className = "july4th-savings-badge hidden tk9-pdp-bundle-savings";
      savings.innerHTML = '<span data-savings-text></span>';
      savingsHost.appendChild(savings);
    } else if (savings && priceRow && savings.parentElement !== priceRow) {
      priceRow.appendChild(savings);
    }
    priceBlock.classList.toggle("tk9-on-sale", isSale);
    priceBlock.classList.toggle("tk9-bundle-deal", isBundleDeal);
    if (current) current.textContent = money(price);
    if (compare) compare.textContent = money(compareAt);
    if (isSale) {
      if (compareWrapper) {
        compareWrapper.classList.remove("hidden");
        compareWrapper.style.setProperty("display", "inline-flex", "important");
        compareWrapper.style.setProperty("visibility", "visible", "important");
        compareWrapper.style.setProperty("width", "auto", "important");
        compareWrapper.style.setProperty("height", "auto", "important");
      }
      if (compare) {
        compare.style.setProperty("display", "inline-flex", "important");
        compare.style.setProperty("visibility", "visible", "important");
        compare.style.setProperty("width", "auto", "important");
        compare.style.setProperty("height", "auto", "important");
      }
      if (savings) {
        savings.classList.remove("hidden");
        savings.style.setProperty("display", "inline-flex", "important");
        savings.style.setProperty("visibility", "visible", "important");
        var savingsText = savings.querySelector("[data-savings-text]") || savings;
        savingsText.textContent = roundedSavingsText(compareAt, price) || (money(compareAt - price) + " OFF");
      }
    } else {
      if (compareWrapper) {
        compareWrapper.classList.add("hidden");
        compareWrapper.removeAttribute("style");
      }
      if (compare) compare.removeAttribute("style");
      if (savings) {
        savings.classList.add("hidden");
        savings.removeAttribute("style");
      }
    }
  }

  function bindPdpBundlePricing() {
    var schedule = function () {
      window.setTimeout(enhancePdpBundlePricing, 30);
      window.setTimeout(enhancePdpKitTiles, 35);
      window.setTimeout(enhanceHarnessSwatchKingRows, 37);
      window.setTimeout(enhanceFanPdpDefaultTwoPack, 40);
      window.setTimeout(enhanceHarnessSizeSelection, 45);
      window.setTimeout(enhanceInventoryPromiseSurfaces, 55);
      window.setTimeout(enhancePdpBundlePricing, 350);
      window.setTimeout(enhancePdpKitTiles, 375);
      window.setTimeout(enhanceHarnessSwatchKingRows, 380);
      window.setTimeout(enhanceFanPdpDefaultTwoPack, 390);
      window.setTimeout(enhanceHarnessSizeSelection, 405);
      window.setTimeout(enhanceInventoryPromiseSurfaces, 420);
      window.setTimeout(enhancePdpBundlePricing, 1200);
      window.setTimeout(enhancePdpKitTiles, 1250);
      window.setTimeout(enhanceHarnessSwatchKingRows, 1260);
      window.setTimeout(enhanceFanPdpDefaultTwoPack, 1275);
      window.setTimeout(enhanceHarnessSizeSelection, 1290);
      window.setTimeout(enhanceInventoryPromiseSurfaces, 1310);
      window.setTimeout(enhancePdpBundlePricing, 3000);
      window.setTimeout(enhancePdpKitTiles, 3050);
      window.setTimeout(enhanceHarnessSwatchKingRows, 3060);
      window.setTimeout(enhanceFanPdpDefaultTwoPack, 3075);
      window.setTimeout(enhanceHarnessSizeSelection, 3090);
      window.setTimeout(enhanceInventoryPromiseSurfaces, 3110);
      window.setTimeout(enhancePdpBundlePricing, 6000);
      window.setTimeout(enhancePdpKitTiles, 6050);
      window.setTimeout(enhanceHarnessSwatchKingRows, 6060);
      window.setTimeout(enhanceFanPdpDefaultTwoPack, 6075);
      window.setTimeout(enhanceHarnessSizeSelection, 6090);
      window.setTimeout(enhanceInventoryPromiseSurfaces, 6110);
    };
    schedule();
    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;
      enhancePdpBundlePricing();
      enhancePdpKitTiles();
      enhanceHarnessSwatchKingRows();
      enhanceFanPdpDefaultTwoPack();
      enhanceHarnessSizeSelection();
      enhanceInventoryPromiseSurfaces();
      if (attempts >= 40) window.clearInterval(interval);
    }, 500);
    document.addEventListener("change", schedule, true);
    document.addEventListener("click", function (event) {
      if (event.target && event.target.closest && event.target.closest("[data-variant-id], [data-option-value], variant-picker, variant-swatch-king, .swatch-view-item, .bcpo-front-button-option, .bcpo-value")) {
        schedule();
      }
    }, true);
    var pushState = history.pushState;
    var replaceState = history.replaceState;
    history.pushState = function () {
      var result = pushState.apply(this, arguments);
      schedule();
      return result;
    };
    history.replaceState = function () {
      var result = replaceState.apply(this, arguments);
      schedule();
      return result;
    };
    window.addEventListener("popstate", schedule);
  }

  function cartAttributes() {
    return state.cart && state.cart.attributes && typeof state.cart.attributes === "object" ? state.cart.attributes : {};
  }

  function activeDiscountCode() {
    var attributes = cartAttributes();
    var attrCode = attributes._tk9_discount_code || attributes.tk9_discount_code || attributes.discount_code || attributes.tk9_slide_cart_discount || "";
    if (attrCode) return String(attrCode || "").trim();
    return cartLevelDiscountCode();
  }

  function cartLevelDiscountCode() {
    var applications = state.cart && state.cart.cart_level_discount_applications || [];
    if (!Array.isArray(applications)) return "";
    for (var index = 0; index < applications.length; index += 1) {
      var application = applications[index] || {};
      var discount = application.discount_application || application;
      if (String(discount.type || "").toLowerCase() !== "discount_code") continue;
      var code = discount.code || discount.title || application.code || application.title || "";
      if (code) return String(code || "").trim();
    }
    return "";
  }

  var FALLBACK_DISCOUNT_RATES = {
    SAVE10: 0.1,
    K9WELCOME: 0.1,
    WELCOME: 0.1,
    K9FB: 0.1,
    K9IG: 0.1
  };

  function configuredDiscountRule(code) {
    var normalizedCode = normalizeText(code);
    var rules = state.rules && state.rules.cart && state.rules.cart.discountSafeThresholds;
    if (!normalizedCode) return null;
    var match = Array.isArray(rules) ? rules.find(function (rule) {
      return normalizeText(rule.code) === normalizedCode;
    }) : null;
    if (match) return match;
    return FALLBACK_DISCOUNT_RATES[normalizedCode] ? { code: normalizedCode, rate: FALLBACK_DISCOUNT_RATES[normalizedCode] } : null;
  }

  function configuredDiscountRate(code) {
    var match = configuredDiscountRule(code);
    return match ? Number(match.rate || 0) : 0;
  }

  function configuredDiscountSavingsEstimateCents(code, cart) {
    var rate = configuredDiscountRate(code);
    if (!(rate > 0 && rate < 1)) return 0;
    var subtotal = centsOrNull(cart && cart.items_subtotal_price);
    if (subtotal === null || subtotal <= 0) subtotal = centsOrNull(cart && cart.total_price);
    if (subtotal === null || subtotal <= 0) subtotal = cartOrderDisplaySubtotalCents();
    return subtotal > 0 ? Math.round(subtotal * rate) : 0;
  }

  function displayedDiscountCode() {
    var attrCode = activeDiscountCode();
    if (attrCode) return attrCode;
    return "";
  }

  function lineLevelDiscountSavingsCents() {
    return merchandiseCartItems().reduce(function (sum, item) {
      return sum + ((item && item.line_level_discount_allocations) || []).reduce(function (lineSum, allocation) {
        return lineSum + (centsOrNull(allocation && allocation.amount) || 0);
      }, 0);
    }, 0);
  }

  function cartLevelDiscountSavingsCents() {
    var applications = state.cart && state.cart.cart_level_discount_applications || [];
    if (Array.isArray(applications) && applications.length) {
      var allocated = applications.reduce(function (sum, application) {
        return sum + (centsOrNull(application && application.total_allocated_amount) || 0);
      }, 0);
      if (allocated > 0) return allocated;
    }
    if (!displayedDiscountCode()) return 0;
    var rawTotal = centsOrNull(state.cart && state.cart.total_price) || 0;
    var itemSubtotal = centsOrNull(state.cart && state.cart.items_subtotal_price);
    if (itemSubtotal !== null && itemSubtotal > rawTotal) return itemSubtotal - rawTotal;
    var totalDiscount = centsOrNull(state.cart && state.cart.total_discount) || 0;
    return Math.max(totalDiscount - lineLevelDiscountSavingsCents(), 0);
  }

  function activeDiscountRate() {
    var code = activeDiscountCode();
    if (!code) return 0;
    var configuredRate = configuredDiscountRate(code);
    if (configuredRate > 0 && configuredRate < 1) return configuredRate;
    return 0;
  }

  function inferredActiveDiscountRate() {
    var code = activeDiscountCode();
    if (!code) return 0;
    var configuredRate = configuredDiscountRate(code);
    if (configuredRate > 0 && configuredRate < 1) return configuredRate;
    var itemSubtotal = centsOrNull(state.cart && state.cart.items_subtotal_price) || cartDisplaySubtotalCents();
    var savings = cartLevelDiscountSavingsCents();
    if (!itemSubtotal || !savings) return 0;
    return Math.min(Math.max(savings / itemSubtotal, 0), 0.95);
  }

  function discountedPriceCents(priceCents) {
    var price = Number(priceCents || 0);
    var rate = activeDiscountRate();
    if (price <= 0 || !(rate > 0 && rate < 1)) return price;
    return Math.max(Math.round(price * (1 - rate)), 0);
  }

  function cartMoneyPromiseContainmentEnabled() {
    return config.cartMoneyPromiseContainment !== false;
  }

  function stripMoneyPromiseCue(value) {
    var text = String(value || "").trim();
    if (!text) return "";
    if (/\$\s*\d+|\b\d+\s*%\b|\bsave\b|\boff\b|\bsavings?\b|\bdiscount\b|\bunlock/i.test(text)) return "";
    return text;
  }

  function offerDiscountPromiseAllowed(offer, compareAtCents, priceCents) {
    if (!offer || offer.action === "link") return false;
    var price = Number(priceCents || offer.priceCents || 0);
    var compareAt = Number(compareAtCents || offer.standalonePriceCents || offer.compareAtPriceCents || 0);
    if (!(price > 0) || !(compareAt > price)) return false;
    if (offer.savingsBadgeText) return true;
    var cue = String([offer.valueCue, offer.kitSavingsCue, offer.tag].filter(Boolean).join(" "));
    return /\$\s*\d+|\bsave\b|\boff\b|\bsavings?\b|\bkit price\b/i.test(cue);
  }

  function checkoutTruthOffer(offer) {
    if (!cartMoneyPromiseContainmentEnabled() || !offer) return offer;
    var price = Number(offer.priceCents || 0);
    var compareAt = Math.max(
      Number(offer.standalonePriceCents || 0),
      Number(offer.compareAtPriceCents || 0)
    );
    if (offerDiscountPromiseAllowed(offer, compareAt, price)) return offer;
    var fullPrice = Math.max(
      price,
      compareAt
    );
    var choices = (offer.contextChoices || []).map(function (choice) {
      var choicePrice = Number(choice.priceCents || 0);
      var choiceFullPrice = Math.max(
        choicePrice,
        Number(choice.standalonePriceCents || 0),
        Number(choice.compareAtPriceCents || 0),
        fullPrice || 0
      );
      return Object.assign({}, choice, {
        priceCents: choiceFullPrice || choicePrice,
        standalonePriceCents: 0,
        compareAtPriceCents: 0
      });
    });
    var tag = /^\s*save\s+\$?\d+/i.test(String(offer.tag || "")) ? "Add-on" : offer.tag;
    return Object.assign({}, offer, {
      priceCents: fullPrice || price,
      standalonePriceCents: 0,
      compareAtPriceCents: 0,
      contextChoices: choices,
      savingsBadgeText: "",
      kitSavingsCue: "",
      valueCue: stripMoneyPromiseCue(offer.valueCue),
      tag: tag
    });
  }

  function offerSavingsBadgeText(compareAtCents, priceCents, options) {
    options = options || {};
    if (cartMoneyPromiseContainmentEnabled() && !options.allowContainedPromise) return "";
    var price = Number(priceCents || 0);
    if (price <= 0) return "";
    var shownPrice = discountedPriceCents(price);
    var compareAt = Number(compareAtCents || 0);
    var savingsBase = compareAt > shownPrice ? compareAt : shownPrice < price ? price : 0;
    var rounded = savingsBase > shownPrice ? roundedDollarAmount(savingsBase - shownPrice) : "";
    return rounded ? rounded + " OFF" : "";
  }

  function discountPriceHtml(priceCents, className, compareAtCents) {
    var price = Number(priceCents || 0);
    var compareAt = Number(compareAtCents || 0);
    if (price <= 0) return money(price);
    var shownPrice = discountedPriceCents(price);
    if (compareAt > shownPrice) {
      return '<span class="' + className + '"><s>' + money(compareAt) + '</s> ' + money(shownPrice) + '</span>';
    }
    if (shownPrice >= price) return money(price);
    return '<span class="' + className + '"><s>' + money(price) + '</s> ' + money(shownPrice) + '</span>';
  }

  function checkoutDiscountCode() {
    var code = activeDiscountCode();
    if (code) return code;
    if (config.dogdadSaleEnabled && config.dogdadSaleCode && cartSaleEndMs() > Date.now()) {
      return String(config.dogdadSaleCode || "").trim().toUpperCase();
    }
    return "";
  }

  function checkoutHref() {
    var code = checkoutDiscountCode();
    if (!code) return config.checkoutUrl;
    try {
      var url = new URL(config.checkoutUrl, window.location.origin);
      url.searchParams.set("discount", code);
      return url.pathname + url.search + url.hash;
    } catch (error) {
      var separator = String(config.checkoutUrl || "").indexOf("?") === -1 ? "?" : "&";
      return config.checkoutUrl + separator + "discount=" + encodeURIComponent(code);
    }
  }

  function additionalCheckoutHtml() {
    if (config.additionalCheckoutButtonsEnabled === false) return "";
    var template = document.querySelector("[data-tk9-additional-checkout-template]");
    if (!template) return "";
    var html = template.innerHTML || "";
    if (!/shopify-accelerated-checkout-cart|additional-checkout-buttons/i.test(html)) return "";
    return html;
  }

  function nativeWalletNames(additionalCheckout) {
    if (!additionalCheckout) return [];
    var names = [];
    try {
      var wrapper = document.createElement("div");
      wrapper.innerHTML = additionalCheckout;
      var node = wrapper.querySelector("shopify-accelerated-checkout-cart, shopify-accelerated-checkout");
      var configs = JSON.parse(node && node.getAttribute("wallet-configs") || "[]");
      names = configs.map(function (item) {
        return item && item.name;
      }).filter(Boolean);
    } catch (error) {}
    return names.filter(function (name, index) {
      return ["shop_pay", "paypal", "amazon_pay", "google_pay", "apple_pay"].indexOf(name) !== -1 && names.indexOf(name) === index;
    }).slice(0, 5);
  }

  function compactFooterViewport() {
    try {
      return window.matchMedia && window.matchMedia("(max-width: 639px)").matches;
    } catch (error) {}
    return window.innerWidth < 640;
  }

  function normalizeText(value) {
    return String(value || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
  }

  function imageUrl(name) {
    if (!name) return "";
    if (/^https?:\/\//i.test(name)) return name;
    return String(config.assetBaseUrl || "") + name;
  }

  function imageTag(className, source, alt) {
    var src = imageUrl(source);
    if (!src) return '<span class="' + className + ' tk9-image-fallback" aria-hidden="true"></span>';
    return '<img class="' + className + '" src="' + src + '" alt="' + escapeHtml(alt || "") + '" loading="lazy" decoding="async">';
  }

  function handleImageError(event) {
    var image = event.target;
    if (!image || !image.classList) return;
    if (!image.closest || !image.closest("[data-tk9-slide-cart]")) return;
    image.classList.add("tk9-image-error");
    image.alt = "";
    image.removeAttribute("src");
  }

  function cartItems() {
    return Array.isArray(state.cart && state.cart.items) ? state.cart.items : [];
  }

  function protectionProductIds() {
    return ((state.rules && state.rules.protection) || []).map(function (item) {
      return Number(item.productId);
    }).filter(Boolean);
  }

  function isProtectionLine(item) {
    var ids = protectionProductIds();
    return ids.indexOf(Number(item && item.product_id)) !== -1;
  }

  function merchandiseCartItems() {
    return cartItems().filter(function (item) {
      return !isProtectionLine(item);
    });
  }

  function cartHasProduct(productId) {
    return cartItems().some(function (item) {
      return Number(item && item.product_id) === Number(productId);
    });
  }

  function cartLineDisplayRank(item) {
    var ids = state.rules && state.rules.productIds || {};
    var productId = Number(item && item.product_id);
    var hasSeatCover = cartHasProduct(ids.hardBottomSeatCover || 7513423413347);
    var hasHarness = hasHarnessInCart();
    var hasPool = cartHasProduct(ids.dogPool || 6801131569251);
    var hasFans = cartHasProduct(ids.dualHeadrestCoolingFans || 7827615121507);

    if (productId === Number(ids.hardBottomSeatCover || 7513423413347)) return 10;
    if (productId === Number(ids.backseatDogBed || 7586514567267)) return hasSeatCover ? 11 : hasFans ? 41 : 210;
    if (productId === Number(ids.singleSeatCover || 6845717872739)) return hasSeatCover ? 12 : 220;
    if (productId === Number(ids.cargoCover || 6845717905507)) return hasSeatCover ? 13 : 221;
    if (productId === Number(ids.carSafetyBelt || 6762308337763)) return hasSeatCover ? 14 : hasHarness ? 36 : 230;

    if (
      productId === Number(ids.fourBuckleHarness || 7090638356579) ||
      productId === Number(ids.twoBuckleHarness || 6749766811747) ||
      productId === Number(ids.tenInOneKit || 6886975340643)
    ) return 30;
    if (productId === Number(ids.customPatch || 4734560632931)) return hasHarness ? 31 : 240;
    if (productId === Number(ids.tacticalLeash || 4508637560931)) return hasHarness ? 32 : 241;
    if (productId === Number(ids.tacticalCollar || 4508633759843)) return hasHarness ? 33 : 242;
    if (productId === Number(ids.patchBundle || 6840101797987)) return hasHarness ? 34 : 243;
    if (productId === Number(ids.hookLoopPatch || 6877742399587)) return hasHarness ? 35 : 244;
    if (productId === Number(ids.tacticalPouch || 6744451809379)) return hasHarness ? 37 : 245;

    if (productId === Number(ids.dogPool || 6801131569251)) return 50;
    if (productId === Number(ids.dogPoolCover || 6920870527075)) return hasPool ? 51 : 250;
    if (productId === Number(ids.quickDryTowel || 7775269453923)) return hasPool ? 52 : 251;
    if (productId === Number(ids.floorMat || 6735967256675)) return hasPool ? 53 : 252;
    if (productId === Number(ids.splashPad || 7383496261731)) return hasPool ? 54 : 253;

    if (productId === Number(ids.dualHeadrestCoolingFans || 7827615121507)) return hasSeatCover ? 15 : 60;
    if (productId === Number(ids.travelBowl || 6784072122467)) return hasSeatCover || hasHarness || hasFans ? 80 : 260;
    if (productId === Number(ids.dogGoggles || 6905734070371)) return hasHarness ? 81 : 261;
    if (productId === Number(ids.firstAidKit || 6884659200099)) return hasHarness ? 82 : 262;
    if (productId === Number(ids.wasteBags || 6872559157347)) return hasHarness ? 83 : 263;
    if (productId === Number(ids.hairRemovalGloves || 7892526432355)) return hasSeatCover ? 84 : 264;
    if (productId === Number(ids.throwBlanket || 7994154942563)) return hasSeatCover ? 85 : 265;

    return 500;
  }

  function displayCartItems() {
    var indexedMerchandise = merchandiseCartItems().map(function (item, index) {
      return {
        item: item,
        index: index,
        rank: cartLineDisplayRank(item)
      };
    });
    indexedMerchandise.sort(function (a, b) {
      if (a.rank !== b.rank) return a.rank - b.rank;
      return a.index - b.index;
    });
    return indexedMerchandise.map(function (entry) {
      return entry.item;
    }).concat(cartItems().filter(isProtectionLine));
  }

  function productIdsInCart() {
    var map = {};
    cartItems().forEach(function (item) {
      if (item.product_id) map[item.product_id] = true;
    });
    return map;
  }

  function variantIdsInCart() {
    var map = {};
    cartItems().forEach(function (item) {
      if (item.variant_id) map[item.variant_id] = true;
      if (item.id) map[item.id] = true;
    });
    return map;
  }

  function lineQuantity(item) {
    var quantity = Number(item && item.quantity);
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function lineUnitOriginalPriceCents(item) {
    var quantity = lineQuantity(item);
    var originalLine = Number(item && item.original_line_price);
    if (!Number.isFinite(originalLine) || originalLine <= 0) originalLine = Number(item && item.line_price);
    if (!Number.isFinite(originalLine) || originalLine <= 0) originalLine = Number(item && item.price) * quantity;
    if (!Number.isFinite(originalLine) || originalLine <= 0) originalLine = Number(item && item.final_line_price);
    return Number.isFinite(originalLine) && originalLine > 0 ? Math.round(originalLine / quantity) : 0;
  }

  function variantQuantitiesForProduct(productId) {
    var map = {};
    cartItems().forEach(function (item) {
      if (Number(item && item.product_id) !== Number(productId)) return;
      var variantId = String(item.variant_id || item.id || "");
      if (!variantId) return;
      map[variantId] = (map[variantId] || 0) + lineQuantity(item);
    });
    return map;
  }

  function cartContainsAnyProduct(productIds) {
    var present = productIdsInCart();
    return (productIds || []).some(function (id) {
      return present[id];
    });
  }

  function hasHarnessInCart() {
    var ids = state.rules && state.rules.productIds || {};
    return cartContainsAnyProduct([
      ids.fourBuckleHarness || 7090638356579,
      ids.twoBuckleHarness || 6749766811747,
      ids.tenInOneKit || 6886975340643
    ]);
  }

  function verifiedHarnessFallbackEnabled() {
    return config.checkoutVerifiedHarnessFallbackEnabled === true;
  }

  function verifiedHarnessAccessoryProductIds() {
    var ids = state.rules && state.rules.productIds || {};
    return [
      ids.tacticalLeash || 4508637560931,
      ids.tacticalCollar || 4508633759843,
      ids.patchBundle || 6840101797987,
      ids.tacticalPouch || 6744451809379,
      ids.customPatch || 4734560632931,
      ids.dogGoggles || 6905734070371,
      ids.firstAidKit || 6884659200099,
      ids.carSafetyBelt || 6762308337763
    ].map(Number).filter(Boolean);
  }

  function expectedHarnessFallbackSavingsCents() {
    if (!verifiedHarnessFallbackEnabled() || !hasHarnessInCart()) return 0;
    var accessoryIds = verifiedHarnessAccessoryProductIds();
    var accessoryCount = merchandiseCartItems().reduce(function (sum, item) {
      return accessoryIds.indexOf(Number(item && item.product_id)) === -1 ? sum : sum + lineQuantity(item);
    }, 0);
    return Math.min(Math.max(accessoryCount, 0), 8) * 500;
  }

  function harnessBundleLineDiscountSavingsCents() {
    if (!verifiedHarnessFallbackEnabled() || !hasHarnessInCart()) return 0;
    return merchandiseCartItems().reduce(function (sum, item) {
      return sum + ((item && item.line_level_discount_allocations) || []).reduce(function (lineSum, allocation) {
        var title = lineDiscountApplicationTitle(allocation);
        if (!/team\s*k9\s+harness\s+bundle\s+savings/i.test(title)) return lineSum;
        return lineSum + (centsOrNull(allocation && allocation.amount) || 0);
      }, 0);
    }, 0);
  }

  function verifiedHarnessFallbackSavingsCents() {
    if (lineLevelDiscountSavingsCents() > 0) return 0;
    return expectedHarnessFallbackSavingsCents();
  }

  function cartLineText(item) {
    return normalizeText([
      item && item.title,
      item && item.product_title,
      item && item.variant_title,
      item && item.sku,
      item && item.options_with_values && JSON.stringify(item.options_with_values),
      item && item.properties && JSON.stringify(item.properties)
    ].join(" "));
  }

  function cartContainsAnyText(needles) {
    if (!Array.isArray(needles) || !needles.length) return false;
    var cartText = normalizeText(cartItems().map(cartLineText).join(" "));
    return needles.some(function (needle) {
      return cartText.indexOf(normalizeText(needle)) !== -1;
    });
  }

  function cartLineContainsAnyText(line, needles) {
    if (!line || !Array.isArray(needles) || !needles.length) return false;
    var text = cartLineText(line);
    return needles.some(function (needle) {
      return text.indexOf(normalizeText(needle)) !== -1;
    });
  }

  function cartLineByProductId(productId) {
    return cartItems().find(function (item) {
      return Number(item.product_id) === Number(productId);
    }) || null;
  }

  function primaryTriggerLine(group) {
    var triggers = group.triggerProductIds || [];
    return cartItems().find(function (item) {
      return triggers.indexOf(item.product_id) !== -1;
    }) || null;
  }

  function triggerLinesForGroup(group) {
    var triggers = group.triggerProductIds || [];
    return cartItems().filter(function (item) {
      return triggers.indexOf(item.product_id) !== -1;
    });
  }

  function triggerUnitsForGroup(group) {
    var units = [];
    triggerLinesForGroup(group).forEach(function (line) {
      var quantity = Math.min(lineQuantity(line), 12);
      for (var index = 0; index < quantity; index += 1) units.push(line);
    });
    return units;
  }

  function detectColor(line) {
    var text = normalizeText([line && line.variant_title, line && line.options_with_values && JSON.stringify(line.options_with_values), line && line.title].join(" "));
    if (/pink camo/.test(text)) return "pink-camo";
    if (/multi cam|multicam|camouflage/.test(text)) return "multicam";
    if (/lavender|purple/.test(text)) return "lavender";
    if (/orange|blaze/.test(text)) return "orange";
    if (/black|k9 black/.test(text)) return "black";
    if (/brown|desert/.test(text)) return "brown";
    if (/green|olive/.test(text)) return "green";
    if (/gray|grey/.test(text)) return "gray";
    if (/beige|tan/.test(text)) return "beige";
    return "default";
  }

  function detectSize(line) {
    var text = normalizeText([line && line.variant_title, line && line.options_with_values && JSON.stringify(line.options_with_values), line && line.title].join(" "));
    if (/extra large|extra-large|x-large|xl|bigger truck|bigger trucks|fits bigger/.test(text)) return "extra-large";
    if (/extra small|extra-small|xs/.test(text)) return "extra-small";
    if (/large/.test(text)) return "large";
    if (/medium/.test(text)) return "medium";
    if (/small/.test(text)) return "small";
    return "default";
  }

  function resolveVariantId(offer, context) {
    var color = context.color;
    var size = context.size;
    var sized = offer.sizeVariantMap && offer.sizeVariantMap[size];

    if (sized && typeof sized === "object" && sized[color]) return sized[color];
    if (sized && typeof sized === "object" && color !== "default") {
      var firstSizedColor = Object.keys(sized).find(function (key) {
        return Boolean(sized[key]);
      });
      if (firstSizedColor) return sized[firstSizedColor];
    }
    if (typeof sized === "number") return sized;
    if (offer.variantMap && offer.variantMap[color]) return offer.variantMap[color];
    if (offer.targetVariantId) return offer.targetVariantId;
    return offer.fallbackVariantId || null;
  }

  function resolveOfferPriceCents(offer, variantId) {
    var prices = offer.priceVariantMap || {};
    var keyed = prices[String(variantId)];
    if (keyed !== undefined && keyed !== null) return Number(keyed);
    return Number(offer.priceCents || 0);
  }

  function resolveOfferCompareAtCents(offer, variantId) {
    var prices = offer.compareAtVariantMap || offer.standalonePriceVariantMap || {};
    var keyed = prices[String(variantId)];
    if (keyed !== undefined && keyed !== null) return Number(keyed);
    return Number(offer.standalonePriceCents || offer.compareAtPriceCents || 0);
  }

  function harnessKitOfferPricing(offer) {
    if (!hasHarnessInCart() || !offer) return offer;
    var overrides = {
      "custom-patch": {
        priceCents: 2499,
        standalonePriceCents: 2999
      },
      "matched-leash": {
        priceCents: 3999,
        standalonePriceCents: 4499
      },
      "matched-collar": {
        priceCents: 3999,
        standalonePriceCents: 4499
      },
      "molle-pouch": {
        priceCents: 3999,
        standalonePriceCents: 4499
      },
      "patch-variety": {
        priceCents: 3499,
        standalonePriceCents: 3999
      },
      "harness-safety-belt": {
        priceCents: 1999,
        standalonePriceCents: 2499
      }
    };
    return overrides[offer.id] ? Object.assign({}, offer, overrides[offer.id]) : offer;
  }

  function componentUnique(list) {
    var seen = {};
    return (list || []).filter(function (id) {
      if (!id || seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }

  function componentSubsets(values) {
    var unique = componentUnique(values).sort();
    var result = [[]];
    unique.forEach(function (value) {
      var length = result.length;
      for (var index = 0; index < length; index += 1) result.push(result[index].concat(value));
    });
    return result;
  }

  function componentKey(ids) {
    return componentUnique(ids).sort().join("|");
  }

  function componentSubset(needed, available) {
    var availableMap = {};
    (available || []).forEach(function (id) {
      availableMap[id] = true;
    });
    return (needed || []).every(function (id) {
      return availableMap[id];
    });
  }

  function formattedWholeDollars(cents) {
    return "$" + Math.ceil(Number(cents || 0) / 100);
  }

  function kitSavingsCue(currentCents, nextCents) {
    if (cartMoneyPromiseContainmentEnabled()) return "";
    var current = Math.max(0, Number(currentCents || 0));
    var next = Math.max(0, Number(nextCents || 0));
    var incremental = Math.max(next - current, 0);
    if (!incremental) return "";
    return current
      ? "Adds " + formattedWholeDollars(incremental) + " cart savings"
      : "Unlocks " + formattedWholeDollars(next) + " cart savings";
  }

  function previewKitDiscountCents(lineDiscountCents, currentKitSavingsCents, nextKitSavingsCents, compareAtCents) {
    var compareAt = Math.max(0, Number(compareAtCents || 0));
    var current = Math.max(0, Number(currentKitSavingsCents || 0));
    var next = Math.max(0, Number(nextKitSavingsCents || 0));
    var incremental = Math.max(next - current, 0);
    var discount = incremental || Math.max(0, Number(lineDiscountCents || 0));
    return compareAt ? Math.min(discount, compareAt) : discount;
  }

  function applyKitSavingsCueOnly(offer, currentKitSavingsCents, nextKitSavingsCents) {
    if (cartMoneyPromiseContainmentEnabled()) return checkoutTruthOffer(offer);
    var cue = kitSavingsCue(currentKitSavingsCents, nextKitSavingsCents);
    if (!offer || !cue) return offer;
    var fullPrice = Number(offer.standalonePriceCents || offer.compareAtPriceCents || offer.priceCents || 0);
    var choices = (offer.contextChoices || []).map(function (choice) {
      var choiceFullPrice = Number(choice.standalonePriceCents || choice.priceCents || fullPrice || 0);
      return Object.assign({}, choice, {
        priceCents: choiceFullPrice || choice.priceCents,
        standalonePriceCents: 0
      });
    });
    return Object.assign({}, offer, {
      priceCents: fullPrice || Number(offer.priceCents || 0),
      standalonePriceCents: 0,
      compareAtPriceCents: 0,
      contextChoices: choices,
      kitSavingsCue: cue,
      valueCue: cue
    });
  }

  function applyLineDiscountPreview(offer, lineDiscountCents, currentKitSavingsCents, nextKitSavingsCents) {
    var variantCompareAt = offer && offer.variantId ? resolveOfferCompareAtCents(offer, offer.variantId) : 0;
    var compareAt = Number(variantCompareAt || offer && (offer.standalonePriceCents || offer.compareAtPriceCents) || 0);
    var lineDiscount = previewKitDiscountCents(lineDiscountCents, currentKitSavingsCents, nextKitSavingsCents, compareAt);
    if (!offer || !lineDiscount || !compareAt) return offer;
    var price = Math.max(compareAt - lineDiscount, 0);
    var savingsBadge = roundedSavingsText(compareAt, price);
    var cue = kitSavingsCue(currentKitSavingsCents, nextKitSavingsCents);
    var choices = (offer.contextChoices || []).map(function (choice) {
      var choiceCompareAt = Number(choice.standalonePriceCents || compareAt || 0);
      return Object.assign({}, choice, {
        priceCents: choiceCompareAt ? Math.max(choiceCompareAt - lineDiscount, 0) : choice.priceCents,
        standalonePriceCents: choiceCompareAt || choice.standalonePriceCents
      });
    });
    return Object.assign({}, offer, {
      priceCents: price,
      standalonePriceCents: compareAt,
      contextChoices: choices,
      savingsBadgeText: savingsBadge,
      kitSavingsCue: cue,
      valueCue: cue
    });
  }

  function kitComponentProductIds(kind) {
    var ids = state.rules && state.rules.productIds || {};
    if (kind === "cover") {
      return {
        bed: [ids.backseatDogBed || 7586514567267],
        fans: [ids.dualHeadrestCoolingFans || 7827615121507],
        "single-seat-cover": [ids.singleSeatCover || 6845717872739],
        "cargo-cover": [ids.cargoCover || 6845717905507],
        "throw-blanket": [ids.throwBlanket || 7994154942563],
        "safety-belt": [ids.carSafetyBelt || 6762308337763],
        "travel-bowl": [ids.travelBowl || 6784072122467],
        "hair-removal-gloves": [ids.hairRemovalGloves || 7892526432355]
      };
    }
    if (kind === "pool") {
      return {
        "pool-cover": [ids.dogPoolCover || 6920870527075],
        "splash-pad": [ids.splashPad || 7383496261731],
        "paw-drying-mat": [ids.floorMat || 6735967256675],
        "quick-dry-towel": [ids.quickDryTowel || 7775269453923],
        "pool-travel-bowl": [ids.travelBowl || 6784072122467],
        "pool-hair-removal-gloves": [ids.hairRemovalGloves || 7892526432355]
      };
    }
    return {
      leash: [ids.tacticalLeash || 4508637560931],
      collar: [ids.tacticalCollar || 4508633759843],
      "patch-bundle": [ids.patchBundle || 6840101797987],
      "molle-pouch": [ids.tacticalPouch || 6744451809379],
      "custom-patch": [ids.customPatch || 4734560632931],
      "dog-goggles": [ids.dogGoggles || 6905734070371],
      "first-aid-kit": [ids.firstAidKit || 6884659200099],
      "safety-belt": [ids.carSafetyBelt || 6762308337763]
    };
  }

  function kitOfferComponent(kind, offerId) {
    var cover = {
      "backseat-bed": "bed",
      "dual-fans": "fans",
      "single-seat-cover": "single-seat-cover",
      "cargo-cover": "cargo-cover",
      "throw-blanket": "throw-blanket",
      "extra-safety-belt": "safety-belt",
      "travel-bowl": "travel-bowl",
      "hair-removal-gloves": "hair-removal-gloves"
    };
    var harness = {
      "matched-leash": "leash",
      "matched-collar": "collar",
      "patch-variety": "patch-bundle",
      "molle-pouch": "molle-pouch",
      "custom-patch": "custom-patch",
      "dog-goggles": "dog-goggles",
      "first-aid-kit": "first-aid-kit",
      "harness-safety-belt": "safety-belt"
    };
    var pool = {
      "pool-cover": "pool-cover",
      "splash-pad": "splash-pad",
      "paw-drying-mat": "paw-drying-mat",
      "quick-dry-towel": "quick-dry-towel",
      "pool-travel-bowl": "pool-travel-bowl",
      "pool-hair-removal-gloves": "pool-hair-removal-gloves"
    };
    return (kind === "cover" ? cover : kind === "pool" ? pool : harness)[offerId] || "";
  }

  function triggerProductIdMap(group) {
    var map = {};
    (group && group.triggerProductIds || []).forEach(function (id) {
      map[Number(id)] = true;
    });
    return map;
  }

  function lineMatchesKitContext(kind, componentId, triggerContext, line) {
    if (!triggerContext || !line) return true;
    var context = contextFromLine(line);
    if (kind === "cover" && componentId === "bed") {
      if (triggerContext.size && context.size && triggerContext.size !== context.size) return false;
      if (triggerContext.color && context.color && triggerContext.color !== context.color) return false;
    }
    if (kind === "pool" && componentId === "pool-cover") {
      if (triggerContext.size && context.size && triggerContext.size !== context.size) return false;
    }
    return true;
  }

  function componentsInCartForKit(kind, group, triggerContext) {
    var productMap = kitComponentProductIds(kind);
    var triggerMap = triggerProductIdMap(group);
    var found = [];
    cartItems().forEach(function (line) {
      var productId = Number(line && line.product_id);
      if (!productId || triggerMap[productId]) return;
      Object.keys(productMap).forEach(function (componentId) {
        if (productMap[componentId].map(Number).indexOf(productId) === -1) return;
        if (!lineMatchesKitContext(kind, componentId, triggerContext, line)) return;
        found.push(componentId);
      });
    });
    return componentUnique(found);
  }

  function coverBaseComponentsFromTriggerLines(lines) {
    var found = [];
    (lines || []).forEach(function (line) {
      var text = normalizeText(cartLineText(line));
      if (/plush backseat dog bed|backseat dog bed|seat cover \+ plush bed|plush bed|seat cover bed|cover bed|dog bed bundle/.test(text)) found.push("bed");
    });
    return componentUnique(found);
  }

  function poolBaseComponentsFromTriggerLines(lines) {
    var patterns = [
      { id: "pool-cover", pattern: /\b(waterproof\s*cover|pool\s*cover|dog\s*pool\s*cover)\b/ },
      { id: "splash-pad", pattern: /\b(splash\s*pad|fountain)\b/ },
      { id: "paw-drying-mat", pattern: /\b(paw[-\s]*drying|floor\s*mat|drying\s*mat)\b/ },
      { id: "quick-dry-towel", pattern: /\b(quick[-\s]*dry|dog\s*towel|towel)\b/ },
      { id: "pool-travel-bowl", pattern: /\b(travel\s*bowl|water\s*bowl|collapsible\s*bowl)\b/ }
    ];
    var found = [];
    (lines || []).forEach(function (line) {
      var text = normalizeText(cartLineText(line));
      patterns.forEach(function (item) {
        if (item.pattern.test(text)) found.push(item.id);
      });
    });
    return componentUnique(found);
  }

  function harnessMappedBaseComponents(line) {
    var map = offerEnginePricing("harness").variantBaseComponents || {};
    var variantId = String(line && (line.variant_id || line.id || line.variantId) || "");
    var components = map[variantId];
    return Array.isArray(components) ? components.slice() : [];
  }

  function harnessBaseComponentsFromTriggerLines(lines) {
    var patterns = [
      { id: "leash", pattern: /\b(leash|bungee)\b/ },
      { id: "collar", pattern: /\bcollar\b/ },
      { id: "patch-bundle", pattern: /\b(12\s*patch|12\s*patches|patch\s*bundle)\b/ },
      { id: "molle-pouch", pattern: /\b(molle|pouch)\b/ },
      { id: "custom-patch", pattern: /\b(custom\s*patch|personalized\s*patch|name\s*patch)\b/ },
      { id: "dog-goggles", pattern: /\b(doggles|dog\s*goggles|goggles)\b/ },
      { id: "first-aid-kit", pattern: /\b(first\s*aid)\b/ },
      { id: "safety-belt", pattern: /\b(safety\s*belt)\b/ }
    ];
    var found = [];
    (lines || []).forEach(function (line) {
      var mapped = harnessMappedBaseComponents(line);
      if (mapped.length) {
        found = found.concat(mapped);
        return;
      }
      var text = normalizeText(cartLineText(line));
      patterns.forEach(function (item) {
        if (item.pattern.test(text)) found.push(item.id);
      });
    });
    return componentUnique(found);
  }

  function offerEnginePricing(kind) {
    return state.offerEngine && state.offerEngine.pricing && state.offerEngine.pricing[kind] || {};
  }

  function engineCents(kind, mapName, key) {
    var map = offerEnginePricing(kind)[mapName] || {};
    var value = map[String(key)];
    return Number(value || 0);
  }

  function fallbackCoverBundleDiscounts() {
    return {
      bed: 2000,
      fans: 1000,
      "single-seat-cover": 1000,
      "cargo-cover": 1000,
      "bed|fans": 3500,
      "bed|single-seat-cover": 3500,
      "bed|cargo-cover": 3500,
      "fans|single-seat-cover": 2500,
      "cargo-cover|fans": 2500,
      "cargo-cover|single-seat-cover": 2500,
      "bed|fans|single-seat-cover": 5500,
      "bed|cargo-cover|fans": 5500,
      "bed|cargo-cover|single-seat-cover": 5500,
      "bed|cargo-cover|fans|single-seat-cover": 7000
    };
  }

  function fallbackComponentMap(kind, mapName) {
    var maps = {
      cover: {
        fallback: {
          bed: 2000,
          fans: 1000,
          "single-seat-cover": 1000,
          "cargo-cover": 1000,
          "throw-blanket": 500,
          "safety-belt": 500,
          "travel-bowl": 500
        },
        standalone: {
          bed: 8999,
          fans: 5999,
          "single-seat-cover": 4999,
          "cargo-cover": 7999,
          "throw-blanket": 3499,
          "safety-belt": 2499,
          "travel-bowl": 2499
        }
      },
      pool: {
        fallback: {
          "pool-cover": 1000,
          "splash-pad": 1000,
          "paw-drying-mat": 500,
          "quick-dry-towel": 500,
          "pool-travel-bowl": 500
        },
        standalone: {
          "pool-cover": 3499,
          "splash-pad": 7999,
          "paw-drying-mat": 3999,
          "quick-dry-towel": 3499,
          "pool-travel-bowl": 2499
        }
      },
      harness: {
        fallback: {
          leash: 500,
          collar: 500,
          "patch-bundle": 500,
          "molle-pouch": 500,
          "custom-patch": 500,
          "dog-goggles": 500,
          "first-aid-kit": 500,
          "safety-belt": 500
        },
        standalone: {
          leash: 4499,
          collar: 4499,
          "patch-bundle": 3999,
          "molle-pouch": 4499,
          "custom-patch": 2999,
          "dog-goggles": 5999,
          "first-aid-kit": 3499,
          "safety-belt": 2499
        }
      }
    };
    return maps[kind] && maps[kind][mapName] || {};
  }

  function componentMapCents(kind, mapName, componentId) {
    var runtimeMapName = mapName === "standalone" ? "componentStandaloneCents" : "componentFallbackDiscountCents";
    return engineCents(kind, runtimeMapName, componentId) || Number(fallbackComponentMap(kind, mapName)[componentId] || 0);
  }

  function coverBundleDiscountCents(components) {
    var key = componentKey(components);
    var runtime = engineCents("cover", "bundleDiscountCents", key);
    if (runtime) return runtime;
    return Number(fallbackCoverBundleDiscounts()[key] || 0);
  }

  function coverBundleKeys() {
    var runtime = offerEnginePricing("cover").bundleDiscountCents || {};
    var keys = Object.keys(runtime);
    return keys.length ? keys : Object.keys(fallbackCoverBundleDiscounts());
  }

  function fallbackPoolBundleDiscounts() {
    var components = ["pool-cover", "splash-pad", "paw-drying-mat", "quick-dry-towel", "pool-travel-bowl"];
    var primary = { "pool-cover": true, "splash-pad": true };
    var result = {};
    componentSubsets(components).forEach(function (selected) {
      if (!selected.length) return;
      var primaryCount = selected.filter(function (id) { return primary[id]; }).length;
      var secondaryCount = selected.length - primaryCount;
      result[componentKey(selected)] = (primaryCount * 1000) + (secondaryCount * 500) + (Math.max(selected.length - 1, 0) * 500);
    });
    return result;
  }

  function poolBundleDiscountCents(components) {
    var key = componentKey(components);
    var runtime = engineCents("pool", "bundleDiscountCents", key);
    if (runtime) return runtime;
    return Number(fallbackPoolBundleDiscounts()[key] || 0);
  }

  function poolBundleKeys() {
    var runtime = offerEnginePricing("pool").bundleDiscountCents || {};
    var keys = Object.keys(runtime);
    return keys.length ? keys : Object.keys(fallbackPoolBundleDiscounts());
  }

  function coverFallbackDiscountCents(componentId) {
    return componentMapCents("cover", "fallback", componentId);
  }

  function coverComponentStandaloneCents(componentId) {
    return componentMapCents("cover", "standalone", componentId);
  }

  function poolFallbackDiscountCents(componentId) {
    return componentMapCents("pool", "fallback", componentId);
  }

  function poolComponentStandaloneCents(componentId) {
    return componentMapCents("pool", "standalone", componentId);
  }

  function harnessComponentStandaloneCents(componentId) {
    return componentMapCents("harness", "standalone", componentId);
  }

  function allocatedKitPlan(totalCents, componentIds, fallbackForComponent, maxForComponent) {
    var remaining = Math.max(0, Number(totalCents || 0));
    var allocations = {};
    (componentIds || []).forEach(function (componentId) {
      var max = Math.max(0, Number(maxForComponent && maxForComponent(componentId) || 0));
      var amount = Math.min(remaining, Math.max(0, Number(fallbackForComponent(componentId) || 0)), max || remaining);
      allocations[componentId] = (allocations[componentId] || 0) + amount;
      remaining -= amount;
    });
    for (var index = (componentIds || []).length - 1; index >= 0 && remaining > 0; index -= 1) {
      var id = componentIds[index];
      var maxCents = Math.max(0, Number(maxForComponent && maxForComponent(id) || 0));
      var capacity = maxCents ? Math.max(maxCents - Number(allocations[id] || 0), 0) : remaining;
      var extra = Math.min(remaining, capacity);
      allocations[id] = (allocations[id] || 0) + extra;
      remaining -= extra;
    }
    var allocated = Object.keys(allocations).reduce(function (sum, id) {
      return sum + Number(allocations[id] || 0);
    }, 0);
    return {
      allocatedCents: allocated,
      allocations: allocations
    };
  }

  function bestCoverKitPlan(baseComponents, availableComponents) {
    var base = componentUnique(baseComponents);
    var available = componentUnique(availableComponents).filter(function (id) {
      return base.indexOf(id) === -1;
    });
    var baseDiscount = coverBundleDiscountCents(base);
    var comboKeys = coverBundleKeys();
    var best = null;
    componentSubsets(available).forEach(function (selected) {
      if (!selected.length) return;
      var combined = base.concat(selected);
      var exactKey = componentKey(combined);
      var candidateKeys = comboKeys.indexOf(exactKey) !== -1 ? [exactKey] : comboKeys.filter(function (key) {
        var comboComponents = key ? key.split("|") : [];
        return componentSubset(base, comboComponents) && componentSubset(comboComponents, combined);
      }).concat("");
      componentUnique(candidateKeys).forEach(function (comboKey) {
        var comboComponents = comboKey ? comboKey.split("|") : [];
        var comboAdded = selected.filter(function (id) {
          return comboComponents.indexOf(id) !== -1;
        });
        var fallbackComponents = selected.filter(function (id) {
          return comboComponents.indexOf(id) === -1;
        });
        var discount = comboKey && comboAdded.length ? Math.max(0, coverBundleDiscountCents(comboComponents) - baseDiscount) : 0;
        fallbackComponents.forEach(function (id) {
          discount += coverFallbackDiscountCents(id);
        });
        if (!discount) return;
        if (!best || discount > best.discountCents || (discount === best.discountCents && selected.length > best.componentIds.length)) {
          best = {
            discountCents: discount,
            componentIds: selected
          };
        }
      });
    });
    if (!best) return { discountCents: 0, allocatedCents: 0, allocations: {}, componentIds: [] };
    var allocated = allocatedKitPlan(best.discountCents, best.componentIds, coverFallbackDiscountCents, coverComponentStandaloneCents);
    return Object.assign({}, best, allocated);
  }

  function bestPoolKitPlan(baseComponents, availableComponents) {
    var base = componentUnique(baseComponents);
    var available = componentUnique(availableComponents).filter(function (id) {
      return base.indexOf(id) === -1;
    });
    var baseDiscount = poolBundleDiscountCents(base);
    var comboKeys = poolBundleKeys();
    var best = null;
    componentSubsets(available).forEach(function (selected) {
      if (!selected.length) return;
      var combined = base.concat(selected);
      var exactKey = componentKey(combined);
      var candidateKeys = comboKeys.indexOf(exactKey) !== -1 ? [exactKey] : comboKeys.filter(function (key) {
        var comboComponents = key ? key.split("|") : [];
        return componentSubset(base, comboComponents) && componentSubset(comboComponents, combined);
      }).concat("");
      componentUnique(candidateKeys).forEach(function (comboKey) {
        var comboComponents = comboKey ? comboKey.split("|") : [];
        var comboAdded = selected.filter(function (id) {
          return comboComponents.indexOf(id) !== -1;
        });
        var fallbackComponents = selected.filter(function (id) {
          return comboComponents.indexOf(id) === -1;
        });
        var discount = comboKey && comboAdded.length ? Math.max(0, poolBundleDiscountCents(comboComponents) - baseDiscount) : 0;
        fallbackComponents.forEach(function (id) {
          discount += poolFallbackDiscountCents(id);
        });
        if (!discount) return;
        if (!best || discount > best.discountCents || (discount === best.discountCents && selected.length > best.componentIds.length)) {
          best = {
            discountCents: discount,
            componentIds: selected
          };
        }
      });
    });
    if (!best) return { discountCents: 0, allocatedCents: 0, allocations: {}, componentIds: [] };
    var allocated = allocatedKitPlan(best.discountCents, best.componentIds, poolFallbackDiscountCents, poolComponentStandaloneCents);
    return Object.assign({}, best, allocated);
  }

  function harnessLadderDiscountCents(count) {
    var ladder = offerEnginePricing("harness").accessoryLadderCents || {
      1: 500,
      2: 1500,
      3: 3000,
      4: 5000,
      5: 7500,
      6: 10500,
      7: 14000,
      8: 18000
    };
    var best = 0;
    Object.keys(ladder).forEach(function (key) {
      if (Number(key) <= Number(count || 0)) best = Math.max(best, ladder[key]);
    });
    return best;
  }

  function harnessFallbackDiscountCents() {
    return componentMapCents("harness", "fallback", "leash") || 500;
  }

  function harnessPrebuiltComponentIncrementalCapsCents() {
    return offerEnginePricing("harness").prebuiltComponentIncrementalDiscountCapsCents || {};
  }

  function bestHarnessKitPlan(baseComponents, availableComponents) {
    var order = ["leash", "collar", "patch-bundle", "molle-pouch", "custom-patch", "dog-goggles", "first-aid-kit", "safety-belt"];
    var base = componentUnique(baseComponents);
    var openSlots = Math.max(8 - base.length, 0);
    var available = order.filter(function (id) {
      return base.indexOf(id) === -1 && componentUnique(availableComponents).indexOf(id) !== -1;
    }).slice(0, openSlots);
    var caps = base.length ? harnessPrebuiltComponentIncrementalCapsCents() : {};
    var runningCount = base.length;
    var discount = available.reduce(function (sum, componentId) {
      var before = harnessLadderDiscountCents(runningCount);
      var after = harnessLadderDiscountCents(runningCount + 1);
      runningCount += 1;
      var incrementalDiscount = Math.max(after - before, 0);
      var cap = Number(caps[componentId]);
      return sum + (Number.isFinite(cap) && cap >= 0 ? Math.min(incrementalDiscount, cap) : incrementalDiscount);
    }, 0);
    if (!discount || !available.length) return { discountCents: 0, allocatedCents: 0, allocations: {}, componentIds: [] };
    var allocated = allocatedKitPlan(discount, available, harnessFallbackDiscountCents, harnessComponentStandaloneCents);
    return Object.assign({
      discountCents: discount,
      componentIds: available
    }, allocated);
  }

  function applyKitLadderPreview(group, offer) {
    if (!group || !offer || offer.action === "change_variant") return offer;
    var kind = group.id === "seat-cover-setup" ? "cover" : group.id === "pool-setup" ? "pool" : group.id === "harness-setup" ? "harness" : "";
    if (!kind) return offer;
    var componentId = kitOfferComponent(kind, offer.id);
    if (!componentId) return offer;
    var triggerLines = triggerUnitsForGroup(group);
    var triggerContext = triggerLines.length ? contextFromLine(triggerLines[0]) : null;
    var baseComponents = kind === "cover"
      ? coverBaseComponentsFromTriggerLines(triggerLines)
      : kind === "pool"
        ? poolBaseComponentsFromTriggerLines(triggerLines)
        : harnessBaseComponentsFromTriggerLines(triggerLines);
    var currentComponents = componentsInCartForKit(kind, group, triggerContext);
    if (baseComponents.indexOf(componentId) !== -1 || currentComponents.indexOf(componentId) !== -1) return offer;
    var currentPlan = kind === "cover"
      ? bestCoverKitPlan(baseComponents, currentComponents)
      : kind === "pool"
        ? bestPoolKitPlan(baseComponents, currentComponents)
        : bestHarnessKitPlan(baseComponents, currentComponents);
    var nextComponents = currentComponents.concat(componentId);
    var nextPlan = kind === "cover"
      ? bestCoverKitPlan(baseComponents, nextComponents)
      : kind === "pool"
        ? bestPoolKitPlan(baseComponents, nextComponents)
        : bestHarnessKitPlan(baseComponents, nextComponents);
    var baseSavings = kind === "cover"
      ? coverBundleDiscountCents(baseComponents)
      : kind === "pool"
        ? poolBundleDiscountCents(baseComponents)
        : harnessLadderDiscountCents(baseComponents.length);
    var currentTotal = baseSavings + Number(currentPlan.allocatedCents || 0);
    var nextTotal = baseSavings + Number(nextPlan.allocatedCents || 0);
    var lineDiscount = Math.min(Number(nextPlan.allocations && nextPlan.allocations[componentId] || 0), Number(offer.standalonePriceCents || offer.compareAtPriceCents || 0));
    if (kind === "harness") {
      if (nextTotal <= currentTotal) return offer;
      if (lineDiscount) return applyLineDiscountPreview(offer, lineDiscount, currentTotal, nextTotal);
      return applyKitSavingsCueOnly(offer, currentTotal, nextTotal);
    }
    if (!lineDiscount || nextTotal <= currentTotal) return offer;
    return applyLineDiscountPreview(offer, lineDiscount, currentTotal, nextTotal);
  }

  function offerWithBlockedDiscount(offer) {
    if (!offer || !Array.isArray(offer.discountBlockedIfProductInCart) || !offer.discountBlockedIfProductInCart.length) return offer;
    if (!cartContainsAnyProduct(offer.discountBlockedIfProductInCart)) return offer;
    var standaloneMap = offer.discountBlockedPriceVariantMap || offer.standalonePriceVariantMap || offer.compareAtVariantMap || {};
    var standalonePrice = Number(offer.discountBlockedPriceCents || offer.standalonePriceCents || offer.compareAtPriceCents || offer.priceCents || 0);
    var blocked = Object.assign({}, offer, {
      priceCents: standalonePrice || Number(offer.priceCents || 0),
      standalonePriceCents: 0,
      compareAtPriceCents: 0,
      standalonePriceVariantMap: {},
      compareAtVariantMap: {},
      valueCue: offer.discountBlockedValueCue || offer.valueCue || ""
    });
    if (standaloneMap && Object.keys(standaloneMap).length) {
      blocked.priceVariantMap = standaloneMap;
    }
    return blocked;
  }

  function resolveOfferImage(offer, variantId, color) {
    var key = String(variantId || "");
    return offer.displayImageVariantMap && offer.displayImageVariantMap[key]
      ? offer.displayImageVariantMap[key]
      : offer.displayImageMap && offer.displayImageMap[color]
        ? offer.displayImageMap[color]
        : offer.displayImage
          ? offer.displayImage
          : offer.imageVariantMap && offer.imageVariantMap[key]
            ? offer.imageVariantMap[key]
            : offer.imageMap && offer.imageMap[color]
              ? offer.imageMap[color]
              : offer.image;
  }

  function sourceLineForChangeVariant(offer) {
    var sourceIds = (offer.sourceVariantIds || []).map(Number);
    if (!sourceIds.length) return null;
    return cartItems().find(function (item) {
      return sourceIds.indexOf(Number(item.variant_id || item.id)) !== -1;
    }) || null;
  }

  function targetVariantForChangeVariant(offer, sourceLine) {
    if (!offer || offer.action !== "change_variant") return null;
    if (offer.targetVariantMap && sourceLine) {
      var sourceId = String(sourceLine.variant_id || sourceLine.id || "");
      if (offer.targetVariantMap[sourceId]) {
        var mappedTargetId = Number(offer.targetVariantMap[sourceId]);
        if (
          Array.isArray(offer.targetVariantIds) &&
          offer.targetVariantIds.length &&
          offer.targetVariantIds.map(Number).indexOf(mappedTargetId) === -1
        ) {
          return null;
        }
        return mappedTargetId;
      }
    }
    return Number(offer.targetVariantId || 0) || null;
  }

  function colorLabel(color) {
    return {
      "pink-camo": "Pink Camo",
      "multicam": "MultiCam",
      "orange": "Blaze Orange",
      "black": "Black",
      "brown": "Brown",
      "green": "Olive Green",
      "gray": "Gray",
      "beige": "Beige",
      "lavender": "Lavender"
    }[color] || "";
  }

  function sizeLabel(size) {
    return {
      "extra-small": "XS",
      "small": "S",
      "medium": "M",
      "large": "L",
      "extra-large": "XL"
    }[size] || "";
  }

  function contextFromLine(line) {
    var color = detectColor(line);
    var size = detectSize(line);
    var label = [colorLabel(color), sizeLabel(size)].filter(Boolean).join(" / ");
    return {
      color: color,
      size: size,
      label: label || cartVariantMeta(line) || "Selected item",
      triggerLine: line
    };
  }

  function offerSupportsContextSelection(offer) {
    return Boolean(offer && offer.action !== "change_variant" && (offer.variantMap || offer.sizeVariantMap || offer.priceVariantMap || offer.imageMap));
  }

  function contextChoiceLabel(offer, context) {
    var color = colorLabel(context && context.color);
    var size = sizeLabel(context && context.size);
    if (offer && offer.variantMap && !offer.sizeVariantMap) return color || (context && context.label) || "Selected item";
    if (offer && offer.sizeVariantMap && !offer.variantMap) return size ? size + " fit" : (context && context.label) || "Selected item";
    return (context && context.label) || color || size || "Selected item";
  }

  function resolveOfferForContext(offer, context) {
    var color = context.color;
    if (
      offer.requireMatchedVariant &&
      offer.variantMap &&
      (!color || color === "default" || !offer.variantMap[color])
    ) {
      return null;
    }
    var variantId = resolveVariantId(offer, context);
    if (!variantId) return null;
    return {
      context: context,
      image: resolveOfferImage(offer, variantId, color),
      label: contextChoiceLabel(offer, context),
      priceCents: resolveOfferPriceCents(offer, variantId),
      standalonePriceCents: resolveOfferCompareAtCents(offer, variantId),
      variantId: variantId
    };
  }

  function dedupeOfferChoices(choices) {
    var seen = {};
    return (choices || []).filter(function (choice) {
      var key = [choice.variantId, choice.priceCents].join("|");
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function variantAvailabilityEntry(variantId) {
    if (!variantId || !state.availability || !state.availability.variantAvailability) return null;
    return state.availability.variantAvailability[String(variantId)] || null;
  }

  function isVariantAvailable(variantId, offer) {
    if (!variantId) return false;
    var entry = variantAvailabilityEntry(variantId);
    if (!entry) return true;
    if (offer && offer.allowBackorderUpsell && entry.available !== false) return true;
    if (entry.upsellEligible === false) return false;
    return entry.available !== false;
  }

  function filterAvailableOfferChoices(group, offer, choices) {
    return (choices || []).filter(function (choice) {
      if (!choice || !choice.variantId) return false;
      if (isVariantAvailable(choice.variantId, offer)) return true;
      trackSuppression(group, Object.assign({}, offer, { variantId: choice.variantId }), "variant_unavailable");
      return false;
    });
  }

  function availabilityEntryMatchesGroup(entry, groupId) {
    var refs = entry && Array.isArray(entry.refs) ? entry.refs : [];
    for (var index = 0; index < refs.length; index += 1) {
      if (String(refs[index].surface || "") !== "slide_cart") continue;
      var source = String(refs[index].source || "");
      if (source.indexOf("offer:" + groupId + ":") === 0) return true;
    }
    return false;
  }

  function liveAvailabilityHandlesForCurrentCart() {
    if (!state.availability || !state.availability.variantAvailability || !state.rules || !state.cart) return [];
    var groups = eligibleGroups();
    if (!groups.length) return [];
    var groupIds = {};
    groups.forEach(function (group) {
      if (group && group.id) groupIds[group.id] = true;
    });
    var handles = {};
    Object.keys(state.availability.variantAvailability).forEach(function (variantId) {
      var entry = state.availability.variantAvailability[variantId];
      var handle = entry && entry.productHandle;
      if (!handle) return;
      var matched = Object.keys(groupIds).some(function (groupId) {
        return availabilityEntryMatchesGroup(entry, groupId);
      });
      if (matched) handles[String(handle)] = true;
    });
    return Object.keys(handles);
  }

  function applyLiveAvailabilityProduct(product, handle) {
    if (!product || !Array.isArray(product.variants) || !state.availability || !state.availability.variantAvailability) return;
    product.variants.forEach(function (variant) {
      var key = String(variant && variant.id || "");
      var entry = state.availability.variantAvailability[key];
      if (!entry || String(entry.productHandle || "") !== String(handle || "")) return;
      if (typeof variant.available === "boolean") {
        entry.publicAvailable = variant.available;
        entry.available = variant.available;
        if (variant.available === false) {
          entry.availabilityState = "out_of_stock";
          entry.upsellEligible = false;
        } else {
          entry.upsellEligible = true;
        }
      }
    });
  }

  function loadLiveAvailabilityForHandle(handle) {
    handle = String(handle || "").trim();
    if (!handle || state.liveAvailabilityHandlesLoaded[handle]) return Promise.resolve();
    if (state.liveAvailabilityHandleRequests[handle]) return state.liveAvailabilityHandleRequests[handle];
    var request = fetchJson("/products/" + encodeURIComponent(handle) + ".js?tk9_offer_availability=" + Date.now(), { cache: "no-store" })
      .then(function (product) {
        applyLiveAvailabilityProduct(product, handle);
        state.liveAvailabilityHandlesLoaded[handle] = true;
      })
      .catch(function (error) {
        state.liveAvailabilityHandlesLoaded[handle] = true;
        debugLog("live offer availability lookup failed", handle, error);
      })
      .finally(function () {
        delete state.liveAvailabilityHandleRequests[handle];
      });
    state.liveAvailabilityHandleRequests[handle] = request;
    return request;
  }

  function loadLiveOfferAvailability() {
    var handles = liveAvailabilityHandlesForCurrentCart();
    if (!handles.length) return Promise.resolve();
    return Promise.all(handles.map(loadLiveAvailabilityForHandle)).then(function () {
      return null;
    });
  }

  function eligibleGroup() {
    var groups = eligibleGroups();
    return groups[0] || null;
  }

  function groupSuppressionReason(group) {
    if (!group) return "";
    if (group.suppressIfProductInCart && cartContainsAnyProduct(group.suppressIfProductInCart)) return "product_in_cart";
    return "";
  }

  function eligibleGroups() {
    if (!state.rules || !state.cart) return [];
    var groups = state.rules.offerGroups || [];
    var matched = groups
      .filter(function (group) {
        if (group.defaultFallback) return false;
        if (groupSuppressionReason(group)) return false;
        return cartContainsAnyProduct(group.triggerProductIds || []);
      })
      .sort(function (a, b) {
        return Number(b.priority || 0) - Number(a.priority || 0);
      });
    if (matched.length) return matched;
    if (!merchandiseCartItems().length) return [];
    return groups
      .filter(function (group) {
        return Boolean(group.defaultFallback);
      })
      .sort(function (a, b) {
        return Number(b.priority || 0) - Number(a.priority || 0);
      });
  }

  function suppressionReason(offer, presentProducts, presentVariants) {
    if (offer.requireProductInCart && !cartContainsAnyProduct(offer.requireProductInCart)) return "required_product_missing";
    if (offer.suppressIfProductInCart && offer.productId && presentProducts[offer.productId]) return "product_in_cart";
    if (Array.isArray(offer.suppressIfProductIdsPresent) && cartContainsAnyProduct(offer.suppressIfProductIdsPresent)) return "product_in_cart";
    if (offer.suppressIfCartContainsText && cartContainsAnyText(offer.suppressIfCartContainsText)) return "bundle_or_text_match";
    if (Number(offer.minCartProductQuantity || 0) > 0 || Number(offer.maxCartProductQuantity || 0) > 0) {
      var quantityProductIds = offer.cartQuantityProductIds || (offer.productId ? [offer.productId] : []);
      var cartProductQuantity = cartQuantityForProductIds(quantityProductIds);
      if (Number(offer.minCartProductQuantity || 0) > 0 && cartProductQuantity < Number(offer.minCartProductQuantity || 0)) return "cart_quantity_below_min";
      if (Number(offer.maxCartProductQuantity || 0) > 0 && cartProductQuantity > Number(offer.maxCartProductQuantity || 0)) return "cart_quantity_above_max";
    }
    if (offer.action === "change_variant" && offer.targetVariantId && presentVariants[offer.targetVariantId]) return "target_variant_in_cart";
    if (offer.action === "change_variant" && offer.sourceVariantIds && offer.sourceVariantIds.length) {
      var sourceLine = sourceLineForChangeVariant(offer);
      if (!sourceLine) return "source_variant_missing";
      var sourceQuantity = lineQuantity(sourceLine);
      if (Number(offer.minSourceQuantity || 0) > 0 && sourceQuantity < Number(offer.minSourceQuantity)) return "source_quantity_below_min";
      if (Number(offer.maxSourceQuantity || 0) > 0 && sourceQuantity > Number(offer.maxSourceQuantity)) return "source_quantity_above_max";
      var targetVariantId = targetVariantForChangeVariant(offer, sourceLine);
      if (!targetVariantId) return "no_matching_variant";
      if (!isVariantAvailable(targetVariantId, offer)) return "target_variant_unavailable";
      if (presentVariants[targetVariantId]) return "target_variant_in_cart";
      if (changeVariantComponentsAlreadyInCart(offer, sourceLine)) return "upgrade_components_already_in_cart";
      return "";
    }
    return "";
  }

  function lineScopedTriggerLines(offer, lines) {
    if (!offer || !offer.perTriggerLineOffer) return lines || [];
    if (offer.action === "change_variant") return lines || [];
    var coverageText = offer.triggerCoverageText || offer.suppressIfTriggerLineContainsText || offer.suppressIfCartContainsText || [];
    var availableByVariant = variantQuantitiesForProduct(offer.productId);
    return (lines || []).filter(function (line) {
      if (coverageText.length && cartLineContainsAnyText(line, coverageText)) return false;
      var resolved = resolveOfferForContext(offer, contextFromLine(line));
      if (!resolved || !resolved.variantId) return false;
      if (!isVariantAvailable(resolved.variantId, offer)) return false;
      var key = String(resolved.variantId);
      if (availableByVariant[key] > 0) {
        availableByVariant[key] -= 1;
        return false;
      }
      return true;
    });
  }

  function trackSuppression(group, offer, reason) {
    if (!reason) return;
    state.suppressed.push({
      groupId: group && group.id || "",
      offerId: offer && offer.id || "",
      productId: offer && offer.productId || "",
      variantId: offer && (offer.variantId || offer.fallbackVariantId || offer.targetVariantId) || "",
      reason: reason
    });
  }

  function resolveOffers(group) {
    if (!group) return [];
    var presentProducts = productIdsInCart();
    var presentVariants = variantIdsInCart();
    var triggerLines = triggerUnitsForGroup(group);
    var triggerLine = triggerLines[0] || {};
    var context = contextFromLine(triggerLine);
    var seenUpgradeTier = false;

    return (group.offers || [])
      .filter(function (offer) {
        var reason = suppressionReason(offer, presentProducts, presentVariants);
        if (reason) trackSuppression(group, offer, reason);
        if (reason) return false;
        return true;
      })
      .map(function (offer) {
        offer = harnessKitOfferPricing(offer);
        offer = offerWithBlockedDiscount(offer);
        var baseLines = triggerLines.length ? triggerLines.filter(function (line) {
          return !offer.suppressIfTriggerLineContainsText || !cartLineContainsAnyText(line, offer.suppressIfTriggerLineContainsText);
        }) : [];
        var lines = lineScopedTriggerLines(offer, baseLines);
        if (offer.perTriggerLineOffer && triggerLines.length && !lines.length) {
          trackSuppression(group, offer, "covered_for_trigger_lines");
          return null;
        }
        var hadVariantChoices = Array.isArray(offer.variantChoices) && offer.variantChoices.length;
        var variantChoices = hadVariantChoices ? offer.variantChoices.map(function (choice) {
          return {
            context: context,
            image: choice.image || offer.image,
            label: choice.label || "Selected option",
            priceCents: Number(choice.priceCents || offer.priceCents || 0),
            standalonePriceCents: Number(choice.standalonePriceCents || offer.standalonePriceCents || offer.compareAtPriceCents || 0),
            variantId: choice.variantId
          };
        }).filter(function (choice) {
          return Boolean(choice.variantId);
        }) : [];
        variantChoices = filterAvailableOfferChoices(group, offer, variantChoices);
        var changeSourceLine = offer.action === "change_variant" ? sourceLineForChangeVariant(offer) : null;
        var changeContext = changeSourceLine ? contextFromLine(changeSourceLine) : context;
        var changeTargetVariantId = targetVariantForChangeVariant(offer, changeSourceLine);
        var rawChoices = changeTargetVariantId ? [{
          context: changeContext,
          image: resolveOfferImage(offer, changeTargetVariantId, changeContext.color),
          label: changeSourceLine ? cartVariantMeta(changeSourceLine) : context.label,
          priceCents: resolveOfferPriceCents(offer, changeTargetVariantId),
          standalonePriceCents: resolveOfferCompareAtCents(offer, changeTargetVariantId),
            variantId: changeTargetVariantId
        }] : (variantChoices.length || hadVariantChoices) ? variantChoices : offerSupportsContextSelection(offer) ? dedupeOfferChoices(lines.map(function (line) {
          return resolveOfferForContext(offer, contextFromLine(line));
        }).filter(Boolean)) : [];
        var choices = filterAvailableOfferChoices(group, offer, rawChoices);
        var selected = choices[0] || (rawChoices.length || hadVariantChoices ? null : resolveOfferForContext(offer, context));
        if (selected && !isVariantAvailable(selected.variantId, offer)) {
          trackSuppression(group, Object.assign({}, offer, { variantId: selected.variantId }), "variant_unavailable");
          selected = null;
        }
        if (!selected) {
          trackSuppression(group, offer, "no_matching_variant");
          return null;
        }
        if (offer.displayPriceMode === "delta" && changeSourceLine && selected.priceCents) {
          var sourceUnitPrice = lineUnitOriginalPriceCents(changeSourceLine);
          var sourceCompareAt = bundleCompareAtCents(changeSourceLine) || sourceUnitPrice;
          var deltaCompareAt = Number(offer.deltaCompareAtPriceCents || 0);
          var standaloneTotal = Number(selected.standalonePriceCents || offer.standalonePriceCents || offer.compareAtPriceCents || 0);
          var consumedDisplayLines = standaloneLinesToConsumeForUpgrade(offer, changeSourceLine, 1);
          var consumedDisplayPrice = consumedDisplayLines.reduce(function (sum, item) {
            return sum + Number(item.valueCents || 0);
          }, 0);
          var consumedDisplayCompareAt = consumedDisplayLines.reduce(function (sum, item) {
            return sum + lineDisplayCompareValueForQuantity(item.line, item.quantity);
          }, 0);
          var displayPrice = Math.max(Number(selected.priceCents || 0) - sourceUnitPrice - consumedDisplayPrice, 0);
          var displayCompareAt = deltaCompareAt > 0
            ? Math.max(deltaCompareAt - consumedDisplayCompareAt, 0)
            : standaloneTotal > sourceCompareAt + consumedDisplayCompareAt
              ? Math.max(standaloneTotal - sourceCompareAt - consumedDisplayCompareAt, 0)
              : 0;
          var displaySavings = Math.max(displayCompareAt - displayPrice, 0);
          selected = Object.assign({}, selected, {
            priceCents: displayPrice,
            standalonePriceCents: displayCompareAt,
            valueCue: displaySavings ? "You save " + roundedDollarAmount(displaySavings) : ""
          });
        }
        return applyKitLadderPreview(group, Object.assign({}, offer, {
          context: selected.context,
          contextChoices: choices.length > 1 ? choices : [],
          contextChoiceLabel: variantChoices.length ? (offer.variantChoiceLabel || "Choose") : "Match",
          image: selected.image,
          priceCents: selected.priceCents,
          standalonePriceCents: selected.standalonePriceCents || offer.standalonePriceCents,
          valueCue: selected.valueCue || offer.valueCue,
          variantId: selected.variantId
        }));
      })
      .filter(function (offer) {
        if (!offer || !offer.variantId) return false;
        if (offer.tier === "upgrade") {
          if (seenUpgradeTier) {
            trackSuppression(group, offer, "ladder_next_rung_hidden");
            return false;
          }
          seenUpgradeTier = true;
        }
        return true;
      })
      .slice(0, Number(state.rules.cart && state.rules.cart.maxOffers) || 5);
  }

  function offerDedupeKey(offer) {
    if (offer.action === "change_variant") return "change:" + (offer.variantId || offer.targetVariantId || offer.id);
    if (offer.productId) return "product:" + offer.productId;
    return "variant:" + (offer.variantId || offer.id);
  }

  function prioritizedOffersForGroup(group, offers) {
    if (!group || group.id !== "harness-setup") return offers;
    var order = {
      "upgrade-2mbh-to-4mbh": 5,
      "custom-patch": 10,
      "matched-leash": 20,
      "matched-collar": 30,
      "patch-variety": 40,
      "harness-safety-belt": 45,
      "single-style-patch": 50,
      "upgrade-complete-matching-set": 60,
      "molle-pouch": 70,
      "dog-goggles": 80,
      "first-aid-kit": 90,
      "harness-hair-removal-gloves": 100,
      "harness-travel-bowl": 110,
      "waste-bags": 120
    };
    return offers.map(function (offer, index) {
      return { offer: offer, index: index };
    }).sort(function (left, right) {
      var leftRank = order[left.offer && left.offer.id] || 1000;
      var rightRank = order[right.offer && right.offer.id] || 1000;
      if (leftRank !== rightRank) return leftRank - rightRank;
      return left.index - right.index;
    }).map(function (entry) {
      return entry.offer;
    });
  }

  function resolveOfferWall(groups) {
    var seen = {};
    var maxOffers = Number(state.rules && state.rules.cart && state.rules.cart.maxOffers) || 8;
    var offers = [];
    state.suppressed = [];
    var groupOffers = (groups || []).map(function (group) {
      return {
        group: group,
        offers: prioritizedOffersForGroup(group, resolveOffers(group))
      };
    });

    function addOffer(group, offer) {
      if (!group || !offer || offers.length >= maxOffers) return false;
      var key = offerDedupeKey(offer);
      if (seen[key]) return false;
      seen[key] = true;
      offers.push(Object.assign({}, offer, {
        groupId: group.id,
        groupTitle: group.title
      }));
      return true;
    }

    if (groupOffers.length <= 1) {
      groupOffers.forEach(function (entry) {
        entry.offers.forEach(function (offer) {
          addOffer(entry.group, offer);
        });
      });
      return offers;
    }

    groupOffers.forEach(function (entry) {
      addOffer(entry.group, entry.offers[0]);
    });

    var index = 1;
    while (offers.length < maxOffers) {
      var added = false;
      groupOffers.forEach(function (entry) {
        if (offers.length >= maxOffers) return;
        if (addOffer(entry.group, entry.offers[index])) added = true;
      });
      if (!added) break;
      index += 1;
    }
    return offers;
  }

  function suppressionSummary() {
    var seen = {};
    return (state.suppressed || []).filter(function (item) {
      var key = [item.groupId, item.offerId, item.reason].join("|");
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function shippingState() {
    var threshold = Number(state.rules && state.rules.cart && state.rules.cart.freeShippingThresholdCents) || 9900;
    var total = Number(state.cart && state.cart.total_price) || 0;
    var original = Number(state.cart && state.cart.original_total_price) || total;
    var discountTotal = Number(state.cart && state.cart.total_discount) || Math.max(original - total, 0);
    var hasActiveDiscount = discountTotal > 0;
    var knownDiscountCode = activeDiscountCode();
    var safeRules = state.rules && state.rules.cart && state.rules.cart.discountSafeThresholds;
    var safeRule = knownDiscountCode && !hasActiveDiscount && Array.isArray(safeRules) ? safeRules.find(function (rule) {
      return normalizeText(rule.code) === normalizeText(knownDiscountCode);
    }) : null;
    var safeRate = safeRule ? Number(safeRule.rate || 0) : 0;
    var safeThreshold = safeRate > 0 && safeRate < 1 ? Math.ceil(threshold / (1 - safeRate)) : threshold;
    var safeRemaining = Math.max(safeThreshold - total, 0);
    var remaining = Math.max(threshold - total, 0);
    var preDiscountUnlocked = !hasActiveDiscount && safeRule && remaining <= 0 && safeRemaining > 0;
    var secured = remaining <= 0 && (!safeRule || safeRemaining <= 0 || hasActiveDiscount);
    return {
      discountCode: safeRule && safeRule.code || "",
      discountRate: safeRate,
      hasActiveDiscount: hasActiveDiscount,
      preDiscountUnlocked: Boolean(preDiscountUnlocked),
      secured: Boolean(secured),
      safeRemaining: safeRemaining,
      safeThreshold: safeThreshold,
      threshold: threshold,
      total: total,
      remaining: remaining,
      unlocked: remaining <= 0,
      progress: Math.min(Math.floor((total / (preDiscountUnlocked ? safeThreshold : threshold)) * 100), 100)
    };
  }

  function shippingCue(offer, shipping) {
    var valueCue = offer.valueCue || "";
    var isShippingCue = /free shipping/i.test(valueCue);
    if (!shipping) return valueCue;
    if (shipping.unlocked || shipping.secured) return isShippingCue ? "" : valueCue;
    if (offer && offer.action === "link") return isShippingCue ? "" : valueCue;
    if (Number(offer.priceCents || 0) >= shipping.remaining) return "Unlocks FREE shipping";
    if (isShippingCue) return "";
    return valueCue;
  }

  function savingsCueText(cue) {
    var text = String(cue || "").trim();
    var match = text.match(/(?:you\s+)?save\s+\$?([0-9]+(?:\.[0-9]+)?)/i);
    if (!match) return "";
    var rounded = roundedDollarAmount(Number(match[1] || 0) * 100);
    return rounded ? rounded + " OFF" : "";
  }

  function shippingOfferLabel(offer) {
    var labels = {
      "custom-patch": "Custom Patch",
      "matched-leash": "Leash",
      "matched-collar": "Collar",
      "molle-pouch": "MOLLE Pouch",
      "patch-variety": "Patch Bundle",
      "harness-safety-belt": "Safety Belt",
      "harness-travel-bowl": "Travel Bowl",
      "travel-bowl": "Travel Bowl",
      "pool-travel-bowl": "Travel Bowl",
      "fan-travel-bowl": "Travel Bowl",
      "gloves-fan-two-pack": "2-Pack Fans",
      "gloves-backseat-bed": "Backseat Bed",
      "gloves-throw-blanket": "Throw Blanket",
      "gloves-travel-bowl": "Travel Bowl"
    };
    if (offer && labels[offer.id]) return labels[offer.id];
    return String(offer && offer.title || "an add-on")
      .replace(/\s*\(USB-A\)\s*/g, "")
      .replace(/^Heavy-Duty Tactical /, "")
      .replace(/^Tactical /, "")
      .replace(/^Custom Hook & Loop /, "Custom ");
  }

  function shippingHint(offers, shipping) {
    if (!shipping || shipping.unlocked) return "";
    var unlockers = offers.filter(function (offer) {
      return offer && offer.action !== "link" && Number(offer.priceCents || 0) >= shipping.remaining;
    });
    if (!unlockers.length) return "Add " + money(shipping.remaining) + " more to unlock FREE shipping";
    return "Add " + unlockers.slice(0, 2).map(function (offer) {
      return shippingOfferLabel(offer);
    }).join(" or ") + " for FREE shipping";
  }

  function shippingProgressText(shipping) {
    if (!shipping) return "";
    if (shipping.secured && shipping.discountCode) return "FREE shipping secured with " + shipping.discountCode;
    if (shipping.preDiscountUnlocked) return "FREE shipping before discount";
    return shipping.unlocked ? "FREE shipping unlocked" : money(shipping.remaining) + " away from FREE shipping";
  }

  function shippingProgressHint(offers, shipping) {
    if (!shipping) return "";
    if (shipping.preDiscountUnlocked) return "Add " + money(shipping.safeRemaining) + " after " + shipping.discountCode;
    if (shipping.secured) return "";
    return shipping.unlocked ? "" : shippingHint(offers, shipping);
  }

  var EVENT_ALIASES = {
    tk9_cart_open: ["tk9_slide_cart_opened"],
    tk9_upsell_add: ["tk9_slide_cart_upsell_added"],
    tk9_discount_apply: ["tk9_slide_cart_discount_applied"],
    tk9_cart_checkout_click: ["tk9_slide_cart_checkout_clicked"]
  };

  function dispatchTrackedEvent(eventName, detail) {
    try {
      var event = new CustomEvent(eventName, { detail: detail || {} });
      document.dispatchEvent(event);
      window.dispatchEvent(event);
    } catch (error) {}
  }

  function trackLuckyOrange(eventName, detail) {
    try {
      window.LOQ = window.LOQ || [];
      window.LOQ.push(["ready", function (LO) {
        try {
          if (!LO || !LO.$internal || !LO.events || !LO.events.track) return;
          LO.$internal.ready("events").then(function () {
            LO.events.track(eventName, detail || {});
          });
        } catch (error) {}
      }]);
    } catch (error) {}
  }

  function emit(eventName, payload) {
    var detail = Object.assign({
      tk9_source: "native_slide_cart",
      tk9_component: "slide_cart",
      tk9_experiment: config.experimentId,
      tk9_variation: activeVariationId(),
      tk9_layout_variant: activeLayoutVariant(),
      tk9_presentation_variant: activePresentationVariant(),
      tk9_cart_value_add_experiment: config.cartValueAddExperimentId,
      tk9_cart_value_add_arm: activeCartValueAddArm(),
      tk9_cart_value_add_slot_count: cartValueAddSlotCount()
    }, payload || {});
    var aliases = EVENT_ALIASES[eventName] || [];
    window.dataLayer = window.dataLayer || [];
    [eventName].concat(aliases).forEach(function (name) {
      window.dataLayer.push(Object.assign({ event: name }, detail));
      dispatchTrackedEvent(name, detail);
      trackLuckyOrange(name, detail);
    });
  }

  function absoluteCartUrl(path) {
    try {
      return new URL(path || "/cart", window.location.origin).href;
    } catch (error) {
      return window.location.origin + (path || "/cart");
    }
  }

  function customPatchDiscountCode(dogName) {
    var configuredCode = String(window.TK9_CUSTOM_PATCH_DISCOUNT_CODE || "").trim();
    if (configuredCode) return configuredCode;
    if (config.dogdadSaleEnabled && config.dogdadSaleCode) return String(config.dogdadSaleCode).trim();
    return "";
  }

  function customPatchDiscountApplyUrl(code) {
    var configuredUrl = String(window.TK9_CUSTOM_PATCH_DISCOUNT_APPLY_URL || "").trim();
    if (configuredUrl) return configuredUrl;
    if (!code) return absoluteCartUrl(config.cartPageUrl || "/cart");
    return absoluteCartUrl("/discount/" + encodeURIComponent(code) + "?redirect=/cart");
  }

  function trackKlaviyoEvent(eventName, payload) {
    try {
      var klaviyo = window.klaviyo;
      if (klaviyo && typeof klaviyo.track === "function") {
        klaviyo.track(eventName, payload || {});
        return true;
      }
      if (klaviyo && typeof klaviyo.push === "function") {
        klaviyo.push(["track", eventName, payload || {}]);
        return true;
      }
      if (window._learnq && typeof window._learnq.push === "function") {
        window._learnq.push(["track", eventName, payload || {}]);
        return true;
      }
      window.klaviyo = window.klaviyo || [];
      if (typeof window.klaviyo.push === "function") {
        window.klaviyo.push(["track", eventName, payload || {}]);
        return true;
      }
    } catch (error) {
      debugLog("klaviyo track failed", error);
    }
    return false;
  }

  function cartHasLineMatching(pattern) {
    var items = state.cart && state.cart.items || [];
    return items.some(function (item) {
      var title = String(item && (item.product_title || item.title || "") || "");
      return pattern.test(title);
    });
  }

  function customPatchSourceInfo(source) {
    var surface = String(source || "").trim() || "slide-cart";
    var clean = surface.toLowerCase();
    var isPdp = /pdp|product/.test(clean);
    var isCart = /cart|slide/.test(clean);
    var label = isPdp ? "PDP" : (isCart ? "Cart" : "Unknown");
    var code = label === "PDP" ? "pdp" : (label === "Cart" ? "cart" : clean.replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "") || "unknown");
    return {
      code: code,
      label: label,
      surface: surface
    };
  }

  function addCustomPatchSourceProperties(properties, source) {
    if (!properties) return properties;
    var info = customPatchSourceInfo(source);
    properties._tk9_custom_patch_source = info.code;
    properties._tk9_custom_patch_source_label = info.label;
    properties._tk9_custom_patch_source_surface = info.surface;
    return properties;
  }

  function customPatchSourceAttributes(source) {
    var info = customPatchSourceInfo(source);
    return {
      tk9_custom_patch_last_source: info.code,
      tk9_custom_patch_last_source_label: info.label,
      tk9_custom_patch_last_source_surface: info.surface
    };
  }

  function emitCustomPatchProofCreated(properties, source, extra) {
    var line1 = String(properties && properties._tk9_patch_mockup_line_1 || "").trim();
    var line2 = String(properties && properties._tk9_patch_mockup_line_2 || "").trim();
    var imageUrl = String(properties && properties._tk9_patch_mockup_url || "").trim();
    if (!line1 || !imageUrl) return;
    var sourceInfo = customPatchSourceInfo(source);

    var dedupeKey = [imageUrl, line1, line2].join("|");
    window.__tk9CustomPatchProofEvents = window.__tk9CustomPatchProofEvents || {};
    if (window.__tk9CustomPatchProofEvents[dedupeKey]) return;
    window.__tk9CustomPatchProofEvents[dedupeKey] = true;

    var discountCode = customPatchDiscountCode(line1);
    var payload = Object.assign({
      event_id: "tk9-patch-proof-" + Date.now() + "-" + Math.random().toString(16).slice(2),
      dog_name: line1,
      patch_line_1: line1,
      patch_line_2: line2,
      has_patch_phone_line: Boolean(line2),
      custom_patch_proof_visual_url: imageUrl,
      discount_code_display: discountCode,
      discount_code_apply_url: customPatchDiscountApplyUrl(discountCode),
      dog_name_discount_code_candidate: line1.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 24),
      cart_url: absoluteCartUrl(config.cartPageUrl || "/cart"),
      checkout_url: absoluteCartUrl(config.checkoutUrl || "/checkout"),
      cart_contains_harness: cartHasLineMatching(/harness/i),
      cart_contains_custom_patch: true,
      cart_item_count: state.cart && state.cart.item_count ? state.cart.item_count : "",
      cart_subtotal: state.cart && state.cart.total_price ? Number(state.cart.total_price) / 100 : "",
      source_surface: sourceInfo.surface,
      custom_patch_source: sourceInfo.code,
      custom_patch_source_label: sourceInfo.label,
      lane: "harness_walk"
    }, extra || {});

    emit("tk9_custom_patch_proof_created", {
      tk9_patch_line_1: line1,
      tk9_patch_line_2_present: line2 ? "1" : "0",
      tk9_patch_mockup_url: imageUrl,
      tk9_source_surface: payload.source_surface,
      tk9_custom_patch_source: payload.custom_patch_source,
      tk9_custom_patch_source_label: payload.custom_patch_source_label,
      tk9_klaviyo_metric: "TK9 Custom Patch Proof Created"
    });
    trackKlaviyoEvent("TK9 Custom Patch Proof Created", payload);
  }

  function fetchJson(url, options) {
    return fetch(url, Object.assign({
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }, options || {})).then(function (response) {
      return response.text().then(function (text) {
        var json = null;
        try {
          json = text ? JSON.parse(text) : null;
        } catch (error) {}
        if (!response.ok) {
          var failure = new Error("Team K9 cart request failed");
          failure.status = response.status;
          failure.body = text;
          throw failure;
        }
        return json;
      });
    });
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function markCartAttributedInBackground(reason, extraAttributes) {
    markCartAttributed(reason, extraAttributes).then(function () {
      if (!state.busy && state.open) {
        return refresh().then(open).catch(function (error) {
          debugLog("background attribution refresh failed", error);
        });
      }
      return null;
    }).catch(function (error) {
      debugLog("background attribution failed", error);
    });
  }

  function sameAttributes(current, next) {
    var currentKeys = Object.keys(current || {});
    var nextKeys = Object.keys(next || {});
    if (currentKeys.length !== nextKeys.length) return false;
    return nextKeys.every(function (key) {
      return String((current || {})[key] || "") === String(next[key] || "");
    });
  }

  function lineProperties(line) {
    var props = line && line.properties;
    return props && typeof props === "object" && !Array.isArray(props) ? props : {};
  }

  function readableTrackingId(value) {
    return String(value || "").trim().replace(/_/g, "-").toLowerCase();
  }

  function trackedLineType(line) {
    var props = lineProperties(line);
    return readableTrackingId(props._tk9_type || props._tk9_slide_cart_type);
  }

  function trackedLineId(line) {
    var props = lineProperties(line);
    return readableTrackingId(
      props._tk9_offer ||
      props._tk9_protection ||
      props._tk9_id ||
      props._tk9_slide_cart_offer ||
      props._tk9_slide_cart_protection ||
      props._tk9_slide_cart_id
    );
  }

  function trackingCatalog() {
    var labels = {};
    ((state.rules && state.rules.protection) || []).forEach(function (item) {
      if (item && item.id) labels[readableTrackingId(item.id)] = item.title || item.id;
    });
    ((state.rules && state.rules.offerGroups) || []).forEach(function (group) {
      ((group && group.offers) || []).forEach(function (offer) {
        if (offer && offer.id) labels[readableTrackingId(offer.id)] = offer.title || offer.id;
      });
    });
    return labels;
  }

  function trackingLabel(id, catalog) {
    var cleanId = readableTrackingId(id);
    if (!cleanId) return "";
    return catalog[cleanId] || cleanId.replace(/-/g, " ").replace(/\b\w/g, function (letter) {
      return letter.toUpperCase();
    });
  }

  function lineTrackingValue(line) {
    var props = lineProperties(line);
    var upgradeDelta = Number(props._tk9_upgrade_delta_cents);
    if (Number.isFinite(upgradeDelta) && upgradeDelta >= 0) return upgradeDelta;
    var value = Number(line && line.final_line_price);
    if (!Number.isFinite(value)) value = Number(line && line.line_price);
    if (!Number.isFinite(value)) value = Number(line && line.price) * Number(line && line.quantity || 1);
    return Number.isFinite(value) ? value : 0;
  }

  function lineTrackingValueForQuantity(line, quantity) {
    var lineQuantityValue = lineQuantity(line);
    var value = lineTrackingValue(line);
    var unitValue = lineQuantityValue > 0 ? Math.round(value / lineQuantityValue) : value;
    return Math.max(0, unitValue * Math.max(0, Number(quantity || 0)));
  }

  function cartKitSelectionSummary() {
    var selections = {};
    cartItems().forEach(function (line) {
      var props = lineProperties(line);
      var selection = cleanKitSelectionText(
        props._tk9_kit_selection ||
        props._tk9_variant_selection ||
        line && line.variant_title ||
        ""
      );
      if (!selection || /^default title$/i.test(selection)) return;
      selections[selection] = (selections[selection] || 0) + lineQuantity(line);
    });
    return Object.keys(selections).map(function (selection) {
      return selection + (selections[selection] > 1 ? " x" + selections[selection] : "");
    }).slice(0, 6).join(", ");
  }

  function cartKitSelectionPayload() {
    return {
      tk9_cart_kit_selection: cartKitSelectionSummary()
    };
  }

  function lineDisplayCompareValueForQuantity(line, quantity) {
    var lineQuantityValue = lineQuantity(line);
    var pricing = displayLinePricing(line);
    var compareLine = Number(pricing && pricing.compareLine);
    if (!Number.isFinite(compareLine) || compareLine <= 0) {
      compareLine = Math.max(
        bundleCompareAtCents(line) * lineQuantityValue,
        cartLineOriginalLineCents(line),
        lineTrackingValue(line)
      );
    }
    var unitCompare = lineQuantityValue > 0 ? Math.round(compareLine / lineQuantityValue) : compareLine;
    return Math.max(0, unitCompare * Math.max(0, Number(quantity || 0)));
  }

  function bundleComponentMap() {
    return [
      { id: "leash", productId: 4508637560931, colorMatched: false, pattern: /\b(leash|bungee)\b/i },
      { id: "collar", productId: 4508633759843, colorMatched: false, pattern: /\bcollar\b/i },
      { id: "patch-bundle", productId: 6840101797987, colorMatched: false, pattern: /\b(12\s*patch|12\s*patches|patch\s*bundle|patches)\b/i },
      { id: "molle-pouch", productId: 6744451809379, colorMatched: false, pattern: /\b(molle|pouch)\b/i }
    ];
  }

  function bundleComponentsInText(text) {
    var normalized = normalizeText(text);
    return bundleComponentMap().filter(function (component) {
      return component.pattern.test(normalized);
    }).map(function (component) {
      return component.id;
    });
  }

  function upgradeTargetComponentIds(offer) {
    return bundleComponentsInText([
      offer && offer.id,
      offer && offer.title,
      offer && offer.copy,
      offer && offer.includesLabel,
      offer && offer.displayIncludes && offer.displayIncludes.join(" "),
      offer && offer.includes && offer.includes.join(" "),
      offer && offer.triggerCoverageText && offer.triggerCoverageText.join(" ")
    ].join(" "));
  }

  function sourceBundleComponentIds(sourceLine) {
    return bundleComponentsInText(cartLineText(sourceLine));
  }

  function standaloneLinesToConsumeForUpgrade(offer, sourceLine, targetQuantity) {
    var sourceComponents = sourceBundleComponentIds(sourceLine);
    var targetComponents = upgradeTargetComponentIds(offer).filter(function (componentId) {
      return sourceComponents.indexOf(componentId) === -1;
    });
    var sourceContext = contextFromLine(sourceLine);
    var components = bundleComponentMap().filter(function (component) {
      return targetComponents.indexOf(component.id) !== -1;
    });
    var consumed = [];
    components.forEach(function (component) {
      var remaining = Math.max(1, Number(targetQuantity || 1));
      cartItems().forEach(function (line) {
        if (!remaining) return;
        if (!line || line.key === sourceLine.key) return;
        if (Number(line.product_id) !== Number(component.productId)) return;
        if (component.colorMatched) {
          var lineContext = contextFromLine(line);
          if (sourceContext.color && lineContext.color && sourceContext.color !== lineContext.color) return;
        }
        var removeQuantity = Math.min(lineQuantity(line), remaining);
        consumed.push({
          line: line,
          quantity: removeQuantity,
          valueCents: lineTrackingValueForQuantity(line, removeQuantity),
          componentId: component.id
        });
        remaining -= removeQuantity;
      });
    });
    return consumed;
  }

  function changeVariantComponentsAlreadyInCart(offer, sourceLine) {
    if (!offer || offer.action !== "change_variant" || !sourceLine) return false;
    var sourceComponents = sourceBundleComponentIds(sourceLine);
    var targetComponents = upgradeTargetComponentIds(offer).filter(function (componentId) {
      return sourceComponents.indexOf(componentId) === -1;
    });
    if (!targetComponents.length) return false;
    var needed = {};
    targetComponents.forEach(function (componentId) {
      needed[componentId] = Math.max(1, lineQuantity(sourceLine));
    });
    standaloneLinesToConsumeForUpgrade(offer, sourceLine, lineQuantity(sourceLine)).forEach(function (entry) {
      if (!needed[entry.componentId]) return;
      needed[entry.componentId] -= Math.max(1, Number(entry.quantity || 1));
    });
    return targetComponents.every(function (componentId) {
      return needed[componentId] <= 0;
    });
  }

  function lineUpgradeDelta(line) {
    var props = lineProperties(line);
    var upgradeDelta = Number(props._tk9_upgrade_delta_cents);
    return Number.isFinite(upgradeDelta) && upgradeDelta > 0 ? upgradeDelta : 0;
  }

  function formatTrackingList(entries, catalog) {
    if (!entries.length) return "none";
    return entries.slice(0, 4).map(function (entry) {
      return trackingLabel(entry.id, catalog) + " (" + money(entry.value) + ")";
    }).join(", ") + (entries.length > 4 ? ", +" + (entries.length - 4) + " more" : "");
  }

  function buildReadableCartAttributes(reason, extraAttributes) {
    var offerMap = {};
    var upgradeMap = {};
    var protectionMap = {};
    var customPatchSources = {};
    var offerValue = 0;
    var upgradeValue = 0;
    var protectionValue = 0;

    cartItems().forEach(function (line) {
      var props = lineProperties(line);
      var type = trackedLineType(line);
      var id = trackedLineId(line);
      var value = lineTrackingValue(line);
      var upgradeDelta = lineUpgradeDelta(line);
      var patchSourceLabel = String(props._tk9_custom_patch_source_label || "").trim();
      if (patchSourceLabel) customPatchSources[patchSourceLabel] = true;
      if (type === "offer") {
        if (upgradeDelta > 0) {
          if (id) upgradeMap[id] = (upgradeMap[id] || 0) + upgradeDelta;
          upgradeValue += upgradeDelta;
        } else {
          if (id) offerMap[id] = (offerMap[id] || 0) + value;
          offerValue += value;
        }
      }
      if (type === "protection") {
        if (id) protectionMap[id] = (protectionMap[id] || 0) + value;
        protectionValue += value;
      }
    });

    var catalog = trackingCatalog();
    var cleanOfferIds = Object.keys(offerMap);
    var cleanUpgradeIds = Object.keys(upgradeMap);
    var cleanProtectionIds = Object.keys(protectionMap);
    var offerEntries = cleanOfferIds.map(function (id) {
      return { id: id, value: offerMap[id] };
    });
    var upgradeEntries = cleanUpgradeIds.map(function (id) {
      return { id: id, value: upgradeMap[id] };
    });
    var protectionEntries = cleanProtectionIds.map(function (id) {
      return { id: id, value: protectionMap[id] };
    });
    var discountCode = activeDiscountCode();
    var totalValue = offerValue + upgradeValue + protectionValue;
    var customPatchSourceLabels = Object.keys(customPatchSources);
    var kitSelectionSummary = cartKitSelectionSummary();
    var parts = [
      "Native slide cart",
      "value added: " + money(totalValue),
      "upgrades: " + formatTrackingList(upgradeEntries, catalog),
      "add-ons: " + formatTrackingList(offerEntries, catalog),
      "protection: " + formatTrackingList(protectionEntries, catalog)
    ];
    if (discountCode) parts.push("discount: " + discountCode.toUpperCase());
    if (reason) parts.push("last: " + reason);

    var compactAttributes = {
      tk9_slide_cart_summary: parts.join(" | "),
      tk9_slide_cart_value_added: money(totalValue),
      tk9_slide_cart_variation: activeVariationId(),
      tk9_slide_cart_layout: activeLayoutVariant(),
      tk9_slide_cart_presentation: activePresentationVariant(),
      tk9_cart_value_add_experiment: config.cartValueAddExperimentId,
      tk9_cart_value_add_arm: activeCartValueAddArm(),
      tk9_cart_value_add_slot_count: cartValueAddSlotCount()
    };
    if (upgradeValue > 0) compactAttributes.tk9_slide_cart_upgrade_value = money(upgradeValue);
    if (offerValue > 0) compactAttributes.tk9_slide_cart_addon_value = money(offerValue);
    if (protectionValue > 0) compactAttributes.tk9_slide_cart_protection_value = money(protectionValue);
    if (discountCode) compactAttributes.tk9_slide_cart_discount = discountCode.toUpperCase();
    if (customPatchSourceLabels.length) compactAttributes.tk9_custom_patch_sources = customPatchSourceLabels.join(", ");
    if (kitSelectionSummary) compactAttributes.tk9_cart_kit_selection = kitSelectionSummary;
    return Object.assign(compactAttributes, extraAttributes || {});
  }

  function compactCartAttributes(attributes) {
    var compact = {};
    Object.keys(attributes || {}).forEach(function (key) {
      if (key.indexOf("tk9_slide_cart") === 0) return;
      if (key === "_tk9_discount_code") return;
      compact[key] = attributes[key];
    });
    return compact;
  }

  function attributionProperties(type, id, surface) {
    var properties = {};
    if (surface) properties._tk9_surface = surface;
    if (type) properties._tk9_type = type;
    if (id) properties._tk9_id = id;
    if (type === "offer" && id) properties._tk9_offer = id;
    if (type === "protection" && id) properties._tk9_protection = id;
    if (surface === "cart") {
      properties._tk9_cart_value_add_experiment = config.cartValueAddExperimentId || "";
      properties._tk9_cart_value_add_arm = activeCartValueAddArm();
      properties._tk9_cart_value_add_slot_count = String(cartValueAddSlotCount());
      properties._tk9_cart_value_add_presentation = activePresentationVariant();
    }
    return properties;
  }

  function currentCartDiscountCodes(){return(state.cart&&state.cart.discount_codes||[]).filter(function(item){return item&&item.applicable!==!1&&item.code}).map(function(item){return String(item.code).trim().toUpperCase()})}function contextualOfferDiscountCode(offer,priceCents){var productId=Number(offer&&offer.productId||0),price=Number(priceCents);if(productId===8093010624611&&Number.isFinite(price)&&price>=0&&price<2999)return"TK9UPSELL-8093010624611-"+String(Math.round(price));return String(offer&&offer.discountCode||"").trim().toUpperCase()}function offerDiscountCodes(offer,priceCents){var code=contextualOfferDiscountCode(offer,priceCents);if(!code)return currentCartDiscountCodes();var productPrefix="TK9UPSELL-"+String(offer.productId||"")+"-",seen={},codes=currentCartDiscountCodes().filter(function(activeCode){return activeCode.indexOf(productPrefix)!==0});codes.push(code);return codes.filter(function(activeCode){return activeCode&&!seen[activeCode]&&(seen[activeCode]=!0)})}function applyOfferDiscountCode(offer,priceCents){var code=contextualOfferDiscountCode(offer,priceCents);if(!code)return Promise.resolve(state.cart);return fetchJson(config.updateUrl,{method:"POST",body:JSON.stringify({discount:offerDiscountCodes(offer,priceCents).join(",")})}).then(function(cart){return state.cart=cart,cart})}function safetyBeltLineTargetCode(cart){var line=(cart&&cart.items||[]).find(function(item){return Number(item&&item.product_id)===8093010624611&&item.properties&&item.properties._tk9_offer_price_cents!==void 0});if(!line)return"";var price=Number(line.properties._tk9_offer_price_cents);return Number.isFinite(price)&&price>=0&&price<2999?"TK9UPSELL-8093010624611-"+String(Math.round(price)):""}function reconcileSafetyBeltOfferDiscount(cart){state.cart=cart;var wanted=safetyBeltLineTargetCode(cart),prefix="TK9UPSELL-8093010624611-",codes=currentCartDiscountCodes(),hasWanted=wanted&&codes.indexOf(wanted)!==-1,hasWrong=codes.some(function(code){return code.indexOf(prefix)===0&&code!==wanted});if(!wanted||hasWanted&&!hasWrong)return Promise.resolve(cart);var nextCodes=codes.filter(function(code){return code.indexOf(prefix)!==0});nextCodes.push(wanted);return fetchJson(config.updateUrl,{method:"POST",body:JSON.stringify({discount:nextCodes.join(",")})}).then(function(nextCart){return state.cart=nextCart,nextCart})}function markCartAttributed(reason,extraAttributes) {
    if (!state.cart || state.attributionBusy) return Promise.resolve(state.cart);
    var attributes = Object.assign({}, cartAttributes());
    var readableAttributes = buildReadableCartAttributes(reason, extraAttributes);
    var nextAttributes = Object.assign({}, compactCartAttributes(attributes), readableAttributes, {
      tk9_slide_cart: "native"
    });
    var discountCode = activeDiscountCode();
    if (discountCode) nextAttributes._tk9_discount_code = String(discountCode).trim().toUpperCase();
    if (sameAttributes(attributes, nextAttributes)) return Promise.resolve(state.cart);
    state.attributionBusy = true;
    var keepAlive = /^(checkout_click|express_pay_)/.test(String(reason || ""));
    return fetchJson(config.updateUrl, {
      method: "POST",
      keepalive: keepAlive,
      body: JSON.stringify({
        attributes: nextAttributes
      })
    })
      .then(function (cart) {
        state.cart = cart;
        state.attributionMarked = true;
        return cart;
      })
      .catch(function (error) {
        debugLog("cart attribution failed", error);
        emit("tk9_cart_attribution_error", {
          tk9_attribution_reason: reason || "",
          tk9_error_status: error.status || ""
        });
        return state.cart;
      })
      .finally(function () {
        state.attributionBusy = false;
      });
  }

  function loadRules() {
    if (state.rules) return Promise.resolve(state.rules);
    return fetchJson(config.rulesUrl, { cache: "no-store" }).then(function (rules) {
      state.rules = rules;
      return rules;
    });
  }

  function loadOfferEngine() {
    if (!config.offerEngineUrl) return Promise.resolve(null);
    if (state.offerEngineLoaded) return Promise.resolve(state.offerEngine);
    return fetchJson(config.offerEngineUrl, { cache: "no-store" })
      .then(function (engine) {
        state.offerEngine = engine;
        state.offerEngineLoaded = true;
        return engine;
      })
      .catch(function (error) {
        state.offerEngineLoaded = true;
        state.offerEngine = null;
        debugLog("offer engine runtime unavailable", error);
        return null;
      });
  }

  function loadAvailability() {
    if (!config.availabilityUrl) {
      state.availabilityLoaded = true;
      state.availability = null;
      return Promise.resolve(null);
    }
    if (state.availabilityLoaded) return Promise.resolve(state.availability);
    return fetchJson(config.availabilityUrl, { cache: "no-store" })
      .then(function (availability) {
        state.availability = availability || null;
        state.availabilityLoaded = true;
        return state.availability;
      })
      .catch(function (error) {
        state.availability = null;
        state.availabilityLoaded = true;
        debugLog("offer availability manifest unavailable", error);
        return null;
      });
  }

  function loadCart() {
    return fetchJson(config.cartUrl, { cache: "no-store" }).then(function (cart) {
      state.cart = cart;
      return cart;
    });
  }

  function normalizeOptimisticCartLine(item) {
    if (!item || !item.key) return null;
    var line = Object.assign({}, item);
    var quantity = Math.max(1, Number(line.quantity || 1));
    var unitPrice = centsOrNull(line.price);
    if (unitPrice === null) unitPrice = centsOrNull(line.original_price);
    if (unitPrice === null) unitPrice = centsOrNull(line.final_price);
    unitPrice = unitPrice || 0;
    if (centsOrNull(line.original_line_price) === null) line.original_line_price = unitPrice * quantity;
    if (centsOrNull(line.line_price) === null) line.line_price = unitPrice * quantity;
    if (centsOrNull(line.final_line_price) === null) line.final_line_price = centsOrNull(line.line_price) || unitPrice * quantity;
    if (centsOrNull(line.original_price) === null) line.original_price = unitPrice;
    if (centsOrNull(line.final_price) === null) line.final_price = centsOrNull(line.final_line_price) ? Math.round(Number(line.final_line_price) / quantity) : unitPrice;
    return line;
  }

  function syncOptimisticCartTotals() {
    if (!state.cart) return;
    var itemCount = cartItems().reduce(function (sum, item) {
      return sum + lineQuantity(item);
    }, 0);
    var displayTotal = cartOrderDisplaySubtotalCents();
    var compareTotal = Math.max(displayTotal, cartOrderCompareAtSubtotalCents());
    state.cart.item_count = itemCount;
    state.cart.items_subtotal_price = compareTotal;
    state.cart.original_total_price = compareTotal;
    state.cart.total_price = displayTotal;
    state.cart.total_discount = Math.max(compareTotal - displayTotal, 0);
  }

  function applyOptimisticAddedLine(addedItem) {
    if (!addedItem || !addedItem.key || displayedDiscountCode()) return false;
    if (!state.cart) {
      state.cart = {
        items: [],
        attributes: {},
        item_count: 0,
        items_subtotal_price: 0,
        original_total_price: 0,
        total_price: 0,
        total_discount: 0
      };
    }
    var line = normalizeOptimisticCartLine(addedItem);
    if (!line) return false;
    var nextCart = Object.assign({}, state.cart);
    var items = (state.cart.items || []).slice();
    var existingIndex = -1;
    for (var index = 0; index < items.length; index += 1) {
      if (items[index] && items[index].key === line.key) {
        existingIndex = index;
        break;
      }
    }
    if (existingIndex >= 0) {
      items[existingIndex] = Object.assign({}, items[existingIndex], line);
    } else {
      items.unshift(line);
    }
    nextCart.items = items;
    state.cart = nextCart;
    syncOptimisticCartTotals();
    render();
    return true;
  }

  function applyOptimisticAddResponse(response) {
    if (!response) return false;
    var items = Array.isArray(response.items) ? response.items : [response];
    return items.reduce(function (applied, item) {
      return applyOptimisticAddedLine(item) || applied;
    }, false);
  }

  function refreshAfterOptimistic(reason, keptOptimistic) {
    return delay(75)
      .then(refresh)
      .then(function () {
        open();
        return state.cart;
      })
      .catch(function (error) {
        debugLog(reason + " refresh after optimistic render failed", error);
        emit("tk9_cart_refresh_after_optimistic_error", {
          tk9_refresh_reason: reason,
          tk9_error_status: error.status || ""
        });
        if (keptOptimistic) {
          render();
          open();
          return state.cart;
        }
        throw error;
      });
  }

  function shouldDeferInitialInventoryPromise() {
    var path = String(window.location.pathname || "/").replace(/\/+$/, "") || "/";
    return !(/^\/products\//.test(path) || path === "/cart");
  }

  function refresh(options) {
    options = options || {};
    var inventoryPromiseRequest = options.deferInventoryPromise === true
      ? Promise.resolve(state.inventoryPromise)
      : loadInventoryPromise();
    return Promise.all([loadRules(), loadOfferEngine(), loadAvailability(), inventoryPromiseRequest, loadCart()])
      .then(function () {
        return loadLiveOfferAvailability();
      })
      .then(function () {
        return loadCartCompareAtPrices();
      })
      .then(function () {
        render();
        enhanceInventoryPromiseSurfaces();
        updatePromoDiscountCtas();
        return state.cart;
      });
  }

  function ensureShell() {
    if (document.querySelector("[data-tk9-slide-cart]")) return;

    var overlay = document.createElement("div");
    overlay.className = "tk9-slide-cart-overlay";
    overlay.setAttribute("data-tk9-slide-cart-overlay", "");

    var drawer = document.createElement("aside");
    drawer.className = "tk9-slide-cart";
    drawer.setAttribute("data-tk9-slide-cart", "");
    drawer.setAttribute("aria-hidden", "true");
    drawer.innerHTML =
      '<header class="tk9-slide-cart__header">' +
        '<div class="tk9-slide-cart__brand">' +
          '<img class="tk9-slide-cart__logo" data-tk9-logo alt="Team K9">' +
        '</div>' +
        '<h2 class="tk9-slide-cart__title" data-tk9-title>Your cart</h2>' +
        '<div class="tk9-slide-cart__header-shipping" data-tk9-header-shipping hidden></div>' +
        '<button class="tk9-slide-cart__close" type="button" data-tk9-close aria-label="Close cart">&times;</button>' +
        '<div class="tk9-slide-cart__deal-strip" data-tk9-cart-deal-strip>' +
          '<div class="tk9-slide-cart__sale-timer" data-tk9-cart-sale-timer hidden aria-label="Sale countdown">' +
            '<span data-tk9-cart-sale-label></span>' +
            '<b data-tk9-cart-sale-countdown></b>' +
          '</div>' +
        '</div>' +
      '</header>' +
      '<div class="tk9-slide-cart__body" data-tk9-body></div>' +
      '<footer class="tk9-slide-cart__footer" data-tk9-footer></footer>';

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    var logo = drawer.querySelector("[data-tk9-logo]");
    if (logo) logo.src = imageUrl("team-k9-logo-black-clean.png");
    startCartSaleTimer();
    startCartProcessingTimer();

    overlay.addEventListener("click", close);
    drawer.querySelector("[data-tk9-close]").addEventListener("click", close);
    var footer = drawer.querySelector("[data-tk9-footer]");
    if (footer) {
      footer.addEventListener("touchmove", preventFooterScroll, { passive: false });
      footer.addEventListener("wheel", preventFooterScroll, { passive: false });
    }
  }

  // Primary-surface switch (2026-07-02, re-merged onto july4-compact-v6):
  // when config.primarySurface is "page", every drawer-open trigger routes
  // to the cart page instead — this is the single choke point. Revert = set
  // primarySurface back to "drawer" in snippets/tk9-slide-cart.liquid.
  // QA escape: ?tk9_slide_cart=1 still opens the real drawer.
  function pageIsPrimarySurface() {
    if (String(config.primarySurface || "drawer") !== "page") return false;
    try {
      var params = new URLSearchParams(window.location.search || "");
      if (params.get(config.enableParam || "tk9_slide_cart") === "1") return false;
    } catch (error) {}
    return true;
  }

  function open() {
    if (pageIsPrimarySurface()) {
      var cartPath = String(config.cartPageUrl || "/cart");
      emit("tk9_cart_open_redirected_to_page", {
        tk9_cart_total_price: state.cart ? state.cart.total_price : 0,
        tk9_cart_item_count: state.cart ? state.cart.item_count : 0
      });
      if (window.location.pathname.replace(/\/$/, "") !== cartPath.replace(/\/$/, "")) {
        window.location.href = cartPath;
      }
      return;
    }
    ensureShell();
    state.open = true;
    document.documentElement.classList.add("tk9-slide-cart-lock");
    document.body.classList.add("tk9-slide-cart-lock");
    document.querySelector("[data-tk9-slide-cart-overlay]").classList.add("is-open");
    var drawer = document.querySelector("[data-tk9-slide-cart]");
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    updateCartSaleTimer();
    emit("tk9_cart_open", Object.assign({
      tk9_cart_total_price: state.cart ? state.cart.total_price : 0,
      tk9_cart_item_count: state.cart ? state.cart.item_count : 0
    }, cartKitSelectionPayload()));
    if (!state.attributionMarked) markCartAttributed("open");
  }

  function close() {
    state.open = false;
    document.documentElement.classList.remove("tk9-slide-cart-lock");
    document.body.classList.remove("tk9-slide-cart-lock");
    var overlay = document.querySelector("[data-tk9-slide-cart-overlay]");
    var drawer = document.querySelector("[data-tk9-slide-cart]");
    if (overlay) overlay.classList.remove("is-open");
    if (drawer) {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
    }
    emit("tk9_cart_close", {});
  }

  function lineImage(item) {
    return item.image || item.featured_image && item.featured_image.url || "";
  }

  var PATCH_NAME_PROPERTY_NAMES = [
    "Which text or name you want printed",
    "Which text or name you want",
    "Patch text",
    "Dog name",
    "_tk9_patch_mockup_line_1"
  ];
  var PATCH_PHONE_PROPERTY_NAMES = [
    "Which phone number you want printed (optional)",
    "Phone number",
    "Phone",
    "_tk9_patch_mockup_line_2"
  ];

  function objectPropertyValue(properties, names) {
    if (!properties || typeof properties !== "object") return "";
    for (var index = 0; index < names.length; index += 1) {
      var name = names[index];
      if (!Object.prototype.hasOwnProperty.call(properties, name)) continue;
      var value = properties[name];
      if (value !== null && value !== undefined && String(value).trim() !== "") {
        return String(value).trim();
      }
    }
    return "";
  }

  function cartLinePropertyValue(item, names) {
    return objectPropertyValue(item && item.properties, names);
  }

  function formatPatchPhoneValue(value) {
    var raw = String(value || "").trim();
    var digits = raw.replace(/\D/g, "");
    if (digits.length === 11 && digits.charAt(0) === "1") digits = digits.slice(1);
    if (digits.length !== 10) return raw;
    return "(" + digits.slice(0, 3) + ") " + digits.slice(3, 6) + "-" + digits.slice(6);
  }

  function formatPatchPhoneInput(input) {
    if (!input) return "";
    var value = String(input.value || "");
    var formatted = formatPatchPhoneValue(value);
    if (formatted && formatted !== value) input.value = formatted;
    return formatted;
  }

  function maybeFormatPdpPatchPhone(target) {
    if (!target || !target.matches || !target.matches("[data-tk9-pdp-patch-phone]")) return;
    formatPatchPhoneInput(target);
  }

  function patchMockupText(value, fallback) {
    var text = String(value || fallback || "").trim().toUpperCase();
    return text.replace(/[&<>"']/g, function (character) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }[character];
    });
  }

  function patchMockupImageData(dogName, phone) {
    var line1 = patchMockupText(dogName, "CUSTOM PATCH");
    var line2 = patchMockupText(phone, "");
    var hasPhone = Boolean(line2);
    var primarySize = line2
      ? (line1.length > 18 ? "50" : line1.length > 13 ? "60" : "76")
      : (line1.length > 16 ? "58" : line1.length > 12 ? "72" : "88");
    var phoneSize = line2.length > 24 ? "30" : line2.length > 19 ? "36" : line2.length > 14 ? "44" : "50";
    var phoneTracking = line2.length > 14 ? "1" : "2";
    var nameFit = line2
      ? (line1.length > 20 ? ' textLength="600" lengthAdjust="spacing"' : "")
      : (line1.length > 12 ? ' textLength="612" lengthAdjust="spacingAndGlyphs"' : "");
    var phoneFit = line2.length > 24 ? ' textLength="590" lengthAdjust="spacing"' : "";
    function patchMarkup(y) {
      if (hasPhone) {
        var phonePrimaryY = y + 128;
        var phoneMarkupTall = '<text x="450" y="' + (y + 216) + '" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + phoneSize + '" font-weight="900" fill="#ffffff" letter-spacing="' + phoneTracking + '"' + phoneFit + '>' + line2 + '</text>';
        return '<g filter="url(#shadow)"><rect x="104" y="' + y + '" width="692" height="280" rx="34" fill="#24272b" stroke="#454a50" stroke-width="10"/><rect x="142" y="' + (y + 46) + '" width="616" height="188" rx="22" fill="url(#patchBg)" stroke="#333a42" stroke-width="5"/><text x="450" y="' + phonePrimaryY + '" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + primarySize + '" font-weight="900" fill="#ffffff"' + nameFit + '>' + line1 + '</text>' + phoneMarkupTall + '</g>';
      }
      var primaryY = y + (line2 ? 84 : 122);
      var phoneMarkup = line2 ? '<text x="450" y="' + (y + 134) + '" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + phoneSize + '" font-weight="900" fill="#ffffff"' + phoneFit + '>' + line2 + '</text>' : "";
      return '<g filter="url(#shadow)"><rect x="85" y="' + y + '" width="730" height="190" rx="28" fill="#24272b" stroke="#454a50" stroke-width="10"/><rect x="120" y="' + (y + 32) + '" width="660" height="126" rx="18" fill="url(#patchBg)" stroke="#333a42" stroke-width="5"/><text x="450" y="' + primaryY + '" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + primarySize + '" font-weight="900" fill="#ffffff"' + nameFit + '>' + line1 + '</text>' + phoneMarkup + '</g>';
    }
    var svgHeight = hasPhone ? 420 : 300;
    var svgY = hasPhone ? 70 : 55;
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="900" height="' + svgHeight + '" viewBox="0 0 900 ' + svgHeight + '"><defs><linearGradient id="patchBg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#282b2f"/><stop offset=".64" stop-color="#101214"/><stop offset="1" stop-color="#25282c"/></linearGradient><filter id="shadow" x="-18%" y="-24%" width="136%" height="160%"><feDropShadow dx="0" dy="12" stdDeviation="14" flood-color="#101828" flood-opacity=".24"/></filter></defs><rect width="900" height="' + svgHeight + '" rx="30" fill="#f7f8fa"/>' + patchMarkup(svgY) + '</svg>';
    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  }

  function patchMockupPairImageData(dogName, phone) {
    var line1 = patchMockupText(dogName, "CUSTOM PATCH");
    var line2 = patchMockupText(phone, "");
    var primarySize = line2
      ? (line1.length > 16 ? "48" : line1.length > 12 ? "58" : "70")
      : (line1.length > 16 ? "58" : line1.length > 12 ? "72" : "88");
    var phoneSize = line2.length > 17 ? "28" : "34";
    var nameFit = line1.length > 8 ? ' textLength="612" lengthAdjust="spacingAndGlyphs"' : "";
    var phoneFit = line2.length > 17 ? ' textLength="560" lengthAdjust="spacingAndGlyphs"' : "";
    function patchMarkup(y) {
      var primaryY = y + (line2 ? 84 : 122);
      var phoneMarkup = line2 ? '<text x="450" y="' + (y + 134) + '" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + phoneSize + '" font-weight="900" fill="#ffffff"' + phoneFit + '>' + line2 + '</text>' : "";
      return '<g filter="url(#shadow)"><rect x="85" y="' + y + '" width="730" height="190" rx="28" fill="#24272b" stroke="#454a50" stroke-width="10"/><rect x="120" y="' + (y + 32) + '" width="660" height="126" rx="18" fill="url(#patchBg)" stroke="#333a42" stroke-width="5"/><text x="450" y="' + primaryY + '" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + primarySize + '" font-weight="900" fill="#ffffff"' + nameFit + '>' + line1 + '</text>' + phoneMarkup + '</g>';
    }
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="900" height="520" viewBox="0 0 900 520"><defs><linearGradient id="patchBg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#282b2f"/><stop offset=".64" stop-color="#101214"/><stop offset="1" stop-color="#25282c"/></linearGradient><filter id="shadow" x="-18%" y="-24%" width="136%" height="160%"><feDropShadow dx="0" dy="12" stdDeviation="14" flood-color="#101828" flood-opacity=".24"/></filter></defs><rect width="900" height="520" rx="30" fill="#f7f8fa"/>' + patchMarkup(58) + patchMarkup(272) + '</svg>';
    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  }

  function addPatchMockupProperties(properties, dogName, phone) {
    properties._tk9_patch_mockup_format = "svg_v4_pair_cart_single_preview";
    properties._tk9_patch_mockup_line_1 = dogName || "";
    properties._tk9_patch_mockup_line_2 = phone || "";
    return properties;
  }

  function patchMockupUploadUrl() {
    return String(window.TK9_PATCH_MOCKUP_UPLOAD_URL || "/apps/teamk9/patch-mockups");
  }

  function resolveWithTimeout(promise, timeoutMs, fallbackValue) {
    return new Promise(function (resolve) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        resolve(fallbackValue);
      }, Math.max(400, Number(timeoutMs || 0) || 1800));

      Promise.resolve(promise).then(function (value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(value);
      }).catch(function () {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve(fallbackValue);
      });
    });
  }

  function patchMockupPngData(dogName, phone, width, height) {
    return new Promise(function (resolve) {
      if (!window.Image || !document.createElement) {
        resolve("");
        return;
      }
      var settled = false;
      var image = new Image();
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        resolve("");
      }, 1600);
      image.onload = function () {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        try {
          var canvas = document.createElement("canvas");
          canvas.width = width || 800;
          canvas.height = height || 800;
          var context = canvas.getContext("2d");
          if (!context) {
            resolve("");
            return;
          }
          context.fillStyle = "#f7f8fa";
          context.fillRect(0, 0, canvas.width, canvas.height);
          var naturalWidth = image.naturalWidth || 900;
          var naturalHeight = image.naturalHeight || 520;
          var scale = Math.min(canvas.width / naturalWidth, canvas.height / naturalHeight);
          var drawWidth = naturalWidth * scale;
          var drawHeight = naturalHeight * scale;
          var drawX = (canvas.width - drawWidth) / 2;
          var drawY = (canvas.height - drawHeight) / 2;
          context.drawImage(image, drawX, drawY, drawWidth, drawHeight);
          resolve(canvas.toDataURL("image/png"));
        } catch (error) {
          debugLog("patch mockup png render failed", error);
          resolve("");
        }
      };
      image.onerror = function () {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        resolve("");
      };
      image.src = patchMockupPairImageData(dogName, phone);
    });
  }

  function uploadPatchMockup(dogName, phone, source, width, height) {
    return patchMockupPngData(dogName, phone, width, height).then(function (imageData) {
      if (!imageData) return "";
      var controller = window.AbortController ? new AbortController() : null;
      var timer = controller ? window.setTimeout(function () {
        try {
          controller.abort();
        } catch (error) {}
      }, 2400) : null;
      return fetch(patchMockupUploadUrl(), {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        signal: controller ? controller.signal : undefined,
        body: JSON.stringify({
          imageData: imageData,
          line1: dogName || "",
          line2: phone || "",
          source: source || "slide-cart"
        })
      }).then(function (response) {
        if (timer) window.clearTimeout(timer);
        if (!response.ok) return "";
        return response.json().then(function (payload) {
          return payload && payload.url ? String(payload.url) : "";
        }).catch(function () {
          return "";
        });
      }).catch(function (error) {
        if (timer) window.clearTimeout(timer);
        debugLog("patch mockup upload failed", error);
        return "";
      });
    });
  }

  function addHostedPatchMockupProperty(properties, dogName, phone, source, width, height) {
    if (!properties || properties._tk9_patch_mockup_url) return Promise.resolve(properties);
    return resolveWithTimeout(uploadPatchMockup(dogName, phone, source, width, height), 2200, "").then(function (url) {
      if (url) properties._tk9_patch_mockup_url = url;
      return properties;
    }).catch(function () {
      return properties;
    });
  }

  function isPatchPhoneProperty(name) {
    var normalized = normalizeText(name);
    return (
      normalized === "phone number" ||
      normalized === "phone" ||
      normalized === "which phone number you want printed optional"
    );
  }

  function isCustomPatchLine(item) {
    var properties = item && item.properties || {};
    var offerId = normalizeText(properties._tk9_id || properties._tk9_offer || properties._tk9_slide_cart_offer || "");
    var productId = Number(item && item.product_id);
    var title = normalizeText([
      item && item.product_title,
      item && item.title,
      item && item.variant_title
    ].join(" "));
    return (
      offerId === "custom patch" ||
      offerId === "custom name patch" ||
      productId === 4734560632931 ||
      (title.indexOf("custom") !== -1 && title.indexOf("patch") !== -1)
    );
  }

  function isCustomPatchOffer(offer) {
    var offerId = readableTrackingId(offer && offer.id);
    var productId = Number(offer && offer.productId);
    var title = normalizeText([offer && offer.title, offer && offer.copy].join(" "));
    return (
      offerId === "custom-patch" ||
      offerId === "custom-name-patch" ||
      productId === 4734560632931 ||
      (title.indexOf("custom") !== -1 && title.indexOf("patch") !== -1)
    );
  }

  function isDogglesRideFamilyOffer(offer) {
    var offerId = readableTrackingId(offer && offer.id);
    return /^(doggles-cooling-fans|doggles-safety-belt|doggles-travel-bowl|doggles-hair-removal-gloves|second-doggles-pair|doggles-seat-cover)$/.test(offerId);
  }

  function customPatchPreviewData(item) {
    return {
      name: cartLinePropertyValue(item, PATCH_NAME_PROPERTY_NAMES) || "DOG NAME",
      phone: formatPatchPhoneValue(cartLinePropertyValue(item, PATCH_PHONE_PROPERTY_NAMES))
    };
  }

  function cartPatchMockupImageData(data) {
    var line1 = patchMockupText(data && data.name, "DOG NAME");
    var line2 = patchMockupText(data && data.phone, "");
    var primarySize = line2
      ? (line1.length > 16 ? "62" : line1.length > 12 ? "72" : "86")
      : (line1.length > 16 ? "70" : line1.length > 12 ? "86" : "104");
    var phoneSize = line2.length > 17 ? "36" : "42";
    var nameFit = line1.length > 11 ? ' textLength="610" lengthAdjust="spacingAndGlyphs"' : "";
    var phoneFit = line2.length > 17 ? ' textLength="560" lengthAdjust="spacingAndGlyphs"' : "";
    function patchMarkup(y, opacity) {
      var primaryY = y + (line2 ? 132 : 176);
      var phoneMarkup = line2
        ? '<text x="450" y="' + (y + 228) + '" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + phoneSize + '" font-weight="900" fill="#ffffff" letter-spacing="1"' + phoneFit + '>' + line2 + '</text>'
        : "";
      return '<g filter="url(#shadow)" opacity="' + opacity + '"><rect x="70" y="' + y + '" width="760" height="310" rx="36" fill="#24272b" stroke="#454a50" stroke-width="10"/><rect x="112" y="' + (y + 48) + '" width="676" height="214" rx="24" fill="url(#patchBg)" stroke="#333a42" stroke-width="5"/><text x="450" y="' + primaryY + '" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="' + primarySize + '" font-weight="900" fill="#ffffff"' + nameFit + '>' + line1 + '</text>' + phoneMarkup + '</g>';
    }
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="900" height="560" viewBox="0 0 900 560"><defs><linearGradient id="patchBg" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#282b2f"/><stop offset=".64" stop-color="#101214"/><stop offset="1" stop-color="#25282c"/></linearGradient><filter id="shadow" x="-18%" y="-24%" width="136%" height="160%"><feDropShadow dx="0" dy="12" stdDeviation="14" flood-color="#101828" flood-opacity=".24"/></filter></defs><rect width="900" height="560" rx="34" fill="#f7f8fa"/>' + patchMarkup(104, "1") + '<text x="450" y="468" text-anchor="middle" font-family="Arial, Helvetica, sans-serif" font-size="42" font-weight="950" fill="#172033">PAIR</text></svg>';
    return "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  }

  function patchPreviewHtml(className, name, phone) {
    var previewName = String(name || "BUDDY").trim().toUpperCase();
    return '<span class="' + escapeHtml(className) + '" role="img" aria-label="Custom patch preview" data-tk9-patch-preview>' +
      '<img class="tk9-patch-mockup__static-image" src="' + escapeHtml(imageUrl("custom-patch.png?v=20260620")) + '" alt="" loading="lazy" decoding="async">' +
      '<span class="tk9-patch-mockup__preview">' +
        '<img class="tk9-patch-mockup__preview-image" alt="' + escapeHtml("Custom patch mockup for " + previewName) + '" loading="lazy" decoding="async" data-tk9-patch-preview-image>' +
      '</span>' +
    '</span>';
  }

  function renderCustomPatchLineImage(item) {
    var data = customPatchPreviewData(item);
    var name = String(data.name || "DOG NAME").trim().toUpperCase();
    var phone = String(data.phone || "").trim().toUpperCase();
    var aria = "Custom patch mockup" + (name ? " for " + name : "");
    return '<img class="tk9-cart-line__image tk9-cart-line__image--patch-mockup" src="' + escapeHtml(cartPatchMockupImageData({ name: name, phone: phone })) + '" alt="' + escapeHtml(aria) + '">';
  }

  function renderCartLineImage(item) {
    if (isCustomPatchLine(item)) return renderCustomPatchLineImage(item);
    return '<img class="tk9-cart-line__image" src="' + escapeHtml(lineImage(item)) + '" alt="">';
  }

  function cartLineUrl(item) {
    var url = item && item.url;
    if (!url || typeof url !== "string") return "";
    if (url.charAt(0) === "/") return url;
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin ? parsed.pathname + parsed.search : "";
    } catch (error) {
      return "";
    }
  }

  function cartLineProductHandle(item) {
    var handle = item && (item.handle || item.product_handle);
    if (handle) return String(handle).replace(/^\/+|\/+$/g, "").trim();
    var url = cartLineUrl(item);
    if (!url) return "";
    var match = url.match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function isDogglesCartLine(item) {
    var ids = state.rules && state.rules.productIds || {};
    var productId = Number(item && item.product_id);
    if (productId === Number(ids.dogGoggles || 6905734070371)) return true;
    return cartLineProductHandle(item) === "dog-goggles";
  }

  function shopifyCents(value) {
    var amount = Number(value);
    return Number.isFinite(amount) && amount > 0 ? Math.round(amount) : 0;
  }

  function recordProductCompareAtPrices(product) {
    ((product && product.variants) || []).forEach(function (variant) {
      var variantId = String(variant && variant.id || "");
      if (!variantId) return;
      var price = shopifyCents(variant.price);
      var compareAt = shopifyCents(variant.compare_at_price || variant.compareAtPrice);
      state.variantCompareAtCents[variantId] = compareAt > price ? compareAt : 0;
    });
  }

  function loadCompareAtForHandle(handle) {
    handle = String(handle || "").trim();
    if (!handle || state.compareAtHandlesLoaded[handle]) return Promise.resolve();
    if (state.compareAtHandleRequests[handle]) return state.compareAtHandleRequests[handle];
    var request = fetchJson("/products/" + encodeURIComponent(handle) + ".js", { cache: "no-store" })
      .then(function (product) {
        recordProductCompareAtPrices(product);
        state.compareAtHandlesLoaded[handle] = true;
      })
      .catch(function (error) {
        state.compareAtHandlesLoaded[handle] = true;
        debugLog("compare-at lookup failed", handle, error);
      })
      .finally(function () {
        delete state.compareAtHandleRequests[handle];
      });
    state.compareAtHandleRequests[handle] = request;
    return request;
  }

  function loadCartCompareAtPrices() {
    var handles = {};
    merchandiseCartItems().forEach(function (item) {
      var handle = cartLineProductHandle(item);
      if (handle) handles[handle] = true;
    });
    var list = Object.keys(handles);
    if (!list.length) return Promise.resolve();
    return Promise.all(list.map(loadCompareAtForHandle)).then(function () {});
  }

  function cartDisplayRules() {
    return state.rules && state.rules.cartDisplay || {};
  }

  function compactCartProductName(name, item) {
    var text = String(name || "").replace(/\s+/g, " ").trim();
    return text
      .replace(/\s*\([^)]{80,}\)\s*/g, " ")
      .replace(/\s+/g, " ")
      .trim() || "Cart item";
  }

  function cartProductName(item) {
    var names = cartDisplayRules().productNames || {};
    var name = names[String(item && item.product_id || "")] || item.product_title || item.title || "Cart item";
    return compactCartProductName(name, item);
  }

  function optionDisplayValue(value) {
    var aliases = cartDisplayRules().optionValueNames || {};
    var text = String(value || "").trim();
    if (!text) return "";
    if (Object.prototype.hasOwnProperty.call(aliases, text)) return aliases[text];
    text = text
      .replace(/\s*\/\s*Default Title\s*/gi, "")
      .replace(/\s*\/\s*Harness\s*/gi, "")
      .replace(/^Backseat Cover(?:\s*\+\s*FREE Safety Belt)?$/i, "")
      .replace(/\s*\((?:fits\s+)?most vehicles\)\s*/gi, "")
      .replace(/\s+/g, " ")
      .trim();
    return text;
  }

  function cartOptionDisplayValue(item, value) {
    var text = optionDisplayValue(value);
    if (!text) return "";
    var normalized = normalizeText(text);
    if (isDogglesCartLine(item) && (normalized === "black" || normalized === "default title")) return "";
    return text;
  }

  function cartVariantMeta(item) {
    var values = [];
    if (Array.isArray(item && item.options_with_values) && item.options_with_values.length) {
      item.options_with_values.forEach(function (option) {
        var value = cartOptionDisplayValue(item, option && option.value);
        if (value && values.indexOf(value) === -1) values.push(value);
      });
    } else if (item && item.variant_title) {
      String(item.variant_title).split("/").forEach(function (part) {
        var value = cartOptionDisplayValue(item, part);
        if (value && values.indexOf(value) === -1) values.push(value);
      });
    }
    return values.join(" / ");
  }

  function isHarnessCartLine(item) {
    var ids = state.rules && state.rules.productIds || {};
    var productId = Number(item && item.product_id);
    return (
      productId === Number(ids.fourBuckleHarness || 7090638356579) ||
      productId === Number(ids.twoBuckleHarness || 6749766811747) ||
      productId === Number(ids.tenInOneKit || 6886975340643)
    );
  }

  function cartLineOptionParts(item) {
    var parts = [];
    if (Array.isArray(item && item.options_with_values) && item.options_with_values.length) {
      item.options_with_values.forEach(function (option) {
        var value = cartOptionDisplayValue(item, option && option.value);
        if (!value) return;
        parts.push({
          name: String(option && option.name || ""),
          value: value,
          rawValue: String(option && option.value || value)
        });
      });
      return parts;
    }
    if (item && item.variant_title) {
      String(item.variant_title).split("/").forEach(function (part) {
        var value = cartOptionDisplayValue(item, part);
        if (!value) return;
        parts.push({
          name: "",
          value: value,
          rawValue: String(part || value)
        });
      });
    }
    return parts;
  }

  function harnessCartSelection(item) {
    if (!isHarnessCartLine(item)) return null;
    var parts = cartLineOptionParts(item);
    var color = "";
    var setup = "";
    var size = null;

    parts.forEach(function (part, index) {
      var name = normalizeText(part.name);
      var value = part.value;
      var valueText = normalizeText(value);
      var detectedSize = sizeChoiceFromText(part.rawValue) || sizeChoiceFromText(value);
      if (detectedSize && !size) {
        size = detectedSize;
        return;
      }
      if (/colou?r/.test(name) || (!color && index === 0)) {
        color = value;
        return;
      }
      if (/style|bundle|kit|setup|type/.test(name) || /harness|leash|collar|patch|molle|system|bundle/.test(valueText)) {
        setup = value;
      }
    });

    if (!color) color = colorLabel(detectColor(item));
    if (!size) size = sizeChoiceFromText(cartVariantMeta(item)) || sizeChoiceFromText(item && item.variant_title);
    if (!size) return null;

    return {
      color: color,
      setup: setup,
      size: size
    };
  }

  function compactHarnessSetupText(setup) {
    var text = String(setup || "").replace(/\s+/g, " ").trim();
    if (!text) return "";
    text = text
      .replace(/^Setup:\s*/i, "")
      .replace(/^Harness\s*\+\s*/i, "")
      .replace(/\bBungee\s+Dog\s+Leash\b/gi, "Leash")
      .replace(/\bBungee\s+Leash\b/gi, "Leash")
      .replace(/\bTactical\s+Dog\s+Collar\b/gi, "Collar")
      .replace(/\bTactical\s+Collar\b/gi, "Collar")
      .replace(/\b(?:12[- ]Patch|12\s+Patch)\s+(?:Harness\s+)?Bundle\b/gi, "12 Patches")
      .replace(/\bCustom\s+Harness\s+Patch(?:\s+\(Printed\s+Pair\))?\b/gi, "Custom Patch")
      .replace(/\bMOLLE\s+Pouches?\b/gi, "Pouch")
      .replace(/\s*\+\s*/g, " + ")
      .replace(/\s+/g, " ")
      .trim();
    return text;
  }

  function renderCartLineMeta(item) {
    var selection = harnessCartSelection(item);
    var meta = cartVariantMeta(item);
    if (!selection) return meta ? '<div class="tk9-cart-line__meta">' + escapeHtml(meta) + '</div>' : "";

    var parts = ['<span class="tk9-cart-line__selected-label">Selected:</span>'];
    if (selection.color) {
      parts.push('<span>' + escapeHtml(selection.color) + '</span>');
    }
    parts.push(
      '<span class="tk9-cart-line__size-pill">' +
        '<span>Size</span>' +
        '<em>' + escapeHtml(selection.size.code) + '</em>' +
        '<small>/ ' + escapeHtml(selection.size.label) + '</small>' +
      '</span>'
    );
    if (selection.setup) {
      var compactSetup = compactHarnessSetupText(selection.setup);
      if (compactSetup) parts.push('<span class="tk9-cart-line__setup">' + escapeHtml(compactSetup) + '</span>');
    }

    return '<div class="tk9-cart-line__selected" aria-label="Selected harness options">' + parts.join("") + '</div>' +
      (selection.size.code === "XS" ? '<div class="tk9-cart-line__size-note"><span class="tk9-cart-line__size-note-full">Review size before checkout. Free exchanges included.</span><span class="tk9-cart-line__size-note-compact">Review size. Free exchanges included.</span></div>' : "");
  }

  function propertyLabel(name) {
    var labels = {
      "Which text or name you want": "Patch",
      "Which text or name you want printed": "Patch",
      "Phone number": "Phone",
      "Which phone number you want printed (optional)": "Phone"
    };
    return labels[name] || name;
  }

  function cartLineProperties(item) {
    var properties = item && item.properties;
    if (!properties || typeof properties !== "object") return [];
    return Object.keys(properties).filter(function (name) {
      var value = properties[name];
      return name.charAt(0) !== "_" && value !== null && value !== undefined && String(value).trim() !== "";
    }).map(function (name) {
      var value = String(properties[name]).trim();
      return {
        rawName: name,
        name: propertyLabel(name),
        value: isPatchPhoneProperty(name) ? formatPatchPhoneValue(value) : value
      };
    });
  }

  function cartLinePropertyClassName(property) {
    var labelClass = normalizeText(property && property.name).replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");
    var text = normalizeText((property && property.rawName || "") + " " + (property && property.name || ""));
    var classes = ["tk9-cart-line__property"];
    if (labelClass) classes.push("tk9-cart-line__property--" + labelClass);
    if (/\bphone\b/.test(text)) classes.push("tk9-cart-line__property--phone");
    if (/\bpatch\b|\btext\b|\bname\b/.test(text) && !/\bphone\b/.test(text)) classes.push("tk9-cart-line__property--patch-text");
    return classes.join(" ");
  }

  function renderLineProperties(item) {
    var properties = cartLineProperties(item);
    var mockupNote = isCustomPatchLine(item)
      ? '<span class="tk9-cart-line__mockup-note">Final print follows your text.</span>'
      : "";
    if (!properties.length) return mockupNote ? '<div class="tk9-cart-line__properties">' + mockupNote + '</div>' : "";
    return '<div class="tk9-cart-line__properties">' + properties.map(function (property) {
      var className = cartLinePropertyClassName(property);
      return '<span class="' + escapeHtml(className) + '"><strong>' + escapeHtml(property.name) + ':</strong> <em class="tk9-cart-line__property-value">' + escapeHtml(property.value) + '</em></span>';
    }).join("") + mockupNote + '</div>';
  }

  function lineDiscountApplicationTitle(allocation) {
    var application = allocation && allocation.discount_application || {};
    return String(
      allocation && (allocation.title || allocation.discount_application_title) ||
      application.title ||
      application.code ||
      application.description ||
      ""
    ).replace(/\s+/g, " ").trim();
  }

  function lineDiscountRows(item) {
    var allocations = item && item.line_level_discount_allocations;
    if (!Array.isArray(allocations) || !allocations.length) return [];
    var rows = [];
    var indexes = {};
    allocations.forEach(function (allocation) {
      var amount = centsOrNull(allocation && allocation.amount) || 0;
      var title = lineDiscountApplicationTitle(allocation);
      if (!amount || !title) return;
      var key = normalizeText(title);
      if (indexes[key] === undefined) {
        indexes[key] = rows.length;
        rows.push({
          title: title,
          amount: 0
        });
      }
      rows[indexes[key]].amount += amount;
    });
    return rows.filter(function (row) {
      return row.amount > 0;
    }).slice(0, 2);
  }

  function quantityDiscountDefinitions() {
    var pricing = state.offerEngine && state.offerEngine.pricing || {};
    return Object.keys(pricing).map(function (key) {
      var entry = pricing[key] || {};
      return entry.quantityDiscounts || null;
    }).filter(function (definition) {
      return definition && Array.isArray(definition.productIds) && definition.productIds.length;
    });
  }

  function quantityDiscountApplies(definition) {
    if (!definition || !Array.isArray(definition.suppressIfProductIdsPresent)) return true;
    return !cartContainsAnyProduct(definition.suppressIfProductIdsPresent);
  }

  function quantityDiscountLineUnits(definition, item) {
    if (!definition || !item || definition.productIds.map(Number).indexOf(Number(item.product_id)) === -1) return 0;
    var variantId = String(item.variant_id || item.id || "");
    var unitMap = definition.variantUnitCounts || {};
    var unitsPerLine = Number(unitMap[variantId] || 1);
    return Math.max(1, unitsPerLine) * lineQuantity(item);
  }

  function quantityDiscountCartUnits(definition) {
    return cartItems().reduce(function (sum, line) {
      return sum + quantityDiscountLineUnits(definition, line);
    }, 0);
  }

  function steppedQuantityDiscountCents(definition, totalUnits) {
    var map = definition && definition.discountByUnitCountCents || {};
    var best = 0;
    Object.keys(map).forEach(function (count) {
      if (Number(count) <= Number(totalUnits || 0)) best = Math.max(best, Number(map[count] || 0));
    });
    return best;
  }

  function targetPriceQuantityDiscountCents(definition, totalUnits) {
    var map = definition && definition.targetPriceByUnitCountCents || {};
    var singleUnit = Number(map["1"] || map[1] || 0);
    if (!singleUnit) return 0;
    var target = Number(map[String(totalUnits)] || 0);
    if (!target) {
      var bestCount = 0;
      Object.keys(map).forEach(function (count) {
        if (Number(count) <= Number(totalUnits || 0)) bestCount = Math.max(bestCount, Number(count));
      });
      target = bestCount ? Number(map[String(bestCount)] || 0) + ((Number(totalUnits || 0) - bestCount) * singleUnit) : 0;
    }
    return target ? Math.max((singleUnit * Number(totalUnits || 0)) - target, 0) : 0;
  }

  function quantityDiscountTotalCents(definition, totalUnits) {
    return steppedQuantityDiscountCents(definition, totalUnits) || targetPriceQuantityDiscountCents(definition, totalUnits);
  }

  function syntheticQuantityBreakRows(item, pricing) {
    if (!cartLineHasShopifyDiscount(item)) return [];
    var lineSavings = pricing && pricing.hasSavings ? Math.max(Number(pricing.compareLine || 0) - Number(pricing.shownLine || 0), 0) : 0;
    if (!lineSavings) return [];
    return quantityDiscountDefinitions().map(function (definition) {
      if (!quantityDiscountApplies(definition)) return null;
      var lineUnits = quantityDiscountLineUnits(definition, item);
      if (!lineUnits) return null;
      var totalUnits = quantityDiscountCartUnits(definition);
      if (totalUnits <= 1) return null;
      var totalDiscount = quantityDiscountTotalCents(definition, totalUnits);
      if (!totalDiscount) return null;
      var amount = Math.min(Math.round(totalDiscount * (lineUnits / totalUnits)), lineSavings);
      if (!amount) return null;
      return {
        title: definition.label || "Quantity Break Savings",
        amount: amount
      };
    }).filter(Boolean).slice(0, 1);
  }

  function renderLineDiscountDetails(item, pricing) {
    var rows = lineDiscountRows(item);
    if (!rows.length) rows = syntheticQuantityBreakRows(item, pricing);
    if (!rows.length) return "";
    return '<div class="tk9-cart-line__discounts" aria-label="Applied line discounts">' + rows.map(function (row) {
      var label = displayLineDiscountTitle(row.title);
      var amount = displaySavingsMoney(row.amount);
      return '<span class="tk9-cart-line__discount" title="' + escapeHtml(row.title + " (-" + money(row.amount) + ")") + '">' +
        '<span class="tk9-cart-line__discount-label">' + escapeHtml(label) + '</span>' +
        '<span class="tk9-cart-line__discount-amount">-' + amount + '</span>' +
      '</span>';
    }).join("") + '</div>';
  }

  function displaySavingsMoney(cents) {
    var value = Math.max(0, Math.round(Number(cents || 0)));
    var remainder = value % 100;
    if (value >= 100 && (remainder <= 2 || remainder >= 98)) {
      return money(remainder >= 98 ? value + (100 - remainder) : value - remainder);
    }
    return money(value);
  }

  function displayLineDiscountTitle(title) {
    var clean = String(title || "").replace(/\s+/g, " ").trim();if(/^TK9UPSELL-/i.test(clean))return"Offer savings";
    if (/team\s*k9\s*harness\s*bundle\s*savings/i.test(clean)) return "Harness bundle savings";
    if (/team\s*k9\s*cart/i.test(clean)) return clean.replace(/^team\s*k9\s*/i, "Team K9 ");
    if (/quantity|tier|break/i.test(clean)) return "Quantity break savings";
    return clean.replace(/^team\s*k9\s+/i, "");
  }

  function cartLinePromiseEntry(item) {
    var variantId = item && (item.variant_id || item.id);
    return inventoryFallbackPromiseEntry(variantId, inventoryPromiseEntry(variantId));
  }

  function cartLineAvailabilityEntry(item) {
    return variantAvailabilityEntry(item && (item.variant_id || item.id));
  }

  function cartLineKnownReadyFallbackState(item) {
    if (!item || isProtectionLine(item) || isCustomPatchLine(item)) return "";
    var ids = state.rules && state.rules.productIds || {};
    var productId = Number(item && item.product_id);
    var readyProductIds = [
      ids.hardBottomSeatCover || 7513423413347,
      ids.singleSeatCover || 6845717872739,
      ids.cargoCover || 6845717905507,
      ids.carSafetyBelt || 6762308337763,
      ids.fourBuckleHarness || 7090638356579,
      ids.twoBuckleHarness || 6749766811747,
      ids.tenInOneKit || 6886975340643,
      ids.tacticalLeash || 4508637560931,
      ids.tacticalCollar || 4508633759843,
      ids.dogGoggles || 6905734070371
    ].map(Number);
    return readyProductIds.indexOf(productId) !== -1 ? "ships_now" : "";
  }

  function cartLineShopifyFallbackState(item, entry) {
    if (entry || isProtectionLine(item) || isCustomPatchLine(item)) return "";
    var availability = cartLineAvailabilityEntry(item);
    if (!availability) return cartLineKnownReadyFallbackState(item);
    var stateName = String(availability.availabilityState || "").trim();
    if (availability.available === false || stateName === "out_of_stock" || stateName === "unavailable") return "";
    if (availability.inStock === true || stateName === "in_stock") return "ships_now";
    var knownReadyState = cartLineKnownReadyFallbackState(item);
    if (knownReadyState) return knownReadyState;
    if (availability.available === true) return "ships_now";
    return "";
  }

  function inventoryCartPromiseText(entry) {
    if (!entry) return "";
    var stateName = inventoryPromiseState(entry);
    var scarcityAvailable = inventoryLowStockAvailable(entry);
    if (stateName === "ships_in_parts" || stateName === "split_ship" || stateName === "split_bundle") {
      return inventoryRouteCartLine(entry, inventorySplitShipText());
    }
    if (inventoryIsLowStockPresentation(entry)) {
      return "";
    }
    if (stateName === "direct_ship" || stateName === "delayed_delivery") {
      return "";
    }
    if (stateName === "reserve" || stateName === "backorder_sellable" || stateName === "production_backorder") {
      return "RESERVE YOURS · Next batch on the way";
    }
    if (stateName === "alert_me" || stateName === "alert_only" || stateName === "hold_or_notify" || stateName === "out_of_stock" || stateName === "do_not_sell") {
      return "SOLD OUT · Get restock alert";
    }
    if (stateName === "ships_now" || stateName === "ready_to_ship" || stateName === "low_stock") return "";
    return "";
  }

  function inventoryCartDeliveryText(entry) {
    if (!entry) return "";
    var stateName = inventoryPromiseState(entry);
    if (stateName === "ships_in_parts" || stateName === "split_ship" || stateName === "split_bundle") return "";
    if (stateName === "direct_ship" || stateName === "delayed_delivery") return "";
    if (stateName === "reserve" || stateName === "backorder_sellable" || stateName === "production_backorder") return "Next batch on the way";
    if (stateName === "alert_me" || stateName === "alert_only" || stateName === "hold_or_notify" || stateName === "out_of_stock" || stateName === "do_not_sell") return "";
    if (inventoryIsLowStockPresentation(entry) || stateName === "ships_now" || stateName === "ready_to_ship" || stateName === "low_stock") {
      return "";
    }
    return "";
  }

  function inventoryCartLineEchoText(entry) {
    if (!entry) return "";
    var stateName = inventoryPromiseState(entry);
    if (inventoryIsKnownCoverBedSplit(entry)) {
      return "IN STOCK · " + inventorySplitShipText();
    }
    if (inventoryHasSeparateBundleSignal(entry)) {
      return "IN STOCK · " + inventorySplitShipText();
    }
    if (stateName === "ships_in_parts" || stateName === "split_ship" || stateName === "split_bundle") {
      return inventoryRouteCartLine(entry, inventorySplitShipText());
    }
    if (inventoryIsLowStockPresentation(entry)) {
      return "LOW STOCK · Ready to ship";
    }
    if (stateName === "direct_ship" || stateName === "delayed_delivery" || stateName === "available_now") {
      return inventoryRouteCartLine(entry, "AVAILABLE NOW · Ships direct with tracking");
    }
    if (stateName === "reserve" || stateName === "backorder_sellable" || stateName === "production_backorder") return "RESERVE YOURS · Next batch on the way";
    if (stateName === "ships_now" || stateName === "ready_to_ship") return "IN STOCK · Ready to ship";
    if (stateName === "low_stock") return "LOW STOCK · Ready to ship";
    return "";
  }

  function isCartLineProofNoise(text) {
    return /trending|sold|viewed|popular|best seller|going fast|sales pace/i.test(String(text || ""));
  }

  function cartLineDeliveryText(item, entry) {
    var deliveryText = inventoryCartDeliveryText(entry);
    if (deliveryText) return deliveryText;
    var fallbackState = cartLineShopifyFallbackState(item, entry);
    if (fallbackState === "ships_now" || fallbackState === "available_now") return "";
    return "";
  }

  function cartLinePromiseText(item) {
    var props = lineProperties(item);
    if (isCustomPatchLine(item)) return "MADE TO ORDER · Ships after printing";
    var entry = cartLinePromiseEntry(item);
    var computed = inventoryCartLineEchoText(entry);
    if (computed) return computed;
    var fallbackState = cartLineShopifyFallbackState(item, entry);
    if (fallbackState === "ships_now") return "IN STOCK · Ready to ship";
    if (fallbackState === "available_now" || fallbackState === "direct_ship" || fallbackState === "delayed_delivery") {
      return "AVAILABLE NOW · Ships direct with tracking";
    }
    var promisedLine = inventoryNormalizeStoredPromiseLine(props._promise_line);
    if (isCartLineProofNoise(promisedLine)) return "";
    if (promisedLine) return promisedLine;
    return "";
  }

  function cartLinePromiseState(item, entry) {
    var props = lineProperties(item);
    if (isCustomPatchLine(item)) return "ships_in_parts";
    var stateName = inventoryPromiseState(entry);
    if (inventoryIsKnownCoverBedSplit(entry) || inventoryHasSeparateBundleSignal(entry)) return "split_bundle";
    if (inventoryIsLowStockPresentation(entry)) return "low_stock";
    if (stateName === "ships_in_parts" || stateName === "split_ship" || stateName === "split_bundle") return stateName;
    var fallbackState = cartLineShopifyFallbackState(item, entry);
    if (fallbackState) return fallbackState;
    return String(props._promise_state || stateName || "").trim();
  }

  function renderCartLinePromise(item, options) {
    if (!config.inventoryPromiseEnabled) return "";
    var entry = cartLinePromiseEntry(item);
    var text = cartLinePromiseText(item);
    var rawStateName = cartLinePromiseState(item, entry);
    var normalizedStateName = rawStateName.toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
    if (!text) return "";
    var stateName = normalizedStateName || "standard";
    var deliveryText = options && options.hideDeliveryDetail ? "" : isCustomPatchLine(item) ? "" : cartLineDeliveryText(item, entry);
    return '<div class="tk9-cart-line__promise tk9-cart-line__promise--' + escapeHtml(stateName) + '">' + inventoryPromiseDisplayHtml(text) + '</div>' +
      (deliveryText ? '<div class="tk9-cart-line__promise-detail tk9-cart-line__promise-detail--' + escapeHtml(stateName) + '">' + escapeHtml(deliveryText) + '</div>' : '');
  }

  function pushVariantTarget(targets, value) {
    if (!value) return;
    if (Array.isArray(value)) {
      value.forEach(function (entry) {
        pushVariantTarget(targets, entry);
      });
      return;
    }
    if (typeof value === "object") {
      Object.keys(value).forEach(function (key) {
        pushVariantTarget(targets, value[key]);
      });
      return;
    }
    targets.push(String(value));
  }

  function offerVariantTargets(offer) {
    var targets = [];
    if (!offer) return targets;
    pushVariantTarget(targets, offer.variantId);
    pushVariantTarget(targets, offer.fallbackVariantId);
    pushVariantTarget(targets, offer.targetVariantId);
    pushVariantTarget(targets, offer.targetVariantIds);
    pushVariantTarget(targets, offer.variantMap);
    pushVariantTarget(targets, offer.sizeVariantMap);
    pushVariantTarget(targets, offer.targetVariantMap);
    ((offer.variantOptions || []).concat(offer.variantChoices || [])).forEach(function (choice) {
      pushVariantTarget(targets, choice && choice.variantId);
    });
    return targets.filter(function (target, index) {
      return target && targets.indexOf(target) === index;
    });
  }

  function activeNonFallbackOfferGroups() {
    if (!state.rules || !state.cart) return [];
    return ((state.rules && state.rules.offerGroups) || []).filter(function (group) {
      if (!group || group.defaultFallback) return false;
      return cartContainsAnyProduct(group.triggerProductIds || []);
    });
  }

  function activeHarnessSetupGroup() {
    return activeNonFallbackOfferGroups().find(function (group) {
      return group && group.id === "harness-setup";
    }) || null;
  }

  function linePropertyCents(item, name) {
    var value = item && item.properties && item.properties[name];
    var amount = Number(value);
    return Number.isFinite(amount) && amount > 0 ? amount : 0;
  }

  function lineOfferIdForPricing(item) {
    var props = lineProperties(item);
    return readableTrackingId(props._tk9_offer || props._tk9_slide_cart_offer || props._tk9_id || "");
  }

  function syntheticOfferEligibleForLine(item, offerId, variantId) {
    var wantedOfferId = readableTrackingId(offerId);
    var wantedVariantId = String(variantId || item && (item.variant_id || item.id) || "");
    if (!wantedVariantId) return false;
    return activeNonFallbackOfferGroups().some(function (group) {
      return ((group && group.offers) || []).some(function (rawOffer) {
        if (wantedOfferId && readableTrackingId(rawOffer && rawOffer.id) !== wantedOfferId) return false;
        var offer = offerWithBlockedDiscount(harnessKitOfferPricing(rawOffer));
        if (offerVariantTargets(offer).indexOf(wantedVariantId) === -1) return false;
        return resolveOfferCompareAtCents(offer, wantedVariantId) > resolveOfferPriceCents(offer, wantedVariantId);
      });
    });
  }

  function centsOrNull(value) {
    if (value === null || value === undefined || value === "") return null;
    var amount = Number(value);
    return Number.isFinite(amount) && amount >= 0 ? amount : null;
  }

  function cartLineOriginalLineCents(item) {
    var quantity = Math.max(1, Number(item && item.quantity || 1));
    var candidates = [
      item && item.original_line_price,
      item && item.line_price,
      Number(item && item.price) * quantity,
      item && item.final_line_price
    ];
    for (var index = 0; index < candidates.length; index += 1) {
      var value = centsOrNull(candidates[index]);
      if (value !== null) return value;
    }
    return 0;
  }

  function cartLineFinalLineCents(item) {
    var candidates = [
      item && item.final_line_price,
      item && item.line_price,
      cartLineOriginalLineCents(item)
    ];
    for (var index = 0; index < candidates.length; index += 1) {
      var value = centsOrNull(candidates[index]);
      if (value !== null) return value;
    }
    return 0;
  }

  function cartLineHasShopifyDiscount(item) {
    var originalLine = cartLineOriginalLineCents(item);
    var finalLine = cartLineFinalLineCents(item);
    if (originalLine > 0 && finalLine >= 0 && finalLine < originalLine) return true;
    return Array.isArray(item && item.line_level_discount_allocations) && item.line_level_discount_allocations.length > 0;
  }

  function syntheticOfferPricingForLine(item) {
    if (cartMoneyPromiseContainmentEnabled()) return null;
    if (!item || cartLineHasShopifyDiscount(item)) return null;
    var variantId = String(item.variant_id || item.id || "");
    if (!variantId) return null;
    var quantity = Math.max(1, Number(item.quantity || 1));
    var originalUnit = Math.round(cartLineOriginalLineCents(item) / quantity);
    var best = null;
    var trackedOfferId = lineOfferIdForPricing(item);

    function consider(priceCents, compareAtCents) {
      var price = Number(priceCents || 0);
      if (!price || !Number.isFinite(price)) return;
      var compareAt = Math.max(Number(compareAtCents || 0), originalUnit || 0);
      if (compareAt <= price || (originalUnit && originalUnit <= price)) return;
      if (!best || price < best.priceCents) {
        best = {
          priceCents: price,
          compareAtCents: compareAt
        };
      }
    }

    if (trackedOfferId && syntheticOfferEligibleForLine(item, trackedOfferId, variantId)) {
      consider(
        linePropertyCents(item, "_tk9_offer_price_cents"),
        linePropertyCents(item, "_tk9_offer_compare_at_cents")
      );
    }

    activeNonFallbackOfferGroups().forEach(function (group) {
      ((group && group.offers) || []).forEach(function (rawOffer) {
        var offer = offerWithBlockedDiscount(harnessKitOfferPricing(rawOffer));
        if (offerVariantTargets(offer).indexOf(variantId) === -1) return;
        consider(resolveOfferPriceCents(offer, variantId), resolveOfferCompareAtCents(offer, variantId));
        ((offer.variantOptions || []).concat(offer.variantChoices || [])).forEach(function (choice) {
          if (String(choice && choice.variantId || "") !== variantId) return;
          consider(choice.priceCents || offer.priceCents, choice.standalonePriceCents || offer.standalonePriceCents || offer.compareAtPriceCents);
        });
      });
    });

    return best;
  }

  function harnessComponentIdForLine(item) {
    var productId = Number(item && item.product_id);
    if (!productId) return "";
    var productMap = kitComponentProductIds("harness");
    return Object.keys(productMap).find(function (componentId) {
      return productMap[componentId].map(Number).indexOf(productId) !== -1;
    }) || "";
  }

  function actualHarnessKitComponentDiscountCents() {
    return cartItems().reduce(function (sum, line) {
      if (!harnessComponentIdForLine(line)) return sum;
      return sum + Math.max(cartLineOriginalLineCents(line) - cartLineFinalLineCents(line), 0);
    }, 0);
  }

  function cleanHarnessKitLinePricing(item, quantity, originalLine, finalLine, bundleCompareLine) {
    if (!item || displayedDiscountCode() || !cartLineHasShopifyDiscount(item) || !hasHarnessInCart()) return null;
    var componentId = harnessComponentIdForLine(item);
    if (!componentId) return null;
    var group = activeHarnessSetupGroup();
    if (!group) return null;
    var triggerLines = triggerUnitsForGroup(group);
    var triggerContext = triggerLines.length ? contextFromLine(triggerLines[0]) : null;
    var baseComponents = harnessBaseComponentsFromTriggerLines(triggerLines);
    if (baseComponents.indexOf(componentId) !== -1) return null;
    var currentComponents = componentsInCartForKit("harness", group, triggerContext);
    if (currentComponents.indexOf(componentId) === -1) return null;
    var plan = bestHarnessKitPlan(baseComponents, currentComponents);
    var allocation = Number(plan.allocations && plan.allocations[componentId] || 0);
    if (!allocation) return null;
    var plannedTotal = Number(plan.allocatedCents || 0);
    var actualTotal = actualHarnessKitComponentDiscountCents();
    if (plannedTotal && Math.abs(plannedTotal - actualTotal) > 2) return null;
    var compareUnit = Math.max(
      Number(harnessComponentStandaloneCents(componentId) || 0),
      Math.round(Math.max(bundleCompareLine, originalLine, finalLine) / Math.max(1, quantity))
    );
    var compareLine = Math.max(compareUnit * Math.max(1, quantity), bundleCompareLine, originalLine, finalLine);
    var shownLine = Math.max(compareLine - allocation, 0);
    return {
      compareLine: compareLine,
      shownLine: shownLine,
      hasSavings: compareLine > shownLine
    };
  }

  function displayLinePricing(item) {
    var quantity = Math.max(1, Number(item && item.quantity || 1));
    var originalLine = cartLineOriginalLineCents(item);
    var finalLine = cartLineFinalLineCents(item);
    var hasShopifyDiscount = cartLineHasShopifyDiscount(item);
    var bundleCompareLine = bundleCompareAtCents(item) * quantity;
    if (cartMoneyPromiseContainmentEnabled()) {
      var containedShownLine = hasShopifyDiscount ? finalLine : (finalLine || originalLine);
      var containedCompareLine = hasShopifyDiscount
        ? Math.max(originalLine, bundleCompareLine, containedShownLine)
        : Math.max(bundleCompareLine, containedShownLine);
      return {
        compareLine: containedCompareLine,
        shownLine: containedShownLine,
        hasSavings: containedCompareLine > containedShownLine
      };
    }
    var cleanKitPricing = cleanHarnessKitLinePricing(item, quantity, originalLine, finalLine, bundleCompareLine);
    if (cleanKitPricing) return cleanKitPricing;
    var shownLine = hasShopifyDiscount ? finalLine : (finalLine || originalLine);
    var compareLine = Math.max(bundleCompareLine, shownLine);

    if (hasShopifyDiscount) {
      compareLine = Math.max(originalLine, bundleCompareLine, shownLine);
    } else {
      var synthetic = syntheticOfferPricingForLine(item);
      if (synthetic && synthetic.priceCents) {
        shownLine = Math.min(shownLine || synthetic.priceCents * quantity, synthetic.priceCents * quantity);
        compareLine = Math.max(compareLine, synthetic.compareAtCents * quantity, originalLine);
      }
    }

    return {
      compareLine: compareLine,
      shownLine: shownLine,
      hasSavings: compareLine > shownLine
    };
  }

  function bundleCompareAtCents(item) {
    var variantId = String(item && item.variant_id || item && item.id || "");
    if (!variantId) return 0;
    var displayRules = cartDisplayRules();
    var bundleDisplayMap = displayRules.bundleCompareAtVariantMap || {};
    var productDisplayMap = displayRules.compareAtVariantMap || displayRules.productCompareAtVariantMap || {};
    var compareAt = Math.max(
      Number(productDisplayMap[variantId] || 0),
      Number(state.variantCompareAtCents[variantId] || 0)
    );
    if (bundleDisplayMap[variantId]) compareAt = Math.max(compareAt, Number(bundleDisplayMap[variantId]));
    ((state.rules && state.rules.offerGroups) || []).forEach(function (group) {
      ((group && group.offers) || []).forEach(function (offer) {
        var standalone = Number(offer.standalonePriceCents || offer.compareAtPriceCents || 0);
        if (!standalone) return;
        var directTargets = offerVariantTargets(offer);
        if (directTargets.indexOf(variantId) !== -1) compareAt = Math.max(compareAt, standalone);
        if (offer.action === "change_variant") {
          var targets = [];
          if (Array.isArray(offer.targetVariantIds)) targets = targets.concat(offer.targetVariantIds.map(String));
          Object.keys(offer.targetVariantMap || {}).forEach(function (sourceId) {
            targets.push(String(offer.targetVariantMap[sourceId]));
          });
          if (targets.indexOf(variantId) !== -1) compareAt = Math.max(compareAt, standalone);
        }
        ((offer.variantOptions || []).concat(offer.variantChoices || [])).forEach(function (choice) {
          if (String(choice && choice.variantId || "") !== variantId) return;
          var choiceStandalone = Number(choice.standalonePriceCents || standalone || 0);
          compareAt = Math.max(compareAt, choiceStandalone);
        });
      });
    });
    return compareAt;
  }

  function cartCompareAtSubtotalCents() {
    return merchandiseCartItems().reduce(function (sum, item) {
      return sum + displayLinePricing(item).compareLine;
    }, 0);
  }

  function cartDisplaySubtotalCents() {
    return merchandiseCartItems().reduce(function (sum, item) {
      return sum + displayLinePricing(item).shownLine;
    }, 0);
  }

  function protectionDisplaySubtotalCents() {
    return cartItems().filter(isProtectionLine).reduce(function (sum, item) {
      return sum + displayLinePricing(item).shownLine;
    }, 0);
  }

  function cartOrderDisplaySubtotalCents() {
    return cartDisplaySubtotalCents() + protectionDisplaySubtotalCents();
  }

  function cartOrderCompareAtSubtotalCents() {
    return cartCompareAtSubtotalCents() + protectionDisplaySubtotalCents();
  }

  function cartLineIndex(item) {
    var key = item && item.key;
    if (!key || !state.cart || !Array.isArray(state.cart.items)) return 0;
    for (var index = 0; index < state.cart.items.length; index += 1) {
      if (state.cart.items[index] && state.cart.items[index].key === key) return index + 1;
    }
    return 0;
  }

  function renderCartLineArticle(item, options) {
    var productUrl = cartLineUrl(item);
    var title = escapeHtml(cartProductName(item));
    var pricing = displayLinePricing(item);
    var linePrice = pricing.hasSavings
      ? '<span class="tk9-discount-price"><s>' + money(pricing.compareLine) + '</s><span class="tk9-cart-line__price-current">' + money(pricing.shownLine) + '</span></span>'
      : '<span class="tk9-cart-line__price-current">' + money(pricing.shownLine) + '</span>';
    var lineCompareAt = pricing.hasSavings ? pricing.compareLine : 0;
    var lineShownPrice = pricing.shownLine;
    var lineSavingsPill = savingsPillHtml(lineCompareAt, lineShownPrice, "tk9-line-save-pill");
    var image = renderCartLineImage(item);
    var linkedImage = productUrl ? '<a class="tk9-cart-line__image-link" href="' + escapeHtml(productUrl) + '" aria-label="View ' + title + '">' + image + '</a>' : image;
    var linkedTitle = productUrl ? '<a class="tk9-cart-line__title" href="' + escapeHtml(productUrl) + '">' + title + '</a>' : '<div class="tk9-cart-line__title">' + title + '</div>';
    var lineIndex = cartLineIndex(item);
    var lineClass = isCustomPatchLine(item) ? "tk9-cart-line tk9-cart-line--custom-patch" : "tk9-cart-line";
    return '<article class="' + lineClass + '">' +
      linkedImage +
      '<div class="tk9-cart-line__body">' +
        linkedTitle +
        renderCartLineMeta(item) +
        renderCartLinePromise(item, options) +
        renderLineProperties(item) +
        renderLineDiscountDetails(item, pricing) +
        '<div class="tk9-cart-line__qty">' +
          '<button type="button" data-tk9-qty="' + escapeHtml(item.key) + '" data-line-index="' + escapeHtml(lineIndex || "") + '" data-quantity="' + Math.max(0, Number(item.quantity || 1) - 1) + '">-</button>' +
          '<span>' + Number(item.quantity || 1) + '</span>' +
          '<button type="button" data-tk9-qty="' + escapeHtml(item.key) + '" data-line-index="' + escapeHtml(lineIndex || "") + '" data-quantity="' + (Number(item.quantity || 1) + 1) + '">+</button>' +
        '</div>' +
      '</div>' +
      '<div class="tk9-cart-line__price">' + lineSavingsPill + linePrice + '</div>' +
    '</article>';
  }

  function renderLines() {
    var items = displayCartItems();
    return items.map(function (item) {
      return renderCartLineArticle(item, { hideDeliveryDetail: true });
    }).join("");
  }

  function renderEmptyCart() {
    var heroes = [
      {
        title: "4-Buckle Tactical Harness",
        copy: "Start with the no-pull walking setup customers come back for.",
        tag: "Best seller",
        href: "/products/all-metal-tactical-harness",
        image: "https://cdn.shopify.com/s/files/1/2715/4364/files/12_86f56c83-b4b8-4336-ab7a-7f40b9a58a1f.png?v=1772982683"
      },
      {
        title: "Hard Bottom Seat Cover",
        copy: "Protect the backseat and unlock the FREE safety belt.",
        tag: "Car favorite",
        href: "/products/hard-bottom-csce",
        image: "https://cdn.shopify.com/s/files/1/2715/4364/files/1_e9bf22e4-6089-4a40-9211-ad520765df00.png?v=1771457232"
      },
      {
        title: "Foldable Dog Pool",
        copy: "Backyard cool-downs, baths, and rinse-offs made easy.",
        tag: "Summer pick",
        href: "/products/dog-pool",
        image: "https://cdn.shopify.com/s/files/1/2715/4364/files/dog_pool_aqua_blue.png?v=1771457232"
      },
      {
        title: "Backseat Cooling Fans",
        copy: "Add USB-A airflow to warm car rides.",
        tag: "Hot-day add",
        href: "/products/dual-headrest-cooling-fans-usb-a",
        image: "https://cdn.shopify.com/s/files/1/2715/4364/files/fan_8.jpg?v=1771457172"
      }
    ];
    return '<section class="tk9-empty-cart">' +
      '<div class="tk9-empty-cart__hero">' +
        '<span>Cart is empty</span>' +
        '<h2>Start a Team K9 setup</h2>' +
        '<p>Start with one of the Team K9 favorites, then we will guide the right add-ons from cart to checkout.</p>' +
        '<a href="/collections/best-sellers">Shop best sellers</a>' +
      '</div>' +
      '<div class="tk9-empty-cart__grid">' +
        heroes.map(function (hero) {
          return '<a class="tk9-empty-card" href="' + escapeHtml(hero.href) + '">' +
            imageTag("tk9-empty-card__image", hero.image, hero.title) +
            '<div class="tk9-empty-card__body">' +
              '<div class="tk9-empty-card__top"><strong>' + escapeHtml(hero.title) + '</strong><span>' + escapeHtml(hero.tag) + '</span></div>' +
              '<p>' + escapeHtml(hero.copy) + '</p>' +
            '</div>' +
          '</a>';
        }).join("") +
      '</div>' +
    '</section>';
  }

  function renderBonus(group) {
    var key = group && group.includedPerkKey;
    var perk = key && state.rules && state.rules.includedPerks && state.rules.includedPerks[key];
    if (!perk) return "";
    var items = perk.items || [];

    if (items.length > 0 && items.length <= 2) {
      return '<section class="tk9-included-strips" aria-label="' + escapeHtml(perk.title || "FREE included") + '">' +
        items.map(function (item) {
          var media = item.image ? imageTag("tk9-included-strip__image", item.image, item.label || "") : '<span class="tk9-included-strip__image tk9-image-fallback" aria-hidden="true"></span>';
          return '<div class="tk9-included-strip">' +
            media +
            '<div class="tk9-included-strip__body">' +
              '<div class="tk9-included-strip__title">' + escapeHtml(item.label || perk.title || "FREE included") + '</div>' +
              (item.copy ? '<div class="tk9-included-strip__copy">' + escapeHtml(item.copy || "") + '</div>' : "") +
            '</div>' +
            '<div class="tk9-included-strip__value">' + escapeHtml(item.value || perk.meta || "FREE") + '</div>' +
          '</div>';
        }).join("") +
      '</section>';
    }

    var icons = items.map(function (item) {
      var media = item.image ? imageTag("tk9-included__image", item.image, item.label || "") : '<span class="tk9-included__image tk9-image-fallback" aria-hidden="true"></span>';
      return '<span class="tk9-included__item">' + media + '<span>' + escapeHtml(item.label || "Included") + '</span></span>';
    }).join("");

    return '<section class="tk9-included">' +
      '<div class="tk9-included__top">' +
        '<div><div class="tk9-included__title">' + escapeHtml(perk.title || "FREE included") + '</div>' +
        '<div class="tk9-included__meta">' + escapeHtml(perk.meta || "") + '</div></div>' +
        '<div class="tk9-included__badge">FREE</div>' +
      '</div>' +
      (icons ? '<div class="tk9-included__items">' + icons + '</div>' : "") +
      '<div class="tk9-included__summary">' + escapeHtml(perk.summary || "") + '</div>' +
    '</section>';
  }

  function isPriorityIncludedPerk(key) {
    return false;
  }

  function renderIncludedPerks(groups, options) {
    var seen = {};
    options = options || {};
    return (groups || []).map(function (group) {
      var key = group && group.includedPerkKey;
      if (!key || seen[key]) return "";
      if (options.priorityOnly && !isPriorityIncludedPerk(key)) return "";
      if (options.deferredOnly && isPriorityIncludedPerk(key)) return "";
      seen[key] = true;
      return renderBonus(group);
    }).join("");
  }

  function renderProgress(offers) {
    var shipping = shippingState();
    var text = shippingProgressText(shipping);
    var hint = shippingProgressHint(offers, shipping);
    return '<section class="tk9-progress">' +
      '<div class="tk9-progress__top"><span>' + text + '</span><span>' + shipping.progress + '%</span></div>' +
      '<div class="tk9-progress__bar"><span style="width:' + shipping.progress + '%"></span></div>' +
      (hint ? '<div class="tk9-progress__hint">' + escapeHtml(hint) + '</div>' : "") +
    '</section>';
  }

  function renderProof(group) {
    var cart = state.cart || {};
    var merchandiseCount = merchandiseCartItems().reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
    if (!merchandiseCount) return "";
    var cartReviewProof = state.rules && state.rules.cart && state.rules.cart.storeReviewProof;
    var reviewProof = cartReviewProof;

    return '<section class="tk9-proof-row">' +
      '<div class="tk9-proof-chip"><strong>★★★★★</strong> ' + escapeHtml(reviewProof || cartReviewProof || "9,390 reviews") + '</div>' +
      '<div class="tk9-proof-chip">60-day guarantee</div>' +
    '</section>';
  }

  function compactHeaderReviewProof(text) {
    var value = String(text || "9,390 reviews").trim();
    var match = value.match(/(\d[\d,]*(?:\.\d+)?)/);
    if (!match) return value.replace(/\s+reviews?\b/i, "");
    var count = Number(match[1].replace(/,/g, ""));
    if (!Number.isFinite(count) || count < 1000) return value.replace(/\s+reviews?\b/i, "");
    var compact = Math.floor(count / 100) / 10;
    return String(compact).replace(/\.0$/, "") + "k";
  }

  function reviewProofLabel(text) {
    var count = compactHeaderReviewProof(text || "9,390 reviews");
    return /\breviews?\b/i.test(count) ? count : count + " reviews";
  }

  function compactHeaderBuyerProof(text) {
    var value = String(text || "60-day guarantee")
      .replace(/\bverified\s+/i, "")
      .replace(/\bcustomers\b/i, "buyers")
      .trim();
    var match = value.match(/(\d[\d,.]*\s*k\+?|\d[\d,]*(?:\.\d+)?\+?)/i);
    var count = match ? match[1].replace(/\s+/g, "") : "";
    return count || value;
  }

  function customerProofLabel(text) {
    var count = compactHeaderBuyerProof(text || "60-day guarantee");
    return count;
  }

  function updateHeaderShippingProgress(offers) {
    var shippingNode = document.querySelector("[data-tk9-header-shipping]");
    if (!shippingNode) return;
    var merchandiseCount = merchandiseCartItems().reduce(function (sum, item) {
      return sum + Number(item.quantity || 0);
    }, 0);
    if (!merchandiseCount) {
      shippingNode.innerHTML = "";
      shippingNode.hidden = true;
      return;
    }
    var shipping = shippingState();
    var text = shippingProgressText(shipping);
    var hint = shippingProgressHint(offers || [], shipping);
    var progress = Math.max(0, Math.min(100, Number(shipping && shipping.progress) || 0));
    var stateClass = shipping && (shipping.unlocked || shipping.secured) ? " is-unlocked" : "";
    shippingNode.hidden = false;
    shippingNode.innerHTML =
      '<div class="tk9-header-shipping' + stateClass + '" aria-label="' + escapeHtml(text + (hint ? ". " + hint : "")) + '">' +
        '<div class="tk9-header-shipping__top"><span>' + escapeHtml(text) + '</span><b>' + progress + '%</b></div>' +
        '<div class="tk9-header-shipping__bar" aria-hidden="true"><span style="width:' + progress + '%"></span></div>' +
      '</div>';
  }

  function compactSetupProductIds(list) {
    return (list || []).map(Number).filter(Boolean);
  }

  function setupProductId(name, fallback) {
    var ids = state.rules && state.rules.productIds || {};
    return Number(ids[name] || fallback || 0);
  }

  function setupProgressDefinitions() {
    var harnessProducts = compactSetupProductIds([
      setupProductId("fourBuckleHarness", 7090638356579),
      setupProductId("twoBuckleHarness", 6749766811747),
      setupProductId("tenInOneKit", 6886975340643)
    ]);
    var seatCoverProduct = setupProductId("hardBottomSeatCover", 7513423413347);
    var fansProduct = setupProductId("dualHeadrestCoolingFans", 7827615121507);
    var poolProduct = setupProductId("dogPool", 6801131569251);

    return {
      "harness-setup": {
        id: "harness",
        kind: "harness",
        badge: "WALK",
        eyebrow: "Harness add-ons",
        title: "Useful harness add-ons",
        copy: "Patch, leash, collar, and ride gear that fit this harness.",
        completeCopy: "Harness add-ons covered.",
        quantity: {
          productIds: harnessProducts,
          target: 2,
          copy: "Multi-dog savings can unlock at 2+ harnesses."
        },
        steps: [
          {
            id: "harness",
            label: "Harness",
            nextLabel: "the harness",
            fallbackImage: "orange-harness.png",
            productIds: harnessProducts,
            offerIds: ["hero-4buckle-harness", "upgrade-2mbh-to-4mbh", "upgrade-complete-matching-set"]
          },
          {
            id: "leash",
            label: "Leash",
            nextLabel: "the leash",
            fallbackImage: "orange-leash.jpg",
            componentIds: ["leash"],
            productIds: compactSetupProductIds([setupProductId("tacticalLeash", 4508637560931)]),
            offerIds: ["matched-leash"]
          },
          {
            id: "collar",
            label: "Collar",
            nextLabel: "the collar",
            fallbackImage: "collar-orange.png",
            componentIds: ["collar"],
            productIds: compactSetupProductIds([setupProductId("tacticalCollar", 4508633759843)]),
            offerIds: ["matched-collar"]
          },
          {
            id: "patches",
            label: "Patches",
            nextLabel: "patches",
            fallbackImage: "patch-variety-bundle.jpg",
            componentIds: ["custom-patch", "patch-bundle"],
            productIds: compactSetupProductIds([
              setupProductId("customPatch", 4734560632931),
              setupProductId("patchBundle", 6840101797987),
              setupProductId("hookLoopPatch", 6877742399587)
            ]),
            offerIds: ["custom-patch", "patch-variety", "single-style-patch"]
          },
          {
            id: "ride",
            label: "Ride",
            nextLabel: "ride gear",
            fallbackImage: "car-safety-belt.jpg",
            componentIds: ["safety-belt"],
            productIds: compactSetupProductIds([setupProductId("carSafetyBelt", 6762308337763)]),
            offerIds: ["harness-safety-belt"]
          }
        ]
      },
      "seat-cover-setup": {
        id: "seat",
        kind: "cover",
        badge: "TRIP",
        eyebrow: "Seat cover add-ons",
        title: "Seat cover bundle deals unlocked",
        copy: "",
        completeCopy: "Seat cover add-ons covered.",
        quantity: {
          productIds: compactSetupProductIds([seatCoverProduct]),
          target: 2,
          copy: "Multi-car savings can unlock at 2+ seat covers."
        },
        steps: [
          {
            id: "cover",
            label: "Cover",
            nextLabel: "the seat cover",
            fallbackImage: "seat-cover-reference.png",
            productIds: compactSetupProductIds([seatCoverProduct]),
            offerIds: ["default-seat-cover"]
          },
          {
            id: "comfort",
            label: "Comfort",
            nextLabel: "the plush bed",
            fallbackImage: "black-bed.png",
            componentIds: ["bed"],
            productIds: compactSetupProductIds([setupProductId("backseatDogBed", 7586514567267)]),
            offerIds: ["backseat-bed", "fan-backseat-bed"]
          },
          {
            id: "cooling",
            label: "Cooling",
            nextLabel: "cooling fans",
            fallbackImage: "dual-fan.jpg",
            componentIds: ["fans"],
            productIds: compactSetupProductIds([fansProduct]),
            offerIds: ["dual-fans", "default-cooling-fans"]
          },
          {
            id: "eye-gear",
            label: "Doggles",
            nextLabel: "Doggles",
            fallbackImage: "https://cdn.shopify.com/s/files/1/2715/4364/products/S5845671b8c71443580c2737e256e52cbr.jpg?v=1771457171",
            componentIds: ["dog-goggles"],
            productIds: compactSetupProductIds([setupProductId("dogGoggles", 6905734070371)]),
            offerIds: ["cover-doggles", "fan-doggles", "dog-goggles"]
          },
          {
            id: "safety",
            label: "Safety",
            nextLabel: "the second belt",
            fallbackImage: "car-safety-belt.jpg",
            componentIds: ["safety-belt"],
            productIds: compactSetupProductIds([setupProductId("carSafetyBelt", 6762308337763)]),
            offerIds: ["extra-safety-belt"]
          },
          {
            id: "hydration",
            label: "Hydrate",
            nextLabel: "the travel bowl",
            fallbackImage: "travel-bowl.jpg",
            componentIds: ["travel-bowl"],
            productIds: compactSetupProductIds([setupProductId("travelBowl", 6784072122467)]),
            offerIds: ["travel-bowl"]
          }
        ]
      },
      "pool-setup": {
        id: "pool",
        kind: "pool",
        badge: "POOL",
        eyebrow: "Pool day add-ons",
        title: "Useful for pool days",
        copy: "Cover, splash, dry-off, and cleanup add-ons.",
        completeCopy: "Pool day add-ons covered.",
        steps: [
          {
            id: "pool",
            label: "Pool",
            nextLabel: "the pool",
            fallbackImage: "pool.png",
            productIds: compactSetupProductIds([poolProduct]),
            offerIds: []
          },
          {
            id: "cover",
            label: "Cover",
            nextLabel: "the pool cover",
            fallbackImage: "pool-cover.jpg",
            componentIds: ["pool-cover"],
            productIds: compactSetupProductIds([setupProductId("dogPoolCover", 6920870527075)]),
            offerIds: ["pool-cover"]
          },
          {
            id: "splash",
            label: "Splash",
            nextLabel: "the splash pad",
            fallbackImage: "splash-pad.jpg",
            componentIds: ["splash-pad"],
            productIds: compactSetupProductIds([setupProductId("splashPad", 7383496261731)]),
            offerIds: ["splash-pad"]
          },
          {
            id: "dry",
            label: "Dry-off",
            nextLabel: "dry-off gear",
            fallbackImage: "dry-towel.png",
            componentIds: ["quick-dry-towel", "paw-drying-mat"],
            productIds: compactSetupProductIds([
              setupProductId("quickDryTowel", 7775269453923),
              setupProductId("floorMat", 6735967256675)
            ]),
            offerIds: ["quick-dry-towel", "paw-drying-mat"]
          },
          {
            id: "cleanup",
            label: "Cleanup",
            nextLabel: "cleanup gear",
            fallbackImage: "https://cdn.shopify.com/s/files/1/2715/4364/files/dog_hair.png?v=1771457172",
            productIds: compactSetupProductIds([setupProductId("hairRemovalGloves", 7892526432355)]),
            offerIds: ["pool-hair-removal-gloves"]
          }
        ]
      },
      "fan-setup": {
        id: "fan",
        kind: "fan",
        badge: "COOL",
        eyebrow: "Fan add-ons",
        title: "Fan bundle deals unlocked",
        copy: "",
        completeCopy: "Fan add-ons covered.",
        quantity: {
          productIds: compactSetupProductIds([fansProduct]),
          target: 2,
          copy: "Pack pricing can unlock when you add more fans."
        },
        steps: [
          {
            id: "fans",
            label: "Fans",
            nextLabel: "the fans",
            fallbackImage: "dual-fan.jpg",
            productIds: compactSetupProductIds([fansProduct]),
            offerIds: ["default-cooling-fans"]
          },
          {
            id: "pack",
            label: "Pack",
            nextLabel: "fan pack",
            fallbackImage: "fan-bundle.png",
            productIds: compactSetupProductIds([fansProduct]),
            minQuantity: 2,
            textMatches: ["2-pack fans", "2 pack fans", "4-pack fans", "4 pack fans", "fan two pack", "fan four pack"],
            offerIds: ["fan-two-pack-upgrade", "fan-four-pack-upgrade"]
          },
          {
            id: "comfort",
            label: "Comfort",
            nextLabel: "the plush bed",
            fallbackImage: "black-bed.png",
            productIds: compactSetupProductIds([setupProductId("backseatDogBed", 7586514567267)]),
            offerIds: ["fan-backseat-bed", "backseat-bed"]
          },
          {
            id: "ride",
            label: "Ride",
            nextLabel: "ride gear",
            fallbackImage: "car-safety-belt.jpg",
            productIds: compactSetupProductIds([
              setupProductId("dogGoggles", 6905734070371),
              setupProductId("carSafetyBelt", 6762308337763)
            ]),
            offerIds: ["fan-doggles", "fan-safety-belt"]
          },
          {
            id: "hydration",
            label: "Hydrate",
            nextLabel: "the travel bowl",
            fallbackImage: "travel-bowl.jpg",
            productIds: compactSetupProductIds([setupProductId("travelBowl", 6784072122467)]),
            offerIds: ["fan-travel-bowl"]
          }
        ]
      }
    };
  }

  function cartQuantityForProductIds(productIds) {
    var wanted = compactSetupProductIds(productIds);
    if (!wanted.length) return 0;
    return cartItems().reduce(function (sum, item) {
      return wanted.indexOf(Number(item && item.product_id)) !== -1 ? sum + lineQuantity(item) : sum;
    }, 0);
  }

  function setupProgressComponentIds(definition, group) {
    if (!definition || !group) return [];
    var kind = definition.kind;
    if (kind !== "cover" && kind !== "pool" && kind !== "harness") return [];
    var triggerLines = triggerUnitsForGroup(group);
    var triggerContext = triggerLines.length ? contextFromLine(triggerLines[0]) : null;
    var baseComponents = kind === "cover"
      ? coverBaseComponentsFromTriggerLines(triggerLines)
      : kind === "pool"
        ? poolBaseComponentsFromTriggerLines(triggerLines)
        : harnessBaseComponentsFromTriggerLines(triggerLines);
    return componentUnique(baseComponents.concat(componentsInCartForKit(kind, group, triggerContext)));
  }

  function setupStepUnlocked(step, componentLookup) {
    if (!step) return false;
    if ((step.componentIds || []).some(function (componentId) {
      return Boolean(componentLookup[componentId]);
    })) return true;
    if (cartQuantityForProductIds(step.productIds) >= Math.max(1, Number(step.minQuantity || 1))) return true;
    if (Array.isArray(step.textMatches) && step.textMatches.length && cartContainsAnyText(step.textMatches)) return true;
    return false;
  }

  function setupProgressOfferMatchesStep(offer, step) {
    if (!offer || !step) return false;
    if ((step.offerIds || []).indexOf(offer.id) !== -1) return true;
    var productIds = compactSetupProductIds(step.productIds);
    return productIds.indexOf(Number(offer.productId)) !== -1;
  }

  function setupProgressOfferForStep(step, offers) {
    var visibleOffers = offers || [];
    for (var index = 0; index < visibleOffers.length; index += 1) {
      if (setupProgressOfferMatchesStep(visibleOffers[index], step)) return visibleOffers[index];
    }
    return null;
  }

  function cartImageForProductIds(productIds) {
    var wanted = compactSetupProductIds(productIds);
    if (!wanted.length) return "";
    var items = cartItems();
    for (var index = 0; index < items.length; index += 1) {
      var item = items[index];
      if (wanted.indexOf(Number(item && item.product_id)) === -1) continue;
      var image = lineImage(item);
      if (image) return image;
    }
    return "";
  }

  function setupProgressStepImage(step, offers) {
    if (!step) return "";
    var cartImage = cartImageForProductIds(step.productIds);
    if (cartImage) return cartImage;
    var offer = setupProgressOfferForStep(step, offers);
    if (offer && offer.image) return offer.image;
    if (offer && Array.isArray(offer.contextChoices) && offer.contextChoices[0] && offer.contextChoices[0].image) {
      return offer.contextChoices[0].image;
    }
    return step.fallbackImage || "";
  }

  function setupProgressShortOfferTitle(offer) {
    return String(offer && offer.title || "the next add-on")
      .replace(/^team\s*k9\S*\s*/i, "")
      .replace(/\s*\([^)]*\)\s*/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function setupProgressNextWin(steps, offers) {
    var visibleOffers = offers || [];
    for (var stepIndex = 0; stepIndex < steps.length; stepIndex += 1) {
      var step = steps[stepIndex];
      if (!step || step.unlocked) continue;
      for (var offerIndex = 0; offerIndex < visibleOffers.length; offerIndex += 1) {
        var offer = visibleOffers[offerIndex];
        if (setupProgressOfferMatchesStep(offer, step)) return { step: step, offer: offer };
      }
    }
    return visibleOffers.length ? { step: null, offer: visibleOffers[0] } : null;
  }

  function setupProgressSavingsText(offer) {
    if (!offer) return "";
    var compareAt = Number(offer.standalonePriceCents || offer.compareAtPriceCents || 0);
    return offerSavingsBadgeText(compareAt, offer.priceCents, {
      allowContainedPromise: offerDiscountPromiseAllowed(offer, compareAt, offer.priceCents)
    });
  }

  function setupProgressQuantityHint(definition) {
    var rule = definition && definition.quantity;
    if (!rule || !rule.target) return "";
    var quantity = cartQuantityForProductIds(rule.productIds);
    if (!quantity || quantity >= Number(rule.target)) return "";
    return rule.copy || "";
  }

  function setupProgressGiftText(group) {
    var key = group && group.includedPerkKey;
    var perk = key && state.rules && state.rules.includedPerks && state.rules.includedPerks[key];
    if (!perk) return "";
    if (/safety\s+belt/i.test(perk.title || "")) return "FREE safety belt unlocked";
    if (/harness/i.test(key || "") || /harness/i.test(perk.title || "")) return "FREE bonuses unlocked";
    return "FREE gift unlocked";
  }

  function setupProgressQuantityText(definition) {
    var rule = definition && definition.quantity;
    if (!rule || !rule.target) return "";
    var quantity = cartQuantityForProductIds(rule.productIds);
    var target = Math.max(1, Number(rule.target || 0));
    if (quantity >= target) return "Quantity break unlocked";
    var needed = Math.max(target - quantity, 1);
    if (definition.id === "fan") return "Add " + needed + " more for pack pricing";
    if (definition.id === "seat") return "Add " + needed + " more for multi-car savings";
    if (definition.id === "harness") return "Add " + needed + " more for multi-dog savings";
    return rule.copy || "";
  }

  function setupProgressMilestones(model) {
    var milestones = [];
    var shipping = shippingState();
    if (shipping) {
      milestones.push({
        label: "Ship",
        text: shipping.unlocked ? "FREE shipping unlocked" : money(shipping.remaining) + " from FREE shipping",
        unlocked: Boolean(shipping.unlocked || shipping.secured)
      });
    }
    if (model && model.giftText) {
      milestones.push({
        label: "Gift",
        text: model.giftText,
        unlocked: true
      });
    }
    if (model && model.quantityText) {
      milestones.push({
        label: "Qty",
        text: model.quantityText,
        unlocked: /unlocked/i.test(model.quantityText)
      });
    }
    return milestones.slice(0, 3);
  }

  function setupRouteArt(familyId) {
    var art = {
      harness: "tk9-cart-map-harness-storybook-v1.jpg",
      seat: "tk9-cart-map-seat-storybook-v1.jpg",
      fan: "tk9-cart-map-fan-storybook-v1.jpg",
      pool: "tk9-cart-map-pool-storybook-v1.jpg"
    };
    return art[familyId] || art.seat;
  }

  function setupRoutePoints(familyId) {
    var maps = {
      harness: [
        { x: 10, y: 55 },
        { x: 30, y: 55 },
        { x: 47, y: 54 },
        { x: 64, y: 54 },
        { x: 86, y: 54 }
      ],
      seat: [
        { x: 26, y: 66 },
        { x: 42, y: 66 },
        { x: 58, y: 66 },
        { x: 74, y: 65 },
        { x: 91, y: 64 }
      ],
      fan: [
        { x: 18, y: 57 },
        { x: 36, y: 57 },
        { x: 53, y: 57 },
        { x: 70, y: 57 },
        { x: 87, y: 58 }
      ],
      pool: [
        { x: 13, y: 57 },
        { x: 31, y: 57 },
        { x: 50, y: 57 },
        { x: 69, y: 57 },
        { x: 88, y: 58 }
      ]
    };
    return maps[familyId] || maps.seat;
  }

  function renderSetupRouteMap(definition, steps, nextStep, calloutLabel, calloutText, savings) {
    var familyId = definition && definition.id || "seat";
    var points = setupRoutePoints(familyId);
    var art = setupRouteArt(familyId);
    var stops = (steps || []).map(function (step, index) {
      var point = points[index] || { x: 50, y: 50 };
      var stateClass = step.unlocked ? " is-unlocked" : nextStep && nextStep.id === step.id ? " is-next" : "";
      var media = step.image ? '<img src="' + escapeHtml(imageUrl(step.image)) + '" alt="" loading="lazy" decoding="async">' : "";
      return '<span class="tk9-setup-map__stop' + stateClass + '" style="--x:' + escapeHtml(point.x) + '%;--y:' + escapeHtml(point.y) + '%">' +
        '<i aria-hidden="true">' + media + '</i><em>' + escapeHtml(step.label || "") + '</em>' +
      '</span>';
    }).join("");
    var callout = '<div class="tk9-setup-map__callout">' +
      '<span>' + escapeHtml(calloutLabel || "Next stop") + '</span>' +
      '<strong>' + escapeHtml(calloutText || "") + '</strong>' +
      (savings ? '<em>' + escapeHtml(savings) + '</em>' : "") +
    '</div>';
    return '<div class="tk9-setup-map" data-tk9-setup-map="' + escapeHtml(familyId) + '">' +
      '<img class="tk9-setup-map__art" src="' + escapeHtml(imageUrl(art)) + '" alt="" loading="lazy" decoding="async">' +
      callout +
      stops +
    '</div>';
  }

  function setupProgressModel(group, offers) {
    if (!activeSetupProgressEnabled() || !group) return null;
    var definition = setupProgressDefinitions()[group.id];
    if (!definition) return null;
    var componentIds = setupProgressComponentIds(definition, group);
    var componentLookup = {};
    componentIds.forEach(function (componentId) {
      componentLookup[componentId] = true;
    });
    var steps = (definition.steps || []).map(function (step) {
      return Object.assign({}, step, {
        image: setupProgressStepImage(step, offers),
        unlocked: setupStepUnlocked(step, componentLookup)
      });
    });
    var unlockedCount = steps.filter(function (step) {
      return step.unlocked;
    }).length;
    if (!unlockedCount) return null;
    return {
      definition: definition,
      steps: steps,
      unlockedCount: unlockedCount,
      totalCount: steps.length,
      progress: Math.max(0, Math.min(100, Math.round((unlockedCount / Math.max(steps.length, 1)) * 100))),
      next: setupProgressNextWin(steps, offers),
      giftText: setupProgressGiftText(group),
      quantityHint: setupProgressQuantityHint(definition),
      quantityText: setupProgressQuantityText(definition)
    };
  }

  function renderSetupProgressMilestones(model) {
    var milestones = setupProgressMilestones(model);
    if (!milestones.length) return "";
    return '<div class="tk9-setup-progress__milestones">' + milestones.map(function (item) {
      return '<span class="' + (item.unlocked ? "is-unlocked" : "is-next") + '">' +
        '<b>' + escapeHtml(item.label) + '</b>' +
        '<em>' + escapeHtml(item.text) + '</em>' +
      '</span>';
    }).join("") + '</div>';
  }

  function renderSetupProgressModel(model) {
    if (!model) return "";
    var definition = model.definition || {};
    var next = model.next;
    var nextLabel = next && next.step
      ? next.step.nextLabel || next.step.label
      : setupProgressShortOfferTitle(next && next.offer);
    var savings = setupProgressSavingsText(next && next.offer);
    var savingsShort = savings ? savings.replace(/\s*OFF$/i, "") : "";
    var nextText = next && next.offer
      ? "Add " + nextLabel + (savingsShort ? " to save " + savingsShort : "")
      : definition.completeCopy || "Setup unlocked.";
    var calloutLabel = next && next.offer ? "Next smart add" : "Setup complete";
    var note = model.quantityHint ? '<div class="tk9-setup-progress__note">' + escapeHtml(model.quantityHint) + '</div>' : "";
    var routeMap = renderSetupRouteMap(definition, model.steps, next && next.step, calloutLabel, nextText, savings);
    var milestones = renderSetupProgressMilestones(model);

    return '<section class="tk9-setup-progress" data-tk9-setup-family="' + escapeHtml(definition.id || "") + '">' +
      '<div class="tk9-setup-progress__top">' +
        '<div class="tk9-setup-progress__badge"><span>' + escapeHtml(definition.badge || "WIN") + '</span><b>Setup</b></div>' +
        '<div class="tk9-setup-progress__heading">' +
          '<span>' + escapeHtml(definition.eyebrow || "Useful add-ons") + '</span>' +
          '<strong>' + escapeHtml(definition.title || "Useful add-ons") + '</strong>' +
        '</div>' +
        '<div class="tk9-setup-progress__score"><span>Built</span><strong>' + escapeHtml(model.unlockedCount + "/" + model.totalCount) + '</strong></div>' +
      '</div>' +
      '<div class="tk9-setup-progress__copy">' + escapeHtml(definition.copy || "") + '</div>' +
      routeMap +
      milestones +
      note +
    '</section>';
  }

  function renderProtection() {
    if (!merchandiseCartItems().length) return "";
    var protections = state.rules && state.rules.protection;
    if (!Array.isArray(protections) || !protections.length) return "";

    var rows = protections.map(function (item) {
      var line = cartLineByProductId(item.productId);
      var isOn = Boolean(line);
      return '<article class="tk9-protection-row" data-tk9-protection="' + escapeHtml(item.id) + '">' +
        imageTag("tk9-protection__image", item.image, item.title) +
        '<div>' +
          '<div class="tk9-protection__title">' + escapeHtml(item.title) + '</div>' +
          '<div class="tk9-protection__copy">' + escapeHtml(item.copy || "") + '</div>' +
        '</div>' +
        '<div class="tk9-protection__action">' +
          '<span class="tk9-protection__price">' + money(item.priceCents) + '</span>' +
          '<button class="tk9-switch' + (isOn ? " is-on" : "") + '" type="button" role="switch" aria-checked="' + (isOn ? "true" : "false") + '" data-tk9-toggle-protection="' + escapeHtml(item.id) + '" aria-label="' + escapeHtml((isOn ? "Remove " : "Add ") + item.title) + '"><span></span></button>' +
        '</div>' +
      '</article>';
    }).join("");

    return '<section class="tk9-protection">' +
      '<div class="tk9-protection__head">' +
        '<div><strong>Protect the order</strong></div>' +
        '<em>Optional</em>' +
      '</div>' +
      '<div class="tk9-protection__list">' + rows + '</div>' +
    '</section>';
  }

  function renderOfferImage(offer) {
    if (isCustomPatchOffer(offer)) {
      return patchPreviewHtml("tk9-offer__image tk9-patch-mockup tk9-patch-mockup--offer", "BUDDY", "(888)-645-2889");
    }
    return imageTag("tk9-offer__image", offer.image, offer.title);
  }

  function compactOfferTitle(title) {
    return String(title || "")
      .replace(/^team\s*k9(?:®|\(r\))?\s*/i, "")
      .replace(/\s*\((?:usb-a|fits seat cover)\)\s*/ig, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function offerBundleLabel(offer) {
    var groupId = String(offer && offer.groupId || "");
    if (groupId === "seat-cover-setup") return "Seat cover bundle";
    if (groupId === "walk-accessory-route") return "Active Ride";
    if (groupId === "harness-setup") return "Harness bundle";
    if (groupId === "pool-setup") return "Pool bundle";
    if (groupId === "fan-setup") return "Fan bundle";
    if (groupId === "glove-cleanup-setup") return "Cleanup bundle";
    if (/doggles/i.test(String(offer && offer.id || ""))) return "Bundle price";
    return "Bundle price";
  }

  function offerTagText(offer, savingsCue) {
    if (savingsCue) return offerBundleLabel(offer);
    var tag = String(offer && offer.tag || "").trim();
    if (/^(staff pick|finish the set|matched to cart|useful add-on|easy win|easy add|add-on)$/i.test(tag)) return "";
    if (offer && (offer.tier === "extended" || offer.tier === "fallback")) return "";
    return tag;
  }

  function offerRewardText(offer, savingsCue) {
    if (savingsCue) return "";
    if (offer && offer.action === "change_variant") return "Upgrade";
    if (offer && offer.tier === "extended") return "Useful add";
    return "Add-on";
  }

  function offerValueCueText(offer) {
    if (!offer) return "";
    if (offer.valueCue) return offer.valueCue;
    var id = String(offer.id || "");
    var groupId = String(offer.groupId || "");
    var cues = {
      "backseat-bed": "Fitted comfort layer",
      "fan-backseat-bed": "Fitted comfort layer",
      "dual-fans": "Warm-ride airflow",
      "extra-safety-belt": "For a second dog",
      "fan-safety-belt": "Ride add-on",
      "cover-doggles": "Road-trip coverage",
      "fan-doggles": "Road-trip coverage",
      "second-doggles-pair": "Buy 2 for $99",
      "doggles-cooling-fans": "Warm-ride airflow",
      "doggles-safety-belt": "Backseat ride add-on",
      "doggles-travel-bowl": "Road-stop water",
      "doggles-hair-removal-gloves": "Loose-fur cleanup",
      "doggles-seat-cover": "Choose size + color",
      "single-seat-cover": "Protects another seat",
      "cargo-cover": "SUV cargo protection",
      "custom-patch": "Personalized pair",
      "matched-leash": "Matches the harness",
      "patch-variety": "12 swap-ready styles",
      "matched-collar": "Harness bundle add",
      "harness-safety-belt": "Ride add-on",
      "molle-pouch": "Trail storage",
      "pool-cover": "Keeps debris out",
      "quick-dry-towel": "Dry-off helper",
      "paw-drying-mat": "Wet-paw catch",
      "splash-pad": "More water play",
      "fan-two-pack-upgrade": "Full backseat airflow",
      "fan-four-pack-upgrade": "Best fan bundle",
      "gloves-seat-cover": "Protect the backseat",
      "gloves-fan-two-pack": "Full backseat airflow",
      "gloves-backseat-bed": "Clean comfort layer",
      "gloves-throw-blanket": "Couch and travel layer",
      "gloves-travel-bowl": "Always useful"
    };
    if (cues[id]) return cues[id];
    if (groupId === "seat-cover-setup") return "Backseat add-on";
    if (groupId === "harness-setup" || groupId === "walk-accessory-route") return "Walk add-on";
    if (groupId === "pool-setup") return "Pool-day add";
    if (groupId === "fan-setup") return "Warm-ride add";
    if (groupId === "glove-cleanup-setup") return "Clean-ride add";
    if (offer.tier === "extended" || offer.tier === "fallback") return "";
    return "";
  }

  function isSafetyBeltOffer(offer) {
    if (!offer) return false;
    var id = String(offer.id || "");
    var ids = state.rules && state.rules.productIds || {};
    var beltProductId = Number(ids.carSafetyBelt || 6762308337763);
    return /safety[-_\s]*belt/.test(id) || Number(offer.productId || 0) === beltProductId;
  }

  function featuredOfferEligible(offer) {
    if (!offer) return false;
    if (isSafetyBeltOffer(offer)) return false;
    if (offer.action === "link" && String(offer.groupId || "") !== "glove-cleanup-setup") return false;
    return true;
  }

  function renderOffer(offer, displayRole) {
    offer = checkoutTruthOffer(offer);
    var shipping = shippingState();
    var cue = shippingCue(offer, shipping);
    var role = displayRole === "featured" || displayRole === "compact" || displayRole === "pair" ? displayRole : "standard";
    var customPatch = isCustomPatchOffer(offer);
    if (customPatch && role === "compact") role = "featured";
    var fields = (offer.requiresProperties || []).map(function (field) {
      var isPhone = isPatchPhoneProperty(field.name);
      var type = isPhone ? "tel" : field.type || "text";
      var autocomplete = field.autocomplete || "off";
      var autocapitalize = field.autocapitalize || "characters";
      var placeholder = field.placeholder ? ' placeholder="' + escapeHtml(field.placeholder) + '"' : "";
      var phoneAttr = isPhone ? ' inputmode="tel" data-tk9-offer-patch-phone="1"' : "";
      return '<label><span>' + escapeHtml(field.label) + '</span><input type="' + escapeHtml(type) + '" data-tk9-property="' + escapeHtml(field.name) + '" data-required="' + (field.required ? "1" : "0") + '" maxlength="' + (field.maxLength || 40) + '" autocomplete="' + escapeHtml(autocomplete) + '" autocapitalize="' + escapeHtml(autocapitalize) + '" spellcheck="false"' + phoneAttr + placeholder + '></label>';
    }).join("");
    var matchSelect = (offer.contextChoices || []).length > 1 ? '<label class="tk9-offer__match"><span>' + escapeHtml(offer.contextChoiceLabel || "Match") + '</span><select data-tk9-offer-variant>' + offer.contextChoices.map(function (choice) {
      return '<option value="' + escapeHtml(choice.variantId) + '" data-price-cents="' + escapeHtml(choice.priceCents) + '" data-standalone-price-cents="' + escapeHtml(choice.standalonePriceCents || offer.standalonePriceCents || offer.compareAtPriceCents || "") + '" data-image="' + escapeHtml(choice.image || "") + '">' + escapeHtml(choice.label || "Selected item") + '</option>';
    }).join("") + '</select></label>' : "";
    var includeItems = Array.isArray(offer.displayIncludes) && offer.displayIncludes.length ? offer.displayIncludes : offer.includes;
    var includeLimit = Math.max(1, Number(offer.maxDisplayIncludes || 12));
    var includes = Array.isArray(includeItems) && includeItems.length ? '<div class="tk9-offer__includes"><span>' + escapeHtml(offer.includesLabel || "Includes") + '</span>' + includeItems.slice(0, includeLimit).map(function (item) {
      return '<em>' + escapeHtml(item) + '</em>';
    }).join("") + '</div>' : "";
    var compareAtCents = Number(offer.standalonePriceCents || offer.compareAtPriceCents || 0);
    var allowSavingsPromise = offerDiscountPromiseAllowed(offer, compareAtCents, offer.priceCents);
    var savingsCue = offerSavingsBadgeText(compareAtCents, offer.priceCents, {
      allowContainedPromise: allowSavingsPromise
    }) || offer.savingsBadgeText || savingsCueText(cue) || "";
    var regularCue = offer.kitSavingsCue || (cue && !savingsCue ? cue : "") || (!savingsCue ? offerValueCueText(offer) : "");
    var tagText = offerTagText(offer, savingsCue);
    var saveTagAttr = /^\s*save\s+\$?\d+/i.test(tagText) ? ' data-tk9-save-tag="1"' : "";
    var rewardText = offerRewardText(offer, savingsCue);
    var upgradeCostLabel = offer.action === "change_variant"
      ? '<span class="tk9-offer__price-note">Upgrade cost</span>'
      : "";
    var compactTitle = compactOfferTitle(offer.title);
    var buttonLabel = offer.buttonLabel || (offer.action === "change_variant" ? "Upgrade" : "Add");
    var offerAttributes = [
      'data-tk9-offer="' + escapeHtml(offer.id) + '"',
      'data-tk9-offer-group="' + escapeHtml(offer.groupId || "") + '"',
      'data-tk9-offer-tier="' + escapeHtml(offer.tier || "direct") + '"',
      'data-tk9-offer-action="' + escapeHtml(offer.action || "add") + '"',
      'data-tk9-offer-variant-id="' + escapeHtml(offer.variantId || "") + '"',
      'data-tk9-offer-product-id="' + escapeHtml(offer.productId || "") + '"',
      'data-tk9-offer-price-cents="' + escapeHtml(offer.priceCents || "") + '"',
      'data-tk9-offer-standalone-price-cents="' + escapeHtml(offer.standalonePriceCents || offer.compareAtPriceCents || "") + '"',
      allowSavingsPromise ? 'data-tk9-offer-allows-savings="1"' : "",
      customPatch ? 'data-tk9-custom-patch-offer="1"' : ""
    ].join(" ");

    return '<article class="tk9-offer tk9-offer--' + role + '" data-tk9-offer-display="' + role + '" ' + offerAttributes + '>' +
      renderOfferImage(offer) +
      '<div class="tk9-offer__content">' +
        (tagText ? '<div class="tk9-offer__meta"><span class="tk9-offer__tag"' + saveTagAttr + '>' + escapeHtml(tagText) + '</span></div>' : "") +
        '<div class="tk9-offer__title">' + escapeHtml(compactTitle || offer.title) + '</div>' +
        '<div class="tk9-offer__copy">' + escapeHtml(offer.copy || "") + '</div>' +
        includes +
        (regularCue ? '<div class="tk9-offer__cue">' + escapeHtml(regularCue) + '</div>' : "") +
        matchSelect +
        (fields ? '<div class="tk9-field-grid">' + fields + '</div><div class="tk9-field-error" hidden></div>' : "") +
        '<div class="tk9-offer__actions"><span class="tk9-offer__price-wrap">' + upgradeCostLabel + '<span class="tk9-offer__price" data-tk9-offer-price>' + discountPriceHtml(offer.priceCents, "tk9-discount-price", offer.standalonePriceCents || offer.compareAtPriceCents) + '</span>' + (savingsCue ? '<span class="tk9-offer__cue tk9-offer__cue--savings" data-tk9-offer-savings>' + escapeHtml(savingsCue) + '</span>' : "") + '</span></div>' +
      '</div>' +
      '<div class="tk9-offer__reward">' +
        (rewardText ? '<span class="tk9-offer__win">' + escapeHtml(rewardText) + '</span>' : "") +
        '<button class="tk9-offer__button' + (offer.action === "change_variant" ? " tk9-offer__button--upgrade" : "") + '" type="button" data-tk9-add-offer="' + escapeHtml(offer.id) + '">' + escapeHtml(buttonLabel) + '</button>' +
      '</div>' +
    '</article>';
  }

  function presentedOffers(offers) {
    if (activePresentationVariant() !== "premium") return offers || [];
    var max = Math.max(1, Number(config.premiumMaxOffers || 8));
    return (offers || []).slice(0, max);
  }

  function offerInGroup(offer, group) {
    return Boolean(offer && group && String(offer.groupId || "") === String(group.id || ""));
  }

  function rankedOffers(group, offers, scoreFn) {
    return (offers || []).map(function (offer, index) {
      return {
        offer: offer,
        index: index,
        score: offerInGroup(offer, group) ? scoreFn(group, offer) : 0
      };
    }).filter(function (entry) {
      return entry.score > 0;
    }).sort(function (a, b) {
      return (b.score - a.score) || (a.index - b.index);
    }).map(function (entry) {
      return entry.offer;
    });
  }

  function featuredUpgradeScore(group, offer) {
    var groupId = String(group && group.id || offer && offer.groupId || "");
    var id = String(offer && offer.id || "");
    if (groupId === "harness-setup" && id === "upgrade-complete-matching-set") return 1000;
    if (groupId === "harness-setup" && id === "upgrade-2mbh-to-4mbh") return 940;
    if (groupId === "fan-setup" && id === "fan-two-pack-upgrade") return 1000;
    if (groupId === "fan-setup" && id === "fan-four-pack-upgrade") return 900;
    if (groupId === "glove-cleanup-setup" && id === "gloves-fan-two-pack") return 940;
    if (groupId === "seat-cover-setup" && id === "backseat-bed") return 860;
    if (groupId === "pool-setup" && id === "pool-cover") return 860;
    if (groupId === "walk-accessory-route" && id === "hero-4buckle-harness") return 840;
    if (offer && offer.tier === "upgrade") return 820;
    if (offer && offer.action === "change_variant") return 780;
    return 0;
  }

  function featuredSetupScore(group, offer) {
    var groupId = String(group && group.id || offer && offer.groupId || "");
    var id = String(offer && offer.id || "");
    var scores = {
      "harness-setup": {
        "custom-patch": 1120,
        "upgrade-complete-matching-set": 1100,
        "matched-leash": 1040,
        "patch-variety": 980,
        "matched-collar": 900,
        "dog-goggles": 820,
        "first-aid-kit": 780
      },
      "walk-accessory-route": {
        "doggles-cooling-fans": 1180,
        "doggles-safety-belt": 1120,
        "doggles-travel-bowl": 1080,
        "doggles-hair-removal-gloves": 1040,
        "second-doggles-pair": 1000,
        "custom-patch": 960,
        "matched-leash": 940,
        "patch-variety": 900,
        "hero-4buckle-harness": 840,
        "doggles-seat-cover": 820,
        "dog-goggles": 820,
        "first-aid-kit": 780
      },
      "seat-cover-setup": {
        "backseat-bed": 1120,
        "dual-fans": 1060,
        "extra-safety-belt": 860,
        "cover-doggles": 840,
        "single-seat-cover": 780
      },
      "pool-setup": {
        "pool-cover": 1120,
        "quick-dry-towel": 1040,
        "paw-drying-mat": 990,
        "splash-pad": 940
      },
      "fan-setup": {
        "fan-two-pack-upgrade": 1120,
        "fan-backseat-bed": 1060,
        "fan-four-pack-upgrade": 1000,
        "fan-safety-belt": 860,
        "fan-doggles": 820
      },
      "glove-cleanup-setup": {
        "gloves-seat-cover": 1180,
        "gloves-fan-two-pack": 1120,
        "gloves-backseat-bed": 1040,
        "gloves-throw-blanket": 820,
        "gloves-travel-bowl": 760
      }
    };
    if (scores[groupId] && scores[groupId][id]) return scores[groupId][id];
    return featuredUpgradeScore(group, offer);
  }

  function featuredCompanionScore(group, offer) {
    var groupId = String(group && group.id || offer && offer.groupId || "");
    var id = String(offer && offer.id || "");
    var scores = {
      "harness-setup": {
        "matched-leash": 1300,
        "patch-variety": 920,
        "matched-collar": 860,
        "dog-goggles": 760
      },
      "walk-accessory-route": {
        "doggles-cooling-fans": 1320,
        "doggles-safety-belt": 1260,
        "doggles-travel-bowl": 1240,
        "doggles-hair-removal-gloves": 1220,
        "second-doggles-pair": 1180,
        "doggles-seat-cover": 980,
        "matched-leash": 900,
        "patch-variety": 860,
        "hero-4buckle-harness": 820,
        "dog-goggles": 760
      },
      "seat-cover-setup": {
        "backseat-bed": 1300,
        "dual-fans": 1220,
        "cover-doggles": 960,
        "single-seat-cover": 920
      },
      "pool-setup": {
        "pool-cover": 1300,
        "quick-dry-towel": 1220,
        "paw-drying-mat": 980,
        "splash-pad": 900
      },
      "fan-setup": {
        "fan-two-pack-upgrade": 1300,
        "fan-backseat-bed": 1220,
        "fan-four-pack-upgrade": 1120,
        "fan-doggles": 780
      },
      "glove-cleanup-setup": {
        "gloves-seat-cover": 1320,
        "gloves-fan-two-pack": 1260,
        "gloves-backseat-bed": 1180,
        "gloves-throw-blanket": 820,
        "gloves-travel-bowl": 760
      }
    };
    if (isCustomPatchOffer(offer)) return 0;
    if (scores[groupId] && scores[groupId][id]) return scores[groupId][id];
    return featuredSetupScore(group, offer);
  }

  function wallFeatureScore(group, offer) {
    var groupId = String(group && group.id || offer && offer.groupId || "");
    var id = String(offer && offer.id || "");
    var scores = {
      "harness-setup": {
        "matched-leash": 1220,
        "patch-variety": 1160,
        "matched-collar": 1080,
        "molle-pouch": 1020,
        "custom-patch": 980,
        "first-aid-kit": 860,
        "harness-safety-belt": 820,
        "dog-goggles": 760
      },
      "walk-accessory-route": {
        "doggles-cooling-fans": 1060,
        "doggles-safety-belt": 1040,
        "doggles-travel-bowl": 1020,
        "doggles-hair-removal-gloves": 1000,
        "second-doggles-pair": 980,
        "doggles-seat-cover": 960,
        "custom-patch": 820,
        "matched-leash": 760,
        "patch-variety": 720,
        "harness-safety-belt": 680
      },
      "seat-cover-setup": {
        "dual-fans": 980,
        "cover-doggles": 960,
        "extra-safety-belt": 900,
        "single-seat-cover": 760
      },
      "pool-setup": {
        "quick-dry-towel": 940,
        "paw-drying-mat": 900,
        "splash-pad": 820
      },
      "fan-setup": {
        "fan-backseat-bed": 980,
        "fan-safety-belt": 920,
        "fan-hair-removal-gloves": 760,
        "fan-doggles": 720
      },
      "glove-cleanup-setup": {
        "gloves-seat-cover": 1120,
        "gloves-fan-two-pack": 1040,
        "gloves-backseat-bed": 980,
        "gloves-throw-blanket": 840,
        "gloves-travel-bowl": 780
      }
    };
    return scores[groupId] && scores[groupId][id] ? scores[groupId][id] : 0;
  }

  function carouselOffer(group, offer) {
    if (!offer) return false;
    if (offer.tier === "extended" || offer.tier === "fallback") return true;
    if (!offerInGroup(offer, group)) return true;
    return String(offer.action || "") === "link";
  }

  function buildOfferMerchandising(groups, offers) {
    var group = groups && groups[0] || null;
    var used = {};
    var primaryOffers = (offers || []).filter(function (offer) {
      return offerInGroup(offer, group);
    });
    var dogglesRideFamilyActive = String(group && group.id || "") === "walk-accessory-route" && primaryOffers.some(isDogglesRideFamilyOffer);
    var primaryCustomPatchOffer = dogglesRideFamilyActive ? null : primaryOffers.find(isCustomPatchOffer) || (offers || []).find(isCustomPatchOffer) || null;
    var featuredCandidates = (offers || []).filter(featuredOfferEligible);
    var primaryFeaturedCandidates = primaryOffers.filter(featuredOfferEligible);

    function mark(offer) {
      if (offer) used[String(offer.id || "")] = true;
    }

    function unused(offer) {
      return offer && !used[String(offer.id || "")];
    }

    var groupId = String(group && group.id || "");
    var max = Math.max(1, Number(config.premiumMaxOffers || 12));
    var maxFeaturedOffers = cartValueAddSlotCount();
    if (groupId === "harness-setup" && primaryCustomPatchOffer) {
      maxFeaturedOffers = 1;
    }
    var featuredOffers = [];
    if (primaryCustomPatchOffer) {
      featuredOffers.push(primaryCustomPatchOffer);
      mark(primaryCustomPatchOffer);
      if (maxFeaturedOffers > featuredOffers.length) {
        rankedOffers(group, featuredCandidates, featuredCompanionScore).filter(unused).slice(0, maxFeaturedOffers - featuredOffers.length).forEach(function (offer) {
          featuredOffers.push(offer);
          mark(offer);
        });
      }
    } else {
      featuredOffers = rankedOffers(group, featuredCandidates, featuredSetupScore).filter(unused).slice(0, maxFeaturedOffers);
      if (!featuredOffers.length && primaryFeaturedCandidates[0]) featuredOffers.push(primaryFeaturedCandidates[0]);
      if (!featuredOffers.length && featuredCandidates[0]) featuredOffers.push(featuredCandidates[0]);
      var featuredCustomPatch = featuredOffers.find(isCustomPatchOffer);
      if (featuredCustomPatch) featuredOffers = [featuredCustomPatch];
      featuredOffers.forEach(mark);
    }
    var featured = featuredOffers[0] || null;

    var wallFeatureLimitMap = {
      "harness-setup": 4,
      "walk-accessory-route": 4,
      "seat-cover-setup": 3,
      "pool-setup": 3,
      "fan-setup": 3,
      "glove-cleanup-setup": 3
    };
    var wallFeatureLimit = wallFeatureLimitMap[groupId] || 3;
    var wallFeatures = rankedOffers(group, offers, wallFeatureScore).filter(unused).slice(0, wallFeatureLimit);
    wallFeatures.forEach(mark);

    if (wallFeatures.length < wallFeatureLimit) {
      primaryOffers.filter(function (offer) {
        return unused(offer) && offer.tier !== "extended" && offer.tier !== "fallback";
      }).slice(0, wallFeatureLimit - wallFeatures.length).forEach(function (offer) {
        wallFeatures.push(offer);
        mark(offer);
      });
    }

    var remainingSlots = Math.max(0, max - featuredOffers.length - wallFeatures.length);
    var wallLimit = groupId === "harness-setup" ? Math.min(3, remainingSlots) : Math.min(2, remainingSlots);
    var wall = primaryOffers.filter(function (offer) {
      return unused(offer) && offer.tier !== "fallback";
    }).slice(0, wallLimit);
    wall.forEach(mark);

    remainingSlots = Math.max(0, max - featuredOffers.length - wallFeatures.length - wall.length);
    var carousel = (offers || []).filter(function (offer) {
      return unused(offer) && carouselOffer(group, offer);
    }).slice(0, Math.min(4, remainingSlots));
    carousel.forEach(mark);

    var wallFirst = groupId === "harness-setup" && Boolean(primaryCustomPatchOffer);
    var renderedOffers = (wallFirst
      ? wallFeatures.concat(featuredOffers, wall, carousel)
      : featuredOffers.concat(wallFeatures, wall, carousel)
    ).filter(Boolean);
    return {
      featured: featured,
      featuredOffers: featuredOffers,
      wallFeatures: wallFeatures,
      wall: wall,
      carousel: carousel,
      wallFirst: wallFirst,
      renderedOffers: renderedOffers
    };
  }

  function renderOfferSectionHeading(title, copy) {
    return '<div class="tk9-offer-section__head"><strong>' + escapeHtml(title) + '</strong>' + (copy ? '<span>' + escapeHtml(copy) + '</span>' : "") + '</div>';
  }

  function featuredOfferHeading(featuredOffers, group) {
    var groupId = String(group && group.id || featuredOffers[0] && featuredOffers[0].groupId || "");
    if (featuredOffers.length === 1 && isCustomPatchOffer(featuredOffers[0])) {
      return {
        title: "Personalize the harness",
        copy: "Type once. Preview before checkout."
      };
    }
    if (featuredOffers.length > 1) {
      var headings = {
        "harness-setup": {
          title: "Harness bundle deals unlocked",
          copy: ""
        },
        "walk-accessory-route": {
          title: "Ride bundle deals unlocked",
          copy: ""
        },
        "seat-cover-setup": {
          title: "Seat cover bundle deals unlocked",
          copy: ""
        },
        "pool-setup": {
          title: "Pool bundle deals unlocked",
          copy: ""
        },
        "fan-setup": {
          title: "Fan bundle deals unlocked",
          copy: ""
        },
        "glove-cleanup-setup": {
          title: "Build the clean-ride setup",
          copy: ""
        }
      };
      if (groupId === "walk-accessory-route" && featuredOffers.some(function (offer) {
        return /doggles|cooling-fans|safety-belt|seat-cover/.test(String(offer && offer.id || ""));
      })) {
        return {
          title: "Ride bundle deals unlocked",
          copy: ""
        };
      }
      if (headings[groupId]) return headings[groupId];
      return {
        title: "Bundle deals unlocked",
        copy: ""
      };
    }
    var singleOfferHeadings = {
      "harness-setup": {
        title: "Harness bundle deal unlocked",
        copy: ""
      },
      "walk-accessory-route": {
        title: "Ride bundle deal unlocked",
        copy: ""
      },
      "seat-cover-setup": {
        title: "Seat cover bundle deal unlocked",
        copy: ""
      },
      "pool-setup": {
        title: "Pool bundle deal unlocked",
        copy: ""
      },
      "fan-setup": {
        title: "Fan bundle deal unlocked",
        copy: ""
      },
      "glove-cleanup-setup": {
        title: "Clean-ride bundle deal unlocked",
        copy: ""
      }
    };
    if (singleOfferHeadings[groupId]) return singleOfferHeadings[groupId];
    return {
      title: "Bundle deal unlocked",
      copy: ""
    };
  }

  function wallOfferHeading(group, wallFeatures) {
    var groupId = String(group && group.id || wallFeatures[0] && wallFeatures[0].groupId || "");
    var headings = {
      "harness-setup": {
        title: "Harness bundle deals unlocked",
        copy: ""
      },
      "walk-accessory-route": {
        title: "Ride bundle deals unlocked",
        copy: ""
      },
      "seat-cover-setup": {
        title: "Seat cover bundle deals unlocked",
        copy: ""
      },
      "pool-setup": {
        title: "Pool bundle deals unlocked",
        copy: ""
      },
      "fan-setup": {
        title: "Fan bundle deals unlocked",
        copy: ""
      },
      "glove-cleanup-setup": {
        title: "Build the clean-ride setup",
        copy: ""
      }
    };
    return headings[groupId] || {
      title: "Recommended",
      copy: ""
    };
  }

  function secondaryOfferHeading(group) {
    var groupId = String(group && group.id || "");
    if (groupId === "harness-setup") {
      return {
        title: "More bundle deals",
        copy: ""
      };
    }
    return {
      title: "More bundle deals",
      copy: ""
    };
  }

  function renderOffers(group, offersOrMerchandising) {
    var offers = offersOrMerchandising && offersOrMerchandising.renderedOffers ? offersOrMerchandising.renderedOffers : offersOrMerchandising || [];
    if (!offers.length) return "";
    if (activePresentationVariant() === "premium") {
      var sections = offersOrMerchandising && offersOrMerchandising.renderedOffers
        ? offersOrMerchandising
        : buildOfferMerchandising(group ? [group] : [], offers);
      var featuredOffers = Array.isArray(sections.featuredOffers) && sections.featuredOffers.length
        ? sections.featuredOffers
        : (sections.featured ? [sections.featured] : []);
      var featuredHeading = featuredOfferHeading(featuredOffers, group);
      var wallHeading = wallOfferHeading(group, sections.wallFeatures || []);
      var secondaryHeading = secondaryOfferHeading(group);
      var wallHeadingForRender = wallHeading;
      if (featuredOffers.length && sections.wallFeatures.length) {
        wallHeadingForRender = {
          title: "More bundle deals",
          copy: ""
        };
      }
      var carouselHeading = {
        title: "More bundle deals",
        copy: ""
      };
      if ((sections.wall.length || sections.wallFeatures.length) && sections.carousel.length && String(secondaryHeading.title || "") === carouselHeading.title) {
        carouselHeading = null;
      }
      var featuredSection = featuredOffers.length ? '<div class="tk9-featured-upsell' + (featuredOffers.length > 1 ? ' tk9-featured-upsell--duo' : '') + '">' +
        renderOfferSectionHeading(featuredHeading.title, featuredHeading.copy) +
        (featuredOffers.length > 1
          ? '<div class="tk9-featured-upsell__grid">' + featuredOffers.map(function (offer) { return renderOffer(offer, "pair"); }).join("") + '</div>'
          : renderOffer(featuredOffers[0], "featured")) +
      '</div>' : "";
      var wallFeatureSection = sections.wallFeatures.length ? '<div class="tk9-wall-features">' +
        renderOfferSectionHeading(wallHeadingForRender.title, wallHeadingForRender.copy) +
        '<div class="tk9-wall-features__grid">' + sections.wallFeatures.map(function (offer) {
          return renderOffer(offer, "compact");
        }).join("") + '</div>' +
      '</div>' : "";
      var wallSection = sections.wall.length ? '<div class="tk9-offer-wall__secondary">' +
        (sections.wallFeatures.length ? "" : renderOfferSectionHeading(secondaryHeading.title, secondaryHeading.copy)) +
        sections.wall.map(function (offer) {
          return renderOffer(offer, "compact");
        }).join("") +
      '</div>' : "";
      var carouselSection = sections.carousel.length ? '<div class="tk9-offer-carousel" aria-label="More helpful add-ons">' +
        (carouselHeading ? renderOfferSectionHeading(carouselHeading.title, carouselHeading.copy) : "") +
        '<div class="tk9-offer-carousel__track">' + sections.carousel.map(function (offer) {
          return renderOffer(offer, "compact");
        }).join("") + '</div>' +
      '</div>' : "";
      return '<section class="tk9-offer-wall tk9-offer-wall--premium" data-tk9-offer-presentation="premium">' +
        (sections.wallFirst ? wallFeatureSection + featuredSection : featuredSection + wallFeatureSection) +
        wallSection +
        carouselSection +
      '</section>';
    }
    return '<section class="tk9-offer-wall tk9-offer-wall--standard" data-tk9-offer-presentation="standard"><div class="tk9-offer-list">' + offers.map(function (offer) {
      return renderOffer(offer, "standard");
    }).join("") + '</div></section>';
  }

  function renderOfferIntro(group, offers) {
    return "";
  }

  function renderDiscountBox() {
    if (!merchandiseCartItems().length) return "";
    var code = activeDiscountCode();
    if (code && !state.discountEditing && !state.discountBusy) {
      return '<section class="tk9-discount-panel tk9-discount-panel--applied">' +
        '<div class="tk9-discount-applied__copy"><strong>Discount</strong><span>' + escapeHtml(promoDiscountCode(code)) + ' applied</span></div>' +
        '<button type="button" class="tk9-discount-applied__change" data-tk9-discount-open>Change</button>' +
      '</section>';
    }
    if (!code && !state.discountMessage && !state.discountEditing) {
      return '<section class="tk9-discount-panel tk9-discount-panel--collapsed">' +
        '<button type="button" class="tk9-discount-toggle" data-tk9-discount-open>Have a discount code?</button>' +
      '</section>';
    }
    return '<section class="tk9-discount-panel">' +
      '<div class="tk9-discount-panel__top"><strong>Discount code</strong><span>Apply eligible codes before checkout.</span></div>' +
      '<form class="tk9-discount-form" data-tk9-discount-form>' +
        '<input name="discount" autocomplete="off" autocapitalize="characters" placeholder="Discount code" value="' + escapeHtml(code) + '" aria-label="Discount code">' +
        '<button type="submit" data-tk9-discount-apply>' + (code ? "Update" : "Apply") + '</button>' +
        (code ? '<button type="button" data-tk9-discount-clear>Clear</button>' : "") +
      '</form>' +
      (state.discountMessage ? '<div class="tk9-discount-message">' + escapeHtml(state.discountMessage) + '</div>' : "") +
    '</section>';
  }

  function renderPaymentPills(wallets) {
    var labels = {
      shop_pay: '<b>Shop</b><em>Pay</em>',
      paypal: '<b>PayPal</b>',
      amazon_pay: '<b>Amazon</b>',
      google_pay: '<b>G</b><em>Pay</em>',
      apple_pay: '<b>Apple</b><em>Pay</em>'
    };
    var classes = {
      shop_pay: "shop",
      paypal: "paypal",
      amazon_pay: "amazon",
      google_pay: "gpay",
      apple_pay: "apple"
    };
    var list = wallets && wallets.length ? wallets : ["shop_pay", "paypal", "amazon_pay", "google_pay"];
    return '<div class="tk9-pay-row tk9-pay-row--count-' + list.length + '" aria-label="Express checkout options">' + list.map(function (wallet) {
      return '<button type="button" class="tk9-pay-logo tk9-pay-logo--' + escapeHtml(classes[wallet] || wallet) + '" data-tk9-wallet="' + escapeHtml(wallet) + '">' + (labels[wallet] || escapeHtml(wallet)) + '</button>';
    }).join("") + '</div>';
  }

  function renderFooter() {
    var footer = document.querySelector("[data-tk9-footer]");
    if (!footer) return;
    if (!merchandiseCartItems().length) {
      footer.innerHTML = "";
      return;
    }
    var original = Number(state.cart && state.cart.original_total_price) || Number(state.cart && state.cart.total_price) || 0;
    var rawTotal = Number(state.cart && state.cart.total_price) || 0;
    var displayTotal = cartOrderDisplaySubtotalCents();
    var total = displayTotal > 0 ? Math.min(rawTotal || displayTotal, displayTotal) : rawTotal;
    var protectionTotal = protectionDisplaySubtotalCents();
    if (protectionTotal > 0 && !displayedDiscountCode() && cartLevelDiscountSavingsCents() <= 0) {
      total = displayTotal;
    }
    var computedCompareAtSubtotal = cartOrderCompareAtSubtotalCents();
    var compareAtSubtotal = cartMoneyPromiseContainmentEnabled()
      ? Math.max(computedCompareAtSubtotal, total)
      : Math.max(original, computedCompareAtSubtotal);
    var code = displayedDiscountCode();
    var discountSavings = cartLevelDiscountSavingsCents();
    var actualHarnessFallbackSavings = harnessBundleLineDiscountSavingsCents();
    var previewHarnessFallbackSavings = actualHarnessFallbackSavings > 0 ? 0 : verifiedHarnessFallbackSavingsCents();
    var savings = Math.max(compareAtSubtotal - total, 0);
    var saleCode = config.dogdadSaleEnabled && config.dogdadSaleCode && cartSaleEndMs() > Date.now()
      ? promoDiscountCode(config.dogdadSaleCode)
      : "";
    var footerDiscountCode = promoDiscountCode(code || saleCode);
    var footerDiscountApplied = Boolean(code);
    var discountCopy = footerDiscountApplied ? footerDiscountCode + " applied" : "Apply " + footerDiscountCode;
    var subtotalMoneyText = subtotalSavingsMoneyText(compareAtSubtotal, total);
    var subtotalPercentText = subtotalSavingsPercentText(compareAtSubtotal, total);
    var subtotalPercentPill = subtotalPercentText
      ? '<span class="tk9-subtotal-save-pill tk9-subtotal-save-pill--percent tk9-subtotal-save-pill--hero">' + escapeHtml(subtotalPercentText) + '</span>'
      : "";
    var subtotalMoneyPill = subtotalMoneyText
      ? '<span class="tk9-subtotal-save-pill tk9-subtotal-save-pill--money tk9-subtotal-save-pill--proof">' + escapeHtml(subtotalMoneyText) + '</span>'
      : "";
    var discountPill = footerDiscountCode && !footerDiscountApplied
      ? '<button type="button" class="tk9-footer-code-pill tk9-footer-code-pill--button" data-tk9-apply-discount="' + escapeHtml(footerDiscountCode) + '" data-tk9-discount-source="cart_footer_promo" data-tk9-discount-display="footer">' + escapeHtml(discountCopy) + '</button>'
      : "";
    var checkoutPreviewTotal = Math.max(total - previewHarnessFallbackSavings, 0);
    var checkoutPreviewRow = previewHarnessFallbackSavings > 0 && !footerDiscountApplied && discountSavings <= 0
      ? '<div class="tk9-footer-row tk9-footer-row--checkout-total"><span class="tk9-footer-row__label"><span>Checkout subtotal</span></span><span class="tk9-footer-row__value"><strong>' + money(checkoutPreviewTotal) + '</strong></span></div>'
      : "";
    var showSubtotalCompare = compareAtSubtotal > total && savings > 0;
    var subtotalWinPillClass = "tk9-subtotal-win-pills" + (subtotalPercentPill ? " tk9-subtotal-win-pills--has-percent" : " tk9-subtotal-win-pills--money-only");
    var subtotalWinPills = showSubtotalCompare && (subtotalPercentPill || subtotalMoneyPill)
      ? '<span class="' + subtotalWinPillClass + '" aria-label="Cart savings">' + subtotalPercentPill + subtotalMoneyPill + '</span>'
      : "";
    var subtotalLabel = '<span class="tk9-footer-row__label tk9-footer-row__label--with-savings"><span>Subtotal</span>' + subtotalWinPills + discountPill + '</span>';
    var subtotalPrice = showSubtotalCompare
      ? '<span class="tk9-footer-price"><span class="tk9-footer-price__amounts"><s>' + money(compareAtSubtotal) + '</s><strong>' + money(total) + '</strong></span></span>'
      : '<span class="tk9-footer-price"><span class="tk9-footer-price__amounts"><strong>' + money(total) + '</strong></span></span>';
    var subtotalValue = '<span class="tk9-footer-row__value">' + subtotalPrice + '</span>';
    var footerPromoRow = "";
    var installmentBasis = checkoutPreviewRow ? checkoutPreviewTotal : total;
    var installmentAmount = money(Math.ceil(installmentBasis / 4));
    var installmentLine = installmentBasis >= 5000 ? '<div class="tk9-installments">Or 4 interest-free payments of ' + installmentAmount + ' with <strong>shop<span>Pay</span></strong></div>' : "";
    var processingCutoffText = cartProcessingCutoffText();
    var processingCutoffLine = '<div class="tk9-processing-cutoff" data-tk9-cart-processing-cutoff' + (processingCutoffText ? "" : " hidden") + '>' + escapeHtml(processingCutoffText) + '</div>';
    var shipping = shippingState();
    var firstTrust = hasHarnessInCart()
      ? "FREE exchanges"
      : shipping && shipping.unlocked
        ? "FREE shipping"
        : "FREE ship $99+";
    var additionalCheckout = additionalCheckoutHtml();
    var hasAdditionalCheckout = Boolean(additionalCheckout);
    var expressCheckoutOpen = hasAdditionalCheckout && (!compactFooterViewport() || state.expressCheckoutOpen);
    var expressToggle = hasAdditionalCheckout
      ? '<button type="button" class="tk9-express-toggle" data-tk9-express-toggle aria-expanded="' + (expressCheckoutOpen ? "true" : "false") + '" aria-controls="tk9-express-checkout"><span>Express checkout</span><span class="tk9-express-toggle__mark" data-tk9-express-marker aria-hidden="true">' + (expressCheckoutOpen ? "-" : "+") + '</span></button>'
      : "";
    var additionalCheckoutBlock = additionalCheckout
      ? '<div id="tk9-express-checkout" class="tk9-pay-stack tk9-pay-stack--native' + (expressCheckoutOpen ? " is-open" : "") + '" data-tk9-additional-checkout aria-hidden="' + (expressCheckoutOpen ? "false" : "true") + '">' + additionalCheckout + '</div>'
      : "";
    footer.classList.toggle("tk9-slide-cart__footer--compact", true);
    footer.innerHTML =
      '<div class="tk9-footer-row">' + subtotalLabel + subtotalValue + '</div>' +
      checkoutPreviewRow +
      footerPromoRow +
      installmentLine +
      processingCutoffLine +
      '<a class="tk9-checkout" href="' + escapeHtml(checkoutHref()) + '" data-tk9-checkout>CHECKOUT</a>' +
      expressToggle +
      additionalCheckoutBlock +
      '<div class="tk9-trust-row" aria-label="Checkout trust details">' +
        '<span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><path d="M7 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/><path d="M18 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"/></svg>' + escapeHtml(firstTrust) + '</span>' +
        '<span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11a8 8 0 0 0-14-5l-2 2"/><path d="M4 4v4h4"/><path d="M4 13a8 8 0 0 0 14 5l2-2"/><path d="M20 20v-4h-4"/></svg>60-day guarantee</span>' +
        '<span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5L12 17.8 6.2 21l1.1-6.5-4.7-4.6 6.5-.9z"/></svg>9k+ reviews</span>' +
      '</div>';
  }

  function render() {
    ensureShell();
    var body = document.querySelector("[data-tk9-body]");
    if (!body) return;
    var titleNode = document.querySelector("[data-tk9-title]");
    updateCartSaleTimer();
    if (titleNode) {
      var titleCount = merchandiseCartItems().reduce(function (sum, item) {
        return sum + Number(item.quantity || 0);
      }, 0);
      titleNode.textContent = titleCount > 0 ? "Your cart (" + titleCount + ")" : "Your cart";
    }
    var groups = eligibleGroups() || [];
    var group = groups[0] || null;
    var offers = resolveOfferWall(groups);
    var visibleOffers = presentedOffers(offers);
    var merchandising = activePresentationVariant() === "premium"
      ? buildOfferMerchandising(groups, visibleOffers)
      : { renderedOffers: visibleOffers };
    var trackingOffers = merchandising.renderedOffers || visibleOffers;
    updateHeaderShippingProgress(trackingOffers);
    body.setAttribute("data-tk9-presentation", activePresentationVariant());
    if (!merchandiseCartItems().length) {
      body.innerHTML = renderEmptyCart();
      renderFooter();
      return;
    }
    var lineHtml = renderLines();
    var priorityPerkHtml = renderIncludedPerks(groups, { priorityOnly: true });
    var deferredPerkHtml = renderIncludedPerks(groups, { deferredOnly: true });
    var setupProgress = setupProgressModel(group, trackingOffers);
    var setupProgressHtml = renderSetupProgressModel(setupProgress);
    var offerIntroHtml = renderOfferIntro(group, trackingOffers);
    var offerHtml = renderOffers(group, merchandising);
    var lowerHtml = renderProtection() + renderDiscountBox();
    body.innerHTML = activeLayoutVariant() === "upsell_first"
      ? lineHtml + priorityPerkHtml + setupProgressHtml + offerIntroHtml + offerHtml + deferredPerkHtml + lowerHtml
      : lineHtml + priorityPerkHtml + deferredPerkHtml + setupProgressHtml + offerIntroHtml + offerHtml + lowerHtml;
    renderFooter();
    emit("tk9_upsell_group_eligible", {
      tk9_upsell_group_id: group ? group.id : "",
      tk9_upsell_group_ids: groups.map(function (eligible) { return eligible.id; }).join(","),
      tk9_upsell_offer_ids: trackingOffers.map(function (offer) { return offer.id; }).join(","),
      tk9_upsell_suppressed_ids: suppressionSummary().map(function (item) { return item.offerId + ":" + item.reason; }).join(","),
      tk9_layout_variant: activeLayoutVariant(),
      tk9_presentation_variant: activePresentationVariant(),
      tk9_cart_value_add_experiment: config.cartValueAddExperimentId,
      tk9_cart_value_add_arm: activeCartValueAddArm(),
      tk9_cart_value_add_slot_count: cartValueAddSlotCount(),
      tk9_presented_offer_count: trackingOffers.length,
      tk9_setup_family: setupProgress && setupProgress.definition ? setupProgress.definition.id : "",
      tk9_setup_unlocked_count: setupProgress ? setupProgress.unlockedCount : 0,
      tk9_setup_total_count: setupProgress ? setupProgress.totalCount : 0
    });
    suppressionSummary().forEach(function (item) {
      emit("tk9_upsell_suppressed", {
        tk9_offer_id: item.offerId,
        tk9_upsell_group_id: item.groupId,
        tk9_product_id: item.productId || "",
        tk9_variant_id: item.variantId || "",
        tk9_suppression_reason: item.reason
      });
    });
    trackingOffers.forEach(function (offer, index) {
      var impressionKey = [
        state.cart && (state.cart.token || state.cart.cart_token || state.cart.id) || "cart",
        activeLayoutVariant(),
        offer.id,
        offer.variantId || ""
      ].join("|");
      if (state.impressionKeys[impressionKey]) return;
      state.impressionKeys[impressionKey] = true;
      emit("tk9_upsell_impression", {
        tk9_offer_id: offer.id,
        tk9_offer_position: index + 1,
        tk9_cart_value_add_experiment: config.cartValueAddExperimentId,
        tk9_cart_value_add_arm: activeCartValueAddArm(),
        tk9_cart_value_add_slot_count: cartValueAddSlotCount(),
        tk9_variant_id: offer.variantId,
        tk9_product_id: offer.productId || ""
      });
    });
  }

  function escapeHtml(value) {
    return String(value || "").replace(/[&<>"']/g, function (char) {
      return {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#039;"
      }[char];
    });
  }

  function collectProperties(offerNode) {
    var properties = {};
    var invalid = false;
    var patchHasValue = false;
    var customPatch = Boolean(offerNode && offerNode.getAttribute("data-tk9-custom-patch-offer") === "1");
    var error = offerNode.querySelector(".tk9-field-error");
    var firstInvalidInput = null;
    offerNode.querySelectorAll("[data-tk9-property]").forEach(function (input) {
      var name = input.getAttribute("data-tk9-property");
      var value = String(input.value || "").trim();
      if (isPatchPhoneProperty(name)) {
        value = formatPatchPhoneValue(value);
        if (value && input.value !== value) input.value = value;
      }
      if (customPatch && value) patchHasValue = true;
      if (!customPatch && input.getAttribute("data-required") === "1" && !value) {
        invalid = true;
        if (!firstInvalidInput) firstInvalidInput = input;
      }
      if (value) properties[name] = value;
    });
    if (customPatch && !patchHasValue) {
      invalid = true;
      firstInvalidInput = offerNode.querySelector("[data-tk9-property]") || null;
    }
    if (error) {
      error.hidden = !invalid;
      error.textContent = invalid ? "Add a dog name or phone line before adding." : "";
    }
    if (invalid && firstInvalidInput) {
      try {
        firstInvalidInput.focus({ preventScroll: false });
      } catch (focusError) {
        try {
          firstInvalidInput.focus();
        } catch (fallbackError) {}
      }
    }
    return invalid ? null : properties;
  }

  function setOfferFieldError(offerNode, message) {
    if (!offerNode) return;
    var error = offerNode.querySelector(".tk9-field-error");
    if (error) {
      error.hidden = false;
      error.textContent = message || "Could not add this right now. Please try again.";
    }
  }

  function customPatchDataFromProperties(properties) {
    return {
      name: objectPropertyValue(properties, PATCH_NAME_PROPERTY_NAMES),
      phone: formatPatchPhoneValue(objectPropertyValue(properties, PATCH_PHONE_PROPERTY_NAMES))
    };
  }

  function offerPatchInputValue(offerNode, names) {
    if (!offerNode) return "";
    var inputs = offerNode.querySelectorAll("[data-tk9-property]");
    for (var index = 0; index < inputs.length; index += 1) {
      var input = inputs[index];
      var name = input.getAttribute("data-tk9-property");
      if (names.indexOf(name) === -1) continue;
      var value = String(input.value || "").trim();
      if (value) return value;
    }
    return "";
  }

  function offerPatchPreviewData(offerNode) {
    var name = offerPatchInputValue(offerNode, PATCH_NAME_PROPERTY_NAMES);
    var phone = formatPatchPhoneValue(offerPatchInputValue(offerNode, PATCH_PHONE_PROPERTY_NAMES));
    return {
      name: name,
      phone: phone || ""
    };
  }

  function updateOfferPatchPreview(target) {
    var offerNode = target && target.closest && target.closest("[data-tk9-custom-patch-offer]");
    if (!offerNode) return;
    if (target.matches && target.matches("[data-tk9-offer-patch-phone]")) formatPatchPhoneInput(target);
    var data = offerPatchPreviewData(offerNode);
    var hasDynamicPreview = Boolean(data.name || data.phone);
    var previewRoot = offerNode.querySelector("[data-tk9-patch-preview]");
    var previewName = offerNode.querySelector("[data-tk9-patch-preview-name]");
    var previewPhone = offerNode.querySelector("[data-tk9-patch-preview-phone]");
    var previewImage = offerNode.querySelector("[data-tk9-patch-preview-image]");
    var error = offerNode.querySelector(".tk9-field-error");
    if (previewRoot) previewRoot.classList.toggle("has-dynamic-preview", hasDynamicPreview);
    if (previewRoot) previewRoot.classList.toggle("has-phone-preview", Boolean(data.phone));
    if (previewImage) {
      if (hasDynamicPreview) {
        previewImage.src = patchMockupPairImageData(data.name || "CUSTOM PATCH", data.phone || "");
        previewImage.alt = "Custom patch mockup" + (data.name ? " for " + String(data.name).toUpperCase() : "");
      } else {
        previewImage.removeAttribute("src");
        previewImage.alt = "Custom patch preview";
      }
    }
    if (previewName) previewName.textContent = String(hasDynamicPreview ? (data.name || "CUSTOM PATCH") : "BUDDY").toUpperCase();
    if (previewPhone) previewPhone.textContent = String(hasDynamicPreview ? (data.phone || "") : "(888)-645-2889").toUpperCase();
    if (error) {
      error.hidden = true;
      error.textContent = "";
    }
  }

  function findOffer(offerId) {
    return resolveOfferWall(eligibleGroups()).find(function (offer) {
      return offer.id === offerId;
    });
  }

  function renderedOfferFallback(offerId, offerNode) {
    if (!offerId || !offerNode) return null;
    var variantId = Number(offerNode.getAttribute("data-tk9-offer-variant-id") || 0);
    if (!variantId) return null;
    var priceCents = Number(offerNode.getAttribute("data-tk9-offer-price-cents") || 0);
    var standalonePriceCents = Number(offerNode.getAttribute("data-tk9-offer-standalone-price-cents") || 0);
    var productId = Number(offerNode.getAttribute("data-tk9-offer-product-id") || 0);
    return {
      id: offerId,
      action: offerNode.getAttribute("data-tk9-offer-action") || "add",
      variantId: variantId,
      productId: productId || "",
      priceCents: priceCents || 0,
      standalonePriceCents: standalonePriceCents || 0
    };
  }

  function selectedOfferVariant(offer, offerNode) {
    if (!offerNode) return offer.variantId;
    var select = offerNode.querySelector("[data-tk9-offer-variant]");
    if (!select || !select.value) return offer.variantId;
    return Number(select.value) || offer.variantId;
  }

  function selectedOfferPricing(offer, offerNode, variantId) {
    var priceCents = resolveOfferPriceCents(offer, variantId);
    var compareAtCents = resolveOfferCompareAtCents(offer, variantId);
    var select = offerNode && offerNode.querySelector("[data-tk9-offer-variant]");
    var option = select && select.options && select.options[select.selectedIndex];
    if (option) {
      var optionPrice = Number(option.getAttribute("data-price-cents"));
      var optionCompareAt = Number(option.getAttribute("data-standalone-price-cents"));
      if (Number.isFinite(optionPrice) && optionPrice > 0) priceCents = optionPrice;
      if (Number.isFinite(optionCompareAt) && optionCompareAt > 0) compareAtCents = optionCompareAt;
    }
    return {
      priceCents: priceCents,
      compareAtCents: compareAtCents
    };
  }

  function updateOfferVariantSelect(select) {
    var option = select && select.options && select.options[select.selectedIndex];
    var offerNode = select && select.closest && select.closest("[data-tk9-offer]");
    if (!option || !offerNode) return;
    var price = offerNode.querySelector("[data-tk9-offer-price]");
    var savings = offerNode.querySelector("[data-tk9-offer-savings]");
    var image = offerNode.querySelector("img.tk9-offer__image");
    var priceCents = Number(option.getAttribute("data-price-cents"));
    var standalonePriceCents = Number(option.getAttribute("data-standalone-price-cents"));
    var imageSrc = option.getAttribute("data-image");
    var allowSavingsPromise = offerNode.hasAttribute("data-tk9-offer-allows-savings");
    if (cartMoneyPromiseContainmentEnabled() && !allowSavingsPromise) {
      priceCents = Math.max(priceCents || 0, standalonePriceCents || 0);
      standalonePriceCents = 0;
    }
    if (price && Number.isFinite(priceCents)) price.innerHTML = discountPriceHtml(priceCents, "tk9-discount-price", Number.isFinite(standalonePriceCents) ? standalonePriceCents : 0);
    if (savings && Number.isFinite(priceCents) && Number.isFinite(standalonePriceCents)) {
      var savingsText = offerSavingsBadgeText(standalonePriceCents, priceCents, {
        allowContainedPromise: allowSavingsPromise
      });
      savings.textContent = savingsText;
      savings.hidden = !savingsText;
    }
    if (image && imageSrc) image.src = imageUrl(imageSrc);
  }

  function addOffer(button) {
    if (state.busy) return;
    var offerId = button.getAttribute("data-tk9-add-offer");
    var offerNode = button.closest("[data-tk9-offer]");
    var renderedOffer = renderedOfferFallback(offerId, offerNode);
    var offer = Object.assign({}, findOffer(offerId) || {}, renderedOffer || {});
    if (offer && offer.action === "link") {
      emit("tk9_upsell_link_click", {
        tk9_offer_id: offer.id,
        tk9_product_id: offer.productId || "",
        tk9_destination: offer.productUrl || ""
      });
      window.location.href = offer.productUrl || offer.url || "/collections/best-sellers";
      return;
    }
    if (!offer || !offer.variantId) {
      debugLog("offer add missing rendered variant", offerId);
      emit("tk9_upsell_add_error", {
        tk9_offer_id: offerId || "",
        tk9_variant_id: "",
        tk9_error_status: "missing_variant"
      });
      refresh().then(open).catch(render);
      return;
    }
    var variantId = selectedOfferVariant(offer, offerNode);

    var properties = offerNode ? collectProperties(offerNode) : {};
    if (properties === null) {
      emit("tk9_custom_patch_validation_error", { tk9_offer_id: offer.id });
      return;
    }

    state.busy = true;
    var originalButtonText = button.textContent;
    button.disabled = true;
    button.textContent = "Adding...";

    var request;
    if (offer.action === "change_variant") request = upgradeVariant(offer);
    else {
      var selectedPricing = selectedOfferPricing(offer, offerNode, variantId);
      var offerPriceCents = selectedPricing.priceCents;
      var offerCompareAtCents = selectedPricing.compareAtCents;
      var offerProperties = mergeInventoryPromiseProperties(Object.assign(attributionProperties("offer", offer.id, "cart"), properties || {}), variantId);
      var hostedMockup = Promise.resolve(offerProperties);
      var customPatchOffer = isCustomPatchOffer(offer);
      if (customPatchOffer) {
        var patchData = customPatchDataFromProperties(properties || {});
        addPatchMockupProperties(offerProperties, patchData.name, patchData.phone);
        addCustomPatchSourceProperties(offerProperties, "slide-cart");
        hostedMockup = Promise.resolve(offerProperties);
      }
      if (offerPriceCents) offerProperties._tk9_offer_price_cents = String(offerPriceCents);
      if (offerCompareAtCents && offerCompareAtCents > offerPriceCents) {
        offerProperties._tk9_offer_compare_at_cents = String(offerCompareAtCents);
        offerProperties._tk9_offer_discount_cents = String(offerCompareAtCents - offerPriceCents);
      }
      request = hostedMockup.then(function () {
        return fetchJson(config.addUrl, {
          method: "POST",
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: offerProperties
          })
        }).then(function (addedItem) {
          if (customPatchOffer) {
            emitCustomPatchProofCreated(offerProperties, "slide-cart", {
              custom_patch_variant_id: String(variantId || ""),
              cart_contains_custom_patch: true
            });
          }
          return addedItem;
        });
      });
    }offer.action!=="change_variant"&&(offer.discountCode||Number(offer.productId)===8093010624611)&&(request=request.then(function(addedItem){return applyOfferDiscountCode(offer,offerPriceCents).then(function(){return addedItem})}));

    emit("tk9_upsell_add", Object.assign({
      tk9_offer_id: offer.id,
      tk9_variant_id: variantId,
      tk9_product_id: offer.productId || "",
      tk9_cart_value_add_experiment: config.cartValueAddExperimentId,
      tk9_cart_value_add_arm: activeCartValueAddArm(),
      tk9_cart_value_add_slot_count: cartValueAddSlotCount(),
      tk9_cart_total_before: state.cart ? state.cart.total_price : 0
    }, cartKitSelectionPayload()));
    request
      .then(function (addedItem) {
        button.textContent = "Updating...";
        var keptOptimistic = false;
        if (offer.action !== "change_variant") {
          keptOptimistic = applyOptimisticAddResponse(addedItem);
          if (keptOptimistic) open();
        }
        return refreshAfterOptimistic("upsell_add", keptOptimistic);
      })
      .then(function () {
        state.busy = false;
        markCartAttributedInBackground(
          customPatchOffer ? "custom_patch_cart_add" : "upsell_add",
          customPatchOffer ? customPatchSourceAttributes("slide-cart") : null
        );
      })
      .catch(function (error) {
        debugLog("offer add failed", error);
        emit("tk9_upsell_add_error", {
          tk9_offer_id: offer.id,
          tk9_variant_id: variantId,
          tk9_error_status: error.status || ""
        });
        if (customPatchOffer) {
          setOfferFieldError(offerNode, "Patch was not added. Please check the text and try again.");
          return null;
        }
        return refresh().then(open).catch(function (refreshError) {
          debugLog("offer add recovery refresh failed", refreshError);
          render();
        });
      })
      .finally(function () {
        state.busy = false;
        if (button && button.isConnected) {
          button.disabled = false;
          button.textContent = originalButtonText;
        }
      });
  }

  function applyDiscount(form, clearCode) {
    if (state.discountBusy || !form) return;
    var input = form.querySelector('input[name="discount"]');
    var code = String(input && input.value || "").trim().toUpperCase();
    if (!code && !clearCode) {
      state.discountMessage = "Enter a code to apply it before checkout.";
      state.discountEditing = true;
      state.discountOpen = true;
      render();
      return;
    }
    state.discountBusy = true;
    var button = form.querySelector("[data-tk9-discount-apply]");
    if (button) button.disabled = true;
    state.discountMessage = clearCode ? "Removing discount..." : "Applying " + code + "...";
    render();

    var attributes = compactCartAttributes(cartAttributes());
    attributes._tk9_discount_code = clearCode ? "" : code;
    fetchJson(config.updateUrl, {
      method: "POST",
      body: JSON.stringify({
        discount: clearCode ? "" : code,
        attributes: attributes
      })
    })
      .then(function (cart) {
        state.cart = cart;
        if (clearCode) {
          state.discountMessage = "";
          state.discountEditing = false;
          state.discountOpen = false;
          state.discountBusy = false;
          emit("tk9_discount_clear", {
            tk9_cart_total_after: Number(cart && cart.total_price) || 0
          });
          return;
        }
        var original = Number(cart && cart.original_total_price) || Number(cart && cart.total_price) || 0;
        var total = Number(cart && cart.total_price) || 0;
        var actualSavings = Math.max(original - total, 0);
        var configuredSavings = configuredDiscountSavingsEstimateCents(code, cart);
        var savings = Math.max(actualSavings, cartLevelDiscountSavingsCents(), configuredSavings);
        if (savings <= 0) {
          var cleanAttributes = compactCartAttributes(cartAttributes());
          cleanAttributes._tk9_discount_code = "";
          return fetchJson(config.updateUrl, {
            method: "POST",
            body: JSON.stringify({
              discount: "",
              attributes: cleanAttributes
            })
          })
            .then(function (cleanCart) {
              state.cart = cleanCart;
              state.discountMessage = code + " is not eligible for this cart.";
              state.discountEditing = true;
              state.discountOpen = true;
              emit("tk9_discount_ineligible", {
                tk9_discount_code: code,
                tk9_cart_total_after: Number(cleanCart && cleanCart.total_price) || 0
              });
            });
        }
        state.discountMessage = "";
        state.discountEditing = false;
        state.discountOpen = false;
        state.discountBusy = false;
        emit("tk9_discount_apply", {
          tk9_discount_code: code,
          tk9_cart_total_after: total,
          tk9_cart_discount_savings: savings
        });
        markCartAttributed("discount_apply");
      })
      .then(refresh)
      .then(open)
      .catch(function (error) {
        debugLog("discount apply failed", error);
        state.discountMessage = code ? code + " is not eligible for this cart." : "Code could not be applied.";
        state.discountEditing = true;
        state.discountOpen = true;
        emit("tk9_discount_apply_error", {
          tk9_discount_code: code,
          tk9_error_status: error.status || ""
        });
        render();
      })
      .finally(function () {
        state.discountBusy = false;
        var nextButton = document.querySelector("[data-tk9-discount-apply]");
        if (nextButton) nextButton.disabled = false;
        render();
      });
  }

  function promoDiscountCode(value) {
    return String(value || "").trim().toUpperCase();
  }

  function promoDiscountCtas(code) {
    var cleanCode = promoDiscountCode(code || config.dogdadSaleCode || "");
    if (!cleanCode) return [];
    return Array.prototype.slice.call(document.querySelectorAll("[data-tk9-apply-discount]")).filter(function (node) {
      var nodeCode = promoDiscountCode(node.getAttribute("data-tk9-apply-discount") || "");
      return !nodeCode || nodeCode === cleanCode;
    });
  }

  function promoDiscountCtaHasDynamicLabel(button) {
    if (!button) return false;
    var display = String(button.getAttribute("data-tk9-discount-display") || "").toLowerCase();
    return display === "footer" || button.hasAttribute("data-tk9-discount-dynamic-label");
  }

  function setPromoDiscountButtonState(button, label, busy) {
    if (!button) return;
    if (!button.getAttribute("data-tk9-apply-discount-original")) {
      button.setAttribute("data-tk9-apply-discount-original", String(button.textContent || "").trim() || "Apply discount");
    }
    button.textContent = label;
    button.classList.toggle("is-applied", !busy && /applied/i.test(label));
    button.setAttribute("aria-live", "polite");
    if (busy) button.setAttribute("aria-busy", "true");
    else button.removeAttribute("aria-busy");
  }

  function updatePromoDiscountCtas() {
    var code = promoDiscountCode(config.dogdadSaleCode || "");
    if (!code) return;
    var active = promoDiscountCode(activeDiscountCode()) === code;
    promoDiscountCtas(code).forEach(function (button) {
      var dynamicLabel = promoDiscountCtaHasDynamicLabel(button);
      if (active) {
        if (dynamicLabel) {
          setPromoDiscountButtonState(button, code + " applied", false);
        } else {
          button.classList.add("is-applied");
        }
        return;
      }
      button.classList.remove("is-applied");
      if (!dynamicLabel) return;
      var original = button.getAttribute("data-tk9-apply-discount-original");
      if (!original && button.getAttribute("data-tk9-discount-display") !== "footer") return;
      button.textContent = button.getAttribute("data-tk9-discount-display") === "footer" ? "Apply " + code : original;
      button.removeAttribute("aria-busy");
    });
  }

  function applyDiscountCode(code, options) {
    var cleanCode = promoDiscountCode(code || config.dogdadSaleCode || "");
    options = options || {};
    if (!cleanCode || state.discountBusy) return Promise.resolve(false);

    var button = options.button || null;
    var fallbackUrl = options.fallbackUrl || (button && button.getAttribute && button.getAttribute("href")) || "";
    if (fallbackUrl && fallbackUrl.toUpperCase().indexOf("/DISCOUNT/" + cleanCode) === -1) fallbackUrl = "";
    var stateButton = promoDiscountCtaHasDynamicLabel(button) ? button : null;
    state.discountBusy = true;
    state.discountEditing = true;
    state.discountOpen = true;
    state.discountMessage = "Applying " + cleanCode + "...";
    setPromoDiscountButtonState(
      stateButton,
      stateButton && stateButton.getAttribute("data-tk9-discount-display") === "footer" ? "Applying " + cleanCode + "..." : "Applying...",
      true
    );
    if (state.open) render();

    var attributes = compactCartAttributes(cartAttributes());
    attributes._tk9_discount_code = cleanCode;

    return fetchJson(config.updateUrl, {
      method: "POST",
      body: JSON.stringify({
        discount: cleanCode,
        attributes: attributes
      })
    })
      .then(function (cart) {
        state.cart = cart;
        var original = Number(cart && cart.original_total_price) || Number(cart && cart.total_price) || 0;
        var total = Number(cart && cart.total_price) || 0;
        var actualSavings = Math.max(original - total, 0);
        var configuredSavings = configuredDiscountSavingsEstimateCents(cleanCode, cart);
        var savings = Math.max(actualSavings, cartLevelDiscountSavingsCents(), configuredSavings);
        state.discountMessage = savings > 0 ? "" : cleanCode + " is ready for eligible items.";
        if (savings > 0) {
          state.discountEditing = false;
          state.discountOpen = false;
        }
        emit("tk9_discount_apply", {
          tk9_discount_code: cleanCode,
          tk9_discount_source: options.source || "promo_cta",
          tk9_cart_total_after: total,
          tk9_cart_discount_savings: savings
        });
        return markCartAttributed("promo_discount_apply");
      })
      .then(refresh)
      .then(function () {
        updatePromoDiscountCtas();
        if (options.openCart) open();
        return state.cart;
      })
      .catch(function (error) {
        debugLog("promo discount apply failed", error);
        state.discountMessage = fallbackUrl
          ? cleanCode + " could not be applied automatically. Opening the secure discount path..."
          : cleanCode + " could not be applied. Try again at checkout.";
        state.discountEditing = true;
        state.discountOpen = true;
        var original = stateButton && stateButton.getAttribute("data-tk9-apply-discount-original");
        if (stateButton && original) setPromoDiscountButtonState(stateButton, original, false);
        emit("tk9_discount_apply_error", {
          tk9_discount_code: cleanCode,
          tk9_discount_source: options.source || "promo_cta",
          tk9_error_status: error.status || "",
          tk9_discount_fallback: fallbackUrl ? "discount_url" : ""
        });
        if (fallbackUrl) {
          window.setTimeout(function () {
            window.location.assign(fallbackUrl);
          }, 80);
        }
        if (state.open) render();
        return false;
      })
      .finally(function () {
        state.discountBusy = false;
        updatePromoDiscountCtas();
        if (state.open) render();
      });
  }

  function findProtection(protectionId) {
    var protections = state.rules && state.rules.protection;
    return (protections || []).find(function (item) {
      return item.id === protectionId;
    }) || null;
  }

  function toggleProtection(button) {
    if (state.busy) return;
    var protectionId = button.getAttribute("data-tk9-toggle-protection");
    var item = findProtection(protectionId);
    if (!item || !item.variantId) return;

    var existingLine = cartLineByProductId(item.productId);
    state.busy = true;
    button.disabled = true;

    var request;
    if (existingLine) {
      request = fetchJson(config.changeUrl, {
        method: "POST",
        body: JSON.stringify({ id: existingLine.key, quantity: 0 })
      });
      emit("tk9_protection_remove", {
        tk9_protection_id: item.id,
        tk9_variant_id: item.variantId,
        tk9_product_id: item.productId
      });
    } else {
      request = fetchJson(config.addUrl, {
        method: "POST",
        body: JSON.stringify({
          id: item.variantId,
          quantity: 1,
          properties: mergeInventoryPromiseProperties(attributionProperties("protection", item.id, "cart"), item.variantId)
        })
      });
      emit("tk9_protection_add", {
        tk9_protection_id: item.id,
        tk9_variant_id: item.variantId,
        tk9_product_id: item.productId,
        tk9_cart_total_before: state.cart ? state.cart.total_price : 0
      });
    }

    request
      .then(function (response) {
        if (existingLine) {
          if (response && Array.isArray(response.items)) {
            state.cart = response;
            render();
            open();
            return refreshAfterOptimistic("protection_remove", true);
          }
          return refresh().then(open);
        }

        var keptOptimistic = applyOptimisticAddResponse(response);
        if (keptOptimistic) open();
        return refreshAfterOptimistic("protection_add", keptOptimistic)
          .then(function () {
            markCartAttributedInBackground("protection_add");
            return state.cart;
          });
      })
      .catch(function (error) {
        debugLog("protection toggle failed", error);
        emit("tk9_protection_error", {
          tk9_protection_id: item.id,
          tk9_variant_id: item.variantId,
          tk9_error_status: error.status || ""
        });
        return refresh().then(open).catch(function (refreshError) {
          debugLog("protection recovery refresh failed", refreshError);
          render();
        });
      })
      .finally(function () {
        state.busy = false;
        button.disabled = false;
      });
  }

  function upgradeVariant(offer) {
    var sourceLine = sourceLineForChangeVariant(offer);
    if (!sourceLine) return Promise.reject(new Error("Source variant not found for upgrade"));
    var targetVariantId = targetVariantForChangeVariant(offer, sourceLine);
    if (!targetVariantId) return Promise.reject(new Error("Target variant not found for upgrade"));
    var sourceQuantity = Math.max(1, Number(sourceLine.quantity || 1));
    var divisor = Math.max(1, Number(offer.targetQuantityDivisor || 1));
    var targetQuantity = Math.max(1, Math.ceil(sourceQuantity / divisor));
    var sourceValue = lineTrackingValue(sourceLine);
    var targetValue = resolveOfferPriceCents(offer, targetVariantId) * targetQuantity;
    var consumedLines = standaloneLinesToConsumeForUpgrade(offer, sourceLine, targetQuantity);
    var consumedValue = consumedLines.reduce(function (sum, item) {
      return sum + Number(item.valueCents || 0);
    }, 0);
    var upgradeDelta = Math.max(targetValue - sourceValue - consumedValue, 0);

    return fetchJson(config.addUrl, {
      method: "POST",
      body: JSON.stringify({
        id: targetVariantId,
        quantity: targetQuantity,
        properties: mergeInventoryPromiseProperties(Object.assign(
          attributionProperties("offer", offer.id, "cart"),
          {
            _tk9_upgrade_from_variant: String(sourceLine.variant_id || sourceLine.id || ""),
            _tk9_upgrade_delta_cents: String(upgradeDelta),
            _tk9_upgrade_consumed_items: consumedLines.map(function (item) {
              return item.componentId;
            }).join(",")
          }
        ), targetVariantId)
      })
    }).then(function (addedItem) {
      return fetchJson(config.changeUrl, {
        method: "POST",
        body: JSON.stringify({
          id: sourceLine.key,
          quantity: 0
        })
      }).catch(function (error) {
        if (!addedItem || !addedItem.key) throw error;
        return fetchJson(config.changeUrl, {
          method: "POST",
          body: JSON.stringify({
            id: addedItem.key,
            quantity: 0
          })
        }).catch(function (rollbackError) {
          debugLog("upgrade rollback failed", rollbackError);
        }).then(function () {
          throw error;
        });
      }).then(function () {
        return consumedLines.reduce(function (promise, item) {
          return promise.then(function () {
            return fetchJson(config.changeUrl, {
              method: "POST",
              body: JSON.stringify({
                id: item.line.key,
                quantity: Math.max(0, lineQuantity(item.line) - Number(item.quantity || 0))
              })
            }).catch(function (error) {
              debugLog("upgrade consumed-line cleanup failed", error);
            });
          });
        }, Promise.resolve());
      }).then(function () {
        return addedItem;
      });
    });
  }

  function changeQuantity(button) {
    if (state.busy) return;
    var key = button.getAttribute("data-tk9-qty");
    var quantity = Number(button.getAttribute("data-quantity"));
    var lineIndex = Number(button.getAttribute("data-line-index") || 0);
    if (!key || !Number.isFinite(quantity)) return;
    state.busy = true;
    button.disabled = true;

    changeCartLineQuantity(key, quantity, lineIndex)
      .then(function (cart) {
        if (cart && Array.isArray(cart.items)) {
          state.cart = cart;
          render();
          open();
          return refreshAfterOptimistic("quantity_change", true);
        }
        return refreshAfterOptimistic("quantity_change", false);
      })
      .catch(function (error) {
        debugLog("quantity change failed", error);
        emit("tk9_quantity_change_error", {
          tk9_line_key: key,
          tk9_quantity: quantity,
          tk9_error_status: error.status || ""
        });
        return refresh().then(open).catch(function (refreshError) {
          debugLog("quantity change recovery refresh failed", refreshError);
          render();
        });
      })
      .finally(function () {
        state.busy = false;
        button.disabled = false;
      });
  }

  function cartHasLineKey(cart, key) {
    return ((cart && cart.items) || []).some(function (item) {
      return item && item.key === key;
    });
  }

  function changeCartLineByIndex(lineIndex, quantity) {
    if (!lineIndex) return Promise.reject(new Error("Missing cart line index"));
    return fetchJson(config.changeUrl, {
      method: "POST",
      body: JSON.stringify({ line: lineIndex, quantity: quantity })
    });
  }

  function changeCartLineQuantity(key, quantity, lineIndex) {
    return fetchJson(config.changeUrl, {
      method: "POST",
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (cart) {
      if (quantity === 0 && lineIndex && cartHasLineKey(cart, key)) {
        return changeCartLineByIndex(lineIndex, quantity);
      }
      return cart;
    }).catch(function (error) {
      if (!lineIndex) throw error;
      debugLog("quantity change by key failed; retrying by line", error);
      return changeCartLineByIndex(lineIndex, quantity);
    });
  }

  function interceptCartForm(event) {
    if (config.shadowOnly || !isEnabled()) return;
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addFromForm(form);
  }

  function activePdpPatchModule() {
    var modules = Array.prototype.slice.call(document.querySelectorAll("[data-tk9-pdp-custom-patch]"));
    return modules.find(function (module) {
      var toggle = module.querySelector("[data-tk9-pdp-patch-toggle]");
      return Boolean(toggle && toggle.checked);
    }) || null;
  }

  function patchVariantForForm(form, module) {
    var formData = new FormData(form);
    var variantId = formData.get("id") || selectedPdpVariantId();
    var variant = embeddedPdpVariant(variantId) || {};
    var variantText = [
      variant.title,
      variant.option1,
      variant.option2,
      variant.option3
    ].join(" ");
    var largeVariantId = Number(module.getAttribute("data-large-variant-id") || 0);
    var smallVariantId = Number(module.getAttribute("data-small-variant-id") || 0);
    if (/medium|large|extra[-\s]*large|48-78|78-120|120-170/i.test(variantText)) return largeVariantId || smallVariantId;
    return smallVariantId || largeVariantId;
  }

  function formDataProperties(formData) {
    var properties = {};
    formData.forEach(function (value, key) {
      var match = String(key || "").match(/^properties\[(.+)\]$/);
      if (match && value !== "") properties[match[1]] = value;
    });
    return properties;
  }

  function cartItemFromProductForm(form) {
    var formData = new FormData(form);
    var variantId = Number(formData.get("id") || selectedPdpVariantId());
    var kitSelection = selectedPdpKitSelection(formData);
    var item = {
      id: variantId,
      quantity: Number(formData.get("quantity") || 1) || 1
    };
    var sellingPlan = formData.get("selling_plan");
    var properties = mergeInventoryPromiseProperties(
      addKitSelectionProperties(formDataProperties(formData), kitSelection),
      variantId
    );
    if (sellingPlan) item.selling_plan = sellingPlan;
    if (Object.keys(properties).length) item.properties = properties;
    return item;
  }

  function selectedPdpPatch(form) {
    var module = activePdpPatchModule();
    if (!module) return null;
    var nameInput = module.querySelector("[data-tk9-pdp-patch-name]");
    var phoneInput = module.querySelector("[data-tk9-pdp-patch-phone]");
    var error = module.querySelector("[data-tk9-pdp-patch-error]");
    var dogName = String(nameInput && nameInput.value || "").trim();
    var phone = formatPatchPhoneInput(phoneInput);
    var variantId = patchVariantForForm(form, module);

    if (!dogName && !phone) {
      if (error) error.textContent = "Add a dog name or phone line for the custom patch.";
      if (nameInput) {
        try {
          nameInput.focus({ preventScroll: false });
        } catch (focusError) {
          try {
            nameInput.focus();
          } catch (fallbackError) {}
        }
      }
      emit("tk9_pdp_custom_patch_validation_error", {});
      return { error: true };
    }

    if (!variantId) {
      if (error) error.textContent = "Please choose a harness size before adding the custom patch.";
      emit("tk9_pdp_custom_patch_variant_error", {});
      return { error: true };
    }

    var properties = attributionProperties("offer", "custom-patch", "pdp");
    if (!cartMoneyPromiseContainmentEnabled()) {
      Object.assign(properties, {
        _tk9_offer_price_cents: "2499",
        _tk9_offer_compare_at_cents: "2999",
        _tk9_offer_discount_cents: "500"
      });
    }
    if (config.inventoryPromiseEnabled) {
      properties._promise_state = "ships_in_parts";
      properties._promise_line = "MADE TO ORDER · Ships after printing";
    }
    if (dogName) properties["Which text or name you want printed"] = dogName;
    if (phone) properties["Which phone number you want printed (optional)"] = phone;
    addPatchMockupProperties(properties, dogName, phone);
    addCustomPatchSourceProperties(properties, "pdp");

    return {
      item: {
        id: variantId,
        quantity: 1,
        properties: properties
      }
    };
  }

  function addFromForm(form) {
    if (!state.inventoryPromiseLoaded && config.inventoryPromiseUrl) {
      loadInventoryPromise().then(function () {
        addFromForm(form);
      });
      return;
    }
    var formData = new FormData(form);
    var kitSelection = selectedPdpKitSelection(formData);
    appendInventoryPromiseProperties(formData);
    var kitSelectionProperties = addKitSelectionProperties({}, kitSelection);
    Object.keys(kitSelectionProperties).forEach(function (name) {
      formData.set("properties[" + name + "]", kitSelectionProperties[name]);
    });
    var patch = selectedPdpPatch(form);
    if (patch && patch.error) return;
    emit("tk9_product_form_add", Object.assign({
      tk9_product_form_action: form.getAttribute("action") || "",
      tk9_cart_total_before: state.cart ? state.cart.total_price : 0,
      tk9_pdp_custom_patch_selected: patch ? "1" : "0"
    }, kitSelection));
    var request = patch
      ? addHostedPatchMockupProperty(
          patch.item.properties,
          patch.item.properties && patch.item.properties._tk9_patch_mockup_line_1,
          patch.item.properties && patch.item.properties._tk9_patch_mockup_line_2,
          "pdp",
          800,
          800
        ).then(function () {
          return fetchJson(config.addUrl, {
            method: "POST",
            body: JSON.stringify({
              items: [
                cartItemFromProductForm(form),
                patch.item
              ]
            })
          });
        })
      : fetch(config.addUrl, {
          method: "POST",
          credentials: "same-origin",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          },
          body: formData
        }).then(function (response) {
          if (!response.ok) throw new Error("Add to cart failed");
          return response.json().catch(function () { return null; });
        });

    request
      .then(function (response) {
        if (patch) {
          emit("tk9_pdp_custom_patch_add", {
            tk9_offer_id: "custom-patch",
            tk9_variant_id: patch.item.id
          });
          emitCustomPatchProofCreated(patch.item.properties, "pdp", {
            custom_patch_variant_id: String(patch.item.id || ""),
            harness_variant_id: String(cartItemFromProductForm(form).id || ""),
            cart_contains_custom_patch: true
          });
          return markCartAttributed("pdp_custom_patch_add", customPatchSourceAttributes("pdp")).then(function () {
            return response;
          });
        }
        return response;
      })
      .then(function (response) {
        var keptOptimistic = applyOptimisticAddResponse(response);
        if (keptOptimistic) open();
        return refreshAfterOptimistic("product_form_add", keptOptimistic);
      })
      .catch(function () {
        window.location.href = config.cartPageUrl;
      });
  }

  function interceptFanBuyBoxSubmit(event) {
    if (config.shadowOnly || !isEnabled()) return;
    var form = event.target && event.target.closest && event.target.closest("[data-tk9-fan-buy-box]");
    if (!form) return;
    var radio = form.querySelector('input[name^="tk9-fan-variant"]:checked');
    var variantId = Number(radio && radio.value);
    if (!variantId) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var button = form.querySelector(".tk9-fan-buy-box__button, button[type='submit'], button");
    var note = form.querySelector(".tk9-fan-buy-box__note");
    var label = radio.closest && radio.closest("label");
    var titleNode = label && label.querySelector("[data-tk9-fan-variant-title], strong");
    var selectedTitle = String(titleNode && titleNode.textContent || "Backseat Cooling Fans").trim();
    var placement = form.getAttribute("data-placement") || form.id || String(radio.name || "fan-advertorial").replace(/^tk9-fan-variant-/, "") || "fan-advertorial";

    if (button) {
      button.disabled = true;
      button.textContent = "Adding...";
    }
    if (note) note.innerHTML = "<strong>Adding to cart...</strong><span>Opening your cart next</span>";

    emit("tk9_fan_add_to_cart_click", {
      tk9_variant_id: variantId,
      tk9_fan_placement: placement,
      tk9_fan_variant_title: selectedTitle
    });

    replaceFanSetupVariant(variantId, {
      _tk9_page: "backseat-dog-cooling-fans",
      _tk9_campaign: "backseat_cooling_fans_feature",
      _tk9_experiment: "fan_advertorial_atc_abc_202605",
      _tk9_buy_box: placement,
      _tk9_selected_bundle: selectedTitle,
      _tk9_landing_path: window.location.pathname
    })
      .then(refresh)
      .then(function () {
        return markCartAttributed("fan_add");
      })
      .then(function () {
        if (note) note.innerHTML = "<strong>Added.</strong><span>Opening cart...</span>";
        if (button) button.textContent = "Added - Opening Cart";
        open();
      })
      .catch(function (error) {
        debugLog("fan add failed", error);
        if (note) note.textContent = "Cart add did not complete. Please try again.";
        if (button) {
          button.disabled = false;
          button.textContent = "Add to Cart";
        }
        window.location.href = config.cartPageUrl;
      });
  }

  function replaceFanSetupVariant(variantId, properties) {
    var fanVariantIds = ["44107734155363", "44107734188131", "44198189924451"];
    return refresh()
      .then(function () {
        var fanLines = ((state.cart && state.cart.items) || []).filter(function (line) {
          return fanVariantIds.indexOf(String(line.variant_id || line.id || "")) !== -1;
        });
        return fanLines.reduce(function (promise, line) {
          return promise.then(function () {
            return fetchJson(config.changeUrl, {
              method: "POST",
              body: JSON.stringify({
                id: line.key,
                quantity: 0
              })
            });
          });
        }, Promise.resolve());
      })
      .then(function () {
        return fetchJson(config.addUrl, {
          method: "POST",
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: mergeInventoryPromiseProperties(properties, variantId)
        })
      });
      });
  }

  function demoCartItemsFromParam(value) {
    if (!value) return [];
    return String(value).split(",").map(function (entry) {
      var parts = entry.split(":");
      var id = Number(parts[0]);
      var quantity = Math.max(1, Number(parts[1] || 1));
      if (!id || !Number.isFinite(quantity)) return null;
      return {
        id: id,
        quantity: quantity,
        properties: {
          _tk9_preview_demo: "1"
        }
      };
    }).filter(Boolean);
  }

  function cleanDemoCartParam() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete("tk9_demo_cart");
      window.history.replaceState({}, document.title, url.toString());
    } catch (error) {}
  }

  function runPreviewDemoCartSeed() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (error) {
      return null;
    }
    var seed = params.get("tk9_demo_cart");
    if (!seed || !params.get("preview_theme_id")) return null;
    var items = demoCartItemsFromParam(seed);
    if (!items.length) return null;
    cleanDemoCartParam();
    return fetchJson("/cart/clear.js", {
      method: "POST",
      body: JSON.stringify({})
    }).then(function () {
      return fetchJson(config.addUrl, {
        method: "POST",
        body: JSON.stringify({ items: items })
      });
    }).then(refresh).then(open);
  }

  function clickNativeWallet(wallet) {
    var root = document.querySelector(".tk9-additional-checkout-buttons");
    if (!root) return false;
    var selectors = {
      shop_pay: [
        'shop-pay-wallet-button',
        'shopify-shop-pay-button',
        '[aria-label*="Shop Pay" i]',
        '[data-testid*="shop" i]'
      ],
      paypal: [
        'shopify-paypal-button',
        '[aria-label*="PayPal" i]',
        '[data-funding-source="paypal"]'
      ],
      amazon_pay: [
        'shopify-amazon-pay-button',
        '[aria-label*="Amazon" i]'
      ],
      google_pay: [
        'shopify-google-pay-button',
        '[aria-label*="Google" i]',
        '[aria-label*="G Pay" i]'
      ],
      apple_pay: [
        'shopify-apple-pay-button',
        '[aria-label*="Apple" i]'
      ]
    };
    var list = selectors[wallet] || [];
    for (var index = 0; index < list.length; index += 1) {
      var node = root.querySelector(list[index]);
      if (!node) continue;
      var clickable = node.shadowRoot && node.shadowRoot.querySelector('button, [role="button"], a');
      if (!clickable && node.querySelector) clickable = node.querySelector('button, [role="button"], a');
      if (!clickable) clickable = node;
      try {
        clickable.click();
        return true;
      } catch (error) {}
    }
    return false;
  }

  function handleWalletPill(button) {
    var wallet = button.getAttribute("data-tk9-wallet") || "";
    emit("tk9_cart_express_pay_click", {
      tk9_wallet: wallet,
      tk9_cart_total_price: state.cart ? state.cart.total_price : 0,
      tk9_cart_item_count: state.cart ? state.cart.item_count : 0
    });
    markCartAttributed("express_pay_" + wallet);
    if (clickNativeWallet(wallet)) return;
    window.location.href = checkoutHref();
  }

  function handleExpressToggle(button) {
    var open = button.getAttribute("aria-expanded") !== "true";
    var panelId = button.getAttribute("aria-controls") || "";
    var panel = panelId ? document.getElementById(panelId) : document.querySelector("[data-tk9-additional-checkout]");
    var marker = button.querySelector("[data-tk9-express-marker]");
    state.expressCheckoutOpen = open;
    button.setAttribute("aria-expanded", open ? "true" : "false");
    if (marker) marker.textContent = open ? "-" : "+";
    if (panel) {
      panel.classList.toggle("is-open", open);
      panel.setAttribute("aria-hidden", open ? "false" : "true");
    }
  }

  function closestCartAddForm(node) {
    if (!node || !node.closest) return null;
    var form = node.closest('form[action*="/cart/add"]');
    if (form) return form;
    var root = node.closest("product-form-component, product-form, .product-form, .sticky-add-to-cart, .sticky-add-to-cart__form");
    if (root && root.matches && root.matches('form[action*="/cart/add"]')) return root;
    if (root && root.querySelector) {
      form = root.querySelector('form[action*="/cart/add"]');
      if (form) return form;
    }
    return document.querySelector('form.shopify-product-form[action*="/cart/add"], form[action*="/cart/add"]');
  }

  function isAddToCartControl(node) {
    if (!node || !node.matches) return false;
    if (node.matches('[data-tk9-add-offer], [data-tk9-qty], [data-tk9-close]')) return false;
    var text = String(node.textContent || node.value || node.getAttribute("aria-label") || "").trim();
    return (
      node.matches('button[name="add"], button[type="submit"], input[type="submit"], [data-add-to-cart], [class*="add-to-cart"]') &&
      /add\s*to\s*cart|add/i.test(text)
    );
  }

  function interceptCartAddClick(event) {
    if (config.shadowOnly || !isEnabled()) return;
    var control = event.target && event.target.closest && event.target.closest('button, input[type="submit"], [role="button"]');
    if (!isAddToCartControl(control)) return;
    var form = closestCartAddForm(control);
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addFromForm(form);
  }

  function bindEvents() {
    document.addEventListener("click", interceptCartAddClick, true);
    document.addEventListener("submit", interceptFanBuyBoxSubmit, true);
    document.addEventListener("submit", interceptCartForm, true);
    document.addEventListener("error", handleImageError, true);
    ["input", "change", "keyup"].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        maybeFormatPdpPatchPhone(event.target);
        updateOfferPatchPreview(event.target);
      }, true);
    });
    document.addEventListener("blur", function (event) {
      maybeFormatPdpPatchPhone(event.target);
      updateOfferPatchPreview(event.target);
    }, true);
    document.addEventListener("focusin", function (event) {
      var target = event.target;
      if (!target || !target.closest || !target.closest('[data-tk9-custom-patch-offer="1"] .tk9-field-grid')) return;
      var drawer = document.querySelector(".tk9-slide-cart");
      if (drawer) drawer.classList.add("tk9-slide-cart--field-focus");
    }, true);
    document.addEventListener("focusout", function () {
      window.setTimeout(function () {
        var drawer = document.querySelector(".tk9-slide-cart");
        if (!drawer) return;
        if (!drawer.querySelector('[data-tk9-custom-patch-offer="1"] .tk9-field-grid input:focus')) {
          drawer.classList.remove("tk9-slide-cart--field-focus");
        }
      }, 0);
    }, true);
    document.addEventListener("change", function (event) {
      var select = event.target.closest && event.target.closest("[data-tk9-offer-variant]");
      if (select) updateOfferVariantSelect(select);
    });
    document.addEventListener("click", function (event) {
      var add = event.target.closest && event.target.closest("[data-tk9-add-offer]");
      if (add) {
        event.preventDefault();
        addOffer(add);
        return;
      }
      var qty = event.target.closest && event.target.closest("[data-tk9-qty]");
      if (qty) {
        event.preventDefault();
        changeQuantity(qty);
        return;
      }
      var protection = event.target.closest && event.target.closest("[data-tk9-toggle-protection]");
      if (protection) {
        event.preventDefault();
        toggleProtection(protection);
        return;
      }
      var wallet = event.target.closest && event.target.closest("[data-tk9-wallet]");
      if (wallet) {
        event.preventDefault();
        handleWalletPill(wallet);
        return;
      }
      var expressToggle = event.target.closest && event.target.closest("[data-tk9-express-toggle]");
      if (expressToggle) {
        event.preventDefault();
        handleExpressToggle(expressToggle);
        return;
      }
      var promoDiscount = event.target.closest && event.target.closest("[data-tk9-apply-discount]");
      if (promoDiscount) {
        var promoCode = promoDiscount.getAttribute("data-tk9-apply-discount") || "";
        if (promoCode) {
          event.preventDefault();
          applyDiscountCode(promoCode || config.dogdadSaleCode || "", {
            button: promoDiscount,
            fallbackUrl: promoDiscount.getAttribute("href") || "",
            source: promoDiscount.getAttribute("data-tk9-discount-source") || "promo_cta"
          });
          return;
        }
      }
      var cartLink = event.target.closest && event.target.closest('a[href="/cart"], a[href^="/cart?"]');
      if (cartLink && isEnabled() && !config.shadowOnly) {
        event.preventDefault();
        refresh().then(open);
      }
      var discountOpen = event.target.closest && event.target.closest("[data-tk9-discount-open]");
      if (discountOpen) {
        event.preventDefault();
        state.discountEditing = true;
        state.discountOpen = true;
        render();
        var discountInput = document.querySelector('[data-tk9-discount-form] input[name="discount"]');
        if (discountInput && shouldAutoFocusDrawerInput()) {
          try {
            discountInput.focus({ preventScroll: true });
          } catch (error) {
            try {
              discountInput.focus();
            } catch (fallbackError) {}
          }
        }
        return;
      }
      var discountApply = event.target.closest && event.target.closest("[data-tk9-discount-apply]");
      if (discountApply) {
        event.preventDefault();
        applyDiscount(discountApply.closest("[data-tk9-discount-form]"));
        return;
      }
      var discountClear = event.target.closest && event.target.closest("[data-tk9-discount-clear]");
      if (discountClear) {
        event.preventDefault();
        applyDiscount(discountClear.closest("[data-tk9-discount-form]"), true);
        return;
      }
      var checkout = event.target.closest && event.target.closest("[data-tk9-checkout]");
      if (checkout) {
        event.preventDefault();
        emit("tk9_cart_checkout_click", Object.assign({
          tk9_cart_total_price: state.cart ? state.cart.total_price : 0,
          tk9_cart_item_count: state.cart ? state.cart.item_count : 0
        }, cartKitSelectionPayload()));
        var checkoutTarget = checkout.getAttribute("href") || checkoutHref();
        var didNavigate = false;
        var navigateToCheckout = function () {
          if (didNavigate) return;
          didNavigate = true;
          window.location.href = checkoutTarget;
        };
        var checkoutTimer = window.setTimeout(navigateToCheckout, 220);
        markCartAttributed("checkout_click").then(function () {
          window.clearTimeout(checkoutTimer);
          navigateToCheckout();
        });
      }
    });
    document.addEventListener("submit", function (event) {
      var discountForm = event.target.closest && event.target.closest("[data-tk9-discount-form]");
      if (!discountForm) return;
      event.preventDefault();
      applyDiscount(discountForm);
    });
  }

  window.TeamK9SlideCart = {
    open: function () {
      if (forceDisabled()) return Promise.resolve(false);
      return refresh().then(open);
    },
    close: close,
    refresh: refresh,
    applyDiscountCode: function (code, options) {
      if (forceDisabled()) return Promise.resolve(false);
      return applyDiscountCode(code, options || {});
    },
    disable: function () {
      try {
        window.localStorage.setItem("tk9_slide_cart_disabled", "1");
        window.localStorage.removeItem("tk9_slide_cart_enabled");
      } catch (error) {}
      close();
      emit("tk9_cart_kill_switch_set", {});
    },
    enableForSession: function () {
      try {
        window.localStorage.removeItem("tk9_slide_cart_disabled");
        window.localStorage.setItem("tk9_slide_cart_enabled", "1");
      } catch (error) {}
      emit("tk9_cart_preview_enable_set", {});
      return refresh().then(open);
    },
    isEnabled: isEnabled,
    isForceDisabled: forceDisabled,
    getState: function () {
      return state;
    }
  };

  if (!isEnabled()) {
    debugLog("disabled");
    return;
  }

  // tk9-fix 2026-06-19: isolate each init step so a synchronous throw in a cosmetic
  // enhancer (injectCriticalLayoutCss / bindPdpBundlePricing) cannot prevent bindEvents()
  // from wiring up the add-to-cart interceptors (which would silently break the cart).
  try { injectCriticalLayoutCss(); } catch (tk9InitErr) { debugLog("injectCriticalLayoutCss failed", tk9InitErr); }
  try { bindPdpBundlePricing(); } catch (tk9InitErr) { debugLog("bindPdpBundlePricing failed", tk9InitErr); }
  try { bindEvents(); } catch (tk9InitErr) { debugLog("bindEvents failed", tk9InitErr); }
  try { ensureShell(); } catch (tk9InitErr) { debugLog("ensureShell failed", tk9InitErr); }
  var demoSeed = runPreviewDemoCartSeed();
  if (demoSeed) {
    demoSeed.catch(function (error) {
      debugLog("demo cart seed failed", error);
      refresh().catch(function (refreshError) {
        debugLog("initial refresh failed", refreshError);
      });
    });
    return;
  }
  refresh({ deferInventoryPromise: shouldDeferInitialInventoryPromise() }).catch(function (error) {
    debugLog("initial refresh failed", error);
  });
})();
